(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredce2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredce2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("8if87", function(module, exports) {

$parcel$export(module.exports, "default", () => $609bbda3516a49df$export$2e2bcd8739ae039);
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true,
            /**
       * Whether to report input validation errors to the end user and update focus to the first input that fails validation.
       * This should always be enabled as this matches default browser form submit behaviour
       * @type boolean
       * @default false
       */ reportValidityOfForms: false
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.10'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        if ('parseHTMLUnsafe' in Document) return Document.parseHTMLUnsafe(resp);
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        try {
            const url = new URL(path, window.location.href);
            path = url.pathname + url.search;
        } catch (e) {
        // fallback for malformed URLs
        }
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(Array.from(mergeTo.attributes), function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement,
                target: selector
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(CSS.escape(newNode.tagName) + '#' + CSS.escape(id));
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            removeClassFromElement(target, htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) addClassToElement(elt, htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) removeClassFromElement(elt, htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' && elt.tagName === 'FORM') return true;
        else if (evt.type === 'click') {
            // find button wrapping the trigger element
            const btn = /** @type {HTMLButtonElement|HTMLInputElement|null} */ elt.closest('input[type="submit"], button');
            // Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            if (btn && btn.form && btn.type === 'submit') return true;
            // find link wrapping the trigger element
            const link = elt.closest('a');
            // Allow links with href="#fragment" (anchors with content after #) to perform normal fragment navigation.
            // Cancel default action for links with href="#" (bare hash) to prevent scrolling to top and unwanted URL changes.
            const samePageAnchor = /^#.+/;
            if (link && link.href && !samePageAnchor.test(link.getAttribute('href'))) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, eltToListenOn)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        if (!form) return;
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error + (detail.target ? ', ' + detail.target : ''));
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    setCurrentPathForHistory(location.pathname + location.search);
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            addClassToElement(ic, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            if (!disabledElement.hasAttribute('disabled')) {
                disabledElement.setAttribute('disabled', '');
                disabledElement.setAttribute('data-disabled-by-htmx', '');
            }
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) removeClassFromElement(ic, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0 && disabledElement.hasAttribute('data-disabled-by-htmx')) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                if (triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                }) && !errors.length && htmx.config.reportValidityOfForms) element.reportValidity();
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true,
                    push: context.push,
                    replace: context.replace,
                    selectOOB: context.selectOOB
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        let pushUrl = responseInfo.etc.push || getClosestAttributeValue(elt, 'hx-push-url');
        let replaceUrl = responseInfo.etc.replace || getClosestAttributeValue(elt, 'hx-replace-url');
        if (pushUrl === 'false') pushUrl = null;
        if (replaceUrl === 'false') replaceUrl = null;
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path?:string}} */ var redirectSwapSpec = {};
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            redirectSwapSpec.push = redirectSwapSpec.push ?? 'true';
            ajaxHelper('get', redirectPath, redirectSwapSpec);
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            addClassToElement(target, htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = etc.selectOOB || getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            const indicator = htmx.config.indicatorClass;
            const request = htmx.config.requestClass;
            getDocument().head.insertAdjacentHTML('beforeend', `<style${nonceAttribute}>` + `.${indicator}{opacity:0;visibility: hidden} ` + `.${request} .${indicator}, .${request}.${indicator}{opacity:1;visibility: visible;transition: opacity 200ms ease-in}` + '</style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = /** @type {CustomEvent} */ evt.detail.elt || evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 * @property {string} [push]
 * @property {string} [replace]
 * @property {string} [selectOOB]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $609bbda3516a49df$export$2e2bcd8739ae039 = htmx;

});


var $iUSsr = parcelRequire("iUSsr");
var $91ca15859685b28b$exports = {};

$parcel$export($91ca15859685b28b$exports, "Alert", () => $91ca15859685b28b$export$caec2af78bcc877f);
$parcel$export($91ca15859685b28b$exports, "Button", () => $91ca15859685b28b$export$353f5b6fc5456de1);
$parcel$export($91ca15859685b28b$exports, "Carousel", () => $91ca15859685b28b$export$144901db2ea8e967);
$parcel$export($91ca15859685b28b$exports, "Collapse", () => $91ca15859685b28b$export$78768a9af065a7b);
$parcel$export($91ca15859685b28b$exports, "Dropdown", () => $91ca15859685b28b$export$931cbfb6bfb85fc);
$parcel$export($91ca15859685b28b$exports, "Modal", () => $91ca15859685b28b$export$2b77a92f1a5ad772);
$parcel$export($91ca15859685b28b$exports, "Offcanvas", () => $91ca15859685b28b$export$591ca0244c9dfcd4);
$parcel$export($91ca15859685b28b$exports, "Tooltip", () => $91ca15859685b28b$export$28c660c63b792dea);
$parcel$export($91ca15859685b28b$exports, "Popover", () => $91ca15859685b28b$export$5b6b19405a83ff9d);
$parcel$export($91ca15859685b28b$exports, "ScrollSpy", () => $91ca15859685b28b$export$a6472a5298a374be);
$parcel$export($91ca15859685b28b$exports, "Tab", () => $91ca15859685b28b$export$3e41faf802a29e71);
$parcel$export($91ca15859685b28b$exports, "Toast", () => $91ca15859685b28b$export$8d8dc7d5f743331b);
/*!
  * Bootstrap v5.3.8 (https://getbootstrap.com/)
  * Copyright 2011-2025 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ var $d37552697cc5ea39$exports = {};

$parcel$export($d37552697cc5ea39$exports, "popperGenerator", () => $b3c2fd6800546b4b$export$ed5e13716264f202);
$parcel$export($d37552697cc5ea39$exports, "detectOverflow", () => $f765731200b57f98$export$2e2bcd8739ae039);
$parcel$export($d37552697cc5ea39$exports, "createPopperBase", () => $b3c2fd6800546b4b$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopper", () => $1bf0bf541303046d$export$8f7491d57c8f97a9);
$parcel$export($d37552697cc5ea39$exports, "createPopperLite", () => $cff5cce2532d9fa1$export$8f7491d57c8f97a9);
var $f5c54167a3c62105$exports = {};

$parcel$export($f5c54167a3c62105$exports, "top", () => $f5c54167a3c62105$export$1e95b668f3b82d);
$parcel$export($f5c54167a3c62105$exports, "bottom", () => $f5c54167a3c62105$export$40e543e69a8b3fbb);
$parcel$export($f5c54167a3c62105$exports, "right", () => $f5c54167a3c62105$export$79ffe56a765070d2);
$parcel$export($f5c54167a3c62105$exports, "left", () => $f5c54167a3c62105$export$eabcd2c8791e7bf4);
$parcel$export($f5c54167a3c62105$exports, "auto", () => $f5c54167a3c62105$export$dfb5619354ba860);
$parcel$export($f5c54167a3c62105$exports, "basePlacements", () => $f5c54167a3c62105$export$aec2ce47c367b8c3);
$parcel$export($f5c54167a3c62105$exports, "start", () => $f5c54167a3c62105$export$b3571188c770cc5a);
$parcel$export($f5c54167a3c62105$exports, "end", () => $f5c54167a3c62105$export$bd5df0f255a350f8);
$parcel$export($f5c54167a3c62105$exports, "clippingParents", () => $f5c54167a3c62105$export$390fd549c5303b4d);
$parcel$export($f5c54167a3c62105$exports, "viewport", () => $f5c54167a3c62105$export$d7b7311ec04a3e8f);
$parcel$export($f5c54167a3c62105$exports, "popper", () => $f5c54167a3c62105$export$ae5ab1c730825774);
$parcel$export($f5c54167a3c62105$exports, "reference", () => $f5c54167a3c62105$export$ca50aac9f3ba507f);
$parcel$export($f5c54167a3c62105$exports, "variationPlacements", () => $f5c54167a3c62105$export$368f9a87e87fa4e1);
$parcel$export($f5c54167a3c62105$exports, "placements", () => $f5c54167a3c62105$export$803cd8101b6c182b);
$parcel$export($f5c54167a3c62105$exports, "beforeRead", () => $f5c54167a3c62105$export$421679a7c3d56e);
$parcel$export($f5c54167a3c62105$exports, "read", () => $f5c54167a3c62105$export$aafa59e2e03f2942);
$parcel$export($f5c54167a3c62105$exports, "afterRead", () => $f5c54167a3c62105$export$6964f6c886723980);
$parcel$export($f5c54167a3c62105$exports, "beforeMain", () => $f5c54167a3c62105$export$c65e99957a05207c);
$parcel$export($f5c54167a3c62105$exports, "main", () => $f5c54167a3c62105$export$f22da7240b7add18);
$parcel$export($f5c54167a3c62105$exports, "afterMain", () => $f5c54167a3c62105$export$bab79516f2d662fe);
$parcel$export($f5c54167a3c62105$exports, "beforeWrite", () => $f5c54167a3c62105$export$8d4d2d70e7d46032);
$parcel$export($f5c54167a3c62105$exports, "write", () => $f5c54167a3c62105$export$68d8715fc104d294);
$parcel$export($f5c54167a3c62105$exports, "afterWrite", () => $f5c54167a3c62105$export$70a6e5159acce2e6);
$parcel$export($f5c54167a3c62105$exports, "modifierPhases", () => $f5c54167a3c62105$export$d087d3878fdf71d5);
var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


var $1341d386dda6ba3e$exports = {};

$parcel$export($1341d386dda6ba3e$exports, "applyStyles", () => $83c1fc4c4e58d7dd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "arrow", () => $1992f2d714808ab6$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "computeStyles", () => $c8f8eadcf7685dc5$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "eventListeners", () => $ff355aafd082b0cd$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "flip", () => $b1f32a1d9525a032$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "hide", () => $174d14927bb4f43b$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "offset", () => $7c04da2e958a3fe8$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "popperOffsets", () => $e92fb10df1450f31$export$2e2bcd8739ae039);
$parcel$export($1341d386dda6ba3e$exports, "preventOverflow", () => $3295dac8746ffe59$export$2e2bcd8739ae039);
function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};


var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}








function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}










function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};



function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}








function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $cff5cce2532d9fa1$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039)
];
var $cff5cce2532d9fa1$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $cff5cce2532d9fa1$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d37552697cc5ea39$exports, $f5c54167a3c62105$exports);
$parcel$exportWildcard($d37552697cc5ea39$exports, $1341d386dda6ba3e$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$elementMap = new Map();
const $91ca15859685b28b$var$Data = {
    set (element, key, instance) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) $91ca15859685b28b$var$elementMap.set(element, new Map());
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($91ca15859685b28b$var$elementMap.has(element)) return $91ca15859685b28b$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$91ca15859685b28b$var$elementMap.has(element)) return;
        const instanceMap = $91ca15859685b28b$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $91ca15859685b28b$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$MAX_UID = 1000000;
const $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER = 1000;
const $91ca15859685b28b$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $91ca15859685b28b$var$parseSelector = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $91ca15859685b28b$var$toType = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $91ca15859685b28b$var$getUID = (prefix)=>{
    do prefix += Math.floor(Math.random() * $91ca15859685b28b$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $91ca15859685b28b$var$getTransitionDurationFromElement = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $91ca15859685b28b$var$MILLISECONDS_MULTIPLIER;
};
const $91ca15859685b28b$var$triggerTransitionEnd = (element)=>{
    element.dispatchEvent(new Event($91ca15859685b28b$var$TRANSITION_END));
};
const $91ca15859685b28b$var$isElement = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $91ca15859685b28b$var$getElement = (object)=>{
    // it's a jQuery object or a node element
    if ($91ca15859685b28b$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($91ca15859685b28b$var$parseSelector(object));
    return null;
};
const $91ca15859685b28b$var$isVisible = (element)=>{
    if (!$91ca15859685b28b$var$isElement(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $91ca15859685b28b$var$isDisabled = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $91ca15859685b28b$var$findShadowRoot = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $91ca15859685b28b$var$findShadowRoot(element.parentNode);
};
const $91ca15859685b28b$var$noop = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $91ca15859685b28b$var$reflow = (element)=>{
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
const $91ca15859685b28b$var$getjQuery = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $91ca15859685b28b$var$DOMContentLoadedCallbacks = [];
const $91ca15859685b28b$var$onDOMContentLoaded = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$91ca15859685b28b$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $91ca15859685b28b$var$DOMContentLoadedCallbacks)callback();
        });
        $91ca15859685b28b$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $91ca15859685b28b$var$isRTL = ()=>document.documentElement.dir === 'rtl';
const $91ca15859685b28b$var$defineJQueryPlugin = (plugin)=>{
    $91ca15859685b28b$var$onDOMContentLoaded(()=>{
        const $ = $91ca15859685b28b$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $91ca15859685b28b$var$execute = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $91ca15859685b28b$var$executeAfterTransition = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $91ca15859685b28b$var$execute(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $91ca15859685b28b$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
        $91ca15859685b28b$var$execute(callback);
    };
    transitionElement.addEventListener($91ca15859685b28b$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $91ca15859685b28b$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $91ca15859685b28b$var$getNextActiveElement = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $91ca15859685b28b$var$stripNameRegex = /\..*/;
const $91ca15859685b28b$var$stripUidRegex = /::\d+$/;
const $91ca15859685b28b$var$eventRegistry = {}; // Events storage
let $91ca15859685b28b$var$uidEvent = 1;
const $91ca15859685b28b$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $91ca15859685b28b$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $91ca15859685b28b$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$91ca15859685b28b$var$uidEvent++}` || element.uidEvent || $91ca15859685b28b$var$uidEvent++;
}
function $91ca15859685b28b$var$getElementEvents(element) {
    const uid = $91ca15859685b28b$var$makeEventUid(element);
    element.uidEvent = uid;
    $91ca15859685b28b$var$eventRegistry[uid] = $91ca15859685b28b$var$eventRegistry[uid] || {};
    return $91ca15859685b28b$var$eventRegistry[uid];
}
function $91ca15859685b28b$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $91ca15859685b28b$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $91ca15859685b28b$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $91ca15859685b28b$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $91ca15859685b28b$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $91ca15859685b28b$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $91ca15859685b28b$var$getTypeEvent(originalTypeEvent);
    if (!$91ca15859685b28b$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $91ca15859685b28b$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $91ca15859685b28b$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $91ca15859685b28b$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $91ca15859685b28b$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $91ca15859685b28b$var$makeEventUid(callable, originalTypeEvent.replace($91ca15859685b28b$var$namespaceRegex, ''));
    const fn = isDelegated ? $91ca15859685b28b$var$bootstrapDelegationHandler(element, handler, callable) : $91ca15859685b28b$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $91ca15859685b28b$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $91ca15859685b28b$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $91ca15859685b28b$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $91ca15859685b28b$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($91ca15859685b28b$var$stripNameRegex, '');
    return $91ca15859685b28b$var$customEvents[event] || event;
}
const $91ca15859685b28b$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $91ca15859685b28b$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $91ca15859685b28b$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $91ca15859685b28b$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $91ca15859685b28b$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$91ca15859685b28b$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($91ca15859685b28b$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $91ca15859685b28b$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = $91ca15859685b28b$var$getjQuery();
        const typeEvent = $91ca15859685b28b$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $91ca15859685b28b$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $91ca15859685b28b$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch (_unused) {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $91ca15859685b28b$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $91ca15859685b28b$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $91ca15859685b28b$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $91ca15859685b28b$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $91ca15859685b28b$var$normalizeData(element.getAttribute(`data-bs-${$91ca15859685b28b$var$normalizeDataKey(key)}`));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ class $91ca15859685b28b$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = $91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...$91ca15859685b28b$var$isElement(element) ? $91ca15859685b28b$var$Manipulator.getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = $91ca15859685b28b$var$isElement(value) ? 'element' : $91ca15859685b28b$var$toType(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $91ca15859685b28b$var$BaseComponent extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        element = $91ca15859685b28b$var$getElement(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        $91ca15859685b28b$var$Data.set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$Data.remove(this._element, this.constructor.DATA_KEY);
        $91ca15859685b28b$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        $91ca15859685b28b$var$executeAfterTransition(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return $91ca15859685b28b$var$Data.get($91ca15859685b28b$var$getElement(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $91ca15859685b28b$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>$91ca15859685b28b$var$parseSelector(sel)).join(',') : null;
};
const $91ca15859685b28b$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!$91ca15859685b28b$var$isDisabled(el) && $91ca15859685b28b$var$isVisible(el));
    },
    getSelectorFromElement (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        if (selector) return $91ca15859685b28b$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $91ca15859685b28b$var$getSelector(element);
        return selector ? $91ca15859685b28b$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $91ca15859685b28b$var$enableDismissTrigger = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    $91ca15859685b28b$var$EventHandler.on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($91ca15859685b28b$var$isDisabled(this)) return;
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$f = 'alert';
const $91ca15859685b28b$var$DATA_KEY$a = 'bs.alert';
const $91ca15859685b28b$var$EVENT_KEY$b = `.${$91ca15859685b28b$var$DATA_KEY$a}`;
const $91ca15859685b28b$var$EVENT_CLOSE = `close${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$EVENT_CLOSED = `closed${$91ca15859685b28b$var$EVENT_KEY$b}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE$5 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ class $91ca15859685b28b$export$caec2af78bcc877f extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$f;
    }
    // Public
    close() {
        const closeEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSE);
        if (closeEvent.defaultPrevented) return;
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$8);
        const isAnimated = this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$5);
        this._queueCallback(()=>this._destroyElement(), this._element, isAnimated);
    }
    // Private
    _destroyElement() {
        this._element.remove();
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_CLOSED);
        this.dispose();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$caec2af78bcc877f.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$e = 'button';
const $91ca15859685b28b$var$DATA_KEY$9 = 'bs.button';
const $91ca15859685b28b$var$EVENT_KEY$a = `.${$91ca15859685b28b$var$DATA_KEY$9}`;
const $91ca15859685b28b$var$DATA_API_KEY$6 = '.data-api';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$3 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6 = `click${$91ca15859685b28b$var$EVENT_KEY$a}${$91ca15859685b28b$var$DATA_API_KEY$6}`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$353f5b6fc5456de1 extends $91ca15859685b28b$var$BaseComponent {
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$e;
    }
    // Public
    toggle() {
        // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
        this._element.setAttribute('aria-pressed', this._element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_ACTIVE$3));
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(this);
            if (config === 'toggle') data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$6, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5, (event)=>{
    event.preventDefault();
    const button = event.target.closest($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$5);
    const data = $91ca15859685b28b$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$d = 'swipe';
const $91ca15859685b28b$var$EVENT_KEY$9 = '.bs.swipe';
const $91ca15859685b28b$var$EVENT_TOUCHSTART = `touchstart${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHMOVE = `touchmove${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_TOUCHEND = `touchend${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERDOWN = `pointerdown${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$EVENT_POINTERUP = `pointerup${$91ca15859685b28b$var$EVENT_KEY$9}`;
const $91ca15859685b28b$var$POINTER_TYPE_TOUCH = 'touch';
const $91ca15859685b28b$var$POINTER_TYPE_PEN = 'pen';
const $91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $91ca15859685b28b$var$SWIPE_THRESHOLD = 40;
const $91ca15859685b28b$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $91ca15859685b28b$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Swipe extends $91ca15859685b28b$var$Config {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$91ca15859685b28b$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$c;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$c;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$d;
    }
    // Public
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_KEY$9);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        $91ca15859685b28b$var$execute(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $91ca15859685b28b$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        $91ca15859685b28b$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_POINTER_EVENT);
        } else {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_PEN || event.pointerType === $91ca15859685b28b$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$c = 'carousel';
const $91ca15859685b28b$var$DATA_KEY$8 = 'bs.carousel';
const $91ca15859685b28b$var$EVENT_KEY$8 = `.${$91ca15859685b28b$var$DATA_KEY$8}`;
const $91ca15859685b28b$var$DATA_API_KEY$5 = '.data-api';
const $91ca15859685b28b$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
const $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
const $91ca15859685b28b$var$ORDER_NEXT = 'next';
const $91ca15859685b28b$var$ORDER_PREV = 'prev';
const $91ca15859685b28b$var$DIRECTION_LEFT = 'left';
const $91ca15859685b28b$var$DIRECTION_RIGHT = 'right';
const $91ca15859685b28b$var$EVENT_SLIDE = `slide${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_SLID = `slid${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN$1 = `keydown${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSEENTER$1 = `mouseenter${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_MOUSELEAVE$1 = `mouseleave${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_DRAG_START = `dragstart${$91ca15859685b28b$var$EVENT_KEY$8}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3 = `load${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5 = `click${$91ca15859685b28b$var$EVENT_KEY$8}${$91ca15859685b28b$var$DATA_API_KEY$5}`;
const $91ca15859685b28b$var$CLASS_NAME_CAROUSEL = 'carousel';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$2 = 'active';
const $91ca15859685b28b$var$CLASS_NAME_SLIDE = 'slide';
const $91ca15859685b28b$var$CLASS_NAME_END = 'carousel-item-end';
const $91ca15859685b28b$var$CLASS_NAME_START = 'carousel-item-start';
const $91ca15859685b28b$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $91ca15859685b28b$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $91ca15859685b28b$var$SELECTOR_ACTIVE = '.active';
const $91ca15859685b28b$var$SELECTOR_ITEM = '.carousel-item';
const $91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM = $91ca15859685b28b$var$SELECTOR_ACTIVE + $91ca15859685b28b$var$SELECTOR_ITEM;
const $91ca15859685b28b$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $91ca15859685b28b$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $91ca15859685b28b$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $91ca15859685b28b$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $91ca15859685b28b$var$KEY_TO_DIRECTION = {
    [$91ca15859685b28b$var$ARROW_LEFT_KEY$1]: $91ca15859685b28b$var$DIRECTION_RIGHT,
    [$91ca15859685b28b$var$ARROW_RIGHT_KEY$1]: $91ca15859685b28b$var$DIRECTION_LEFT
};
const $91ca15859685b28b$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $91ca15859685b28b$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$144901db2ea8e967 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $91ca15859685b28b$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$b;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$b;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$c;
    }
    // Public
    next() {
        this._slide($91ca15859685b28b$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && $91ca15859685b28b$var$isVisible(this._element)) this.next();
    }
    prev() {
        this._slide($91ca15859685b28b$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) $91ca15859685b28b$var$triggerTransitionEnd(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN$1, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEENTER$1, ()=>this.pause());
            $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSELEAVE$1, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && $91ca15859685b28b$var$Swipe.isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM_IMG, this._element))$91ca15859685b28b$var$EventHandler.on(img, $91ca15859685b28b$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $91ca15859685b28b$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($91ca15859685b28b$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new $91ca15859685b28b$var$Swipe(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $91ca15859685b28b$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = $91ca15859685b28b$var$SelectorEngine.findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $91ca15859685b28b$var$ORDER_NEXT;
        const nextElement = element || $91ca15859685b28b$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return $91ca15859685b28b$var$EventHandler.trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($91ca15859685b28b$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_START : $91ca15859685b28b$var$CLASS_NAME_END;
        const orderClassName = isNext ? $91ca15859685b28b$var$CLASS_NAME_NEXT : $91ca15859685b28b$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        $91ca15859685b28b$var$reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2);
            activeElement.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($91ca15859685b28b$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ($91ca15859685b28b$var$isRTL()) return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_PREV : $91ca15859685b28b$var$ORDER_NEXT;
        return direction === $91ca15859685b28b$var$DIRECTION_LEFT ? $91ca15859685b28b$var$ORDER_NEXT : $91ca15859685b28b$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ($91ca15859685b28b$var$isRTL()) return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_LEFT : $91ca15859685b28b$var$DIRECTION_RIGHT;
        return order === $91ca15859685b28b$var$ORDER_PREV ? $91ca15859685b28b$var$DIRECTION_RIGHT : $91ca15859685b28b$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$5, $91ca15859685b28b$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($91ca15859685b28b$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($91ca15859685b28b$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$3, ()=>{
    const carousels = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$91ca15859685b28b$export$144901db2ea8e967.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$b = 'collapse';
const $91ca15859685b28b$var$DATA_KEY$7 = 'bs.collapse';
const $91ca15859685b28b$var$EVENT_KEY$7 = `.${$91ca15859685b28b$var$DATA_KEY$7}`;
const $91ca15859685b28b$var$DATA_API_KEY$4 = '.data-api';
const $91ca15859685b28b$var$EVENT_SHOW$6 = `show${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_SHOWN$6 = `shown${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDE$6 = `hide${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$6 = `hidden${$91ca15859685b28b$var$EVENT_KEY$7}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4 = `click${$91ca15859685b28b$var$EVENT_KEY$7}${$91ca15859685b28b$var$DATA_API_KEY$4}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$7 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSE = 'collapse';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $91ca15859685b28b$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE} .${$91ca15859685b28b$var$CLASS_NAME_COLLAPSE}`;
const $91ca15859685b28b$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $91ca15859685b28b$var$WIDTH = 'width';
const $91ca15859685b28b$var$HEIGHT = 'height';
const $91ca15859685b28b$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
const $91ca15859685b28b$var$Default$a = {
    parent: null,
    toggle: true
};
const $91ca15859685b28b$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$78768a9af065a7b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const elem of toggleList){
            const selector = $91ca15859685b28b$var$SelectorEngine.getSelectorFromElement(elem);
            const filterElement = $91ca15859685b28b$var$SelectorEngine.find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$a;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$a;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$b;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$6);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
            this._element.style[dimension] = '';
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$6);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$6);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSE, $91ca15859685b28b$var$CLASS_NAME_SHOW$7);
        for (const trigger of this._triggerArray){
            const element = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_COLLAPSE);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$6);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$7);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle); // Coerce string values
        config.parent = $91ca15859685b28b$var$getElement(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_HORIZONTAL) ? $91ca15859685b28b$var$WIDTH : $91ca15859685b28b$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4);
        for (const element of children){
            const selected = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return $91ca15859685b28b$var$SelectorEngine.find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($91ca15859685b28b$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$4, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of $91ca15859685b28b$var$SelectorEngine.getMultipleElementsFromSelector(this))$91ca15859685b28b$export$78768a9af065a7b.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$a = 'dropdown';
const $91ca15859685b28b$var$DATA_KEY$6 = 'bs.dropdown';
const $91ca15859685b28b$var$EVENT_KEY$6 = `.${$91ca15859685b28b$var$DATA_KEY$6}`;
const $91ca15859685b28b$var$DATA_API_KEY$3 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$2 = 'Escape';
const $91ca15859685b28b$var$TAB_KEY$1 = 'Tab';
const $91ca15859685b28b$var$ARROW_UP_KEY$1 = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
const $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
const $91ca15859685b28b$var$EVENT_HIDE$5 = `hide${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$5 = `hidden${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOW$5 = `show${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_SHOWN$5 = `shown${$91ca15859685b28b$var$EVENT_KEY$6}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3 = `click${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API = `keydown${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$EVENT_KEYUP_DATA_API = `keyup${$91ca15859685b28b$var$EVENT_KEY$6}${$91ca15859685b28b$var$DATA_API_KEY$3}`;
const $91ca15859685b28b$var$CLASS_NAME_SHOW$6 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP = 'dropup';
const $91ca15859685b28b$var$CLASS_NAME_DROPEND = 'dropend';
const $91ca15859685b28b$var$CLASS_NAME_DROPSTART = 'dropstart';
const $91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN = `${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3}.${$91ca15859685b28b$var$CLASS_NAME_SHOW$6}`;
const $91ca15859685b28b$var$SELECTOR_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$SELECTOR_NAVBAR = '.navbar';
const $91ca15859685b28b$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
const $91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
const $91ca15859685b28b$var$PLACEMENT_TOP = $91ca15859685b28b$var$isRTL() ? 'top-end' : 'top-start';
const $91ca15859685b28b$var$PLACEMENT_TOPEND = $91ca15859685b28b$var$isRTL() ? 'top-start' : 'top-end';
const $91ca15859685b28b$var$PLACEMENT_BOTTOM = $91ca15859685b28b$var$isRTL() ? 'bottom-end' : 'bottom-start';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMEND = $91ca15859685b28b$var$isRTL() ? 'bottom-start' : 'bottom-end';
const $91ca15859685b28b$var$PLACEMENT_RIGHT = $91ca15859685b28b$var$isRTL() ? 'left-start' : 'right-start';
const $91ca15859685b28b$var$PLACEMENT_LEFT = $91ca15859685b28b$var$isRTL() ? 'right-start' : 'left-start';
const $91ca15859685b28b$var$PLACEMENT_TOPCENTER = 'top';
const $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER = 'bottom';
const $91ca15859685b28b$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
const $91ca15859685b28b$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$931cbfb6bfb85fc extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._popper = null;
        this._parent = this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        this._menu = $91ca15859685b28b$var$SelectorEngine.next(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.prev(this._element, $91ca15859685b28b$var$SELECTOR_MENU)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MENU, this._parent);
        this._inNavbar = this._detectNavbar();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$9;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$9;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$a;
    }
    // Public
    toggle() {
        return this._isShown() ? this.hide() : this.show();
    }
    show() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$5, relatedTarget);
        if (showEvent.defaultPrevented) return;
        this._createPopper();
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement && !this._parent.closest($91ca15859685b28b$var$SELECTOR_NAVBAR_NAV)) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._element.focus();
        this._element.setAttribute('aria-expanded', true);
        this._menu.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$5, relatedTarget);
    }
    hide() {
        if ($91ca15859685b28b$var$isDisabled(this._element) || !this._isShown()) return;
        const relatedTarget = {
            relatedTarget: this._element
        };
        this._completeHide(relatedTarget);
    }
    dispose() {
        if (this._popper) this._popper.destroy();
        super.dispose();
    }
    update() {
        this._inNavbar = this._detectNavbar();
        if (this._popper) this._popper.update();
    }
    // Private
    _completeHide(relatedTarget) {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$5, relatedTarget);
        if (hideEvent.defaultPrevented) return;
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        if (this._popper) this._popper.destroy();
        this._menu.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
        this._element.setAttribute('aria-expanded', 'false');
        $91ca15859685b28b$var$Manipulator.removeDataAttribute(this._menu, 'popper');
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$5, relatedTarget);
    }
    _getConfig(config) {
        config = super._getConfig(config);
        if (typeof config.reference === 'object' && !$91ca15859685b28b$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError(`${$91ca15859685b28b$var$NAME$a.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`);
        return config;
    }
    _createPopper() {
        if (typeof $d37552697cc5ea39$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org/docs/v2/)');
        let referenceElement = this._element;
        if (this._config.reference === 'parent') referenceElement = this._parent;
        else if ($91ca15859685b28b$var$isElement(this._config.reference)) referenceElement = $91ca15859685b28b$var$getElement(this._config.reference);
        else if (typeof this._config.reference === 'object') referenceElement = this._config.reference;
        const popperConfig = this._getPopperConfig();
        this._popper = $d37552697cc5ea39$exports.createPopper(referenceElement, this._menu, popperConfig);
    }
    _isShown() {
        return this._menu.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$6);
    }
    _getPlacement() {
        const parentDropdown = this._parent;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPEND)) return $91ca15859685b28b$var$PLACEMENT_RIGHT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPSTART)) return $91ca15859685b28b$var$PLACEMENT_LEFT;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP_CENTER)) return $91ca15859685b28b$var$PLACEMENT_TOPCENTER;
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_CENTER)) return $91ca15859685b28b$var$PLACEMENT_BOTTOMCENTER;
        // We need to trim the value because custom properties can also include spaces
        const isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
        if (parentDropdown.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPUP)) return isEnd ? $91ca15859685b28b$var$PLACEMENT_TOPEND : $91ca15859685b28b$var$PLACEMENT_TOP;
        return isEnd ? $91ca15859685b28b$var$PLACEMENT_BOTTOMEND : $91ca15859685b28b$var$PLACEMENT_BOTTOM;
    }
    _detectNavbar() {
        return this._element.closest($91ca15859685b28b$var$SELECTOR_NAVBAR) !== null;
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _getPopperConfig() {
        const defaultBsPopperConfig = {
            placement: this._getPlacement(),
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                }
            ]
        };
        // Disable Popper if we have a static display or Dropdown is in Navbar
        if (this._inNavbar || this._config.display === 'static') {
            $91ca15859685b28b$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
            defaultBsPopperConfig.modifiers = [
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ];
        }
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _selectMenuItem({ key: key, target: target }) {
        const items = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter((element)=>$91ca15859685b28b$var$isVisible(element));
        if (!items.length) return;
        // if target isn't included in items (e.g. when expanding the dropdown)
        // allow cycling to get the last item in case key equals ARROW_UP_KEY
        $91ca15859685b28b$var$getNextActiveElement(items, target, key === $91ca15859685b28b$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
    static clearMenus(event) {
        if (event.button === $91ca15859685b28b$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $91ca15859685b28b$var$TAB_KEY$1) return;
        const openToggles = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_SHOWN);
        for (const toggle of openToggles){
            const context = $91ca15859685b28b$export$931cbfb6bfb85fc.getInstance(toggle);
            if (!context || context._config.autoClose === false) continue;
            const composedPath = event.composedPath();
            const isMenuTarget = composedPath.includes(context._menu);
            if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
            if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $91ca15859685b28b$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
            const relatedTarget = {
                relatedTarget: context._element
            };
            if (event.type === 'click') relatedTarget.clickEvent = event;
            context._completeHide(relatedTarget);
        }
    }
    static dataApiKeydownHandler(event) {
        // If not an UP | DOWN | ESCAPE key => not a dropdown command
        // If input/textarea && if key is other than ESCAPE => not a dropdown command
        const isInput = /input|textarea/i.test(event.target.tagName);
        const isEscapeEvent = event.key === $91ca15859685b28b$var$ESCAPE_KEY$2;
        const isUpOrDownEvent = [
            $91ca15859685b28b$var$ARROW_UP_KEY$1,
            $91ca15859685b28b$var$ARROW_DOWN_KEY$1
        ].includes(event.key);
        if (!isUpOrDownEvent && !isEscapeEvent) return;
        if (isInput && !isEscapeEvent) return;
        event.preventDefault();
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        const getToggleButton = this.matches($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3) ? this : $91ca15859685b28b$var$SelectorEngine.prev(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.next(this, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3)[0] || $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
        const instance = $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(getToggleButton);
        if (isUpOrDownEvent) {
            event.stopPropagation();
            instance.show();
            instance._selectMenuItem(event);
            return;
        }
        if (instance._isShown()) {
            // else is escape and we check if it is shown
            event.stopPropagation();
            instance.hide();
            getToggleButton.focus();
        }
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_DATA_API, $91ca15859685b28b$var$SELECTOR_MENU, $91ca15859685b28b$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYUP_DATA_API, $91ca15859685b28b$export$931cbfb6bfb85fc.clearMenus);
$91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$3, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $91ca15859685b28b$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$9 = 'backdrop';
const $91ca15859685b28b$var$CLASS_NAME_FADE$4 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$5 = 'show';
const $91ca15859685b28b$var$EVENT_MOUSEDOWN = `mousedown.bs.${$91ca15859685b28b$var$NAME$9}`;
const $91ca15859685b28b$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $91ca15859685b28b$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$Backdrop extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$8;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$8;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$9;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) $91ca15859685b28b$var$reflow(element);
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            $91ca15859685b28b$var$execute(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            $91ca15859685b28b$var$execute(callback);
            return;
        }
        this._getElement().classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$5);
        this._emulateAnimation(()=>{
            this.dispose();
            $91ca15859685b28b$var$execute(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        $91ca15859685b28b$var$EventHandler.off(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$4);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = $91ca15859685b28b$var$getElement(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        $91ca15859685b28b$var$EventHandler.on(element, $91ca15859685b28b$var$EVENT_MOUSEDOWN, ()=>{
            $91ca15859685b28b$var$execute(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        $91ca15859685b28b$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$8 = 'focustrap';
const $91ca15859685b28b$var$DATA_KEY$5 = 'bs.focustrap';
const $91ca15859685b28b$var$EVENT_KEY$5 = `.${$91ca15859685b28b$var$DATA_KEY$5}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN$2 = `focusin${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_TAB = `keydown.tab${$91ca15859685b28b$var$EVENT_KEY$5}`;
const $91ca15859685b28b$var$TAB_KEY = 'Tab';
const $91ca15859685b28b$var$TAB_NAV_FORWARD = 'forward';
const $91ca15859685b28b$var$TAB_NAV_BACKWARD = 'backward';
const $91ca15859685b28b$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $91ca15859685b28b$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$FocusTrap extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$7;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$7;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$8;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5); // guard against infinite focus loop
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_FOCUSIN$2, (event)=>this._handleFocusin(event));
        $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        $91ca15859685b28b$var$EventHandler.off(document, $91ca15859685b28b$var$EVENT_KEY$5);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = $91ca15859685b28b$var$SelectorEngine.focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $91ca15859685b28b$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $91ca15859685b28b$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $91ca15859685b28b$var$TAB_NAV_BACKWARD : $91ca15859685b28b$var$TAB_NAV_FORWARD;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $91ca15859685b28b$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $91ca15859685b28b$var$PROPERTY_PADDING = 'padding-right';
const $91ca15859685b28b$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $91ca15859685b28b$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_FIXED_CONTENT, $91ca15859685b28b$var$PROPERTY_PADDING);
        this._resetElementAttributes($91ca15859685b28b$var$SELECTOR_STICKY_CONTENT, $91ca15859685b28b$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) $91ca15859685b28b$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = $91ca15859685b28b$var$Manipulator.getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            $91ca15859685b28b$var$Manipulator.removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ($91ca15859685b28b$var$isElement(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of $91ca15859685b28b$var$SelectorEngine.find(selector, this._element))callBack(sel);
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$7 = 'modal';
const $91ca15859685b28b$var$DATA_KEY$4 = 'bs.modal';
const $91ca15859685b28b$var$EVENT_KEY$4 = `.${$91ca15859685b28b$var$DATA_KEY$4}`;
const $91ca15859685b28b$var$DATA_API_KEY$2 = '.data-api';
const $91ca15859685b28b$var$ESCAPE_KEY$1 = 'Escape';
const $91ca15859685b28b$var$EVENT_HIDE$4 = `hide${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1 = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$4 = `hidden${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOW$4 = `show${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_SHOWN$4 = `shown${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_RESIZE$1 = `resize${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DISMISS = `click.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1 = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$4}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2 = `click${$91ca15859685b28b$var$EVENT_KEY$4}${$91ca15859685b28b$var$DATA_API_KEY$2}`;
const $91ca15859685b28b$var$CLASS_NAME_OPEN = 'modal-open';
const $91ca15859685b28b$var$CLASS_NAME_FADE$3 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$4 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_STATIC = 'modal-static';
const $91ca15859685b28b$var$OPEN_SELECTOR$1 = '.modal.show';
const $91ca15859685b28b$var$SELECTOR_DIALOG = '.modal-dialog';
const $91ca15859685b28b$var$SELECTOR_MODAL_BODY = '.modal-body';
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
const $91ca15859685b28b$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $91ca15859685b28b$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$2b77a92f1a5ad772 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._dialog = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new $91ca15859685b28b$var$ScrollBarHelper();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$6;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$6;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$7;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$4, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($91ca15859685b28b$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$4);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        $91ca15859685b28b$var$EventHandler.off(window, $91ca15859685b28b$var$EVENT_KEY$4);
        $91ca15859685b28b$var$EventHandler.off(this._dialog, $91ca15859685b28b$var$EVENT_KEY$4);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new $91ca15859685b28b$var$Backdrop({
            isVisible: Boolean(this._config.backdrop),
            // 'static' option will be translated to true, and booleans will keep their value,
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$4);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$4, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS$1, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY$1) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE$1, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            $91ca15859685b28b$var$EventHandler.one(this._element, $91ca15859685b28b$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($91ca15859685b28b$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$4);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$3);
    }
    _triggerBackdropTransition() {
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED$1);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = $91ca15859685b28b$var$isRTL() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$2, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_SHOW$4, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$4, ()=>{
            if ($91ca15859685b28b$var$isVisible(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $91ca15859685b28b$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$6 = 'offcanvas';
const $91ca15859685b28b$var$DATA_KEY$3 = 'bs.offcanvas';
const $91ca15859685b28b$var$EVENT_KEY$3 = `.${$91ca15859685b28b$var$DATA_KEY$3}`;
const $91ca15859685b28b$var$DATA_API_KEY$1 = '.data-api';
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2 = `load${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$ESCAPE_KEY = 'Escape';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$3 = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING$1 = 'showing';
const $91ca15859685b28b$var$CLASS_NAME_HIDING = 'hiding';
const $91ca15859685b28b$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
const $91ca15859685b28b$var$OPEN_SELECTOR = '.offcanvas.show';
const $91ca15859685b28b$var$EVENT_SHOW$3 = `show${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_SHOWN$3 = `shown${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE$3 = `hide${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDE_PREVENTED = `hidePrevented${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$3 = `hidden${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_RESIZE = `resize${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1 = `click${$91ca15859685b28b$var$EVENT_KEY$3}${$91ca15859685b28b$var$DATA_API_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$91ca15859685b28b$var$EVENT_KEY$3}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
const $91ca15859685b28b$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
const $91ca15859685b28b$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$591ca0244c9dfcd4 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._isShown = false;
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$5;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$5;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$6;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW$3, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._backdrop.show();
        if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().hide();
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
        const completeCallBack = ()=>{
            if (!this._config.scroll || this._config.backdrop) this._focustrap.activate();
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$3);
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING$1);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN$3, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(completeCallBack, this._element, true);
    }
    hide() {
        if (!this._isShown) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE$3);
        if (hideEvent.defaultPrevented) return;
        this._focustrap.deactivate();
        this._element.blur();
        this._isShown = false;
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDING);
        this._backdrop.hide();
        const completeCallback = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$3, $91ca15859685b28b$var$CLASS_NAME_HIDING);
            this._element.removeAttribute('aria-modal');
            this._element.removeAttribute('role');
            if (!this._config.scroll) new $91ca15859685b28b$var$ScrollBarHelper().reset();
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN$3);
        };
        this._queueCallback(completeCallback, this._element, true);
    }
    dispose() {
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    // Private
    _initializeBackDrop() {
        const clickCallback = ()=>{
            if (this._config.backdrop === 'static') {
                $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
                return;
            }
            this.hide();
        };
        // 'static' option will be translated to true, and booleans will keep their value
        const isVisible = Boolean(this._config.backdrop);
        return new $91ca15859685b28b$var$Backdrop({
            className: $91ca15859685b28b$var$CLASS_NAME_BACKDROP,
            isVisible: isVisible,
            isAnimated: true,
            rootElement: this._element.parentNode,
            clickCallback: isVisible ? clickCallback : null
        });
    }
    _initializeFocusTrap() {
        return new $91ca15859685b28b$var$FocusTrap({
            trapElement: this._element
        });
    }
    _addEventListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $91ca15859685b28b$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE_PREVENTED);
        });
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config](this);
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API$1, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$var$EventHandler.one(target, $91ca15859685b28b$var$EVENT_HIDDEN$3, ()=>{
        // focus on trigger when it is closed
        if ($91ca15859685b28b$var$isVisible(this)) this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    const alreadyOpen = $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $91ca15859685b28b$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    const data = $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$2, ()=>{
    for (const selector of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$OPEN_SELECTOR))$91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
});
$91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_RESIZE, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]'))if (getComputedStyle(element).position !== 'fixed') $91ca15859685b28b$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
});
$91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
const $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
const $91ca15859685b28b$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $91ca15859685b28b$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    dd: [],
    div: [],
    dl: [],
    dt: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
const $91ca15859685b28b$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ const $91ca15859685b28b$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
const $91ca15859685b28b$var$allowedAttribute = (attribute, allowedAttributeList)=>{
    const attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($91ca15859685b28b$var$uriAttributes.has(attributeName)) return Boolean($91ca15859685b28b$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter((attributeRegex)=>attributeRegex instanceof RegExp).some((regex)=>regex.test(attributeName));
};
function $91ca15859685b28b$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    const domParser = new window.DOMParser();
    const createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    const elements = [].concat(...createdDocument.body.querySelectorAll('*'));
    for (const element of elements){
        const elementName = element.nodeName.toLowerCase();
        if (!Object.keys(allowList).includes(elementName)) {
            element.remove();
            continue;
        }
        const attributeList = [].concat(...element.attributes);
        const allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
        for (const attribute of attributeList)if (!$91ca15859685b28b$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$5 = 'TemplateFactory';
const $91ca15859685b28b$var$Default$4 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
const $91ca15859685b28b$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
const $91ca15859685b28b$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$var$TemplateFactory extends $91ca15859685b28b$var$Config {
    constructor(config){
        super();
        this._config = this._getConfig(config);
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$4;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$4;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$5;
    }
    // Public
    getContent() {
        return Object.values(this._config.content).map((config)=>this._resolvePossibleFunction(config)).filter(Boolean);
    }
    hasContent() {
        return this.getContent().length > 0;
    }
    changeContent(content) {
        this._checkContent(content);
        this._config.content = {
            ...this._config.content,
            ...content
        };
        return this;
    }
    toHtml() {
        const templateWrapper = document.createElement('div');
        templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
        for (const [selector, text] of Object.entries(this._config.content))this._setContent(templateWrapper, text, selector);
        const template = templateWrapper.children[0];
        const extraClass = this._resolvePossibleFunction(this._config.extraClass);
        if (extraClass) template.classList.add(...extraClass.split(' '));
        return template;
    }
    // Private
    _typeCheckConfig(config) {
        super._typeCheckConfig(config);
        this._checkContent(config.content);
    }
    _checkContent(arg) {
        for (const [selector, content] of Object.entries(arg))super._typeCheckConfig({
            selector: selector,
            entry: content
        }, $91ca15859685b28b$var$DefaultContentType);
    }
    _setContent(template, content, selector) {
        const templateElement = $91ca15859685b28b$var$SelectorEngine.findOne(selector, template);
        if (!templateElement) return;
        content = this._resolvePossibleFunction(content);
        if (!content) {
            templateElement.remove();
            return;
        }
        if ($91ca15859685b28b$var$isElement(content)) {
            this._putElementInTemplate($91ca15859685b28b$var$getElement(content), templateElement);
            return;
        }
        if (this._config.html) {
            templateElement.innerHTML = this._maybeSanitize(content);
            return;
        }
        templateElement.textContent = content;
    }
    _maybeSanitize(arg) {
        return this._config.sanitize ? $91ca15859685b28b$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            undefined,
            this
        ]);
    }
    _putElementInTemplate(element, templateElement) {
        if (this._config.html) {
            templateElement.innerHTML = '';
            templateElement.append(element);
            return;
        }
        templateElement.textContent = element.textContent;
    }
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$4 = 'tooltip';
const $91ca15859685b28b$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
const $91ca15859685b28b$var$CLASS_NAME_FADE$2 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_MODAL = 'modal';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$2 = 'show';
const $91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
const $91ca15859685b28b$var$SELECTOR_MODAL = `.${$91ca15859685b28b$var$CLASS_NAME_MODAL}`;
const $91ca15859685b28b$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
const $91ca15859685b28b$var$TRIGGER_HOVER = 'hover';
const $91ca15859685b28b$var$TRIGGER_FOCUS = 'focus';
const $91ca15859685b28b$var$TRIGGER_CLICK = 'click';
const $91ca15859685b28b$var$TRIGGER_MANUAL = 'manual';
const $91ca15859685b28b$var$EVENT_HIDE$2 = 'hide';
const $91ca15859685b28b$var$EVENT_HIDDEN$2 = 'hidden';
const $91ca15859685b28b$var$EVENT_SHOW$2 = 'show';
const $91ca15859685b28b$var$EVENT_SHOWN$2 = 'shown';
const $91ca15859685b28b$var$EVENT_INSERTED = 'inserted';
const $91ca15859685b28b$var$EVENT_CLICK$1 = 'click';
const $91ca15859685b28b$var$EVENT_FOCUSIN$1 = 'focusin';
const $91ca15859685b28b$var$EVENT_FOCUSOUT$1 = 'focusout';
const $91ca15859685b28b$var$EVENT_MOUSEENTER = 'mouseenter';
const $91ca15859685b28b$var$EVENT_MOUSELEAVE = 'mouseleave';
const $91ca15859685b28b$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $91ca15859685b28b$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $91ca15859685b28b$var$isRTL() ? 'right' : 'left'
};
const $91ca15859685b28b$var$Default$3 = {
    allowList: $91ca15859685b28b$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
const $91ca15859685b28b$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$28c660c63b792dea extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        if (typeof $d37552697cc5ea39$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org/docs/v2/)');
        super(element, config);
        // Private
        this._isEnabled = true;
        this._timeout = 0;
        this._isHovered = null;
        this._activeTrigger = {};
        this._popper = null;
        this._templateFactory = null;
        this._newContent = null;
        // Protected
        this.tip = null;
        this._setListeners();
        if (!this._config.selector) this._fixTitle();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$3;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$3;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$4;
    }
    // Public
    enable() {
        this._isEnabled = true;
    }
    disable() {
        this._isEnabled = false;
    }
    toggleEnabled() {
        this._isEnabled = !this._isEnabled;
    }
    toggle() {
        if (!this._isEnabled) return;
        if (this._isShown()) {
            this._leave();
            return;
        }
        this._enter();
    }
    dispose() {
        clearTimeout(this._timeout);
        $91ca15859685b28b$var$EventHandler.off(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
        if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
        this._disposePopper();
        super.dispose();
    }
    show() {
        if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
        if (!(this._isWithContent() && this._isEnabled)) return;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOW$2));
        const shadowRoot = $91ca15859685b28b$var$findShadowRoot(this._element);
        const isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
        if (showEvent.defaultPrevented || !isInTheDom) return;
        // TODO: v6 remove this or make it optional
        this._disposePopper();
        const tip = this._getTipElement();
        this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
        const { container: container } = this._config;
        if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
            container.append(tip);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_INSERTED));
        }
        this._popper = this._createPopper(tip);
        tip.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we add extra
        // empty mouseover listeners to the body's immediate children;
        // only needed because of broken event delegation on iOS
        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.on(element, 'mouseover', $91ca15859685b28b$var$noop);
        const complete = ()=>{
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_SHOWN$2));
            if (this._isHovered === false) this._leave();
            this._isHovered = false;
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    hide() {
        if (!this._isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDE$2));
        if (hideEvent.defaultPrevented) return;
        const tip = this._getTipElement();
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // If this is a touch-enabled device we remove the extra
        // empty mouseover listeners we added for iOS support
        if ('ontouchstart' in document.documentElement) for (const element of [].concat(...document.body.children))$91ca15859685b28b$var$EventHandler.off(element, 'mouseover', $91ca15859685b28b$var$noop);
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_FOCUS] = false;
        this._activeTrigger[$91ca15859685b28b$var$TRIGGER_HOVER] = false;
        this._isHovered = null; // it is a trick to support manual triggering
        const complete = ()=>{
            if (this._isWithActiveTrigger()) return;
            if (!this._isHovered) this._disposePopper();
            this._element.removeAttribute('aria-describedby');
            $91ca15859685b28b$var$EventHandler.trigger(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_HIDDEN$2));
        };
        this._queueCallback(complete, this.tip, this._isAnimated());
    }
    update() {
        if (this._popper) this._popper.update();
    }
    // Protected
    _isWithContent() {
        return Boolean(this._getTitle());
    }
    _getTipElement() {
        if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
        return this.tip;
    }
    _createTipElement(content) {
        const tip = this._getTemplateFactory(content).toHtml();
        // TODO: remove this check in v6
        if (!tip) return null;
        tip.classList.remove($91ca15859685b28b$var$CLASS_NAME_FADE$2, $91ca15859685b28b$var$CLASS_NAME_SHOW$2);
        // TODO: v6 the following can be achieved with CSS only
        tip.classList.add(`bs-${this.constructor.NAME}-auto`);
        const tipId = $91ca15859685b28b$var$getUID(this.constructor.NAME).toString();
        tip.setAttribute('id', tipId);
        if (this._isAnimated()) tip.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE$2);
        return tip;
    }
    setContent(content) {
        this._newContent = content;
        if (this._isShown()) {
            this._disposePopper();
            this.show();
        }
    }
    _getTemplateFactory(content) {
        if (this._templateFactory) this._templateFactory.changeContent(content);
        else this._templateFactory = new $91ca15859685b28b$var$TemplateFactory({
            ...this._config,
            content: // the `content` var has to be after `this._config`
            // to override config.content in case of popover
            content,
            extraClass: this._resolvePossibleFunction(this._config.customClass)
        });
        return this._templateFactory;
    }
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TOOLTIP_INNER]: this._getTitle()
        };
    }
    _getTitle() {
        return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
    }
    // Private
    _initializeOnDelegatedTarget(event) {
        return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
    _isAnimated() {
        return this._config.animation || this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$2);
    }
    _isShown() {
        return this.tip && this.tip.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW$2);
    }
    _createPopper(tip) {
        const placement = $91ca15859685b28b$var$execute(this._config.placement, [
            this,
            tip,
            this._element
        ]);
        const attachment = $91ca15859685b28b$var$AttachmentMap[placement.toUpperCase()];
        return $d37552697cc5ea39$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
    }
    _getOffset() {
        const { offset: offset } = this._config;
        if (typeof offset === 'string') return offset.split(',').map((value)=>Number.parseInt(value, 10));
        if (typeof offset === 'function') return (popperData)=>offset(popperData, this._element);
        return offset;
    }
    _resolvePossibleFunction(arg) {
        return $91ca15859685b28b$var$execute(arg, [
            this._element,
            this._element
        ]);
    }
    _getPopperConfig(attachment) {
        const defaultBsPopperConfig = {
            placement: attachment,
            modifiers: [
                {
                    name: 'flip',
                    options: {
                        fallbackPlacements: this._config.fallbackPlacements
                    }
                },
                {
                    name: 'offset',
                    options: {
                        offset: this._getOffset()
                    }
                },
                {
                    name: 'preventOverflow',
                    options: {
                        boundary: this._config.boundary
                    }
                },
                {
                    name: 'arrow',
                    options: {
                        element: `.${this.constructor.NAME}-arrow`
                    }
                },
                {
                    name: 'preSetPlacement',
                    enabled: true,
                    phase: 'beforeMain',
                    fn: (data)=>{
                        // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                        // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                        this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                    }
                }
            ]
        };
        return {
            ...defaultBsPopperConfig,
            ...$91ca15859685b28b$var$execute(this._config.popperConfig, [
                undefined,
                defaultBsPopperConfig
            ])
        };
    }
    _setListeners() {
        const triggers = this._config.trigger.split(' ');
        for (const trigger of triggers){
            if (trigger === 'click') $91ca15859685b28b$var$EventHandler.on(this._element, this.constructor.eventName($91ca15859685b28b$var$EVENT_CLICK$1), this._config.selector, (event)=>{
                const context = this._initializeOnDelegatedTarget(event);
                context._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK] = !(context._isShown() && context._activeTrigger[$91ca15859685b28b$var$TRIGGER_CLICK]);
                context.toggle();
            });
            else if (trigger !== $91ca15859685b28b$var$TRIGGER_MANUAL) {
                const eventIn = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSEENTER) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSIN$1);
                const eventOut = trigger === $91ca15859685b28b$var$TRIGGER_HOVER ? this.constructor.eventName($91ca15859685b28b$var$EVENT_MOUSELEAVE) : this.constructor.eventName($91ca15859685b28b$var$EVENT_FOCUSOUT$1);
                $91ca15859685b28b$var$EventHandler.on(this._element, eventIn, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusin' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = true;
                    context._enter();
                });
                $91ca15859685b28b$var$EventHandler.on(this._element, eventOut, this._config.selector, (event)=>{
                    const context = this._initializeOnDelegatedTarget(event);
                    context._activeTrigger[event.type === 'focusout' ? $91ca15859685b28b$var$TRIGGER_FOCUS : $91ca15859685b28b$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                    context._leave();
                });
            }
        }
        this._hideModalHandler = ()=>{
            if (this._element) this.hide();
        };
        $91ca15859685b28b$var$EventHandler.on(this._element.closest($91ca15859685b28b$var$SELECTOR_MODAL), $91ca15859685b28b$var$EVENT_MODAL_HIDE, this._hideModalHandler);
    }
    _fixTitle() {
        const title = this._element.getAttribute('title');
        if (!title) return;
        if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
        this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
        this._element.removeAttribute('title');
    }
    _enter() {
        if (this._isShown() || this._isHovered) {
            this._isHovered = true;
            return;
        }
        this._isHovered = true;
        this._setTimeout(()=>{
            if (this._isHovered) this.show();
        }, this._config.delay.show);
    }
    _leave() {
        if (this._isWithActiveTrigger()) return;
        this._isHovered = false;
        this._setTimeout(()=>{
            if (!this._isHovered) this.hide();
        }, this._config.delay.hide);
    }
    _setTimeout(handler, timeout) {
        clearTimeout(this._timeout);
        this._timeout = setTimeout(handler, timeout);
    }
    _isWithActiveTrigger() {
        return Object.values(this._activeTrigger).includes(true);
    }
    _getConfig(config) {
        const dataAttributes = $91ca15859685b28b$var$Manipulator.getDataAttributes(this._element);
        for (const dataAttribute of Object.keys(dataAttributes))if ($91ca15859685b28b$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
        config = {
            ...dataAttributes,
            ...typeof config === 'object' && config ? config : {}
        };
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        config.container = config.container === false ? document.body : $91ca15859685b28b$var$getElement(config.container);
        if (typeof config.delay === 'number') config.delay = {
            show: config.delay,
            hide: config.delay
        };
        if (typeof config.title === 'number') config.title = config.title.toString();
        if (typeof config.content === 'number') config.content = config.content.toString();
        return config;
    }
    _getDelegateConfig() {
        const config = {};
        for (const [key, value] of Object.entries(this._config))if (this.constructor.Default[key] !== value) config[key] = value;
        config.selector = false;
        config.trigger = 'manual';
        // In the future can be replaced with:
        // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
        // `Object.fromEntries(keysWithDifferentValues)`
        return config;
    }
    _disposePopper() {
        if (this._popper) {
            this._popper.destroy();
            this._popper = null;
        }
        if (this.tip) {
            this.tip.remove();
            this.tip = null;
        }
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$3 = 'popover';
const $91ca15859685b28b$var$SELECTOR_TITLE = '.popover-header';
const $91ca15859685b28b$var$SELECTOR_CONTENT = '.popover-body';
const $91ca15859685b28b$var$Default$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.Default,
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
};
const $91ca15859685b28b$var$DefaultType$2 = {
    ...$91ca15859685b28b$export$28c660c63b792dea.DefaultType,
    content: '(null|string|element|function)'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$5b6b19405a83ff9d extends $91ca15859685b28b$export$28c660c63b792dea {
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$2;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$2;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$3;
    }
    // Overrides
    _isWithContent() {
        return this._getTitle() || this._getContent();
    }
    // Private
    _getContentForTemplate() {
        return {
            [$91ca15859685b28b$var$SELECTOR_TITLE]: this._getTitle(),
            [$91ca15859685b28b$var$SELECTOR_CONTENT]: this._getContent()
        };
    }
    _getContent() {
        return this._resolvePossibleFunction(this._config.content);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$2 = 'scrollspy';
const $91ca15859685b28b$var$DATA_KEY$2 = 'bs.scrollspy';
const $91ca15859685b28b$var$EVENT_KEY$2 = `.${$91ca15859685b28b$var$DATA_KEY$2}`;
const $91ca15859685b28b$var$DATA_API_KEY = '.data-api';
const $91ca15859685b28b$var$EVENT_ACTIVATE = `activate${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_CLICK = `click${$91ca15859685b28b$var$EVENT_KEY$2}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1 = `load${$91ca15859685b28b$var$EVENT_KEY$2}${$91ca15859685b28b$var$DATA_API_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE$1 = 'active';
const $91ca15859685b28b$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
const $91ca15859685b28b$var$SELECTOR_TARGET_LINKS = '[href]';
const $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
const $91ca15859685b28b$var$SELECTOR_NAV_LINKS = '.nav-link';
const $91ca15859685b28b$var$SELECTOR_NAV_ITEMS = '.nav-item';
const $91ca15859685b28b$var$SELECTOR_LIST_ITEMS = '.list-group-item';
const $91ca15859685b28b$var$SELECTOR_LINK_ITEMS = `${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_NAV_ITEMS} > ${$91ca15859685b28b$var$SELECTOR_NAV_LINKS}, ${$91ca15859685b28b$var$SELECTOR_LIST_ITEMS}`;
const $91ca15859685b28b$var$SELECTOR_DROPDOWN = '.dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
const $91ca15859685b28b$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
const $91ca15859685b28b$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$a6472a5298a374be extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        // this._element is the observablesContainer and config.target the menu links wrapper
        this._targetLinks = new Map();
        this._observableSections = new Map();
        this._rootElement = getComputedStyle(this._element).overflowY === 'visible' ? null : this._element;
        this._activeTarget = null;
        this._observer = null;
        this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        this.refresh(); // initialize
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default$1;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType$1;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME$2;
    }
    // Public
    refresh() {
        this._initializeTargetsAndObservables();
        this._maybeEnableSmoothScroll();
        if (this._observer) this._observer.disconnect();
        else this._observer = this._getNewObserver();
        for (const section of this._observableSections.values())this._observer.observe(section);
    }
    dispose() {
        this._observer.disconnect();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
        config.target = $91ca15859685b28b$var$getElement(config.target) || document.body;
        // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
        config.rootMargin = config.offset ? `${config.offset}px 0px -30%` : config.rootMargin;
        if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map((value)=>Number.parseFloat(value));
        return config;
    }
    _maybeEnableSmoothScroll() {
        if (!this._config.smoothScroll) return;
        // unregister any previous listeners
        $91ca15859685b28b$var$EventHandler.off(this._config.target, $91ca15859685b28b$var$EVENT_CLICK);
        $91ca15859685b28b$var$EventHandler.on(this._config.target, $91ca15859685b28b$var$EVENT_CLICK, $91ca15859685b28b$var$SELECTOR_TARGET_LINKS, (event)=>{
            const observableSection = this._observableSections.get(event.target.hash);
            if (observableSection) {
                event.preventDefault();
                const root = this._rootElement || window;
                const height = observableSection.offsetTop - this._element.offsetTop;
                if (root.scrollTo) {
                    root.scrollTo({
                        top: height,
                        behavior: 'smooth'
                    });
                    return;
                }
                // Chrome 60 doesn't support `scrollTo`
                root.scrollTop = height;
            }
        });
    }
    _getNewObserver() {
        const options = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin
        };
        return new IntersectionObserver((entries)=>this._observerCallback(entries), options);
    }
    // The logic of selection
    _observerCallback(entries) {
        const targetElement = (entry)=>this._targetLinks.get(`#${entry.target.id}`);
        const activate = (entry)=>{
            this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
            this._process(targetElement(entry));
        };
        const parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
        const userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
        this._previousScrollData.parentScrollTop = parentScrollTop;
        for (const entry of entries){
            if (!entry.isIntersecting) {
                this._activeTarget = null;
                this._clearActiveClass(targetElement(entry));
                continue;
            }
            const entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            // if we are scrolling down, pick the bigger offsetTop
            if (userScrollsDown && entryIsLowerThanPrevious) {
                activate(entry);
                // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                if (!parentScrollTop) return;
                continue;
            }
            // if we are scrolling up, pick the smallest offsetTop
            if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
        }
    }
    _initializeTargetsAndObservables() {
        this._targetLinks = new Map();
        this._observableSections = new Map();
        const targetLinks = $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_TARGET_LINKS, this._config.target);
        for (const anchor of targetLinks){
            // ensure that the anchor has an id and is not disabled
            if (!anchor.hash || $91ca15859685b28b$var$isDisabled(anchor)) continue;
            const observableSection = $91ca15859685b28b$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
            // ensure that the observableSection exists & is visible
            if ($91ca15859685b28b$var$isVisible(observableSection)) {
                this._targetLinks.set(decodeURI(anchor.hash), anchor);
                this._observableSections.set(anchor.hash, observableSection);
            }
        }
    }
    _process(target) {
        if (this._activeTarget === target) return;
        this._clearActiveClass(this._config.target);
        this._activeTarget = target;
        target.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        this._activateParents(target);
        $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_ACTIVATE, {
            relatedTarget: target
        });
    }
    _activateParents(target) {
        // Activate dropdown parents
        if (target.classList.contains($91ca15859685b28b$var$CLASS_NAME_DROPDOWN_ITEM)) {
            $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($91ca15859685b28b$var$SELECTOR_DROPDOWN)).classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
            return;
        }
        for (const listGroup of $91ca15859685b28b$var$SelectorEngine.parents(target, $91ca15859685b28b$var$SELECTOR_NAV_LIST_GROUP))// Set triggered links parents as active
        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
        for (const item of $91ca15859685b28b$var$SelectorEngine.prev(listGroup, $91ca15859685b28b$var$SELECTOR_LINK_ITEMS))item.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    _clearActiveClass(parent) {
        parent.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
        const activeNodes = $91ca15859685b28b$var$SelectorEngine.find(`${$91ca15859685b28b$var$SELECTOR_TARGET_LINKS}.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE$1}`, parent);
        for (const node of activeNodes)node.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE$1);
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API$1, ()=>{
    for (const spy of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_SPY))$91ca15859685b28b$export$a6472a5298a374be.getOrCreateInstance(spy);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME$1 = 'tab';
const $91ca15859685b28b$var$DATA_KEY$1 = 'bs.tab';
const $91ca15859685b28b$var$EVENT_KEY$1 = `.${$91ca15859685b28b$var$DATA_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDE$1 = `hide${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_HIDDEN$1 = `hidden${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOW$1 = `show${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_SHOWN$1 = `shown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_CLICK_DATA_API = `click${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_KEYDOWN = `keydown${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$EVENT_LOAD_DATA_API = `load${$91ca15859685b28b$var$EVENT_KEY$1}`;
const $91ca15859685b28b$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $91ca15859685b28b$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $91ca15859685b28b$var$ARROW_UP_KEY = 'ArrowUp';
const $91ca15859685b28b$var$ARROW_DOWN_KEY = 'ArrowDown';
const $91ca15859685b28b$var$HOME_KEY = 'Home';
const $91ca15859685b28b$var$END_KEY = 'End';
const $91ca15859685b28b$var$CLASS_NAME_ACTIVE = 'active';
const $91ca15859685b28b$var$CLASS_NAME_FADE$1 = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_SHOW$1 = 'show';
const $91ca15859685b28b$var$CLASS_DROPDOWN = 'dropdown';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
const $91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
const $91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE = `:not(${$91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE})`;
const $91ca15859685b28b$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
const $91ca15859685b28b$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
const $91ca15859685b28b$var$SELECTOR_INNER = `.nav-link${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, .list-group-item${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}, [role="tab"]${$91ca15859685b28b$var$NOT_SELECTOR_DROPDOWN_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
const $91ca15859685b28b$var$SELECTOR_INNER_ELEM = `${$91ca15859685b28b$var$SELECTOR_INNER}, ${$91ca15859685b28b$var$SELECTOR_DATA_TOGGLE}`;
const $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE = `.${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="tab"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="pill"], .${$91ca15859685b28b$var$CLASS_NAME_ACTIVE}[data-bs-toggle="list"]`;
/**
 * Class definition
 */ class $91ca15859685b28b$export$3e41faf802a29e71 extends $91ca15859685b28b$var$BaseComponent {
    constructor(element){
        super(element);
        this._parent = this._element.closest($91ca15859685b28b$var$SELECTOR_TAB_PANEL);
        if (!this._parent) return;
        // Set up initial aria attributes
        this._setInitialAttributes(this._parent, this._getChildren());
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
    }
    // Getters
    static get NAME() {
        return $91ca15859685b28b$var$NAME$1;
    }
    // Public
    show() {
        // Shows this elem and deactivate the active sibling if exists
        const innerElem = this._element;
        if (this._elemIsActive(innerElem)) return;
        // Search for active tab on same parent to deactivate it
        const active = this._getActiveElem();
        const hideEvent = active ? $91ca15859685b28b$var$EventHandler.trigger(active, $91ca15859685b28b$var$EVENT_HIDE$1, {
            relatedTarget: innerElem
        }) : null;
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(innerElem, $91ca15859685b28b$var$EVENT_SHOW$1, {
            relatedTarget: active
        });
        if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
        this._deactivate(active, innerElem);
        this._activate(innerElem, active);
    }
    // Private
    _activate(element, relatedElem) {
        if (!element) return;
        element.classList.add($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        this._activate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.removeAttribute('tabindex');
            element.setAttribute('aria-selected', true);
            this._toggleDropDown(element, true);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_SHOWN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _deactivate(element, relatedElem) {
        if (!element) return;
        element.classList.remove($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        element.blur();
        this._deactivate($91ca15859685b28b$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
        const complete = ()=>{
            if (element.getAttribute('role') !== 'tab') {
                element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW$1);
                return;
            }
            element.setAttribute('aria-selected', false);
            element.setAttribute('tabindex', '-1');
            this._toggleDropDown(element, false);
            $91ca15859685b28b$var$EventHandler.trigger(element, $91ca15859685b28b$var$EVENT_HIDDEN$1, {
                relatedTarget: relatedElem
            });
        };
        this._queueCallback(complete, element, element.classList.contains($91ca15859685b28b$var$CLASS_NAME_FADE$1));
    }
    _keydown(event) {
        if (![
            $91ca15859685b28b$var$ARROW_LEFT_KEY,
            $91ca15859685b28b$var$ARROW_RIGHT_KEY,
            $91ca15859685b28b$var$ARROW_UP_KEY,
            $91ca15859685b28b$var$ARROW_DOWN_KEY,
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) return;
        event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
        event.preventDefault();
        const children = this._getChildren().filter((element)=>!$91ca15859685b28b$var$isDisabled(element));
        let nextActiveElement;
        if ([
            $91ca15859685b28b$var$HOME_KEY,
            $91ca15859685b28b$var$END_KEY
        ].includes(event.key)) nextActiveElement = children[event.key === $91ca15859685b28b$var$HOME_KEY ? 0 : children.length - 1];
        else {
            const isNext = [
                $91ca15859685b28b$var$ARROW_RIGHT_KEY,
                $91ca15859685b28b$var$ARROW_DOWN_KEY
            ].includes(event.key);
            nextActiveElement = $91ca15859685b28b$var$getNextActiveElement(children, event.target, isNext, true);
        }
        if (nextActiveElement) {
            nextActiveElement.focus({
                preventScroll: true
            });
            $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(nextActiveElement).show();
        }
    }
    _getChildren() {
        // collection of inner elements
        return $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_INNER_ELEM, this._parent);
    }
    _getActiveElem() {
        return this._getChildren().find((child)=>this._elemIsActive(child)) || null;
    }
    _setInitialAttributes(parent, children) {
        this._setAttributeIfNotExists(parent, 'role', 'tablist');
        for (const child of children)this._setInitialAttributesOnChild(child);
    }
    _setInitialAttributesOnChild(child) {
        child = this._getInnerElement(child);
        const isActive = this._elemIsActive(child);
        const outerElem = this._getOuterElement(child);
        child.setAttribute('aria-selected', isActive);
        if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
        if (!isActive) child.setAttribute('tabindex', '-1');
        this._setAttributeIfNotExists(child, 'role', 'tab');
        // set attributes to the related panel too
        this._setInitialAttributesOnTargetPanel(child);
    }
    _setInitialAttributesOnTargetPanel(child) {
        const target = $91ca15859685b28b$var$SelectorEngine.getElementFromSelector(child);
        if (!target) return;
        this._setAttributeIfNotExists(target, 'role', 'tabpanel');
        if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', `${child.id}`);
    }
    _toggleDropDown(element, open) {
        const outerElem = this._getOuterElement(element);
        if (!outerElem.classList.contains($91ca15859685b28b$var$CLASS_DROPDOWN)) return;
        const toggle = (selector, className)=>{
            const element = $91ca15859685b28b$var$SelectorEngine.findOne(selector, outerElem);
            if (element) element.classList.toggle(className, open);
        };
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_TOGGLE, $91ca15859685b28b$var$CLASS_NAME_ACTIVE);
        toggle($91ca15859685b28b$var$SELECTOR_DROPDOWN_MENU, $91ca15859685b28b$var$CLASS_NAME_SHOW$1);
        outerElem.setAttribute('aria-expanded', open);
    }
    _setAttributeIfNotExists(element, attribute, value) {
        if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
    }
    _elemIsActive(elem) {
        return elem.classList.contains($91ca15859685b28b$var$CLASS_NAME_ACTIVE);
    }
    // Try to get the inner element (usually the .nav-link)
    _getInnerElement(elem) {
        return elem.matches($91ca15859685b28b$var$SELECTOR_INNER_ELEM) ? elem : $91ca15859685b28b$var$SelectorEngine.findOne($91ca15859685b28b$var$SELECTOR_INNER_ELEM, elem);
    }
    // Try to get the outer element (usually the .nav-item)
    _getOuterElement(elem) {
        return elem.closest($91ca15859685b28b$var$SELECTOR_OUTER) || elem;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this);
            if (typeof config !== 'string') return;
            if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
            data[config]();
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$EventHandler.on(document, $91ca15859685b28b$var$EVENT_CLICK_DATA_API, $91ca15859685b28b$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($91ca15859685b28b$var$isDisabled(this)) return;
    $91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $91ca15859685b28b$var$EventHandler.on(window, $91ca15859685b28b$var$EVENT_LOAD_DATA_API, ()=>{
    for (const element of $91ca15859685b28b$var$SelectorEngine.find($91ca15859685b28b$var$SELECTOR_DATA_TOGGLE_ACTIVE))$91ca15859685b28b$export$3e41faf802a29e71.getOrCreateInstance(element);
});
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $91ca15859685b28b$var$NAME = 'toast';
const $91ca15859685b28b$var$DATA_KEY = 'bs.toast';
const $91ca15859685b28b$var$EVENT_KEY = `.${$91ca15859685b28b$var$DATA_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOVER = `mouseover${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_MOUSEOUT = `mouseout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSIN = `focusin${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_FOCUSOUT = `focusout${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDE = `hide${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_HIDDEN = `hidden${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOW = `show${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$EVENT_SHOWN = `shown${$91ca15859685b28b$var$EVENT_KEY}`;
const $91ca15859685b28b$var$CLASS_NAME_FADE = 'fade';
const $91ca15859685b28b$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
const $91ca15859685b28b$var$CLASS_NAME_SHOW = 'show';
const $91ca15859685b28b$var$CLASS_NAME_SHOWING = 'showing';
const $91ca15859685b28b$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
const $91ca15859685b28b$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ class $91ca15859685b28b$export$8d8dc7d5f743331b extends $91ca15859685b28b$var$BaseComponent {
    constructor(element, config){
        super(element, config);
        this._timeout = null;
        this._hasMouseInteraction = false;
        this._hasKeyboardInteraction = false;
        this._setListeners();
    }
    // Getters
    static get Default() {
        return $91ca15859685b28b$var$Default;
    }
    static get DefaultType() {
        return $91ca15859685b28b$var$DefaultType;
    }
    static get NAME() {
        return $91ca15859685b28b$var$NAME;
    }
    // Public
    show() {
        const showEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOW);
        if (showEvent.defaultPrevented) return;
        this._clearTimeout();
        if (this._config.animation) this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_FADE);
        const complete = ()=>{
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_SHOWN);
            this._maybeScheduleHide();
        };
        this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
        $91ca15859685b28b$var$reflow(this._element);
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOW, $91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    hide() {
        if (!this.isShown()) return;
        const hideEvent = $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        const complete = ()=>{
            this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_HIDE); // @deprecated
            this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOWING, $91ca15859685b28b$var$CLASS_NAME_SHOW);
            $91ca15859685b28b$var$EventHandler.trigger(this._element, $91ca15859685b28b$var$EVENT_HIDDEN);
        };
        this._element.classList.add($91ca15859685b28b$var$CLASS_NAME_SHOWING);
        this._queueCallback(complete, this._element, this._config.animation);
    }
    dispose() {
        this._clearTimeout();
        if (this.isShown()) this._element.classList.remove($91ca15859685b28b$var$CLASS_NAME_SHOW);
        super.dispose();
    }
    isShown() {
        return this._element.classList.contains($91ca15859685b28b$var$CLASS_NAME_SHOW);
    }
    // Private
    _maybeScheduleHide() {
        if (!this._config.autohide) return;
        if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
        this._timeout = setTimeout(()=>{
            this.hide();
        }, this._config.delay);
    }
    _onInteraction(event, isInteracting) {
        switch(event.type){
            case 'mouseover':
            case 'mouseout':
                this._hasMouseInteraction = isInteracting;
                break;
            case 'focusin':
            case 'focusout':
                this._hasKeyboardInteraction = isInteracting;
                break;
        }
        if (isInteracting) {
            this._clearTimeout();
            return;
        }
        const nextElement = event.relatedTarget;
        if (this._element === nextElement || this._element.contains(nextElement)) return;
        this._maybeScheduleHide();
    }
    _setListeners() {
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOVER, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_MOUSEOUT, (event)=>this._onInteraction(event, false));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSIN, (event)=>this._onInteraction(event, true));
        $91ca15859685b28b$var$EventHandler.on(this._element, $91ca15859685b28b$var$EVENT_FOCUSOUT, (event)=>this._onInteraction(event, false));
    }
    _clearTimeout() {
        clearTimeout(this._timeout);
        this._timeout = null;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $91ca15859685b28b$export$8d8dc7d5f743331b.getOrCreateInstance(this, config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config](this);
            }
        });
    }
}
/**
 * Data API implementation
 */ $91ca15859685b28b$var$enableDismissTrigger($91ca15859685b28b$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $91ca15859685b28b$var$defineJQueryPlugin($91ca15859685b28b$export$8d8dc7d5f743331b);



var $8if87 = parcelRequire("8if87");

let $60c4c646f8389328$var$activeAnnotation = null;
function $60c4c646f8389328$var$elementsWithin(root, selector) {
    return [
        ...root.matches?.(selector) ? [
            root
        ] : [],
        ...root.querySelectorAll(selector)
    ];
}
function $60c4c646f8389328$var$closeAnnotation(restoreFocus = false) {
    const trigger = $60c4c646f8389328$var$activeAnnotation;
    if (!trigger) return;
    $91ca15859685b28b$export$5b6b19405a83ff9d.getInstance(trigger)?.hide();
    if (restoreFocus && trigger.isConnected) trigger.focus({
        preventScroll: true
    });
}
function $60c4c646f8389328$var$initBootstrapTriggers(root = document) {
    $60c4c646f8389328$var$elementsWithin(root, '[data-bs-toggle="tooltip"]').forEach((element)=>{
        $91ca15859685b28b$export$28c660c63b792dea.getOrCreateInstance(element);
    });
    $60c4c646f8389328$var$elementsWithin(root, '[data-bs-toggle="popover"]').forEach((element)=>{
        if ($91ca15859685b28b$export$5b6b19405a83ff9d.getInstance(element)) return;
        if (!element.dataset.coaNoteTarget) {
            $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(element);
            return;
        }
        $91ca15859685b28b$export$5b6b19405a83ff9d.getOrCreateInstance(element, {
            container: document.body,
            placement: 'auto',
            trigger: 'click',
            animation: false,
            html: true,
            title: ()=>{
                const title = document.createElement('span');
                title.textContent = element.dataset.coaNoteTitle;
                return title;
            },
            content: ()=>document.getElementById(element.dataset.coaNoteTarget)?.querySelector('[data-coa-note-body]')?.innerHTML || ''
        });
        element.addEventListener('show.bs.popover', ()=>{
            if ($60c4c646f8389328$var$activeAnnotation !== element) $60c4c646f8389328$var$closeAnnotation();
            $60c4c646f8389328$var$activeAnnotation = element;
            element.setAttribute('aria-expanded', 'true');
        });
        element.addEventListener('shown.bs.popover', ()=>{
            const popover = document.getElementById(element.getAttribute('aria-describedby'));
            if (!popover) return;
            popover.setAttribute('role', 'dialog');
            popover.setAttribute('aria-label', element.dataset.coaNoteTitle);
            popover.tabIndex = -1;
            // const close = document.createElement('button');
            // close.type = 'button';
            // close.className = 'btn btn-outline-secondary btn-sm d-block mt-2';
            // close.textContent = 'Close';
            // close.addEventListener('click', () => closeAnnotation(true));
            // popover.querySelector('.popover-body').append(close);
            popover.focus({
                preventScroll: true
            });
        });
        element.addEventListener('hidden.bs.popover', ()=>{
            element.setAttribute('aria-expanded', 'false');
            if ($60c4c646f8389328$var$activeAnnotation === element) $60c4c646f8389328$var$activeAnnotation = null;
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>$60c4c646f8389328$var$initBootstrapTriggers());
document.addEventListener('htmx:load', (event)=>$60c4c646f8389328$var$initBootstrapTriggers(event.detail.elt));
document.addEventListener('htmx:beforeCleanupElement', (event)=>{
    $60c4c646f8389328$var$elementsWithin(event.detail.elt, '[data-bs-toggle="tooltip"], [data-bs-toggle="popover"]').forEach((element)=>{
        if ($60c4c646f8389328$var$activeAnnotation === element) $60c4c646f8389328$var$activeAnnotation = null;
        $91ca15859685b28b$export$5b6b19405a83ff9d.getInstance(element)?.dispose();
        $91ca15859685b28b$export$28c660c63b792dea.getInstance(element)?.dispose();
    });
});
document.addEventListener('click', (event)=>{
    if (!$60c4c646f8389328$var$activeAnnotation) return;
    const popover = document.getElementById($60c4c646f8389328$var$activeAnnotation.getAttribute('aria-describedby'));
    if (!$60c4c646f8389328$var$activeAnnotation.contains(event.target) && !popover?.contains(event.target)) $60c4c646f8389328$var$closeAnnotation();
});
document.addEventListener('keydown', (event)=>{
    if (event.key === 'Escape' && $60c4c646f8389328$var$activeAnnotation) {
        event.preventDefault();
        $60c4c646f8389328$var$closeAnnotation(true);
    }
});



var $iUSsr = parcelRequire("iUSsr");

var $07852d701a7a6680$exports = {};

(function(global1, factory) {
    $07852d701a7a6680$exports = factory((parcelRequire("iUSsr")));
})($07852d701a7a6680$exports, function($) {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function _arrayWithoutHoles(r) {
        if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
    }
    function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
            writable: false
        }), e;
    }
    function _createForOfIteratorHelper(r, e) {
        var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (!t) {
            if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) {
                t && (r = t);
                var n = 0, F = function() {};
                return {
                    s: F,
                    n: function() {
                        return n >= r.length ? {
                            done: true
                        } : {
                            done: false,
                            value: r[n++]
                        };
                    },
                    e: function(r) {
                        throw r;
                    },
                    f: F
                };
            }
            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        var o, a = true, u = false;
        return {
            s: function() {
                t = t.call(r);
            },
            n: function() {
                var r = t.next();
                return a = r.done, r;
            },
            e: function(r) {
                u = true, o = r;
            },
            f: function() {
                try {
                    a || null == t.return || t.return();
                } finally{
                    if (u) throw o;
                }
            }
        };
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[r] = t, e;
    }
    function _iterableToArray(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys$1(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys$1(Object(t), true).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toConsumableArray(r) {
        return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    var es_array_concat = {};
    var globalThis_1;
    var hasRequiredGlobalThis;
    function requireGlobalThis() {
        if (hasRequiredGlobalThis) return globalThis_1;
        hasRequiredGlobalThis = 1;
        var check = function(it) {
            return it && it.Math === Math && it;
        };
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        globalThis_1 = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof globalThis_1 == 'object' && globalThis_1) || // eslint-disable-next-line no-new-func -- fallback
        function() {
            return this;
        }() || Function('return this')();
        return globalThis_1;
    }
    var objectGetOwnPropertyDescriptor = {};
    var fails;
    var hasRequiredFails;
    function requireFails() {
        if (hasRequiredFails) return fails;
        hasRequiredFails = 1;
        fails = function(exec) {
            try {
                return !!exec();
            } catch (error) {
                return true;
            }
        };
        return fails;
    }
    var descriptors;
    var hasRequiredDescriptors;
    function requireDescriptors() {
        if (hasRequiredDescriptors) return descriptors;
        hasRequiredDescriptors = 1;
        var fails = requireFails();
        // Detect IE8's incomplete defineProperty implementation
        descriptors = !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] !== 7;
        });
        return descriptors;
    }
    var functionBindNative;
    var hasRequiredFunctionBindNative;
    function requireFunctionBindNative() {
        if (hasRequiredFunctionBindNative) return functionBindNative;
        hasRequiredFunctionBindNative = 1;
        var fails = requireFails();
        functionBindNative = !fails(function() {
            // eslint-disable-next-line es/no-function-prototype-bind -- safe
            var test = (function() {}).bind();
            // eslint-disable-next-line no-prototype-builtins -- safe
            return typeof test != 'function' || test.hasOwnProperty('prototype');
        });
        return functionBindNative;
    }
    var functionCall;
    var hasRequiredFunctionCall;
    function requireFunctionCall() {
        if (hasRequiredFunctionCall) return functionCall;
        hasRequiredFunctionCall = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var call = Function.prototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        functionCall = NATIVE_BIND ? call.bind(call) : function() {
            return call.apply(call, arguments);
        };
        return functionCall;
    }
    var objectPropertyIsEnumerable = {};
    var hasRequiredObjectPropertyIsEnumerable;
    function requireObjectPropertyIsEnumerable() {
        if (hasRequiredObjectPropertyIsEnumerable) return objectPropertyIsEnumerable;
        hasRequiredObjectPropertyIsEnumerable = 1;
        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
            1: 2
        }, 1);
        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
            var descriptor = getOwnPropertyDescriptor(this, V);
            return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
        return objectPropertyIsEnumerable;
    }
    var createPropertyDescriptor;
    var hasRequiredCreatePropertyDescriptor;
    function requireCreatePropertyDescriptor() {
        if (hasRequiredCreatePropertyDescriptor) return createPropertyDescriptor;
        hasRequiredCreatePropertyDescriptor = 1;
        createPropertyDescriptor = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
        return createPropertyDescriptor;
    }
    var functionUncurryThis;
    var hasRequiredFunctionUncurryThis;
    function requireFunctionUncurryThis() {
        if (hasRequiredFunctionUncurryThis) return functionUncurryThis;
        hasRequiredFunctionUncurryThis = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
        functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
            return function() {
                return call.apply(fn, arguments);
            };
        };
        return functionUncurryThis;
    }
    var classofRaw;
    var hasRequiredClassofRaw;
    function requireClassofRaw() {
        if (hasRequiredClassofRaw) return classofRaw;
        hasRequiredClassofRaw = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis(''.slice);
        classofRaw = function(it) {
            return stringSlice(toString(it), 8, -1);
        };
        return classofRaw;
    }
    var indexedObject;
    var hasRequiredIndexedObject;
    function requireIndexedObject() {
        if (hasRequiredIndexedObject) return indexedObject;
        hasRequiredIndexedObject = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var classof = requireClassofRaw();
        var $Object = Object;
        var split = uncurryThis(''.split);
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        indexedObject = fails(function() {
            // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
            // eslint-disable-next-line no-prototype-builtins -- safe
            return !$Object('z').propertyIsEnumerable(0);
        }) ? function(it) {
            return classof(it) === 'String' ? split(it, '') : $Object(it);
        } : $Object;
        return indexedObject;
    }
    var isNullOrUndefined;
    var hasRequiredIsNullOrUndefined;
    function requireIsNullOrUndefined() {
        if (hasRequiredIsNullOrUndefined) return isNullOrUndefined;
        hasRequiredIsNullOrUndefined = 1;
        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        isNullOrUndefined = function(it) {
            return it === null || it === undefined;
        };
        return isNullOrUndefined;
    }
    var requireObjectCoercible;
    var hasRequiredRequireObjectCoercible;
    function requireRequireObjectCoercible() {
        if (hasRequiredRequireObjectCoercible) return requireObjectCoercible;
        hasRequiredRequireObjectCoercible = 1;
        var isNullOrUndefined = requireIsNullOrUndefined();
        var $TypeError = TypeError;
        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        requireObjectCoercible = function(it) {
            if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
            return it;
        };
        return requireObjectCoercible;
    }
    var toIndexedObject;
    var hasRequiredToIndexedObject;
    function requireToIndexedObject() {
        if (hasRequiredToIndexedObject) return toIndexedObject;
        hasRequiredToIndexedObject = 1;
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = requireIndexedObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        toIndexedObject = function(it) {
            return IndexedObject(requireObjectCoercible(it));
        };
        return toIndexedObject;
    }
    var isCallable;
    var hasRequiredIsCallable;
    function requireIsCallable() {
        if (hasRequiredIsCallable) return isCallable;
        hasRequiredIsCallable = 1;
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        var documentAll = typeof document == 'object' && document.all;
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
            return typeof argument == 'function' || argument === documentAll;
        } : function(argument) {
            return typeof argument == 'function';
        };
        return isCallable;
    }
    var isObject$1;
    var hasRequiredIsObject;
    function requireIsObject() {
        if (hasRequiredIsObject) return isObject$1;
        hasRequiredIsObject = 1;
        var isCallable = requireIsCallable();
        isObject$1 = function(it) {
            return typeof it == 'object' ? it !== null : isCallable(it);
        };
        return isObject$1;
    }
    var getBuiltIn;
    var hasRequiredGetBuiltIn;
    function requireGetBuiltIn() {
        if (hasRequiredGetBuiltIn) return getBuiltIn;
        hasRequiredGetBuiltIn = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var aFunction = function(argument) {
            return isCallable(argument) ? argument : undefined;
        };
        getBuiltIn = function(namespace, method) {
            return arguments.length < 2 ? aFunction(globalThis1[namespace]) : globalThis1[namespace] && globalThis1[namespace][method];
        };
        return getBuiltIn;
    }
    var objectIsPrototypeOf;
    var hasRequiredObjectIsPrototypeOf;
    function requireObjectIsPrototypeOf() {
        if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
        hasRequiredObjectIsPrototypeOf = 1;
        var uncurryThis = requireFunctionUncurryThis();
        objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
        return objectIsPrototypeOf;
    }
    var environmentUserAgent;
    var hasRequiredEnvironmentUserAgent;
    function requireEnvironmentUserAgent() {
        if (hasRequiredEnvironmentUserAgent) return environmentUserAgent;
        hasRequiredEnvironmentUserAgent = 1;
        var globalThis1 = requireGlobalThis();
        var navigator1 = globalThis1.navigator;
        var userAgent = navigator1 && navigator1.userAgent;
        environmentUserAgent = userAgent ? String(userAgent) : '';
        return environmentUserAgent;
    }
    var environmentV8Version;
    var hasRequiredEnvironmentV8Version;
    function requireEnvironmentV8Version() {
        if (hasRequiredEnvironmentV8Version) return environmentV8Version;
        hasRequiredEnvironmentV8Version = 1;
        var globalThis1 = requireGlobalThis();
        var userAgent = requireEnvironmentUserAgent();
        var process = globalThis1.process;
        var Deno = globalThis1.Deno;
        var versions = process && process.versions || Deno && Deno.version;
        var v8 = versions && versions.v8;
        var match, version;
        if (v8) {
            match = v8.split('.');
            // in old Chrome, versions of V8 isn't V8 = Chrome / 10
            // but their correct versions are not interesting for us
            version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }
        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
                match = userAgent.match(/Chrome\/(\d+)/);
                if (match) version = +match[1];
            }
        }
        environmentV8Version = version;
        return environmentV8Version;
    }
    var symbolConstructorDetection;
    var hasRequiredSymbolConstructorDetection;
    function requireSymbolConstructorDetection() {
        if (hasRequiredSymbolConstructorDetection) return symbolConstructorDetection;
        hasRequiredSymbolConstructorDetection = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = requireEnvironmentV8Version();
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        var $String = globalThis1.String;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol('symbol detection');
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
        return symbolConstructorDetection;
    }
    var useSymbolAsUid;
    var hasRequiredUseSymbolAsUid;
    function requireUseSymbolAsUid() {
        if (hasRequiredUseSymbolAsUid) return useSymbolAsUid;
        hasRequiredUseSymbolAsUid = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        useSymbolAsUid = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
        return useSymbolAsUid;
    }
    var isSymbol;
    var hasRequiredIsSymbol;
    function requireIsSymbol() {
        if (hasRequiredIsSymbol) return isSymbol;
        hasRequiredIsSymbol = 1;
        var getBuiltIn = requireGetBuiltIn();
        var isCallable = requireIsCallable();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var $Object = Object;
        isSymbol = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == 'symbol';
        } : function(it) {
            var $Symbol = getBuiltIn('Symbol');
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };
        return isSymbol;
    }
    var tryToString;
    var hasRequiredTryToString;
    function requireTryToString() {
        if (hasRequiredTryToString) return tryToString;
        hasRequiredTryToString = 1;
        var $String = String;
        tryToString = function(argument) {
            try {
                return $String(argument);
            } catch (error) {
                return 'Object';
            }
        };
        return tryToString;
    }
    var aCallable;
    var hasRequiredACallable;
    function requireACallable() {
        if (hasRequiredACallable) return aCallable;
        hasRequiredACallable = 1;
        var isCallable = requireIsCallable();
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        // `Assert: IsCallable(argument) is true`
        aCallable = function(argument) {
            if (isCallable(argument)) return argument;
            throw new $TypeError(tryToString(argument) + ' is not a function');
        };
        return aCallable;
    }
    var getMethod;
    var hasRequiredGetMethod;
    function requireGetMethod() {
        if (hasRequiredGetMethod) return getMethod;
        hasRequiredGetMethod = 1;
        var aCallable = requireACallable();
        var isNullOrUndefined = requireIsNullOrUndefined();
        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        getMethod = function(V, P) {
            var func = V[P];
            return isNullOrUndefined(func) ? undefined : aCallable(func);
        };
        return getMethod;
    }
    var ordinaryToPrimitive;
    var hasRequiredOrdinaryToPrimitive;
    function requireOrdinaryToPrimitive() {
        if (hasRequiredOrdinaryToPrimitive) return ordinaryToPrimitive;
        hasRequiredOrdinaryToPrimitive = 1;
        var call = requireFunctionCall();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var $TypeError = TypeError;
        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        ordinaryToPrimitive = function(input, pref) {
            var fn, val;
            if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
            if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            throw new $TypeError("Can't convert object to primitive value");
        };
        return ordinaryToPrimitive;
    }
    var sharedStore = {
        exports: {}
    };
    var isPure;
    var hasRequiredIsPure;
    function requireIsPure() {
        if (hasRequiredIsPure) return isPure;
        hasRequiredIsPure = 1;
        isPure = false;
        return isPure;
    }
    var defineGlobalProperty;
    var hasRequiredDefineGlobalProperty;
    function requireDefineGlobalProperty() {
        if (hasRequiredDefineGlobalProperty) return defineGlobalProperty;
        hasRequiredDefineGlobalProperty = 1;
        var globalThis1 = requireGlobalThis();
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        defineGlobalProperty = function(key, value) {
            try {
                defineProperty(globalThis1, key, {
                    value: value,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                globalThis1[key] = value;
            }
            return value;
        };
        return defineGlobalProperty;
    }
    var hasRequiredSharedStore;
    function requireSharedStore() {
        if (hasRequiredSharedStore) return sharedStore.exports;
        hasRequiredSharedStore = 1;
        var IS_PURE = requireIsPure();
        var globalThis1 = requireGlobalThis();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var SHARED = '__core-js_shared__';
        var store = sharedStore.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
        (store.versions || (store.versions = [])).push({
            version: '3.49.0',
            mode: IS_PURE ? 'pure' : 'global',
            copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
            license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
            source: 'https://github.com/zloirock/core-js'
        });
        return sharedStore.exports;
    }
    var shared;
    var hasRequiredShared;
    function requireShared() {
        if (hasRequiredShared) return shared;
        hasRequiredShared = 1;
        var store = requireSharedStore();
        shared = function(key, value) {
            return store[key] || (store[key] = value || {});
        };
        return shared;
    }
    var toObject;
    var hasRequiredToObject;
    function requireToObject() {
        if (hasRequiredToObject) return toObject;
        hasRequiredToObject = 1;
        var requireObjectCoercible = requireRequireObjectCoercible();
        var $Object = Object;
        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        toObject = function(argument) {
            return $Object(requireObjectCoercible(argument));
        };
        return toObject;
    }
    var hasOwnProperty_1;
    var hasRequiredHasOwnProperty;
    function requireHasOwnProperty() {
        if (hasRequiredHasOwnProperty) return hasOwnProperty_1;
        hasRequiredHasOwnProperty = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toObject = requireToObject();
        var hasOwnProperty = uncurryThis({}.hasOwnProperty);
        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
        };
        return hasOwnProperty_1;
    }
    var uid;
    var hasRequiredUid;
    function requireUid() {
        if (hasRequiredUid) return uid;
        hasRequiredUid = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.1.toString);
        uid = function(key) {
            return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
        };
        return uid;
    }
    var wellKnownSymbol;
    var hasRequiredWellKnownSymbol;
    function requireWellKnownSymbol() {
        if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
        hasRequiredWellKnownSymbol = 1;
        var globalThis1 = requireGlobalThis();
        var shared = requireShared();
        var hasOwn = requireHasOwnProperty();
        var uid = requireUid();
        var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var Symbol1 = globalThis1.Symbol;
        var WellKnownSymbolsStore = shared('wks');
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1['for'] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
        wellKnownSymbol = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol('Symbol.' + name);
            return WellKnownSymbolsStore[name];
        };
        return wellKnownSymbol;
    }
    var toPrimitive;
    var hasRequiredToPrimitive;
    function requireToPrimitive() {
        if (hasRequiredToPrimitive) return toPrimitive;
        hasRequiredToPrimitive = 1;
        var call = requireFunctionCall();
        var isObject = requireIsObject();
        var isSymbol = requireIsSymbol();
        var getMethod = requireGetMethod();
        var ordinaryToPrimitive = requireOrdinaryToPrimitive();
        var wellKnownSymbol = requireWellKnownSymbol();
        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        toPrimitive = function(input, pref) {
            if (!isObject(input) || isSymbol(input)) return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result;
            if (exoticToPrim) {
                if (pref === undefined) pref = 'default';
                result = call(exoticToPrim, input, pref);
                if (!isObject(result) || isSymbol(result)) return result;
                throw new $TypeError("Can't convert object to primitive value");
            }
            if (pref === undefined) pref = 'number';
            return ordinaryToPrimitive(input, pref);
        };
        return toPrimitive;
    }
    var toPropertyKey;
    var hasRequiredToPropertyKey;
    function requireToPropertyKey() {
        if (hasRequiredToPropertyKey) return toPropertyKey;
        hasRequiredToPropertyKey = 1;
        var toPrimitive = requireToPrimitive();
        var isSymbol = requireIsSymbol();
        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        toPropertyKey = function(argument) {
            var key = toPrimitive(argument, 'string');
            return isSymbol(key) ? key : key + '';
        };
        return toPropertyKey;
    }
    var documentCreateElement;
    var hasRequiredDocumentCreateElement;
    function requireDocumentCreateElement() {
        if (hasRequiredDocumentCreateElement) return documentCreateElement;
        hasRequiredDocumentCreateElement = 1;
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var document1 = globalThis1.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document1) && isObject(document1.createElement);
        documentCreateElement = function(it) {
            return EXISTS ? document1.createElement(it) : {};
        };
        return documentCreateElement;
    }
    var ie8DomDefine;
    var hasRequiredIe8DomDefine;
    function requireIe8DomDefine() {
        if (hasRequiredIe8DomDefine) return ie8DomDefine;
        hasRequiredIe8DomDefine = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        var createElement = requireDocumentCreateElement();
        // Thanks to IE8 for its funny defineProperty
        ie8DomDefine = !DESCRIPTORS && !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(createElement('div'), 'a', {
                get: function() {
                    return 7;
                }
            }).a !== 7;
        });
        return ie8DomDefine;
    }
    var hasRequiredObjectGetOwnPropertyDescriptor;
    function requireObjectGetOwnPropertyDescriptor() {
        if (hasRequiredObjectGetOwnPropertyDescriptor) return objectGetOwnPropertyDescriptor;
        hasRequiredObjectGetOwnPropertyDescriptor = 1;
        var DESCRIPTORS = requireDescriptors();
        var call = requireFunctionCall();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        var toIndexedObject = requireToIndexedObject();
        var toPropertyKey = requireToPropertyKey();
        var hasOwn = requireHasOwnProperty();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
            O = toIndexedObject(O);
            P = toPropertyKey(P);
            if (IE8_DOM_DEFINE) try {
                return $getOwnPropertyDescriptor(O, P);
            } catch (error) {}
            if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
        return objectGetOwnPropertyDescriptor;
    }
    var objectDefineProperty = {};
    var v8PrototypeDefineBug;
    var hasRequiredV8PrototypeDefineBug;
    function requireV8PrototypeDefineBug() {
        if (hasRequiredV8PrototypeDefineBug) return v8PrototypeDefineBug;
        hasRequiredV8PrototypeDefineBug = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        v8PrototypeDefineBug = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(function() {}, 'prototype', {
                value: 42,
                writable: false
            }).prototype !== 42;
        });
        return v8PrototypeDefineBug;
    }
    var anObject;
    var hasRequiredAnObject;
    function requireAnObject() {
        if (hasRequiredAnObject) return anObject;
        hasRequiredAnObject = 1;
        var isObject = requireIsObject();
        var $String = String;
        var $TypeError = TypeError;
        // `Assert: Type(argument) is Object`
        anObject = function(argument) {
            if (isObject(argument)) return argument;
            throw new $TypeError($String(argument) + ' is not an object');
        };
        return anObject;
    }
    var hasRequiredObjectDefineProperty;
    function requireObjectDefineProperty() {
        if (hasRequiredObjectDefineProperty) return objectDefineProperty;
        hasRequiredObjectDefineProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var anObject = requireAnObject();
        var toPropertyKey = requireToPropertyKey();
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = 'enumerable';
        var CONFIGURABLE = 'configurable';
        var WRITABLE = 'writable';
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        objectDefineProperty.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                var current = $getOwnPropertyDescriptor(O, P);
                if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                        writable: false
                    };
                }
            }
            return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return $defineProperty(O, P, Attributes);
            } catch (error) {}
            if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
        };
        return objectDefineProperty;
    }
    var createNonEnumerableProperty;
    var hasRequiredCreateNonEnumerableProperty;
    function requireCreateNonEnumerableProperty() {
        if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
        hasRequiredCreateNonEnumerableProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createNonEnumerableProperty = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
        return createNonEnumerableProperty;
    }
    var makeBuiltIn = {
        exports: {}
    };
    var functionName;
    var hasRequiredFunctionName;
    function requireFunctionName() {
        if (hasRequiredFunctionName) return functionName;
        hasRequiredFunctionName = 1;
        var DESCRIPTORS = requireDescriptors();
        var hasOwn = requireHasOwnProperty();
        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
        var EXISTS = hasOwn(FunctionPrototype, 'name');
        // additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() {}).name === 'something';
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
        functionName = {
            EXISTS: EXISTS,
            PROPER: PROPER,
            CONFIGURABLE: CONFIGURABLE
        };
        return functionName;
    }
    var inspectSource;
    var hasRequiredInspectSource;
    function requireInspectSource() {
        if (hasRequiredInspectSource) return inspectSource;
        hasRequiredInspectSource = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var isCallable = requireIsCallable();
        var store = requireSharedStore();
        var functionToString = uncurryThis(Function.toString);
        // this helper broken in `core-js [at] 3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
            return functionToString(it);
        };
        inspectSource = store.inspectSource;
        return inspectSource;
    }
    var weakMapBasicDetection;
    var hasRequiredWeakMapBasicDetection;
    function requireWeakMapBasicDetection() {
        if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
        hasRequiredWeakMapBasicDetection = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var WeakMap = globalThis1.WeakMap;
        weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
        return weakMapBasicDetection;
    }
    var sharedKey;
    var hasRequiredSharedKey;
    function requireSharedKey() {
        if (hasRequiredSharedKey) return sharedKey;
        hasRequiredSharedKey = 1;
        var shared = requireShared();
        var uid = requireUid();
        var keys = shared('keys');
        sharedKey = function(key) {
            return keys[key] || (keys[key] = uid(key));
        };
        return sharedKey;
    }
    var hiddenKeys;
    var hasRequiredHiddenKeys;
    function requireHiddenKeys() {
        if (hasRequiredHiddenKeys) return hiddenKeys;
        hasRequiredHiddenKeys = 1;
        hiddenKeys = {};
        return hiddenKeys;
    }
    var internalState;
    var hasRequiredInternalState;
    function requireInternalState() {
        if (hasRequiredInternalState) return internalState;
        hasRequiredInternalState = 1;
        var NATIVE_WEAK_MAP = requireWeakMapBasicDetection();
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var hasOwn = requireHasOwnProperty();
        var shared = requireSharedStore();
        var sharedKey = requireSharedKey();
        var hiddenKeys = requireHiddenKeys();
        var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
        var TypeError1 = globalThis1.TypeError;
        var WeakMap = globalThis1.WeakMap;
        var set, get, has;
        var enforce = function(it) {
            return has(it) ? get(it) : set(it, {});
        };
        var getterFor = function(TYPE) {
            return function(it) {
                var state;
                if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1('Incompatible receiver, ' + TYPE + ' required');
                return state;
            };
        };
        if (NATIVE_WEAK_MAP || shared.state) {
            var store = shared.state || (shared.state = new WeakMap());
            /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
            store.has = store.has;
            store.set = store.set;
            /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                store.set(it, metadata);
                return metadata;
            };
            get = function(it) {
                return store.get(it) || {};
            };
            has = function(it) {
                return store.has(it);
            };
        } else {
            var STATE = sharedKey('state');
            hiddenKeys[STATE] = true;
            set = function(it, metadata) {
                if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                createNonEnumerableProperty(it, STATE, metadata);
                return metadata;
            };
            get = function(it) {
                return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
                return hasOwn(it, STATE);
            };
        }
        internalState = {
            set: set,
            get: get,
            has: has,
            enforce: enforce,
            getterFor: getterFor
        };
        return internalState;
    }
    var hasRequiredMakeBuiltIn;
    function requireMakeBuiltIn() {
        if (hasRequiredMakeBuiltIn) return makeBuiltIn.exports;
        hasRequiredMakeBuiltIn = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var hasOwn = requireHasOwnProperty();
        var DESCRIPTORS = requireDescriptors();
        var CONFIGURABLE_FUNCTION_NAME = requireFunctionName().CONFIGURABLE;
        var inspectSource = requireInspectSource();
        var InternalStateModule = requireInternalState();
        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis(''.slice);
        var replace = uncurryThis(''.replace);
        var join = uncurryThis([].join);
        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
            return defineProperty(function() {}, 'length', {
                value: 8
            }).length !== 8;
        });
        var TEMPLATE = String(String).split('String');
        var makeBuiltIn$1 = makeBuiltIn.exports = function(value, name, options) {
            if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
            if (options && options.getter) name = 'get ' + name;
            if (options && options.setter) name = 'set ' + name;
            if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                if (DESCRIPTORS) defineProperty(value, 'name', {
                    value: name,
                    configurable: true
                });
                else value.name = name;
            }
            if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
                value: options.arity
            });
            try {
                if (options && hasOwn(options, 'constructor') && options.constructor) {
                    if (DESCRIPTORS) defineProperty(value, 'prototype', {
                        writable: false
                    });
                } else if (value.prototype) value.prototype = undefined;
            } catch (error) {}
            var state = enforceInternalState(value);
            if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
            return value;
        };
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn$1(function toString() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, 'toString');
        return makeBuiltIn.exports;
    }
    var defineBuiltIn;
    var hasRequiredDefineBuiltIn;
    function requireDefineBuiltIn() {
        if (hasRequiredDefineBuiltIn) return defineBuiltIn;
        hasRequiredDefineBuiltIn = 1;
        var isCallable = requireIsCallable();
        var definePropertyModule = requireObjectDefineProperty();
        var makeBuiltIn = requireMakeBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        defineBuiltIn = function(O, key, value, options) {
            if (!options) options = {};
            var simple = options.enumerable;
            var name = options.name !== undefined ? options.name : key;
            if (isCallable(value)) makeBuiltIn(value, name, options);
            if (options.global) {
                if (simple) O[key] = value;
                else defineGlobalProperty(key, value);
            } else {
                try {
                    if (!options.unsafe) delete O[key];
                    else if (O[key]) simple = true;
                } catch (error) {}
                if (simple) O[key] = value;
                else definePropertyModule.f(O, key, {
                    value: value,
                    enumerable: false,
                    configurable: !options.nonConfigurable,
                    writable: !options.nonWritable
                });
            }
            return O;
        };
        return defineBuiltIn;
    }
    var objectGetOwnPropertyNames = {};
    var mathTrunc;
    var hasRequiredMathTrunc;
    function requireMathTrunc() {
        if (hasRequiredMathTrunc) return mathTrunc;
        hasRequiredMathTrunc = 1;
        var ceil = Math.ceil;
        var floor = Math.floor;
        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        mathTrunc = Math.trunc || function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
        };
        return mathTrunc;
    }
    var toIntegerOrInfinity;
    var hasRequiredToIntegerOrInfinity;
    function requireToIntegerOrInfinity() {
        if (hasRequiredToIntegerOrInfinity) return toIntegerOrInfinity;
        hasRequiredToIntegerOrInfinity = 1;
        var trunc = requireMathTrunc();
        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        toIntegerOrInfinity = function(argument) {
            var number = +argument;
            // eslint-disable-next-line no-self-compare -- NaN check
            return number !== number || number === 0 ? 0 : trunc(number);
        };
        return toIntegerOrInfinity;
    }
    var toAbsoluteIndex;
    var hasRequiredToAbsoluteIndex;
    function requireToAbsoluteIndex() {
        if (hasRequiredToAbsoluteIndex) return toAbsoluteIndex;
        hasRequiredToAbsoluteIndex = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var max = Math.max;
        var min = Math.min;
        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        toAbsoluteIndex = function(index, length) {
            var integer = toIntegerOrInfinity(index);
            return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
        return toAbsoluteIndex;
    }
    var toLength;
    var hasRequiredToLength;
    function requireToLength() {
        if (hasRequiredToLength) return toLength;
        hasRequiredToLength = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var min = Math.min;
        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        toLength = function(argument) {
            var len = toIntegerOrInfinity(argument);
            return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
        return toLength;
    }
    var lengthOfArrayLike;
    var hasRequiredLengthOfArrayLike;
    function requireLengthOfArrayLike() {
        if (hasRequiredLengthOfArrayLike) return lengthOfArrayLike;
        hasRequiredLengthOfArrayLike = 1;
        var toLength = requireToLength();
        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        lengthOfArrayLike = function(obj) {
            return toLength(obj.length);
        };
        return lengthOfArrayLike;
    }
    var arrayIncludes;
    var hasRequiredArrayIncludes;
    function requireArrayIncludes() {
        if (hasRequiredArrayIncludes) return arrayIncludes;
        hasRequiredArrayIncludes = 1;
        var toIndexedObject = requireToIndexedObject();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIndexedObject($this);
                var length = lengthOfArrayLike(O);
                if (length === 0) return !IS_INCLUDES && -1;
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare -- NaN check
                if (IS_INCLUDES && el !== el) while(length > index){
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
                }
                else for(; length > index; index++){
                    if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
        arrayIncludes = {
            // `Array.prototype.includes` method
            // https://tc39.es/ecma262/#sec-array.prototype.includes
            includes: createMethod(true),
            // `Array.prototype.indexOf` method
            // https://tc39.es/ecma262/#sec-array.prototype.indexof
            indexOf: createMethod(false)
        };
        return arrayIncludes;
    }
    var objectKeysInternal;
    var hasRequiredObjectKeysInternal;
    function requireObjectKeysInternal() {
        if (hasRequiredObjectKeysInternal) return objectKeysInternal;
        hasRequiredObjectKeysInternal = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var hasOwn = requireHasOwnProperty();
        var toIndexedObject = requireToIndexedObject();
        var indexOf = requireArrayIncludes().indexOf;
        var hiddenKeys = requireHiddenKeys();
        var push = uncurryThis([].push);
        objectKeysInternal = function(object, names) {
            var O = toIndexedObject(object);
            var i = 0;
            var result = [];
            var key;
            for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
            // Don't enum bug & hidden keys
            while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
            return result;
        };
        return objectKeysInternal;
    }
    var enumBugKeys;
    var hasRequiredEnumBugKeys;
    function requireEnumBugKeys() {
        if (hasRequiredEnumBugKeys) return enumBugKeys;
        hasRequiredEnumBugKeys = 1;
        // IE8- don't enum bug keys
        enumBugKeys = [
            'constructor',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'toLocaleString',
            'toString',
            'valueOf'
        ];
        return enumBugKeys;
    }
    var hasRequiredObjectGetOwnPropertyNames;
    function requireObjectGetOwnPropertyNames() {
        if (hasRequiredObjectGetOwnPropertyNames) return objectGetOwnPropertyNames;
        hasRequiredObjectGetOwnPropertyNames = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = enumBugKeys.concat('length', 'prototype');
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
        };
        return objectGetOwnPropertyNames;
    }
    var objectGetOwnPropertySymbols = {};
    var hasRequiredObjectGetOwnPropertySymbols;
    function requireObjectGetOwnPropertySymbols() {
        if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
        hasRequiredObjectGetOwnPropertySymbols = 1;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
        return objectGetOwnPropertySymbols;
    }
    var ownKeys;
    var hasRequiredOwnKeys;
    function requireOwnKeys() {
        if (hasRequiredOwnKeys) return ownKeys;
        hasRequiredOwnKeys = 1;
        var getBuiltIn = requireGetBuiltIn();
        var uncurryThis = requireFunctionUncurryThis();
        var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var anObject = requireAnObject();
        var concat = uncurryThis([].concat);
        // all object keys, includes non-enumerable and symbols
        ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
        return ownKeys;
    }
    var copyConstructorProperties;
    var hasRequiredCopyConstructorProperties;
    function requireCopyConstructorProperties() {
        if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
        hasRequiredCopyConstructorProperties = 1;
        var hasOwn = requireHasOwnProperty();
        var ownKeys = requireOwnKeys();
        var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
        var definePropertyModule = requireObjectDefineProperty();
        copyConstructorProperties = function(target, source, exceptions) {
            var keys = ownKeys(source);
            var defineProperty = definePropertyModule.f;
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        };
        return copyConstructorProperties;
    }
    var isForced_1;
    var hasRequiredIsForced;
    function requireIsForced() {
        if (hasRequiredIsForced) return isForced_1;
        hasRequiredIsForced = 1;
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var replacement = /#|\.prototype\./;
        var isForced = function(feature, detection) {
            var value = data[normalize(feature)];
            return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
        };
        var normalize = isForced.normalize = function(string) {
            return String(string).replace(replacement, '.').toLowerCase();
        };
        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';
        isForced_1 = isForced;
        return isForced_1;
    }
    var _export;
    var hasRequired_export;
    function require_export() {
        if (hasRequired_export) return _export;
        hasRequired_export = 1;
        var globalThis1 = requireGlobalThis();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var defineBuiltIn = requireDefineBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var copyConstructorProperties = requireCopyConstructorProperties();
        var isForced = requireIsForced();
        /*
  	  options.target         - name of the target object
  	  options.global         - target is the global object
  	  options.stat           - export as static methods of target
  	  options.proto          - export as prototype methods of target
  	  options.real           - real prototype method for the `pure` version
  	  options.forced         - export even if the native feature is available
  	  options.bind           - bind methods to the target, required for the `pure` version
  	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  	  options.sham           - add a flag to not completely full polyfills
  	  options.enumerable     - export as enumerable property
  	  options.dontCallGetSet - prevent calling a getter on target
  	  options.name           - the .name of the function if it does not match the key
  	*/ _export = function(options, source) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) target = globalThis1;
            else if (STATIC) target = globalThis1[TARGET] || defineGlobalProperty(TARGET, {});
            else target = globalThis1[TARGET] && globalThis1[TARGET].prototype;
            if (target) for(key in source){
                sourceProperty = source[key];
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(target, key);
                    targetProperty = descriptor && descriptor.value;
                } else targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                // contained in target
                if (!FORCED && targetProperty !== undefined) {
                    if (typeof sourceProperty == typeof targetProperty) continue;
                    copyConstructorProperties(sourceProperty, targetProperty);
                }
                // add a flag to not completely full polyfills
                if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                defineBuiltIn(target, key, sourceProperty, options);
            }
        };
        return _export;
    }
    var isArray;
    var hasRequiredIsArray;
    function requireIsArray() {
        if (hasRequiredIsArray) return isArray;
        hasRequiredIsArray = 1;
        var classof = requireClassofRaw();
        // `IsArray` abstract operation
        // https://tc39.es/ecma262/#sec-isarray
        // eslint-disable-next-line es/no-array-isarray -- safe
        isArray = Array.isArray || function isArray(argument) {
            return classof(argument) === 'Array';
        };
        return isArray;
    }
    var doesNotExceedSafeInteger;
    var hasRequiredDoesNotExceedSafeInteger;
    function requireDoesNotExceedSafeInteger() {
        if (hasRequiredDoesNotExceedSafeInteger) return doesNotExceedSafeInteger;
        hasRequiredDoesNotExceedSafeInteger = 1;
        var $TypeError = TypeError;
        var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
        doesNotExceedSafeInteger = function(it) {
            if (it > MAX_SAFE_INTEGER) throw new $TypeError('Maximum allowed index exceeded');
            return it;
        };
        return doesNotExceedSafeInteger;
    }
    var createProperty;
    var hasRequiredCreateProperty;
    function requireCreateProperty() {
        if (hasRequiredCreateProperty) return createProperty;
        hasRequiredCreateProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createProperty = function(object, key, value) {
            if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
            else object[key] = value;
        };
        return createProperty;
    }
    var arraySetLength;
    var hasRequiredArraySetLength;
    function requireArraySetLength() {
        if (hasRequiredArraySetLength) return arraySetLength;
        hasRequiredArraySetLength = 1;
        var DESCRIPTORS = requireDescriptors();
        var isArray = requireIsArray();
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Safari < 13 does not throw an error in this case
        var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function() {
            // makes no sense without proper strict mode support
            if (this !== undefined) return true;
            try {
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                Object.defineProperty([], 'length', {
                    writable: false
                }).length = 1;
            } catch (error) {
                return error instanceof TypeError;
            }
        }();
        arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
            if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) throw new $TypeError('Cannot set read only .length');
            return O.length = length;
        } : function(O, length) {
            return O.length = length;
        };
        return arraySetLength;
    }
    var toStringTagSupport;
    var hasRequiredToStringTagSupport;
    function requireToStringTagSupport() {
        if (hasRequiredToStringTagSupport) return toStringTagSupport;
        hasRequiredToStringTagSupport = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var test = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        test[TO_STRING_TAG] = 'z';
        toStringTagSupport = String(test) === '[object z]';
        return toStringTagSupport;
    }
    var classof;
    var hasRequiredClassof;
    function requireClassof() {
        if (hasRequiredClassof) return classof;
        hasRequiredClassof = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var isCallable = requireIsCallable();
        var classofRaw = requireClassofRaw();
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var $Object = Object;
        // ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
        }()) === 'Arguments';
        // fallback for IE11 Script Access Denied error
        var tryGet = function(it, key) {
            try {
                return it[key];
            } catch (error) {}
        };
        // getting tag from ES6+ `Object.prototype.toString`
        classof = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result;
            return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
        };
        return classof;
    }
    var isConstructor;
    var hasRequiredIsConstructor;
    function requireIsConstructor() {
        if (hasRequiredIsConstructor) return isConstructor;
        hasRequiredIsConstructor = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var classof = requireClassof();
        var getBuiltIn = requireGetBuiltIn();
        var inspectSource = requireInspectSource();
        var noop = function() {};
        var construct = getBuiltIn('Reflect', 'construct');
        var constructorRegExp = /^\s*(?:class|function)\b/;
        var exec = uncurryThis(constructorRegExp.exec);
        var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
        var isConstructorModern = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            try {
                construct(noop, [], argument);
                return true;
            } catch (error) {
                return false;
            }
        };
        var isConstructorLegacy = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            switch(classof(argument)){
                case 'AsyncFunction':
                case 'GeneratorFunction':
                case 'AsyncGeneratorFunction':
                    return false;
            }
            try {
                // we can't check .prototype since constructors produced by .bind haven't it
                // `Function#toString` throws on some built-it function in some legacy engines
                // (for example, `DOMQuad` and similar in FF41-)
                return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
            } catch (error) {
                return true;
            }
        };
        isConstructorLegacy.sham = true;
        // `IsConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-isconstructor
        isConstructor = !construct || fails(function() {
            var called;
            return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                called = true;
            }) || called;
        }) ? isConstructorLegacy : isConstructorModern;
        return isConstructor;
    }
    var arraySpeciesConstructor;
    var hasRequiredArraySpeciesConstructor;
    function requireArraySpeciesConstructor() {
        if (hasRequiredArraySpeciesConstructor) return arraySpeciesConstructor;
        hasRequiredArraySpeciesConstructor = 1;
        var isArray = requireIsArray();
        var isConstructor = requireIsConstructor();
        var isObject = requireIsObject();
        var wellKnownSymbol = requireWellKnownSymbol();
        var SPECIES = wellKnownSymbol('species');
        var $Array = Array;
        // a part of `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesConstructor = function(originalArray) {
            var C;
            if (isArray(originalArray)) {
                C = originalArray.constructor;
                // cross-realm fallback
                if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
                else if (isObject(C)) {
                    C = C[SPECIES];
                    if (C === null) C = undefined;
                }
            }
            return C === undefined ? $Array : C;
        };
        return arraySpeciesConstructor;
    }
    var arraySpeciesCreate;
    var hasRequiredArraySpeciesCreate;
    function requireArraySpeciesCreate() {
        if (hasRequiredArraySpeciesCreate) return arraySpeciesCreate;
        hasRequiredArraySpeciesCreate = 1;
        var arraySpeciesConstructor = requireArraySpeciesConstructor();
        // `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesCreate = function(originalArray, length) {
            return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
        };
        return arraySpeciesCreate;
    }
    var arrayMethodHasSpeciesSupport;
    var hasRequiredArrayMethodHasSpeciesSupport;
    function requireArrayMethodHasSpeciesSupport() {
        if (hasRequiredArrayMethodHasSpeciesSupport) return arrayMethodHasSpeciesSupport;
        hasRequiredArrayMethodHasSpeciesSupport = 1;
        var fails = requireFails();
        var wellKnownSymbol = requireWellKnownSymbol();
        var V8_VERSION = requireEnvironmentV8Version();
        var SPECIES = wellKnownSymbol('species');
        arrayMethodHasSpeciesSupport = function(METHOD_NAME) {
            // We can't use this feature detection in V8 since it causes
            // deoptimization and serious performance degradation
            // https://github.com/zloirock/core-js/issues/677
            return V8_VERSION >= 51 || !fails(function() {
                var array = [];
                var constructor = array.constructor = {};
                constructor[SPECIES] = function() {
                    return {
                        foo: 1
                    };
                };
                return array[METHOD_NAME](Boolean).foo !== 1;
            });
        };
        return arrayMethodHasSpeciesSupport;
    }
    var hasRequiredEs_array_concat;
    function requireEs_array_concat() {
        if (hasRequiredEs_array_concat) return es_array_concat;
        hasRequiredEs_array_concat = 1;
        var $ = require_export();
        var fails = requireFails();
        var isArray = requireIsArray();
        var isObject = requireIsObject();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var doesNotExceedSafeInteger = requireDoesNotExceedSafeInteger();
        var createProperty = requireCreateProperty();
        var setArrayLength = requireArraySetLength();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var wellKnownSymbol = requireWellKnownSymbol();
        var V8_VERSION = requireEnvironmentV8Version();
        var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/679
        var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
            var array = [];
            array[IS_CONCAT_SPREADABLE] = false;
            return array.concat()[0] !== array;
        });
        var isConcatSpreadable = function(O) {
            if (!isObject(O)) return false;
            var spreadable = O[IS_CONCAT_SPREADABLE];
            return spreadable !== undefined ? !!spreadable : isArray(O);
        };
        var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
        // `Array.prototype.concat` method
        // https://tc39.es/ecma262/#sec-array.prototype.concat
        // with adding support of @@isConcatSpreadable and @@species
        $({
            target: 'Array',
            proto: true,
            arity: 1,
            forced: FORCED
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            concat: function concat(arg) {
                var O = toObject(this);
                var A = arraySpeciesCreate(O, 0);
                var n = 0;
                var i, k, length, len, E;
                for(i = -1, length = arguments.length; i < length; i++){
                    E = i === -1 ? O : arguments[i];
                    if (isConcatSpreadable(E)) {
                        len = lengthOfArrayLike(E);
                        doesNotExceedSafeInteger(n + len);
                        for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                    } else {
                        doesNotExceedSafeInteger(n + 1);
                        createProperty(A, n++, E);
                    }
                }
                setArrayLength(A, n);
                return A;
            }
        });
        return es_array_concat;
    }
    requireEs_array_concat();
    var es_array_includes = {};
    var objectDefineProperties = {};
    var objectKeys;
    var hasRequiredObjectKeys;
    function requireObjectKeys() {
        if (hasRequiredObjectKeys) return objectKeys;
        hasRequiredObjectKeys = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        objectKeys = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
        };
        return objectKeys;
    }
    var hasRequiredObjectDefineProperties;
    function requireObjectDefineProperties() {
        if (hasRequiredObjectDefineProperties) return objectDefineProperties;
        hasRequiredObjectDefineProperties = 1;
        var DESCRIPTORS = requireDescriptors();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var definePropertyModule = requireObjectDefineProperty();
        var anObject = requireAnObject();
        var toIndexedObject = requireToIndexedObject();
        var objectKeys = requireObjectKeys();
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        // eslint-disable-next-line es/no-object-defineproperties -- safe
        objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
            anObject(O);
            var props = toIndexedObject(Properties);
            var keys = objectKeys(Properties);
            var length = keys.length;
            var index = 0;
            var key;
            while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
            return O;
        };
        return objectDefineProperties;
    }
    var html;
    var hasRequiredHtml;
    function requireHtml() {
        if (hasRequiredHtml) return html;
        hasRequiredHtml = 1;
        var getBuiltIn = requireGetBuiltIn();
        html = getBuiltIn('document', 'documentElement');
        return html;
    }
    var objectCreate;
    var hasRequiredObjectCreate;
    function requireObjectCreate() {
        if (hasRequiredObjectCreate) return objectCreate;
        hasRequiredObjectCreate = 1;
        /* global ActiveXObject -- old IE, WSH */ var anObject = requireAnObject();
        var definePropertiesModule = requireObjectDefineProperties();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = requireHiddenKeys();
        var html = requireHtml();
        var documentCreateElement = requireDocumentCreateElement();
        var sharedKey = requireSharedKey();
        var GT = '>';
        var LT = '<';
        var PROTOTYPE = 'prototype';
        var SCRIPT = 'script';
        var IE_PROTO = sharedKey('IE_PROTO');
        var EmptyConstructor = function() {};
        var scriptTag = function(content) {
            return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
        };
        // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
        var NullProtoObjectViaActiveX = function(activeXDocument) {
            activeXDocument.write(scriptTag(''));
            activeXDocument.close();
            var temp = activeXDocument.parentWindow.Object;
            // eslint-disable-next-line no-useless-assignment -- avoid memory leak
            activeXDocument = null;
            return temp;
        };
        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var NullProtoObjectViaIFrame = function() {
            // Thrash, waste and sodomy: IE GC bug
            var iframe = documentCreateElement('iframe');
            var JS = 'java' + SCRIPT + ':';
            var iframeDocument;
            iframe.style.display = 'none';
            html.appendChild(iframe);
            // https://github.com/zloirock/core-js/issues/475
            iframe.src = String(JS);
            iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(scriptTag('document.F=Object'));
            iframeDocument.close();
            return iframeDocument.F;
        };
        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug
        var activeXDocument;
        var NullProtoObject = function() {
            try {
                activeXDocument = new ActiveXObject('htmlfile');
            } catch (error) {}
            NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
             : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
            var length = enumBugKeys.length;
            while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
            return NullProtoObject();
        };
        hiddenKeys[IE_PROTO] = true;
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        // eslint-disable-next-line es/no-object-create -- safe
        objectCreate = Object.create || function create(O, Properties) {
            var result;
            if (O !== null) {
                EmptyConstructor[PROTOTYPE] = anObject(O);
                result = new EmptyConstructor();
                EmptyConstructor[PROTOTYPE] = null;
                // add "__proto__" for Object.getPrototypeOf polyfill
                result[IE_PROTO] = O;
            } else result = NullProtoObject();
            return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
        };
        return objectCreate;
    }
    var addToUnscopables;
    var hasRequiredAddToUnscopables;
    function requireAddToUnscopables() {
        if (hasRequiredAddToUnscopables) return addToUnscopables;
        hasRequiredAddToUnscopables = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var create = requireObjectCreate();
        var defineProperty = requireObjectDefineProperty().f;
        var UNSCOPABLES = wellKnownSymbol('unscopables');
        var ArrayPrototype = Array.prototype;
        // Array.prototype[@@unscopables]
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null)
        });
        // add a key to Array.prototype[@@unscopables]
        addToUnscopables = function(key) {
            ArrayPrototype[UNSCOPABLES][key] = true;
        };
        return addToUnscopables;
    }
    var hasRequiredEs_array_includes;
    function requireEs_array_includes() {
        if (hasRequiredEs_array_includes) return es_array_includes;
        hasRequiredEs_array_includes = 1;
        var $ = require_export();
        var $includes = requireArrayIncludes().includes;
        var fails = requireFails();
        var addToUnscopables = requireAddToUnscopables();
        // FF99+ bug
        var BROKEN_ON_SPARSE = fails(function() {
            // eslint-disable-next-line es/no-array-prototype-includes -- detection
            return !Array(1).includes();
        });
        // Safari 26.4- bug
        var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function() {
            // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
            return [
                ,
                1
            ].includes(undefined, 1);
        });
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        $({
            target: 'Array',
            proto: true,
            forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX
        }, {
            includes: function includes(el /* , fromIndex = 0 */ ) {
                return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('includes');
        return es_array_includes;
    }
    requireEs_array_includes();
    var es_object_assign = {};
    var objectAssign;
    var hasRequiredObjectAssign;
    function requireObjectAssign() {
        if (hasRequiredObjectAssign) return objectAssign;
        hasRequiredObjectAssign = 1;
        var DESCRIPTORS = requireDescriptors();
        var uncurryThis = requireFunctionUncurryThis();
        var call = requireFunctionCall();
        var fails = requireFails();
        var objectKeys = requireObjectKeys();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var toObject = requireToObject();
        var IndexedObject = requireIndexedObject();
        // eslint-disable-next-line es/no-object-assign -- safe
        var $assign = Object.assign;
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        var defineProperty = Object.defineProperty;
        var concat = uncurryThis([].concat);
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        objectAssign = !$assign || fails(function() {
            // should have correct order of operations (Edge bug)
            if (DESCRIPTORS && $assign({
                b: 1
            }, $assign(defineProperty({}, 'a', {
                enumerable: true,
                get: function() {
                    defineProperty(this, 'b', {
                        value: 3,
                        enumerable: false
                    });
                }
            }), {
                b: 2
            })).b !== 1) return true;
            // should work with symbols and should have deterministic property order (V8 bug)
            var A = {};
            var B = {};
            // eslint-disable-next-line es/no-symbol -- safe
            var symbol = Symbol('assign detection');
            var alphabet = 'abcdefghijklmnopqrst';
            A[symbol] = 7;
            // eslint-disable-next-line es/no-array-prototype-foreach -- safe
            alphabet.split('').forEach(function(chr) {
                B[chr] = chr;
            });
            return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
        }) ? function assign(target, source) {
            var T = toObject(target);
            var argumentsLength = arguments.length;
            var index = 1;
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            var propertyIsEnumerable = propertyIsEnumerableModule.f;
            while(argumentsLength > index){
                var S = IndexedObject(arguments[index++]);
                var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while(length > j){
                    key = keys[j++];
                    if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                }
            }
            return T;
        } : $assign;
        return objectAssign;
    }
    var hasRequiredEs_object_assign;
    function requireEs_object_assign() {
        if (hasRequiredEs_object_assign) return es_object_assign;
        hasRequiredEs_object_assign = 1;
        var $ = require_export();
        var assign = requireObjectAssign();
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        // eslint-disable-next-line es/no-object-assign -- required for testing
        $({
            target: 'Object',
            stat: true,
            arity: 2,
            forced: Object.assign !== assign
        }, {
            assign: assign
        });
        return es_object_assign;
    }
    requireEs_object_assign();
    var es_object_keys = {};
    var hasRequiredEs_object_keys;
    function requireEs_object_keys() {
        if (hasRequiredEs_object_keys) return es_object_keys;
        hasRequiredEs_object_keys = 1;
        var $ = require_export();
        var toObject = requireToObject();
        var nativeKeys = requireObjectKeys();
        var fails = requireFails();
        var FAILS_ON_PRIMITIVES = fails(function() {
            nativeKeys(1);
        });
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        $({
            target: 'Object',
            stat: true,
            forced: FAILS_ON_PRIMITIVES
        }, {
            keys: function keys(it) {
                return nativeKeys(toObject(it));
            }
        });
        return es_object_keys;
    }
    requireEs_object_keys();
    var es_regexp_exec = {};
    var toString;
    var hasRequiredToString;
    function requireToString() {
        if (hasRequiredToString) return toString;
        hasRequiredToString = 1;
        var classof = requireClassof();
        var $String = String;
        toString = function(argument) {
            if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
            return $String(argument);
        };
        return toString;
    }
    var regexpFlags;
    var hasRequiredRegexpFlags;
    function requireRegexpFlags() {
        if (hasRequiredRegexpFlags) return regexpFlags;
        hasRequiredRegexpFlags = 1;
        var anObject = requireAnObject();
        // `RegExp.prototype.flags` getter implementation
        // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
        regexpFlags = function() {
            var that = anObject(this);
            var result = '';
            if (that.hasIndices) result += 'd';
            if (that.global) result += 'g';
            if (that.ignoreCase) result += 'i';
            if (that.multiline) result += 'm';
            if (that.dotAll) result += 's';
            if (that.unicode) result += 'u';
            if (that.unicodeSets) result += 'v';
            if (that.sticky) result += 'y';
            return result;
        };
        return regexpFlags;
    }
    var regexpStickyHelpers;
    var hasRequiredRegexpStickyHelpers;
    function requireRegexpStickyHelpers() {
        if (hasRequiredRegexpStickyHelpers) return regexpStickyHelpers;
        hasRequiredRegexpStickyHelpers = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        var UNSUPPORTED_Y = fails(function() {
            var re = $RegExp('a', 'y');
            re.lastIndex = 2;
            return re.exec('abcd') !== null;
        });
        // UC Browser bug
        // https://github.com/zloirock/core-js/issues/1008
        var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
            return !$RegExp('a', 'y').sticky;
        });
        var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
            var re = $RegExp('^r', 'gy');
            re.lastIndex = 2;
            return re.exec('str') !== null;
        });
        regexpStickyHelpers = {
            BROKEN_CARET: BROKEN_CARET,
            MISSED_STICKY: MISSED_STICKY,
            UNSUPPORTED_Y: UNSUPPORTED_Y
        };
        return regexpStickyHelpers;
    }
    var regexpUnsupportedDotAll;
    var hasRequiredRegexpUnsupportedDotAll;
    function requireRegexpUnsupportedDotAll() {
        if (hasRequiredRegexpUnsupportedDotAll) return regexpUnsupportedDotAll;
        hasRequiredRegexpUnsupportedDotAll = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        regexpUnsupportedDotAll = fails(function() {
            var re = $RegExp('.', 's');
            return !(re.dotAll && re.test('\n') && re.flags === 's');
        });
        return regexpUnsupportedDotAll;
    }
    var regexpUnsupportedNcg;
    var hasRequiredRegexpUnsupportedNcg;
    function requireRegexpUnsupportedNcg() {
        if (hasRequiredRegexpUnsupportedNcg) return regexpUnsupportedNcg;
        hasRequiredRegexpUnsupportedNcg = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        regexpUnsupportedNcg = fails(function() {
            var re = $RegExp('(?<a>b)', 'g');
            return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
        });
        return regexpUnsupportedNcg;
    }
    var regexpExec;
    var hasRequiredRegexpExec;
    function requireRegexpExec() {
        if (hasRequiredRegexpExec) return regexpExec;
        hasRequiredRegexpExec = 1;
        /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var toString = requireToString();
        var regexpFlags = requireRegexpFlags();
        var stickyHelpers = requireRegexpStickyHelpers();
        var shared = requireShared();
        var create = requireObjectCreate();
        var getInternalState = requireInternalState().get;
        var UNSUPPORTED_DOT_ALL = requireRegexpUnsupportedDotAll();
        var UNSUPPORTED_NCG = requireRegexpUnsupportedNcg();
        var nativeReplace = shared('native-string-replace', String.prototype.replace);
        var nativeExec = RegExp.prototype.exec;
        var patchedExec = nativeExec;
        var charAt = uncurryThis(''.charAt);
        var indexOf = uncurryThis(''.indexOf);
        var replace = uncurryThis(''.replace);
        var stringSlice = uncurryThis(''.slice);
        var UPDATES_LAST_INDEX_WRONG = function() {
            var re1 = /a/;
            var re2 = /b*/g;
            call(nativeExec, re1, 'a');
            call(nativeExec, re2, 'a');
            return re1.lastIndex !== 0 || re2.lastIndex !== 0;
        }();
        var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
        // nonparticipating capturing group, copied from es5-shim's String#split patch.
        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
        var setGroups = function(re, groups) {
            var object = re.groups = create(null);
            for(var i = 0; i < groups.length; i++){
                var group = groups[i];
                object[group[0]] = re[group[1]];
            }
        };
        if (PATCH) patchedExec = function exec(string) {
            var re = this;
            var state = getInternalState(re);
            var str = toString(string);
            var raw = state.raw;
            var result, reCopy, lastIndex;
            if (raw) {
                raw.lastIndex = re.lastIndex;
                result = call(patchedExec, raw, str);
                re.lastIndex = raw.lastIndex;
                if (result && state.groups) setGroups(result, state.groups);
                return result;
            }
            var groups = state.groups;
            var sticky = UNSUPPORTED_Y && re.sticky;
            var flags = call(regexpFlags, re);
            var source = re.source;
            var charsAdded = 0;
            var strCopy = str;
            if (sticky) {
                flags = replace(flags, 'y', '');
                if (indexOf(flags, 'g') === -1) flags += 'g';
                strCopy = stringSlice(str, re.lastIndex);
                // Support anchored sticky behavior.
                var prevChar = re.lastIndex > 0 && charAt(str, re.lastIndex - 1);
                if (re.lastIndex > 0 && (!re.multiline || re.multiline && prevChar !== '\n' && prevChar !== '\r' && prevChar !== '\u2028' && prevChar !== '\u2029')) {
                    source = '(?: (?:' + source + '))';
                    strCopy = ' ' + strCopy;
                    charsAdded++;
                }
                // ^(? + rx + ) is needed, in combination with some str slicing, to
                // simulate the 'y' flag.
                reCopy = new RegExp('^(?:' + source + ')', flags);
            }
            if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
            var match = call(nativeExec, sticky ? reCopy : re, strCopy);
            if (sticky) {
                if (match) {
                    match.input = str;
                    match[0] = stringSlice(match[0], charsAdded);
                    match.index = re.lastIndex;
                    re.lastIndex += match[0].length;
                } else re.lastIndex = 0;
            } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
            if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
            // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
            call(nativeReplace, match[0], reCopy, function() {
                for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
            });
            if (match && groups) setGroups(match, groups);
            return match;
        };
        regexpExec = patchedExec;
        return regexpExec;
    }
    var hasRequiredEs_regexp_exec;
    function requireEs_regexp_exec() {
        if (hasRequiredEs_regexp_exec) return es_regexp_exec;
        hasRequiredEs_regexp_exec = 1;
        var $ = require_export();
        var exec = requireRegexpExec();
        // `RegExp.prototype.exec` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.exec
        $({
            target: 'RegExp',
            proto: true,
            forced: /./.exec !== exec
        }, {
            exec: exec
        });
        return es_regexp_exec;
    }
    requireEs_regexp_exec();
    var es_string_includes = {};
    var isRegexp;
    var hasRequiredIsRegexp;
    function requireIsRegexp() {
        if (hasRequiredIsRegexp) return isRegexp;
        hasRequiredIsRegexp = 1;
        var isObject = requireIsObject();
        var classof = requireClassofRaw();
        var wellKnownSymbol = requireWellKnownSymbol();
        var MATCH = wellKnownSymbol('match');
        // `IsRegExp` abstract operation
        // https://tc39.es/ecma262/#sec-isregexp
        isRegexp = function(it) {
            var isRegExp;
            return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
        };
        return isRegexp;
    }
    var notARegexp;
    var hasRequiredNotARegexp;
    function requireNotARegexp() {
        if (hasRequiredNotARegexp) return notARegexp;
        hasRequiredNotARegexp = 1;
        var isRegExp = requireIsRegexp();
        var $TypeError = TypeError;
        notARegexp = function(it) {
            if (isRegExp(it)) throw new $TypeError("The method doesn't accept regular expressions");
            return it;
        };
        return notARegexp;
    }
    var correctIsRegexpLogic;
    var hasRequiredCorrectIsRegexpLogic;
    function requireCorrectIsRegexpLogic() {
        if (hasRequiredCorrectIsRegexpLogic) return correctIsRegexpLogic;
        hasRequiredCorrectIsRegexpLogic = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var MATCH = wellKnownSymbol('match');
        correctIsRegexpLogic = function(METHOD_NAME) {
            var regexp = /./;
            try {
                '/./'[METHOD_NAME](regexp);
            } catch (error1) {
                try {
                    regexp[MATCH] = false;
                    return '/./'[METHOD_NAME](regexp);
                } catch (error2) {}
            }
            return false;
        };
        return correctIsRegexpLogic;
    }
    var hasRequiredEs_string_includes;
    function requireEs_string_includes() {
        if (hasRequiredEs_string_includes) return es_string_includes;
        hasRequiredEs_string_includes = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThis();
        var notARegExp = requireNotARegexp();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var toString = requireToString();
        var correctIsRegExpLogic = requireCorrectIsRegexpLogic();
        var stringIndexOf = uncurryThis(''.indexOf);
        // `String.prototype.includes` method
        // https://tc39.es/ecma262/#sec-string.prototype.includes
        $({
            target: 'String',
            proto: true,
            forced: !correctIsRegExpLogic('includes')
        }, {
            includes: function includes(searchString /* , position = 0 */ ) {
                return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        return es_string_includes;
    }
    requireEs_string_includes();
    var es_array_find = {};
    var functionUncurryThisClause;
    var hasRequiredFunctionUncurryThisClause;
    function requireFunctionUncurryThisClause() {
        if (hasRequiredFunctionUncurryThisClause) return functionUncurryThisClause;
        hasRequiredFunctionUncurryThisClause = 1;
        var classofRaw = requireClassofRaw();
        var uncurryThis = requireFunctionUncurryThis();
        functionUncurryThisClause = function(fn) {
            // Nashorn bug:
            //   https://github.com/zloirock/core-js/issues/1128
            //   https://github.com/zloirock/core-js/issues/1130
            if (classofRaw(fn) === 'Function') return uncurryThis(fn);
        };
        return functionUncurryThisClause;
    }
    var functionBindContext;
    var hasRequiredFunctionBindContext;
    function requireFunctionBindContext() {
        if (hasRequiredFunctionBindContext) return functionBindContext;
        hasRequiredFunctionBindContext = 1;
        var uncurryThis = requireFunctionUncurryThisClause();
        var aCallable = requireACallable();
        var NATIVE_BIND = requireFunctionBindNative();
        var bind = uncurryThis(uncurryThis.bind);
        // optional / simple context binding
        functionBindContext = function(fn, that) {
            aCallable(fn);
            return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
                return fn.apply(that, arguments);
            };
        };
        return functionBindContext;
    }
    var arrayIteration;
    var hasRequiredArrayIteration;
    function requireArrayIteration() {
        if (hasRequiredArrayIteration) return arrayIteration;
        hasRequiredArrayIteration = 1;
        var bind = requireFunctionBindContext();
        var IndexedObject = requireIndexedObject();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var createProperty = requireCreateProperty();
        // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
        var createMethod = function(TYPE) {
            var IS_MAP = TYPE === 1;
            var IS_FILTER = TYPE === 2;
            var IS_SOME = TYPE === 3;
            var IS_EVERY = TYPE === 4;
            var IS_FIND_INDEX = TYPE === 6;
            var IS_FILTER_REJECT = TYPE === 7;
            var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
            return function($this, callbackfn, that) {
                var O = toObject($this);
                var self1 = IndexedObject(O);
                var length = lengthOfArrayLike(self1);
                var boundFunction = bind(callbackfn, that);
                var index = 0;
                var resIndex = 0;
                var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
                var value, result;
                for(; length > index; index++)if (NO_HOLES || index in self1) {
                    value = self1[index];
                    result = boundFunction(value, index, O);
                    if (TYPE) {
                        if (IS_MAP) createProperty(target, index, result); // map
                        else if (result) switch(TYPE){
                            case 3:
                                return true; // some
                            case 5:
                                return value; // find
                            case 6:
                                return index; // findIndex
                            case 2:
                                createProperty(target, resIndex++, value); // filter
                        }
                        else switch(TYPE){
                            case 4:
                                return false; // every
                            case 7:
                                createProperty(target, resIndex++, value); // filterReject
                        }
                    }
                }
                return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
            };
        };
        arrayIteration = {
            // `Array.prototype.forEach` method
            // https://tc39.es/ecma262/#sec-array.prototype.foreach
            forEach: createMethod(0),
            // `Array.prototype.map` method
            // https://tc39.es/ecma262/#sec-array.prototype.map
            map: createMethod(1),
            // `Array.prototype.filter` method
            // https://tc39.es/ecma262/#sec-array.prototype.filter
            filter: createMethod(2),
            // `Array.prototype.some` method
            // https://tc39.es/ecma262/#sec-array.prototype.some
            some: createMethod(3),
            // `Array.prototype.every` method
            // https://tc39.es/ecma262/#sec-array.prototype.every
            every: createMethod(4),
            // `Array.prototype.find` method
            // https://tc39.es/ecma262/#sec-array.prototype.find
            find: createMethod(5),
            // `Array.prototype.findIndex` method
            // https://tc39.es/ecma262/#sec-array.prototype.findIndex
            findIndex: createMethod(6),
            // `Array.prototype.filterReject` method
            // https://github.com/tc39/proposal-array-filtering
            filterReject: createMethod(7)
        };
        return arrayIteration;
    }
    var hasRequiredEs_array_find;
    function requireEs_array_find() {
        if (hasRequiredEs_array_find) return es_array_find;
        hasRequiredEs_array_find = 1;
        var $ = require_export();
        var $find = requireArrayIteration().find;
        var addToUnscopables = requireAddToUnscopables();
        var FIND = 'find';
        var SKIPS_HOLES = true;
        // Shouldn't skip holes
        // eslint-disable-next-line es/no-array-prototype-find -- testing
        if (FIND in []) Array(1)[FIND](function() {
            SKIPS_HOLES = false;
        });
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        $({
            target: 'Array',
            proto: true,
            forced: SKIPS_HOLES
        }, {
            find: function find(callbackfn /* , that = undefined */ ) {
                return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables(FIND);
        return es_array_find;
    }
    requireEs_array_find();
    var es_object_entries = {};
    var correctPrototypeGetter;
    var hasRequiredCorrectPrototypeGetter;
    function requireCorrectPrototypeGetter() {
        if (hasRequiredCorrectPrototypeGetter) return correctPrototypeGetter;
        hasRequiredCorrectPrototypeGetter = 1;
        var fails = requireFails();
        correctPrototypeGetter = !fails(function() {
            function F() {}
            F.prototype.constructor = null;
            // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
            return Object.getPrototypeOf(new F()) !== F.prototype;
        });
        return correctPrototypeGetter;
    }
    var objectGetPrototypeOf;
    var hasRequiredObjectGetPrototypeOf;
    function requireObjectGetPrototypeOf() {
        if (hasRequiredObjectGetPrototypeOf) return objectGetPrototypeOf;
        hasRequiredObjectGetPrototypeOf = 1;
        var hasOwn = requireHasOwnProperty();
        var isCallable = requireIsCallable();
        var toObject = requireToObject();
        var sharedKey = requireSharedKey();
        var CORRECT_PROTOTYPE_GETTER = requireCorrectPrototypeGetter();
        var IE_PROTO = sharedKey('IE_PROTO');
        var $Object = Object;
        var ObjectPrototype = $Object.prototype;
        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        // eslint-disable-next-line es/no-object-getprototypeof -- safe
        objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
            var object = toObject(O);
            if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
            var constructor = object.constructor;
            if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
            return object instanceof $Object ? ObjectPrototype : null;
        };
        return objectGetPrototypeOf;
    }
    var objectToArray;
    var hasRequiredObjectToArray;
    function requireObjectToArray() {
        if (hasRequiredObjectToArray) return objectToArray;
        hasRequiredObjectToArray = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        var uncurryThis = requireFunctionUncurryThis();
        var objectGetPrototypeOf = requireObjectGetPrototypeOf();
        var objectKeys = requireObjectKeys();
        var toIndexedObject = requireToIndexedObject();
        var $propertyIsEnumerable = requireObjectPropertyIsEnumerable().f;
        var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
        var push = uncurryThis([].push);
        // in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
        // of `null` prototype objects
        var IE_BUG = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-create -- safe
            var O = Object.create(null);
            O[2] = 2;
            return !propertyIsEnumerable(O, 2);
        });
        // `Object.{ entries, values }` methods implementation
        var createMethod = function(TO_ENTRIES) {
            return function(it) {
                var O = toIndexedObject(it);
                var keys = objectKeys(O);
                var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
                var length = keys.length;
                var i = 0;
                var result = [];
                var key;
                while(length > i){
                    key = keys[i++];
                    if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) push(result, TO_ENTRIES ? [
                        key,
                        O[key]
                    ] : O[key]);
                }
                return result;
            };
        };
        objectToArray = {
            // `Object.entries` method
            // https://tc39.es/ecma262/#sec-object.entries
            entries: createMethod(true),
            // `Object.values` method
            // https://tc39.es/ecma262/#sec-object.values
            values: createMethod(false)
        };
        return objectToArray;
    }
    var hasRequiredEs_object_entries;
    function requireEs_object_entries() {
        if (hasRequiredEs_object_entries) return es_object_entries;
        hasRequiredEs_object_entries = 1;
        var $ = require_export();
        var $entries = requireObjectToArray().entries;
        // `Object.entries` method
        // https://tc39.es/ecma262/#sec-object.entries
        $({
            target: 'Object',
            stat: true
        }, {
            entries: function entries(O) {
                return $entries(O);
            }
        });
        return es_object_entries;
    }
    requireEs_object_entries();
    var es_object_toString = {};
    var objectToString;
    var hasRequiredObjectToString;
    function requireObjectToString() {
        if (hasRequiredObjectToString) return objectToString;
        hasRequiredObjectToString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var classof = requireClassof();
        // `Object.prototype.toString` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        objectToString = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
            return '[object ' + classof(this) + ']';
        };
        return objectToString;
    }
    var hasRequiredEs_object_toString;
    function requireEs_object_toString() {
        if (hasRequiredEs_object_toString) return es_object_toString;
        hasRequiredEs_object_toString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var defineBuiltIn = requireDefineBuiltIn();
        var toString = requireObjectToString();
        // `Object.prototype.toString` method
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
            unsafe: true
        });
        return es_object_toString;
    }
    requireEs_object_toString();
    var es_string_split = {};
    var fixRegexpWellKnownSymbolLogic;
    var hasRequiredFixRegexpWellKnownSymbolLogic;
    function requireFixRegexpWellKnownSymbolLogic() {
        if (hasRequiredFixRegexpWellKnownSymbolLogic) return fixRegexpWellKnownSymbolLogic;
        hasRequiredFixRegexpWellKnownSymbolLogic = 1;
        // TODO: Remove from `core-js [at] 4` since it's moved to entry points
        requireEs_regexp_exec();
        var call = requireFunctionCall();
        var defineBuiltIn = requireDefineBuiltIn();
        var regexpExec = requireRegexpExec();
        var fails = requireFails();
        var wellKnownSymbol = requireWellKnownSymbol();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var SPECIES = wellKnownSymbol('species');
        var RegExpPrototype = RegExp.prototype;
        fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
            var SYMBOL = wellKnownSymbol(KEY);
            var DELEGATES_TO_SYMBOL = !fails(function() {
                // String methods call symbol-named RegExp methods
                var O = {};
                // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                O[SYMBOL] = function() {
                    return 7;
                };
                return ''[KEY](O) !== 7;
            });
            var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                // Symbol-named RegExp methods call .exec
                var execCalled = false;
                var re = /a/;
                if (KEY === 'split') {
                    // We can't use real regex here since it causes deoptimization
                    // and serious performance degradation in V8
                    // https://github.com/zloirock/core-js/issues/306
                    // RegExp[@@split] doesn't call the regex's exec method, but first creates
                    // a new one. We need to return the patched regex when creating the new one.
                    var constructor = {};
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    constructor[SPECIES] = function() {
                        return re;
                    };
                    re = {
                        constructor: constructor,
                        flags: ''
                    };
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    re[SYMBOL] = /./[SYMBOL];
                }
                re.exec = function() {
                    execCalled = true;
                    return null;
                };
                re[SYMBOL]('');
                return !execCalled;
            });
            if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
                var nativeRegExpMethod = /./[SYMBOL];
                var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                    var $exec = regexp.exec;
                    if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                        if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                        // polyfilled function), leasing to infinite recursion.
                        // We avoid it by directly calling the native @@method method.
                        return {
                            done: true,
                            value: call(nativeRegExpMethod, regexp, str, arg2)
                        };
                        return {
                            done: true,
                            value: call(nativeMethod, str, regexp, arg2)
                        };
                    }
                    return {
                        done: false
                    };
                });
                defineBuiltIn(String.prototype, KEY, methods[0]);
                defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
            }
            if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
        };
        return fixRegexpWellKnownSymbolLogic;
    }
    var aConstructor;
    var hasRequiredAConstructor;
    function requireAConstructor() {
        if (hasRequiredAConstructor) return aConstructor;
        hasRequiredAConstructor = 1;
        var isConstructor = requireIsConstructor();
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        // `Assert: IsConstructor(argument) is true`
        aConstructor = function(argument) {
            if (isConstructor(argument)) return argument;
            throw new $TypeError(tryToString(argument) + ' is not a constructor');
        };
        return aConstructor;
    }
    var speciesConstructor;
    var hasRequiredSpeciesConstructor;
    function requireSpeciesConstructor() {
        if (hasRequiredSpeciesConstructor) return speciesConstructor;
        hasRequiredSpeciesConstructor = 1;
        var anObject = requireAnObject();
        var aConstructor = requireAConstructor();
        var isNullOrUndefined = requireIsNullOrUndefined();
        var wellKnownSymbol = requireWellKnownSymbol();
        var SPECIES = wellKnownSymbol('species');
        // `SpeciesConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-speciesconstructor
        speciesConstructor = function(O, defaultConstructor) {
            var C = anObject(O).constructor;
            var S;
            return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
        };
        return speciesConstructor;
    }
    var stringMultibyte;
    var hasRequiredStringMultibyte;
    function requireStringMultibyte() {
        if (hasRequiredStringMultibyte) return stringMultibyte;
        hasRequiredStringMultibyte = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var charAt = uncurryThis(''.charAt);
        var charCodeAt = uncurryThis(''.charCodeAt);
        var stringSlice = uncurryThis(''.slice);
        var createMethod = function(CONVERT_TO_STRING) {
            return function($this, pos) {
                var S = toString(requireObjectCoercible($this));
                var position = toIntegerOrInfinity(pos);
                var size = S.length;
                var first, second;
                if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                first = charCodeAt(S, position);
                return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
            };
        };
        stringMultibyte = {
            // `String.prototype.codePointAt` method
            // https://tc39.es/ecma262/#sec-string.prototype.codepointat
            codeAt: createMethod(false),
            // `String.prototype.at` method
            // https://github.com/mathiasbynens/String.prototype.at
            charAt: createMethod(true)
        };
        return stringMultibyte;
    }
    var advanceStringIndex;
    var hasRequiredAdvanceStringIndex;
    function requireAdvanceStringIndex() {
        if (hasRequiredAdvanceStringIndex) return advanceStringIndex;
        hasRequiredAdvanceStringIndex = 1;
        var charAt = requireStringMultibyte().charAt;
        // `AdvanceStringIndex` abstract operation
        // https://tc39.es/ecma262/#sec-advancestringindex
        advanceStringIndex = function(S, index, unicode) {
            return index + (unicode ? charAt(S, index).length || 1 : 1);
        };
        return advanceStringIndex;
    }
    var regexpFlagsDetection;
    var hasRequiredRegexpFlagsDetection;
    function requireRegexpFlagsDetection() {
        if (hasRequiredRegexpFlagsDetection) return regexpFlagsDetection;
        hasRequiredRegexpFlagsDetection = 1;
        var globalThis1 = requireGlobalThis();
        var fails = requireFails();
        // babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
        var RegExp1 = globalThis1.RegExp;
        var FLAGS_GETTER_IS_CORRECT = !fails(function() {
            var INDICES_SUPPORT = true;
            try {
                RegExp1('.', 'd');
            } catch (error) {
                INDICES_SUPPORT = false;
            }
            var O = {};
            // modern V8 bug
            var calls = '';
            var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
            var addGetter = function(key, chr) {
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                Object.defineProperty(O, key, {
                    get: function() {
                        calls += chr;
                        return true;
                    }
                });
            };
            var pairs = {
                dotAll: 's',
                global: 'g',
                ignoreCase: 'i',
                multiline: 'm',
                sticky: 'y'
            };
            if (INDICES_SUPPORT) pairs.hasIndices = 'd';
            for(var key in pairs)addGetter(key, pairs[key]);
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            var result = Object.getOwnPropertyDescriptor(RegExp1.prototype, 'flags').get.call(O);
            return result !== expected || calls !== expected;
        });
        regexpFlagsDetection = {
            correct: FLAGS_GETTER_IS_CORRECT
        };
        return regexpFlagsDetection;
    }
    var regexpGetFlags;
    var hasRequiredRegexpGetFlags;
    function requireRegexpGetFlags() {
        if (hasRequiredRegexpGetFlags) return regexpGetFlags;
        hasRequiredRegexpGetFlags = 1;
        var call = requireFunctionCall();
        var hasOwn = requireHasOwnProperty();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var regExpFlagsDetection = requireRegexpFlagsDetection();
        var regExpFlagsGetterImplementation = requireRegexpFlags();
        var RegExpPrototype = RegExp.prototype;
        regexpGetFlags = regExpFlagsDetection.correct ? function(it) {
            return it.flags;
        } : function(it) {
            return !regExpFlagsDetection.correct && isPrototypeOf(RegExpPrototype, it) && !hasOwn(it, 'flags') ? call(regExpFlagsGetterImplementation, it) : it.flags;
        };
        return regexpGetFlags;
    }
    var regexpExecAbstract;
    var hasRequiredRegexpExecAbstract;
    function requireRegexpExecAbstract() {
        if (hasRequiredRegexpExecAbstract) return regexpExecAbstract;
        hasRequiredRegexpExecAbstract = 1;
        var call = requireFunctionCall();
        var anObject = requireAnObject();
        var isCallable = requireIsCallable();
        var classof = requireClassofRaw();
        var regexpExec = requireRegexpExec();
        var $TypeError = TypeError;
        // `RegExpExec` abstract operation
        // https://tc39.es/ecma262/#sec-regexpexec
        regexpExecAbstract = function(R, S) {
            var exec = R.exec;
            if (isCallable(exec)) {
                var result = call(exec, R, S);
                if (result !== null) anObject(result);
                return result;
            }
            if (classof(R) === 'RegExp') return call(regexpExec, R, S);
            throw new $TypeError('RegExp#exec called on incompatible receiver');
        };
        return regexpExecAbstract;
    }
    var hasRequiredEs_string_split;
    function requireEs_string_split() {
        if (hasRequiredEs_string_split) return es_string_split;
        hasRequiredEs_string_split = 1;
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var speciesConstructor = requireSpeciesConstructor();
        var advanceStringIndex = requireAdvanceStringIndex();
        var toLength = requireToLength();
        var toString = requireToString();
        var getMethod = requireGetMethod();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var stickyHelpers = requireRegexpStickyHelpers();
        var fails = requireFails();
        var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
        var MAX_UINT32 = 0xFFFFFFFF;
        var min = Math.min;
        var push = uncurryThis([].push);
        var stringSlice = uncurryThis(''.slice);
        var stringIndexOf = uncurryThis(''.indexOf);
        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        // Weex JS has frozen built-in prototypes, so use try / catch wrapper
        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
            // eslint-disable-next-line regexp/no-empty-group -- required for testing
            var re = /(?:)/;
            var originalExec = re.exec;
            re.exec = function() {
                return originalExec.apply(this, arguments);
            };
            var result = 'ab'.split(re);
            return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
        });
        var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
        'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
        '.'.split(/()()/).length > 1 || ''.split(/.?/).length;
        // @@split logic
        fixRegExpWellKnownSymbolLogic('split', function(SPLIT, nativeSplit, maybeCallNative) {
            var internalSplit = '0'.split(undefined, 0).length ? function(separator, limit) {
                return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
            } : nativeSplit;
            return [
                // `String.prototype.split` method
                // https://tc39.es/ecma262/#sec-string.prototype.split
                function split(separator, limit) {
                    var O = requireObjectCoercible(this);
                    var splitter = isObject(separator) ? getMethod(separator, SPLIT) : undefined;
                    return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
                },
                // `RegExp.prototype[@@split]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                //
                // NOTE: This cannot be properly polyfilled in engines that don't support
                // the 'y' flag.
                function(string, limit) {
                    var rx = anObject(this);
                    var S = toString(string);
                    if (!BUGGY) {
                        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                        if (res.done) return res.value;
                    }
                    var C = speciesConstructor(rx, RegExp);
                    var flags = toString(getRegExpFlags(rx));
                    var unicodeMatching = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                    if (UNSUPPORTED_Y) {
                        if (!~stringIndexOf(flags, 'g')) flags += 'g';
                    } else if (!~stringIndexOf(flags, 'y')) flags += 'y';
                    // ^(? + rx + ) is needed, in combination with some S slicing, to
                    // simulate the 'y' flag.
                    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
                    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                    if (lim === 0) return [];
                    if (S.length === 0) return regExpExec(splitter, S) === null ? [
                        S
                    ] : [];
                    var p = 0;
                    var q = 0;
                    var A = [];
                    while(q < S.length){
                        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                        var e;
                        if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                        else {
                            push(A, stringSlice(S, p, q));
                            if (A.length === lim) return A;
                            for(var i = 1; i <= z.length - 1; i++){
                                push(A, z[i]);
                                if (A.length === lim) return A;
                            }
                            q = p = e;
                        }
                    }
                    push(A, stringSlice(S, p));
                    return A;
                }
            ];
        }, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
        return es_string_split;
    }
    requireEs_string_split();
    var es_string_trim = {};
    var whitespaces;
    var hasRequiredWhitespaces;
    function requireWhitespaces() {
        if (hasRequiredWhitespaces) return whitespaces;
        hasRequiredWhitespaces = 1;
        // a string of all valid unicode whitespaces
        whitespaces = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        return whitespaces;
    }
    var stringTrim;
    var hasRequiredStringTrim;
    function requireStringTrim() {
        if (hasRequiredStringTrim) return stringTrim;
        hasRequiredStringTrim = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var toString = requireToString();
        var whitespaces = requireWhitespaces();
        var replace = uncurryThis(''.replace);
        var ltrim = RegExp('^[' + whitespaces + ']+');
        var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
        // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
        var createMethod = function(TYPE) {
            return function($this) {
                var string = toString(requireObjectCoercible($this));
                if (TYPE & 1) string = replace(string, ltrim, '');
                if (TYPE & 2) string = replace(string, rtrim, '$1');
                return string;
            };
        };
        stringTrim = {
            // `String.prototype.{ trimLeft, trimStart }` methods
            // https://tc39.es/ecma262/#sec-string.prototype.trimstart
            start: createMethod(1),
            // `String.prototype.{ trimRight, trimEnd }` methods
            // https://tc39.es/ecma262/#sec-string.prototype.trimend
            end: createMethod(2),
            // `String.prototype.trim` method
            // https://tc39.es/ecma262/#sec-string.prototype.trim
            trim: createMethod(3)
        };
        return stringTrim;
    }
    var stringTrimForced;
    var hasRequiredStringTrimForced;
    function requireStringTrimForced() {
        if (hasRequiredStringTrimForced) return stringTrimForced;
        hasRequiredStringTrimForced = 1;
        var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
        var fails = requireFails();
        var whitespaces = requireWhitespaces();
        var non = '\u200B\u0085\u180E';
        // check that a method works with the correct list
        // of whitespaces and has a correct name
        stringTrimForced = function(METHOD_NAME) {
            return fails(function() {
                return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
            });
        };
        return stringTrimForced;
    }
    var hasRequiredEs_string_trim;
    function requireEs_string_trim() {
        if (hasRequiredEs_string_trim) return es_string_trim;
        hasRequiredEs_string_trim = 1;
        var $ = require_export();
        var $trim = requireStringTrim().trim;
        var forcedStringTrimMethod = requireStringTrimForced();
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        $({
            target: 'String',
            proto: true,
            forced: forcedStringTrimMethod('trim')
        }, {
            trim: function trim() {
                return $trim(this);
            }
        });
        return es_string_trim;
    }
    requireEs_string_trim();
    var web_domCollections_forEach = {};
    var domIterables;
    var hasRequiredDomIterables;
    function requireDomIterables() {
        if (hasRequiredDomIterables) return domIterables;
        hasRequiredDomIterables = 1;
        // iterable DOM collections
        // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
        domIterables = {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0
        };
        return domIterables;
    }
    var domTokenListPrototype;
    var hasRequiredDomTokenListPrototype;
    function requireDomTokenListPrototype() {
        if (hasRequiredDomTokenListPrototype) return domTokenListPrototype;
        hasRequiredDomTokenListPrototype = 1;
        // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
        var documentCreateElement = requireDocumentCreateElement();
        var classList = documentCreateElement('span').classList;
        var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
        domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
        return domTokenListPrototype;
    }
    var arrayMethodIsStrict;
    var hasRequiredArrayMethodIsStrict;
    function requireArrayMethodIsStrict() {
        if (hasRequiredArrayMethodIsStrict) return arrayMethodIsStrict;
        hasRequiredArrayMethodIsStrict = 1;
        var fails = requireFails();
        arrayMethodIsStrict = function(METHOD_NAME, argument) {
            var method = [][METHOD_NAME];
            return !!method && fails(function() {
                // eslint-disable-next-line no-useless-call -- required for testing
                method.call(null, argument || function() {
                    return 1;
                }, 1);
            });
        };
        return arrayMethodIsStrict;
    }
    var arrayForEach;
    var hasRequiredArrayForEach;
    function requireArrayForEach() {
        if (hasRequiredArrayForEach) return arrayForEach;
        hasRequiredArrayForEach = 1;
        var $forEach = requireArrayIteration().forEach;
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var STRICT_METHOD = arrayMethodIsStrict('forEach');
        // `Array.prototype.forEach` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
            return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        // eslint-disable-next-line es/no-array-prototype-foreach -- safe
        } : [].forEach;
        return arrayForEach;
    }
    var hasRequiredWeb_domCollections_forEach;
    function requireWeb_domCollections_forEach() {
        if (hasRequiredWeb_domCollections_forEach) return web_domCollections_forEach;
        hasRequiredWeb_domCollections_forEach = 1;
        var globalThis1 = requireGlobalThis();
        var DOMIterables = requireDomIterables();
        var DOMTokenListPrototype = requireDomTokenListPrototype();
        var forEach = requireArrayForEach();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var handlePrototype = function(CollectionPrototype) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
            } catch (error) {
                CollectionPrototype.forEach = forEach;
            }
        };
        for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(globalThis1[COLLECTION_NAME] && globalThis1[COLLECTION_NAME].prototype);
        handlePrototype(DOMTokenListPrototype);
        return web_domCollections_forEach;
    }
    requireWeb_domCollections_forEach();
    var es_string_startsWith = {};
    var hasRequiredEs_string_startsWith;
    function requireEs_string_startsWith() {
        if (hasRequiredEs_string_startsWith) return es_string_startsWith;
        hasRequiredEs_string_startsWith = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThisClause();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var toLength = requireToLength();
        var toString = requireToString();
        var notARegExp = requireNotARegexp();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var correctIsRegExpLogic = requireCorrectIsRegexpLogic();
        var IS_PURE = requireIsPure();
        var stringSlice = uncurryThis(''.slice);
        var min = Math.min;
        var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
        // https://github.com/zloirock/core-js/pull/702
        var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
            var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
            return descriptor && !descriptor.writable;
        }();
        // `String.prototype.startsWith` method
        // https://tc39.es/ecma262/#sec-string.prototype.startswith
        $({
            target: 'String',
            proto: true,
            forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
        }, {
            startsWith: function startsWith(searchString /* , position = 0 */ ) {
                var that = toString(requireObjectCoercible(this));
                notARegExp(searchString);
                var search = toString(searchString);
                var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
                return stringSlice(that, index, index + search.length) === search;
            }
        });
        return es_string_startsWith;
    }
    requireEs_string_startsWith();
    var es_array_filter = {};
    var hasRequiredEs_array_filter;
    function requireEs_array_filter() {
        if (hasRequiredEs_array_filter) return es_array_filter;
        hasRequiredEs_array_filter = 1;
        var $ = require_export();
        var $filter = requireArrayIteration().filter;
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        // with adding support of @@species
        $({
            target: 'Array',
            proto: true,
            forced: !HAS_SPECIES_SUPPORT
        }, {
            filter: function filter(callbackfn /* , thisArg */ ) {
                return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        return es_array_filter;
    }
    requireEs_array_filter();
    var es_array_from = {};
    var iteratorClose;
    var hasRequiredIteratorClose;
    function requireIteratorClose() {
        if (hasRequiredIteratorClose) return iteratorClose;
        hasRequiredIteratorClose = 1;
        var call = requireFunctionCall();
        var anObject = requireAnObject();
        var getMethod = requireGetMethod();
        iteratorClose = function(iterator, kind, value) {
            var innerResult, innerError;
            anObject(iterator);
            try {
                innerResult = getMethod(iterator, 'return');
                if (!innerResult) {
                    if (kind === 'throw') throw value;
                    return value;
                }
                innerResult = call(innerResult, iterator);
            } catch (error) {
                innerError = true;
                innerResult = error;
            }
            if (kind === 'throw') throw value;
            if (innerError) throw innerResult;
            anObject(innerResult);
            return value;
        };
        return iteratorClose;
    }
    var callWithSafeIterationClosing;
    var hasRequiredCallWithSafeIterationClosing;
    function requireCallWithSafeIterationClosing() {
        if (hasRequiredCallWithSafeIterationClosing) return callWithSafeIterationClosing;
        hasRequiredCallWithSafeIterationClosing = 1;
        var anObject = requireAnObject();
        var iteratorClose = requireIteratorClose();
        // call something on iterator step with safe closing on error
        callWithSafeIterationClosing = function(iterator, fn, value, ENTRIES) {
            try {
                return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
            } catch (error) {
                iteratorClose(iterator, 'throw', error);
            }
        };
        return callWithSafeIterationClosing;
    }
    var iterators;
    var hasRequiredIterators;
    function requireIterators() {
        if (hasRequiredIterators) return iterators;
        hasRequiredIterators = 1;
        iterators = {};
        return iterators;
    }
    var isArrayIteratorMethod;
    var hasRequiredIsArrayIteratorMethod;
    function requireIsArrayIteratorMethod() {
        if (hasRequiredIsArrayIteratorMethod) return isArrayIteratorMethod;
        hasRequiredIsArrayIteratorMethod = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var Iterators = requireIterators();
        var ITERATOR = wellKnownSymbol('iterator');
        var ArrayPrototype = Array.prototype;
        // check on default Array iterator
        isArrayIteratorMethod = function(it) {
            return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
        };
        return isArrayIteratorMethod;
    }
    var getIteratorMethod;
    var hasRequiredGetIteratorMethod;
    function requireGetIteratorMethod() {
        if (hasRequiredGetIteratorMethod) return getIteratorMethod;
        hasRequiredGetIteratorMethod = 1;
        var classof = requireClassof();
        var getMethod = requireGetMethod();
        var isNullOrUndefined = requireIsNullOrUndefined();
        var Iterators = requireIterators();
        var wellKnownSymbol = requireWellKnownSymbol();
        var ITERATOR = wellKnownSymbol('iterator');
        getIteratorMethod = function(it) {
            if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
        };
        return getIteratorMethod;
    }
    var getIterator;
    var hasRequiredGetIterator;
    function requireGetIterator() {
        if (hasRequiredGetIterator) return getIterator;
        hasRequiredGetIterator = 1;
        var call = requireFunctionCall();
        var aCallable = requireACallable();
        var anObject = requireAnObject();
        var tryToString = requireTryToString();
        var getIteratorMethod = requireGetIteratorMethod();
        var $TypeError = TypeError;
        getIterator = function(argument, usingIterator) {
            var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
            if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
            throw new $TypeError(tryToString(argument) + ' is not iterable');
        };
        return getIterator;
    }
    var arrayFrom;
    var hasRequiredArrayFrom;
    function requireArrayFrom() {
        if (hasRequiredArrayFrom) return arrayFrom;
        hasRequiredArrayFrom = 1;
        var bind = requireFunctionBindContext();
        var call = requireFunctionCall();
        var toObject = requireToObject();
        var callWithSafeIterationClosing = requireCallWithSafeIterationClosing();
        var isArrayIteratorMethod = requireIsArrayIteratorMethod();
        var isConstructor = requireIsConstructor();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var createProperty = requireCreateProperty();
        var setArrayLength = requireArraySetLength();
        var getIterator = requireGetIterator();
        var getIteratorMethod = requireGetIteratorMethod();
        var iteratorClose = requireIteratorClose();
        var $Array = Array;
        // `Array.from` method implementation
        // https://tc39.es/ecma262/#sec-array.from
        arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
            var IS_CONSTRUCTOR = isConstructor(this);
            var argumentsLength = arguments.length;
            var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
            var O = toObject(arrayLike);
            var iteratorMethod = getIteratorMethod(O);
            var index = 0;
            var length, result, step, iterator, next, value;
            // if the target is not iterable or it's an array with the default iterator - use a simple case
            if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
                result = IS_CONSTRUCTOR ? new this() : [];
                iterator = getIterator(O, iteratorMethod);
                next = iterator.next;
                for(; !(step = call(next, iterator)).done; index++){
                    value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [
                        step.value,
                        index
                    ], true) : step.value;
                    try {
                        createProperty(result, index, value);
                    } catch (error) {
                        iteratorClose(iterator, 'throw', error);
                    }
                }
            } else {
                length = lengthOfArrayLike(O);
                result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
                for(; length > index; index++){
                    value = mapping ? mapfn(O[index], index) : O[index];
                    createProperty(result, index, value);
                }
            }
            setArrayLength(result, index);
            return result;
        };
        return arrayFrom;
    }
    var checkCorrectnessOfIteration;
    var hasRequiredCheckCorrectnessOfIteration;
    function requireCheckCorrectnessOfIteration() {
        if (hasRequiredCheckCorrectnessOfIteration) return checkCorrectnessOfIteration;
        hasRequiredCheckCorrectnessOfIteration = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var ITERATOR = wellKnownSymbol('iterator');
        var SAFE_CLOSING = false;
        try {
            var called = 0;
            var iteratorWithReturn = {
                next: function() {
                    return {
                        done: !!called++
                    };
                },
                'return': function() {
                    SAFE_CLOSING = true;
                }
            };
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            iteratorWithReturn[ITERATOR] = function() {
                return this;
            };
            // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
            Array.from(iteratorWithReturn, function() {
                throw 2;
            });
        } catch (error) {}
        checkCorrectnessOfIteration = function(exec, SKIP_CLOSING) {
            try {
                if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
            } catch (error) {
                return false;
            } // workaround of old WebKit + `eval` bug
            var ITERATION_SUPPORT = false;
            try {
                var object = {};
                // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                object[ITERATOR] = function() {
                    return {
                        next: function() {
                            return {
                                done: ITERATION_SUPPORT = true
                            };
                        }
                    };
                };
                exec(object);
            } catch (error) {}
            return ITERATION_SUPPORT;
        };
        return checkCorrectnessOfIteration;
    }
    var hasRequiredEs_array_from;
    function requireEs_array_from() {
        if (hasRequiredEs_array_from) return es_array_from;
        hasRequiredEs_array_from = 1;
        var $ = require_export();
        var from = requireArrayFrom();
        var checkCorrectnessOfIteration = requireCheckCorrectnessOfIteration();
        var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
            // eslint-disable-next-line es/no-array-from -- required for testing
            Array.from(iterable);
        });
        // `Array.from` method
        // https://tc39.es/ecma262/#sec-array.from
        $({
            target: 'Array',
            stat: true,
            forced: INCORRECT_ITERATION
        }, {
            from: from
        });
        return es_array_from;
    }
    requireEs_array_from();
    var es_string_iterator = {};
    var iteratorsCore;
    var hasRequiredIteratorsCore;
    function requireIteratorsCore() {
        if (hasRequiredIteratorsCore) return iteratorsCore;
        hasRequiredIteratorsCore = 1;
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var create = requireObjectCreate();
        var getPrototypeOf = requireObjectGetPrototypeOf();
        var defineBuiltIn = requireDefineBuiltIn();
        var wellKnownSymbol = requireWellKnownSymbol();
        var IS_PURE = requireIsPure();
        var ITERATOR = wellKnownSymbol('iterator');
        var BUGGY_SAFARI_ITERATORS = false;
        // `%IteratorPrototype%` object
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-object
        var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
        /* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
            arrayIterator = [].keys();
            // Safari 8 has buggy iterators w/o `next`
            if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
            else {
                PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
                if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
            }
        }
        var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function() {
            var test = {};
            // FF44- legacy iterators case
            return IteratorPrototype[ITERATOR].call(test) !== test;
        });
        if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
        else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);
        // `%IteratorPrototype%[@@iterator]()` method
        // https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
        if (!isCallable(IteratorPrototype[ITERATOR])) defineBuiltIn(IteratorPrototype, ITERATOR, function() {
            return this;
        });
        iteratorsCore = {
            IteratorPrototype: IteratorPrototype,
            BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
        };
        return iteratorsCore;
    }
    var setToStringTag;
    var hasRequiredSetToStringTag;
    function requireSetToStringTag() {
        if (hasRequiredSetToStringTag) return setToStringTag;
        hasRequiredSetToStringTag = 1;
        var defineProperty = requireObjectDefineProperty().f;
        var hasOwn = requireHasOwnProperty();
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        setToStringTag = function(target, TAG, STATIC) {
            if (target && !STATIC) target = target.prototype;
            if (target && !hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
                configurable: true,
                value: TAG
            });
        };
        return setToStringTag;
    }
    var iteratorCreateConstructor;
    var hasRequiredIteratorCreateConstructor;
    function requireIteratorCreateConstructor() {
        if (hasRequiredIteratorCreateConstructor) return iteratorCreateConstructor;
        hasRequiredIteratorCreateConstructor = 1;
        var IteratorPrototype = requireIteratorsCore().IteratorPrototype;
        var create = requireObjectCreate();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        var setToStringTag = requireSetToStringTag();
        var Iterators = requireIterators();
        var returnThis = function() {
            return this;
        };
        iteratorCreateConstructor = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
            var TO_STRING_TAG = NAME + ' Iterator';
            IteratorConstructor.prototype = create(IteratorPrototype, {
                next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
            });
            setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
            Iterators[TO_STRING_TAG] = returnThis;
            return IteratorConstructor;
        };
        return iteratorCreateConstructor;
    }
    var functionUncurryThisAccessor;
    var hasRequiredFunctionUncurryThisAccessor;
    function requireFunctionUncurryThisAccessor() {
        if (hasRequiredFunctionUncurryThisAccessor) return functionUncurryThisAccessor;
        hasRequiredFunctionUncurryThisAccessor = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var aCallable = requireACallable();
        functionUncurryThisAccessor = function(object, key, method) {
            try {
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
            } catch (error) {}
        };
        return functionUncurryThisAccessor;
    }
    var isPossiblePrototype;
    var hasRequiredIsPossiblePrototype;
    function requireIsPossiblePrototype() {
        if (hasRequiredIsPossiblePrototype) return isPossiblePrototype;
        hasRequiredIsPossiblePrototype = 1;
        var isObject = requireIsObject();
        isPossiblePrototype = function(argument) {
            return isObject(argument) || argument === null;
        };
        return isPossiblePrototype;
    }
    var aPossiblePrototype;
    var hasRequiredAPossiblePrototype;
    function requireAPossiblePrototype() {
        if (hasRequiredAPossiblePrototype) return aPossiblePrototype;
        hasRequiredAPossiblePrototype = 1;
        var isPossiblePrototype = requireIsPossiblePrototype();
        var $String = String;
        var $TypeError = TypeError;
        aPossiblePrototype = function(argument) {
            if (isPossiblePrototype(argument)) return argument;
            throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
        };
        return aPossiblePrototype;
    }
    var objectSetPrototypeOf;
    var hasRequiredObjectSetPrototypeOf;
    function requireObjectSetPrototypeOf() {
        if (hasRequiredObjectSetPrototypeOf) return objectSetPrototypeOf;
        hasRequiredObjectSetPrototypeOf = 1;
        /* eslint-disable no-proto -- safe */ var uncurryThisAccessor = requireFunctionUncurryThisAccessor();
        var isObject = requireIsObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var aPossiblePrototype = requireAPossiblePrototype();
        // `Object.setPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.setprototypeof
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        // eslint-disable-next-line es/no-object-setprototypeof -- safe
        objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
            var CORRECT_SETTER = false;
            var test = {};
            var setter;
            try {
                setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
                setter(test, []);
                CORRECT_SETTER = test instanceof Array;
            } catch (error) {}
            return function setPrototypeOf(O, proto) {
                requireObjectCoercible(O);
                aPossiblePrototype(proto);
                if (!isObject(O)) return O;
                if (CORRECT_SETTER) setter(O, proto);
                else O.__proto__ = proto;
                return O;
            };
        }() : undefined);
        return objectSetPrototypeOf;
    }
    var iteratorDefine;
    var hasRequiredIteratorDefine;
    function requireIteratorDefine() {
        if (hasRequiredIteratorDefine) return iteratorDefine;
        hasRequiredIteratorDefine = 1;
        var $ = require_export();
        var call = requireFunctionCall();
        var IS_PURE = requireIsPure();
        var FunctionName = requireFunctionName();
        var isCallable = requireIsCallable();
        var createIteratorConstructor = requireIteratorCreateConstructor();
        var getPrototypeOf = requireObjectGetPrototypeOf();
        var setPrototypeOf = requireObjectSetPrototypeOf();
        var setToStringTag = requireSetToStringTag();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var defineBuiltIn = requireDefineBuiltIn();
        var wellKnownSymbol = requireWellKnownSymbol();
        var Iterators = requireIterators();
        var IteratorsCore = requireIteratorsCore();
        var PROPER_FUNCTION_NAME = FunctionName.PROPER;
        var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
        var IteratorPrototype = IteratorsCore.IteratorPrototype;
        var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
        var ITERATOR = wellKnownSymbol('iterator');
        var KEYS = 'keys';
        var VALUES = 'values';
        var ENTRIES = 'entries';
        var returnThis = function() {
            return this;
        };
        iteratorDefine = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
            createIteratorConstructor(IteratorConstructor, NAME, next);
            var getIterationMethod = function(KIND) {
                if (KIND === DEFAULT && defaultIterator) return defaultIterator;
                if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
                switch(KIND){
                    case KEYS:
                        return function keys() {
                            return new IteratorConstructor(this, KIND);
                        };
                    case VALUES:
                        return function values() {
                            return new IteratorConstructor(this, KIND);
                        };
                    case ENTRIES:
                        return function entries() {
                            return new IteratorConstructor(this, KIND);
                        };
                }
                return function() {
                    return new IteratorConstructor(this);
                };
            };
            var TO_STRING_TAG = NAME + ' Iterator';
            var INCORRECT_VALUES_NAME = false;
            var IterablePrototype = Iterable.prototype;
            var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
            var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
            var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
            var CurrentIteratorPrototype, methods, KEY;
            // fix native
            if (anyNativeIterator) {
                CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
                if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
                    if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
                        if (setPrototypeOf) setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
                        else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
                    }
                    // Set @@toStringTag to native iterators
                    setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
                    if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
                }
            }
            // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
            if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
                if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
                else {
                    INCORRECT_VALUES_NAME = true;
                    defaultIterator = function values() {
                        return call(nativeIterator, this);
                    };
                }
            }
            // export additional methods
            if (DEFAULT) {
                methods = {
                    values: getIterationMethod(VALUES),
                    keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
                    entries: getIterationMethod(ENTRIES)
                };
                if (FORCED) {
                    for(KEY in methods)if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
                } else $({
                    target: NAME,
                    proto: true,
                    forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
                }, methods);
            }
            // define iterator
            if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, {
                name: DEFAULT
            });
            Iterators[NAME] = defaultIterator;
            return methods;
        };
        return iteratorDefine;
    }
    var createIterResultObject;
    var hasRequiredCreateIterResultObject;
    function requireCreateIterResultObject() {
        if (hasRequiredCreateIterResultObject) return createIterResultObject;
        hasRequiredCreateIterResultObject = 1;
        // `CreateIterResultObject` abstract operation
        // https://tc39.es/ecma262/#sec-createiterresultobject
        createIterResultObject = function(value, done) {
            return {
                value: value,
                done: done
            };
        };
        return createIterResultObject;
    }
    var hasRequiredEs_string_iterator;
    function requireEs_string_iterator() {
        if (hasRequiredEs_string_iterator) return es_string_iterator;
        hasRequiredEs_string_iterator = 1;
        var charAt = requireStringMultibyte().charAt;
        var toString = requireToString();
        var InternalStateModule = requireInternalState();
        var defineIterator = requireIteratorDefine();
        var createIterResultObject = requireCreateIterResultObject();
        var STRING_ITERATOR = 'String Iterator';
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
        // `String.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-string.prototype-@@iterator
        defineIterator(String, 'String', function(iterated) {
            setInternalState(this, {
                type: STRING_ITERATOR,
                string: toString(iterated),
                index: 0
            });
        // `%StringIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
        }, function next() {
            var state = getInternalState(this);
            var string = state.string;
            var index = state.index;
            var point;
            if (index >= string.length) return createIterResultObject(undefined, true);
            point = charAt(string, index);
            state.index += point.length;
            return createIterResultObject(point, false);
        });
        return es_string_iterator;
    }
    requireEs_string_iterator();
    /**
   * Bootstrap Table DOM Manipulation Utility Library
   * Provides jQuery-style DOM manipulation APIs using native JavaScript
   *
   * Security Notice:
   * - The `create()` method uses innerHTML to parse HTML strings. Always sanitize user input
   *   before passing it to create() to prevent XSS attacks.
   * - The `html()` method sets innerHTML directly. Use the `text()` method for user-provided content.
   * - The `attr()` method allows setting arbitrary attributes including event handlers.
   *   Avoid setting event handler attributes (onclick, onerror, etc.) with user-controlled data.
   */ var DOMHelper = /*#__PURE__*/ function() {
        function DOMHelper() {
            _classCallCheck(this, DOMHelper);
        }
        return _createClass(DOMHelper, null, [
            {
                key: "$",
                value: /**
       * Element selector
       * @param {string|Element} selector - CSS selector or DOM element
       * @param {Element} context - Search context, defaults to document
       * @returns {Element|null} First matched element
       */ function $(selector) {
                    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
                    if (typeof selector === 'string') return context.querySelector(selector);
                    if (selector instanceof Element) return selector;
                    return null;
                }
            },
            {
                key: "$$",
                value: function $$(selector) {
                    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
                    if (typeof selector === 'string') return Array.from(context.querySelectorAll(selector));
                    if (selector instanceof NodeList) return Array.from(selector);
                    if (selector instanceof Element) return [
                        selector
                    ];
                    return [];
                }
            },
            {
                key: "create",
                value: function create(html) {
                    if (typeof html !== 'string') return null;
                    var trimmed = html.trim();
                    if (!trimmed) return null;
                    var template = document.createElement('template');
                    template.innerHTML = trimmed;
                    return template.content.firstChild;
                }
            },
            {
                key: "addClass",
                value: function addClass(element, className) {
                    var _element$classList;
                    if (typeof element === 'string') element = this.$(element);
                    if (!element || !element.classList) return element;
                    if (!className) return element;
                    var classes = className.split(' ').filter(function(c) {
                        return c;
                    });
                    (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(classes));
                    return element;
                }
            },
            {
                key: "removeClass",
                value: function removeClass(element, className) {
                    var _element$classList2;
                    if (typeof element === 'string') element = this.$(element);
                    if (!element || !element.classList) return element;
                    if (!className) return element;
                    var classes = className.split(' ').filter(function(c) {
                        return c;
                    });
                    (_element$classList2 = element.classList).remove.apply(_element$classList2, _toConsumableArray(classes));
                    return element;
                }
            },
            {
                key: "toggleClass",
                value: function toggleClass(element, className) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element || !element.classList) return element;
                    if (!className) return element;
                    var classes = className.split(' ').filter(function(c) {
                        return c;
                    });
                    classes.forEach(function(cls) {
                        return element.classList.toggle(cls);
                    });
                    return element;
                }
            },
            {
                key: "hasClass",
                value: function hasClass(element, className) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element || !element.classList) return false;
                    if (!className) return false;
                    return element.classList.contains(className);
                }
            },
            {
                key: "attr",
                value: function attr(element, name, value) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return value === undefined ? null : element;
                    if (value === undefined) return element.getAttribute(name);
                    element.setAttribute(name, value);
                    return element;
                }
            },
            {
                key: "removeAttr",
                value: function removeAttr(element, name) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return element;
                    element.removeAttribute(name);
                    return element;
                }
            },
            {
                key: "data",
                value: function data(element, key, value) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return value === undefined ? undefined : element;
                    if (value === undefined) return element.dataset[key];
                    element.dataset[key] = value;
                    return element;
                }
            },
            {
                key: "append",
                value: function append(parent, child) {
                    if (typeof parent === 'string') parent = this.$(parent);
                    if (typeof child === 'string') child = this.create(child);
                    if (parent && child) parent.appendChild(child);
                    return parent;
                }
            },
            {
                key: "prepend",
                value: function prepend(parent, child) {
                    if (typeof parent === 'string') parent = this.$(parent);
                    if (typeof child === 'string') child = this.create(child);
                    if (parent && child) parent.insertBefore(child, parent.firstChild);
                    return parent;
                }
            },
            {
                key: "insertAfter",
                value: function insertAfter(newElement, targetElement) {
                    if (typeof targetElement === 'string') targetElement = this.$(targetElement);
                    if (typeof newElement === 'string') newElement = this.create(newElement);
                    if (targetElement && newElement && targetElement.parentNode) targetElement.parentNode.insertBefore(newElement, targetElement.nextSibling);
                    return newElement;
                }
            },
            {
                key: "insertBefore",
                value: function insertBefore(newElement, targetElement) {
                    if (typeof targetElement === 'string') targetElement = this.$(targetElement);
                    if (typeof newElement === 'string') newElement = this.create(newElement);
                    if (targetElement && newElement && targetElement.parentNode) targetElement.parentNode.insertBefore(newElement, targetElement);
                    return newElement;
                }
            },
            {
                key: "find",
                value: function find(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return [];
                    return Array.from(element.querySelectorAll(selector));
                }
            },
            {
                key: "findFirst",
                value: function findFirst(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return null;
                    return element.querySelector(selector);
                }
            },
            {
                key: "css",
                value: function css(element, property, value) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return null;
                    if (_typeof(property) === 'object') {
                        // Batch set styles
                        Object.assign(element.style, property);
                        return element;
                    }
                    if (value === undefined) // Get style
                    return getComputedStyle(element)[property];
                    // Set style
                    element.style[property] = value;
                    return element;
                }
            },
            {
                key: "width",
                value: function width(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return 0;
                    return element.offsetWidth;
                }
            },
            {
                key: "height",
                value: function height(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return 0;
                    return element.offsetHeight;
                }
            },
            {
                key: "outerWidth",
                value: function outerWidth(element) {
                    var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return 0;
                    var width = element.offsetWidth;
                    if (includeMargin) {
                        var style = getComputedStyle(element);
                        var marginLeft = parseInt(style.marginLeft, 10) || 0;
                        var marginRight = parseInt(style.marginRight, 10) || 0;
                        width += marginLeft + marginRight;
                    }
                    return width;
                }
            },
            {
                key: "outerHeight",
                value: function outerHeight(element) {
                    var includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return 0;
                    var height = element.offsetHeight;
                    if (includeMargin) {
                        var style = getComputedStyle(element);
                        var marginTop = parseInt(style.marginTop, 10) || 0;
                        var marginBottom = parseInt(style.marginBottom, 10) || 0;
                        height += marginTop + marginBottom;
                    }
                    return height;
                }
            },
            {
                key: "val",
                value: function val(element, value) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return value === undefined ? null : element;
                    if (value === undefined) return element.value;
                    element.value = value;
                    return element;
                }
            },
            {
                key: "html",
                value: function html(element, content) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return content === undefined ? null : element;
                    if (content === undefined) return element.innerHTML;
                    element.innerHTML = content;
                    return element;
                }
            },
            {
                key: "text",
                value: function text(element, content) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return content === undefined ? null : element;
                    if (content === undefined) return element.textContent;
                    element.textContent = content;
                    return element;
                }
            },
            {
                key: "remove",
                value: function remove(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element || !element.parentNode) return element;
                    element.parentNode.removeChild(element);
                    return element;
                }
            },
            {
                key: "empty",
                value: function empty(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return element;
                    element.innerHTML = '';
                    return element;
                }
            },
            {
                key: "each",
                value: function each(elements, callback) {
                    if (typeof elements === 'string') elements = this.$$(elements);
                    else if (elements instanceof NodeList) elements = Array.from(elements);
                    else if (!Array.isArray(elements)) elements = [
                        elements
                    ];
                    elements.forEach(function(element, index) {
                        callback.call(element, index, element);
                    });
                    return elements;
                }
            },
            {
                key: "parent",
                value: function parent(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return null;
                    var parent = element.parentElement;
                    if (selector) while(parent && !parent.matches(selector))parent = parent.parentElement;
                    return parent;
                }
            },
            {
                key: "children",
                value: function children(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return [];
                    var children = Array.from(element.children);
                    if (selector) children = children.filter(function(child) {
                        return child.matches(selector);
                    });
                    return children;
                }
            },
            {
                key: "next",
                value: function next(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return null;
                    var next = element.nextElementSibling;
                    if (selector) while(next && !next.matches(selector))next = next.nextElementSibling;
                    return next;
                }
            },
            {
                key: "prev",
                value: function prev(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return null;
                    var prev = element.previousElementSibling;
                    if (selector) while(prev && !prev.matches(selector))prev = prev.previousElementSibling;
                    return prev;
                }
            },
            {
                key: "offset",
                value: function offset(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return {
                        top: 0,
                        left: 0,
                        width: 0,
                        height: 0
                    };
                    var rect = element.getBoundingClientRect();
                    return {
                        top: rect.top + window.scrollY,
                        left: rect.left + window.scrollX,
                        width: rect.width,
                        height: rect.height
                    };
                }
            },
            {
                key: "position",
                value: function position(element) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return {
                        top: 0,
                        left: 0
                    };
                    return {
                        top: element.offsetTop,
                        left: element.offsetLeft
                    };
                }
            },
            {
                key: "is",
                value: function is(element, selector) {
                    if (typeof element === 'string') element = this.$(element);
                    if (!element) return false;
                    return element.matches(selector);
                }
            }
        ]);
    }(); // Export DOMHelper class
    /**
   * Framework detection and icon utilities.
   *
   * This module provides utility functions for detecting the Bootstrap framework version
   * and managing icon prefixes and mappings for different CSS frameworks.
   *
   * @module utils/framework
   */ /**
   * Returns the prefix for the icons based on the theme.
   *
   * @param {string} theme - The theme name (bootstrap3, bootstrap4, bootstrap5, bootstrap-table, bulma, foundation, materialize, semantic).
   * @returns {string} The icons prefix.
   */ function getIconsPrefix(theme) {
        return ({
            bootstrap3: 'glyphicon',
            bootstrap4: 'fa',
            bootstrap5: 'bi',
            'bootstrap-table': 'icon',
            bulma: 'fa',
            foundation: 'fa',
            materialize: 'material-icons',
            semantic: 'fa'
        })[theme] || 'fa';
    }
    /**
   * Gets the icons for a given prefix.
   *
   * @param {Object.<string, Object>} icons - The icons object.
   * @param {string} prefix - The prefix. For example, 'fa', 'bi', etc.
   * @return {Object} The icons object for the given prefix.
   */ function getIcons(icons, prefix) {
        return icons[prefix] || {};
    }
    /**
   * Assigns new icons to icons object.
   *
   * @param {Object.<string, Object>} icons - The icons object.
   * @param {string} icon - The icon name. For example, 'search', 'refresh', etc.
   * @param {Object.<string, string>} values - The values object.
   */ function assignIcons(icons, icon, values) {
        for(var _i = 0, _Object$keys = Object.keys(icons); _i < _Object$keys.length; _i++){
            var key = _Object$keys[_i];
            icons[key][icon] = values[key];
        }
    }
    /**
   * Gets the Bootstrap version.
   *
   * @returns {number|undefined} The Bootstrap version number (3, 4, or 5), or undefined for non-Bootstrap themes.
   */ function getBootstrapVersion() {
        var _$$fn, _window$bootstrap, _$$fn2;
        // Check if using a non-Bootstrap theme
        if (typeof $ !== 'undefined' && (_$$fn = $.fn) !== null && _$$fn !== void 0 && (_$$fn = _$$fn.bootstrapTable) !== null && _$$fn !== void 0 && _$$fn.theme) {
            var theme = $.fn.bootstrapTable.theme;
            if (!theme.startsWith('bootstrap')) return;
        }
        var bootstrapVersion = 5;
        if (typeof window !== 'undefined' && (_window$bootstrap = window.bootstrap) !== null && _window$bootstrap !== void 0 && (_window$bootstrap = _window$bootstrap.Tooltip) !== null && _window$bootstrap !== void 0 && _window$bootstrap.VERSION) bootstrapVersion = parseInt(window.bootstrap.Tooltip.VERSION, 10);
        else if (typeof $ !== 'undefined' && (_$$fn2 = $.fn) !== null && _$$fn2 !== void 0 && (_$$fn2 = _$$fn2.dropdown) !== null && _$$fn2 !== void 0 && (_$$fn2 = _$$fn2.Constructor) !== null && _$$fn2 !== void 0 && _$$fn2.VERSION) bootstrapVersion = parseInt($.fn.dropdown.Constructor.VERSION, 10);
        return bootstrapVersion;
    }
    /**
   * Gets the search input element.
   *
   * @param {Object} that - The Bootstrap Table instance.
   * @returns {HTMLElement|null} The search input element, or null if not found.
   */ function getSearchInput(that) {
        if (typeof that.options.searchSelector === 'string') return DOMHelper.$(that.options.searchSelector);
        var toolbar = that.$toolbar ? that.$toolbar[0] : null;
        if (!toolbar) return null;
        var result = DOMHelper.find(toolbar, '.search input');
        return result.length > 0 ? result[0] : null;
    }
    var framework = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        assignIcons: assignIcons,
        getBootstrapVersion: getBootstrapVersion,
        getIcons: getIcons,
        getIconsPrefix: getIconsPrefix,
        getSearchInput: getSearchInput
    });
    var es_object_getPrototypeOf = {};
    var hasRequiredEs_object_getPrototypeOf;
    function requireEs_object_getPrototypeOf() {
        if (hasRequiredEs_object_getPrototypeOf) return es_object_getPrototypeOf;
        hasRequiredEs_object_getPrototypeOf = 1;
        var $ = require_export();
        var fails = requireFails();
        var toObject = requireToObject();
        var nativeGetPrototypeOf = requireObjectGetPrototypeOf();
        var CORRECT_PROTOTYPE_GETTER = requireCorrectPrototypeGetter();
        var FAILS_ON_PRIMITIVES = fails(function() {
            nativeGetPrototypeOf(1);
        });
        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        $({
            target: 'Object',
            stat: true,
            forced: FAILS_ON_PRIMITIVES,
            sham: !CORRECT_PROTOTYPE_GETTER
        }, {
            getPrototypeOf: function getPrototypeOf(it) {
                return nativeGetPrototypeOf(toObject(it));
            }
        });
        return es_object_getPrototypeOf;
    }
    requireEs_object_getPrototypeOf();
    /**
   * Object manipulation utilities.
   *
   * This module provides utility functions for working with plain JavaScript objects,
   * including deep copying, merging, comparing, and checking object properties.
   *
   * @module utils/object
   */ /**
   * Checks if a value is a plain object.
   *
   * @param {*} obj - The value to check.
   * @returns {boolean} True if the value is a plain object, false otherwise.
   */ function isObject(obj) {
        if (_typeof(obj) !== 'object' || obj === null) return false;
        var proto = obj;
        while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
        return Object.getPrototypeOf(obj) === proto;
    }
    // $.extend: https://github.com/jquery/jquery/blob/3.6.2/src/core.js#L132
    /**
   * Merges the contents of two or more objects together into the first object.
   * This is a re-implementation of jQuery's extend function.
   *
   * @param {boolean} [deep=false] - If true, the merge becomes recursive (deep copy).
   * @param {Object} target - The object to extend.
   * @param {...Object} objects - The objects to merge into the target.
   * @returns {Object} The extended target object.
   */ function extend() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var target = args[0] || {};
        var i = 1;
        var deep = false;
        var clone;
        // Handle a deep copy situation
        if (typeof target === 'boolean') {
            deep = target;
            // Skip the boolean and the target
            target = args[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (_typeof(target) !== 'object' && typeof target !== 'function') target = {};
        for(; i < args.length; i++){
            var options = args[i];
            // Ignore undefined/null values
            if (typeof options === 'undefined' || options === null) continue;
            // Extend the base object
            // eslint-disable-next-line guard-for-in
            for(var name in options){
                var copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === '__proto__' || target === copy) continue;
                var copyIsArray = Array.isArray(copy);
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (isObject(copy) || copyIsArray)) {
                    var src = target[name];
                    if (copyIsArray && Array.isArray(src)) {
                        if (src.every(function(it) {
                            return !isObject(it) && !Array.isArray(it);
                        })) {
                            target[name] = copy;
                            continue;
                        }
                    }
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !isObject(src)) clone = {};
                    else clone = src;
                    // Never move original objects, clone them
                    target[name] = extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        return target;
    }
    /**
   * Creates a deep copy of a value.
   *
   * @param {*} arg - The value to deep copy.
   * @returns {*} A deep copy of the input value.
   */ function deepCopy(arg) {
        if (arg === undefined) return arg;
        return extend(true, Array.isArray(arg) ? [] : {}, arg);
    }
    /**
   * Compares two objects for equality.
   *
   * @param {Object} objectA - The first object to compare.
   * @param {Object} objectB - The second object to compare.
   * @param {boolean} [compareLength=false] - If true, also compare the number of keys.
   * @returns {boolean} True if the objects are equal, false otherwise.
   */ function compareObjects(objectA, objectB, compareLength) {
        var aKeys = Object.keys(objectA);
        var bKeys = Object.keys(objectB);
        if (compareLength && aKeys.length !== bKeys.length) return false;
        for(var _i = 0, _aKeys = aKeys; _i < _aKeys.length; _i++){
            var key = _aKeys[_i];
            if (bKeys.includes(key) && objectA[key] !== objectB[key]) return false;
        }
        return true;
    }
    /**
   * Checks if an object is empty (has no own properties).
   *
   * @param {Object} [obj={}] - The object to check.
   * @returns {boolean} True if the object is empty, false otherwise.
   */ function isEmptyObject() {
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.entries(obj).length === 0 && obj.constructor === Object;
    }
    var object = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        compareObjects: compareObjects,
        deepCopy: deepCopy,
        extend: extend,
        isEmptyObject: isEmptyObject,
        isObject: isObject
    });
    var es_regexp_constructor = {};
    var inheritIfRequired;
    var hasRequiredInheritIfRequired;
    function requireInheritIfRequired() {
        if (hasRequiredInheritIfRequired) return inheritIfRequired;
        hasRequiredInheritIfRequired = 1;
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var setPrototypeOf = requireObjectSetPrototypeOf();
        // makes subclassing work correct for wrapped built-ins
        inheritIfRequired = function($this, dummy, Wrapper) {
            var NewTarget, NewTargetPrototype;
            if (// it can work only with native `setPrototypeOf`
            setPrototypeOf && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
            isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) setPrototypeOf($this, NewTargetPrototype);
            return $this;
        };
        return inheritIfRequired;
    }
    var proxyAccessor;
    var hasRequiredProxyAccessor;
    function requireProxyAccessor() {
        if (hasRequiredProxyAccessor) return proxyAccessor;
        hasRequiredProxyAccessor = 1;
        var defineProperty = requireObjectDefineProperty().f;
        proxyAccessor = function(Target, Source, key) {
            key in Target || defineProperty(Target, key, {
                configurable: true,
                get: function() {
                    return Source[key];
                },
                set: function(it) {
                    Source[key] = it;
                }
            });
        };
        return proxyAccessor;
    }
    var defineBuiltInAccessor;
    var hasRequiredDefineBuiltInAccessor;
    function requireDefineBuiltInAccessor() {
        if (hasRequiredDefineBuiltInAccessor) return defineBuiltInAccessor;
        hasRequiredDefineBuiltInAccessor = 1;
        var makeBuiltIn = requireMakeBuiltIn();
        var defineProperty = requireObjectDefineProperty();
        defineBuiltInAccessor = function(target, name, descriptor) {
            if (descriptor.get) makeBuiltIn(descriptor.get, name, {
                getter: true
            });
            if (descriptor.set) makeBuiltIn(descriptor.set, name, {
                setter: true
            });
            return defineProperty.f(target, name, descriptor);
        };
        return defineBuiltInAccessor;
    }
    var setSpecies;
    var hasRequiredSetSpecies;
    function requireSetSpecies() {
        if (hasRequiredSetSpecies) return setSpecies;
        hasRequiredSetSpecies = 1;
        var getBuiltIn = requireGetBuiltIn();
        var defineBuiltInAccessor = requireDefineBuiltInAccessor();
        var wellKnownSymbol = requireWellKnownSymbol();
        var DESCRIPTORS = requireDescriptors();
        var SPECIES = wellKnownSymbol('species');
        setSpecies = function(CONSTRUCTOR_NAME) {
            var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
            if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineBuiltInAccessor(Constructor, SPECIES, {
                configurable: true,
                get: function() {
                    return this;
                }
            });
        };
        return setSpecies;
    }
    var hasRequiredEs_regexp_constructor;
    function requireEs_regexp_constructor() {
        if (hasRequiredEs_regexp_constructor) return es_regexp_constructor;
        hasRequiredEs_regexp_constructor = 1;
        var DESCRIPTORS = requireDescriptors();
        var globalThis1 = requireGlobalThis();
        var uncurryThis = requireFunctionUncurryThis();
        var isForced = requireIsForced();
        var inheritIfRequired = requireInheritIfRequired();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var create = requireObjectCreate();
        var getOwnPropertyNames = requireObjectGetOwnPropertyNames().f;
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var isRegExp = requireIsRegexp();
        var toString = requireToString();
        var getRegExpFlags = requireRegexpGetFlags();
        var stickyHelpers = requireRegexpStickyHelpers();
        var proxyAccessor = requireProxyAccessor();
        var defineBuiltIn = requireDefineBuiltIn();
        var fails = requireFails();
        var hasOwn = requireHasOwnProperty();
        var enforceInternalState = requireInternalState().enforce;
        var setSpecies = requireSetSpecies();
        var wellKnownSymbol = requireWellKnownSymbol();
        var UNSUPPORTED_DOT_ALL = requireRegexpUnsupportedDotAll();
        var UNSUPPORTED_NCG = requireRegexpUnsupportedNcg();
        var MATCH = wellKnownSymbol('match');
        var NativeRegExp = globalThis1.RegExp;
        var RegExpPrototype = NativeRegExp.prototype;
        var SyntaxError = globalThis1.SyntaxError;
        var exec = uncurryThis(RegExpPrototype.exec);
        var charAt = uncurryThis(''.charAt);
        var replace = uncurryThis(''.replace);
        var stringIndexOf = uncurryThis(''.indexOf);
        var stringSlice = uncurryThis(''.slice);
        // TODO: Use only proper RegExpIdentifierName
        var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
        var re1 = /a/g;
        var re2 = /a/g;
        // "new" should create a new object, old webkit bug
        var CORRECT_NEW = new NativeRegExp(re1) !== re1;
        var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
        var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
        var BASE_FORCED = DESCRIPTORS && (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function() {
            re2[MATCH] = false;
            // RegExp constructor can alter flags and IsRegExp works correct with @@match
            // eslint-disable-next-line sonarjs/inconsistent-function-call -- required for testing
            return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
        }));
        var handleDotAll = function(string) {
            var length = string.length;
            var index = 0;
            var result = '';
            var brackets = false;
            var chr;
            for(; index < length; index++){
                chr = charAt(string, index);
                if (chr === '\\') {
                    result += chr + charAt(string, ++index);
                    continue;
                }
                if (!brackets && chr === '.') result += '[\\s\\S]';
                else {
                    if (chr === '[') brackets = true;
                    else if (chr === ']') brackets = false;
                    result += chr;
                }
            }
            return result;
        };
        var handleNCG = function(string) {
            var length = string.length;
            var index = 0;
            var result = '';
            var named = [];
            var names = create(null);
            var brackets = false;
            var ncg = false;
            var groupid = 0;
            var groupname = '';
            var chr;
            for(; index < length; index++){
                chr = charAt(string, index);
                if (chr === '\\') {
                    chr += charAt(string, ++index);
                    // use `\x5c` for escaped backslash to avoid corruption by `\k<name>` to `\N` replacement below
                    if (!ncg && charAt(chr, 1) === '\\') {
                        result += '\\x5c';
                        continue;
                    }
                } else if (chr === ']') brackets = false;
                else if (!brackets) switch(true){
                    case chr === '[':
                        brackets = true;
                        break;
                    case chr === '(':
                        result += chr;
                        if (exec(IS_NCG, stringSlice(string, index + 1))) {
                            index += 2;
                            ncg = true;
                            groupid++;
                        } else if (charAt(string, index + 1) !== '?') groupid++;
                        continue;
                    case chr === '>' && ncg:
                        if (groupname === '' || hasOwn(names, groupname)) throw new SyntaxError('Invalid capture group name');
                        names[groupname] = true;
                        named[named.length] = [
                            groupname,
                            groupid
                        ];
                        ncg = false;
                        groupname = '';
                        continue;
                }
                if (ncg) groupname += chr;
                else result += chr;
            }
            // convert `\k<name>` backreferences to numbered backreferences
            for(var ni = 0; ni < named.length; ni++){
                var backref = '\\k<' + named[ni][0] + '>';
                var numRef = '\\' + named[ni][1];
                while(stringIndexOf(result, backref) > -1)result = replace(result, backref, numRef);
            }
            return [
                result,
                named
            ];
        };
        // `RegExp` constructor
        // https://tc39.es/ecma262/#sec-regexp-constructor
        if (isForced('RegExp', BASE_FORCED)) {
            var RegExpWrapper = function RegExp1(pattern, flags) {
                var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
                var patternIsRegExp = isRegExp(pattern);
                var flagsAreUndefined = flags === undefined;
                var groups = [];
                var rawPattern = pattern;
                var rawFlags, dotAll, sticky, handled, result, state;
                if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) return pattern;
                if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
                    pattern = pattern.source;
                    if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
                }
                pattern = pattern === undefined ? '' : toString(pattern);
                flags = flags === undefined ? '' : toString(flags);
                rawPattern = pattern;
                if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
                    dotAll = !!flags && stringIndexOf(flags, 's') > -1;
                    if (dotAll) flags = replace(flags, /s/g, '');
                }
                rawFlags = flags;
                if (MISSED_STICKY && 'sticky' in re1) {
                    sticky = !!flags && stringIndexOf(flags, 'y') > -1;
                    if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
                }
                if (UNSUPPORTED_NCG) {
                    handled = handleNCG(pattern);
                    pattern = handled[0];
                    groups = handled[1];
                }
                result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);
                if (dotAll || sticky || groups.length) {
                    state = enforceInternalState(result);
                    if (dotAll) {
                        state.dotAll = true;
                        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
                    }
                    if (sticky) state.sticky = true;
                    if (groups.length) state.groups = groups;
                }
                if (pattern !== rawPattern) try {
                    // fails in old engines, but we have no alternatives for unsupported regex syntax
                    createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
                } catch (error) {}
                return result;
            };
            for(var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;)proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
            RegExpPrototype.constructor = RegExpWrapper;
            RegExpWrapper.prototype = RegExpPrototype;
            defineBuiltIn(globalThis1, 'RegExp', RegExpWrapper, {
                constructor: true
            });
        }
        // https://tc39.es/ecma262/#sec-get-regexp-@@species
        setSpecies('RegExp');
        return es_regexp_constructor;
    }
    requireEs_regexp_constructor();
    var es_regexp_toString = {};
    var hasRequiredEs_regexp_toString;
    function requireEs_regexp_toString() {
        if (hasRequiredEs_regexp_toString) return es_regexp_toString;
        hasRequiredEs_regexp_toString = 1;
        var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
        var defineBuiltIn = requireDefineBuiltIn();
        var anObject = requireAnObject();
        var $toString = requireToString();
        var fails = requireFails();
        var getRegExpFlags = requireRegexpGetFlags();
        var TO_STRING = 'toString';
        var RegExpPrototype = RegExp.prototype;
        var nativeToString = RegExpPrototype[TO_STRING];
        var NOT_GENERIC = fails(function() {
            return nativeToString.call({
                source: 'a',
                flags: 'b'
            }) !== '/a/b';
        });
        // FF44- RegExp#toString has a wrong name
        var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
        // `RegExp.prototype.toString` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
        if (NOT_GENERIC || INCORRECT_NAME) defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
            var R = anObject(this);
            var pattern = $toString(R.source);
            var flags = $toString(getRegExpFlags(R));
            return '/' + pattern + '/' + flags;
        }, {
            unsafe: true
        });
        return es_regexp_toString;
    }
    requireEs_regexp_toString();
    var es_string_replace = {};
    var functionApply;
    var hasRequiredFunctionApply;
    function requireFunctionApply() {
        if (hasRequiredFunctionApply) return functionApply;
        hasRequiredFunctionApply = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var FunctionPrototype = Function.prototype;
        var apply = FunctionPrototype.apply;
        var call = FunctionPrototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
        functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
            return call.apply(apply, arguments);
        });
        return functionApply;
    }
    var getSubstitution;
    var hasRequiredGetSubstitution;
    function requireGetSubstitution() {
        if (hasRequiredGetSubstitution) return getSubstitution;
        hasRequiredGetSubstitution = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toObject = requireToObject();
        var floor = Math.floor;
        var charAt = uncurryThis(''.charAt);
        var replace = uncurryThis(''.replace);
        var stringSlice = uncurryThis(''.slice);
        // eslint-disable-next-line redos/no-vulnerable -- safe
        var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
        var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
        // `GetSubstitution` abstract operation
        // https://tc39.es/ecma262/#sec-getsubstitution
        getSubstitution = function(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
            if (namedCaptures !== undefined) {
                namedCaptures = toObject(namedCaptures);
                symbols = SUBSTITUTION_SYMBOLS;
            }
            return replace(replacement, symbols, function(match, ch) {
                var capture;
                switch(charAt(ch, 0)){
                    case '$':
                        return '$';
                    case '&':
                        return matched;
                    case '`':
                        return stringSlice(str, 0, position);
                    case "'":
                        return stringSlice(str, tailPos);
                    case '<':
                        capture = namedCaptures[stringSlice(ch, 1, -1)];
                        break;
                    default:
                        var n = +ch;
                        if (n === 0) return match;
                        if (n > m) {
                            var f = floor(n / 10);
                            if (f === 0) return match;
                            if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                            return match;
                        }
                        capture = captures[n - 1];
                }
                return capture === undefined ? '' : capture;
            });
        };
        return getSubstitution;
    }
    var hasRequiredEs_string_replace;
    function requireEs_string_replace() {
        if (hasRequiredEs_string_replace) return es_string_replace;
        hasRequiredEs_string_replace = 1;
        var apply = requireFunctionApply();
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var fails = requireFails();
        var anObject = requireAnObject();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var toLength = requireToLength();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var advanceStringIndex = requireAdvanceStringIndex();
        var getMethod = requireGetMethod();
        var getSubstitution = requireGetSubstitution();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var wellKnownSymbol = requireWellKnownSymbol();
        var REPLACE = wellKnownSymbol('replace');
        var max = Math.max;
        var min = Math.min;
        var concat = uncurryThis([].concat);
        var push = uncurryThis([].push);
        var stringIndexOf = uncurryThis(''.indexOf);
        var stringSlice = uncurryThis(''.slice);
        var maybeToString = function(it) {
            return it === undefined ? it : String(it);
        };
        // IE <= 11 replaces $0 with the whole match, as if it was $&
        // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
        var REPLACE_KEEPS_$0 = function() {
            // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
            return 'a'.replace(/./, '$0') === '$0';
        }();
        // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
        var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
            if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
            return false;
        }();
        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
            var re = /./;
            re.exec = function() {
                var result = [];
                result.groups = {
                    a: '7'
                };
                return result;
            };
            // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
            return ''.replace(re, '$<a>') !== '7';
        });
        // @@replace logic
        fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
            var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
            return [
                // `String.prototype.replace` method
                // https://tc39.es/ecma262/#sec-string.prototype.replace
                function replace(searchValue, replaceValue) {
                    var O = requireObjectCoercible(this);
                    var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
                    return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                function(string, replaceValue) {
                    var rx = anObject(this);
                    var S = toString(string);
                    var functionalReplace = isCallable(replaceValue);
                    if (!functionalReplace) replaceValue = toString(replaceValue);
                    var flags = toString(getRegExpFlags(rx));
                    if (typeof replaceValue == 'string' && !~stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) && !~stringIndexOf(replaceValue, '$<') && !~stringIndexOf(flags, 'y')) {
                        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                        if (res.done) return res.value;
                    }
                    var global1 = !!~stringIndexOf(flags, 'g');
                    var fullUnicode;
                    if (global1) {
                        fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                        rx.lastIndex = 0;
                    }
                    var results = [];
                    var result;
                    while(true){
                        result = regExpExec(rx, S);
                        if (result === null) break;
                        push(results, result);
                        if (!global1) break;
                        var matchStr = toString(result[0]);
                        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                    }
                    var accumulatedResult = '';
                    var nextSourcePosition = 0;
                    for(var i = 0; i < results.length; i++){
                        result = results[i];
                        var matched = toString(result[0]);
                        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                        var captures = [];
                        var replacement;
                        // NOTE: This is equivalent to
                        //   captures = result.slice(1).map(maybeToString)
                        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                        for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                        var namedCaptures = result.groups;
                        if (functionalReplace) {
                            var replacerArgs = concat([
                                matched
                            ], captures, position, S);
                            if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                            replacement = toString(apply(replaceValue, undefined, replacerArgs));
                        } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                        if (position >= nextSourcePosition) {
                            accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                            nextSourcePosition = position + matched.length;
                        }
                    }
                    return accumulatedResult + stringSlice(S, nextSourcePosition);
                }
            ];
        }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
        return es_string_replace;
    }
    requireEs_string_replace();
    /**
   * String manipulation utilities.
   *
   * This module provides utility functions for string processing, including:
   * - String formatting (sprintf)
   * - HTML escaping and unescaping
   * - Accent character normalization for search
   * - HTML tag removal
   * - CSS style string normalization
   *
   * @module utils/string
   */ /**
   * Mapping of accented characters to their non-accented equivalents.
   * Used by normalizeAccent function to convert accented characters.
   *
   * @constant {Object.<string, string>}
   */ var ACCENT_MAP = {
        // Nordic
        "\xc6": 'AE',
        "\xe6": 'ae',
        "\xd8": 'O',
        "\xf8": 'o',
        "\xc5": 'A',
        "\xe5": 'a',
        // German
        "\xc4": 'A',
        "\xe4": 'a',
        "\xd6": 'O',
        "\xf6": 'o',
        "\xdc": 'U',
        "\xfc": 'u',
        \u1E9E: 'SS',
        "\xdf": 'ss',
        // French & others
        \u0152: 'OE',
        \u0153: 'oe',
        // Slavic/Central European
        \u010C: 'C',
        \u010D: 'c',
        \u0106: 'C',
        \u0107: 'c',
        \u0160: 'S',
        \u0161: 's',
        \u017D: 'Z',
        \u017E: 'z',
        \u0141: 'L',
        \u0142: 'l',
        \u0110: 'Dj',
        \u0111: 'dj',
        \u0143: 'N',
        \u0144: 'n',
        \u0118: 'E',
        \u0119: 'e',
        \u0104: 'A',
        \u0105: 'a',
        \u0154: 'R',
        \u0155: 'r',
        // Turkish
        \u011E: 'G',
        \u011F: 'g',
        \u0130: 'I',
        \u0131: 'i',
        \u015E: 'S',
        \u015F: 's',
        // Romanian
        \u0102: 'A',
        \u0103: 'a',
        "\xc2": 'A',
        "\xe2": 'a',
        "\xce": 'I',
        "\xee": 'i',
        \u0218: 'S',
        \u0219: 's',
        \u021A: 'T',
        \u021B: 't',
        // Greek
        \u0391: 'A',
        \u0386: 'A',
        \u03B1: 'a',
        \u03AC: 'a',
        \u0392: 'V',
        \u03B2: 'v',
        \u0393: 'G',
        \u03B3: 'g',
        \u0394: 'D',
        \u03B4: 'd',
        \u0395: 'E',
        \u0388: 'E',
        \u03B5: 'e',
        \u03AD: 'e',
        \u0396: 'Z',
        \u03B6: 'z',
        \u0397: 'I',
        \u0389: 'I',
        \u03B7: 'i',
        \u03AE: 'i',
        \u0399: 'I',
        \u038A: 'I',
        \u03B9: 'i',
        \u03AF: 'i',
        \u039A: 'K',
        \u03BA: 'k',
        \u039B: 'L',
        \u03BB: 'l',
        \u039C: 'M',
        \u03BC: 'm',
        \u039D: 'N',
        \u03BD: 'n',
        \u039E: 'X',
        \u03BE: 'x',
        \u039F: 'O',
        \u038C: 'O',
        \u03BF: 'o',
        \u03CC: 'o',
        \u03A0: 'P',
        \u03C0: 'p',
        \u03A1: 'R',
        \u03C1: 'r',
        \u03A3: 'S',
        \u03C3: 's',
        \u03C2: 's',
        \u03A4: 'T',
        \u03C4: 't',
        \u03A5: 'Y',
        \u038E: 'Y',
        \u03C5: 'y',
        \u03CD: 'y',
        \u03A6: 'F',
        \u03C6: 'f',
        \u03A7: 'CH',
        \u03C7: 'ch',
        \u03A8: 'PS',
        \u03C8: 'ps',
        \u03A9: 'O',
        \u038F: 'O',
        \u03C9: 'o',
        \u03CE: 'o'
    };
    /**
   * Simple string formatter that replaces %s placeholders with provided arguments.
   * Only supports %s placeholder. Returns empty string if any argument is undefined.
   *
   * @param {string} _str - The format string containing %s placeholders.
   * @param {...*} args - The values to replace the placeholders with.
   * @returns {string} The formatted string, or empty string if any argument is undefined.
   */ function sprintf(_str) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        var flag = true;
        var i = 0;
        var str = _str.replace(/%s/g, function() {
            var arg = args[i++];
            if (typeof arg === 'undefined') {
                flag = false;
                return '';
            }
            return arg;
        });
        return flag ? str : '';
    }
    /**
   * Escapes apostrophes in a string by replacing them with HTML entity.
   *
   * @param {*} value - The value to escape.
   * @returns {string} The string with apostrophes escaped.
   */ function escapeApostrophe(value) {
        return value.toString().replace(/'/g, '&#39;');
    }
    /**
   * Escapes HTML special characters in a string.
   *
   * @param {*} text - The text to escape.
   * @returns {*} The escaped text, or the original value if falsy.
   */ function escapeHTML(text) {
        if (!text) return text;
        return text.toString().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    /**
   * Escapes HTML attribute value to prevent XSS attacks.
   * The order of replacements is important for attributes: & must be first,
   * then " and ' to prevent breaking out of the attribute.
   *
   * @param {*} text - The attribute value to escape.
   * @returns {*} The escaped text, or the original value if falsy.
   */ function escapeAttr(text) {
        if (!text) return text;
        return text.toString().replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
    /**
   * Unescapes HTML entities in a string.
   *
   * @param {*} text - The text to unescape.
   * @returns {*} The unescaped text, or the original value if not a string or falsy.
   */ function unescapeHTML(text) {
        if (typeof text !== 'string' || !text) return text;
        return text.toString().replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, '\'').replace(/&amp;/g, '&');
    }
    /**
   * Removes HTML tags and HTML entities from a string.
   *
   * @param {*} text - The text to remove HTML from.
   * @returns {*} The text with HTML removed, or the original value if falsy.
   */ function removeHTML(text) {
        if (!text) return text;
        return text.toString().replace(/(<([^>]+)>)/ig, '').replace(/&[#A-Za-z0-9]+;/gi, '').trim();
    }
    /**
   * Normalizes accented characters in a string to their non-accented equivalents.
   * Converts to lowercase and removes diacritical marks.
   *
   * @param {*} value - The value to normalize.
   * @returns {*} The normalized string, or the original value if not a string.
   */ function normalizeAccent(value) {
        if (typeof value !== 'string') return value;
        var pattern = new RegExp("[".concat(Object.keys(ACCENT_MAP).join(''), "]"), 'g');
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(pattern, function(char) {
            return ACCENT_MAP[char];
        }).toLowerCase().trim();
    }
    /**
   * Normalizes a CSS style string by ensuring it ends with '; ' for proper concatenation.
   * Returns undefined if the input is empty or contains only whitespace.
   *
   * @param {string|undefined} style - The style string to normalize.
   * @returns {string|undefined} The normalized style string ending with '; ', or undefined.
   * @example
   * normalizeStyle('color: red')  // returns 'color: red; '
   * normalizeStyle('color: red;') // returns 'color: red; '
   * normalizeStyle('')            // returns undefined
   * normalizeStyle(undefined)     // returns undefined
   */ function normalizeStyle(style) {
        if (!style) return undefined;
        var trimmed = style.trim();
        if (!trimmed) return undefined;
        return trimmed.replace(/;?\s*$/, '; ');
    }
    var string = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        escapeApostrophe: escapeApostrophe,
        escapeAttr: escapeAttr,
        escapeHTML: escapeHTML,
        normalizeAccent: normalizeAccent,
        normalizeStyle: normalizeStyle,
        removeHTML: removeHTML,
        sprintf: sprintf,
        unescapeHTML: unescapeHTML
    });
    var es_array_indexOf = {};
    var hasRequiredEs_array_indexOf;
    function requireEs_array_indexOf() {
        if (hasRequiredEs_array_indexOf) return es_array_indexOf;
        hasRequiredEs_array_indexOf = 1;
        /* eslint-disable es/no-array-prototype-indexof -- required for testing */ var $ = require_export();
        var uncurryThis = requireFunctionUncurryThisClause();
        var $indexOf = requireArrayIncludes().indexOf;
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var nativeIndexOf = uncurryThis([].indexOf);
        var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([
            1
        ], 1, -0) < 0;
        var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        $({
            target: 'Array',
            proto: true,
            forced: FORCED
        }, {
            indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
                var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
                return NEGATIVE_ZERO ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf(this, searchElement, fromIndex);
            }
        });
        return es_array_indexOf;
    }
    requireEs_array_indexOf();
    var es_array_map = {};
    var hasRequiredEs_array_map;
    function requireEs_array_map() {
        if (hasRequiredEs_array_map) return es_array_map;
        hasRequiredEs_array_map = 1;
        var $ = require_export();
        var $map = requireArrayIteration().map;
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        // with adding support of @@species
        $({
            target: 'Array',
            proto: true,
            forced: !HAS_SPECIES_SUPPORT
        }, {
            map: function map(callbackfn /* , thisArg */ ) {
                return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        return es_array_map;
    }
    requireEs_array_map();
    /**
   * DOM manipulation utility functions.
   *
   * This module provides helper functions for DOM manipulation using native JavaScript,
   * including scrollbar width calculation, class name conversion, style parsing,
   * h() function for element creation, and HTML-to-DOM conversion.
   *
   * Note: For a full jQuery-like DOM manipulation library, see src/helpers/dom.js
   *
   * @module utils/dom
   */ var cachedWidth;
    /**
   * Gets the width of the browser scrollbar.
   * The result is cached after the first call for performance.
   *
   * @returns {number} The width of the scrollbar in pixels.
   */ function getScrollBarWidth() {
        if (cachedWidth === undefined) {
            var inner = DOMHelper.create('<div class="fixed-table-scroll-inner"></div>');
            var outer = DOMHelper.create('<div class="fixed-table-scroll-outer"></div>');
            DOMHelper.append(outer, inner);
            DOMHelper.append(document.body, outer);
            var w1 = inner.offsetWidth;
            DOMHelper.css(outer, 'overflow', 'scroll');
            var w2 = inner.offsetWidth;
            if (w1 === w2) w2 = outer.clientWidth;
            DOMHelper.remove(outer);
            cachedWidth = w1 - w2;
        }
        return cachedWidth;
    }
    /**
   * Converts a class specification to a string.
   * Handles string, array, and object formats.
   *
   * @param {string|Array|Object.<string, boolean>} class_ - The class specification.
   * @returns {string} The class names as a space-separated string.
   */ function classToString(class_) {
        if (typeof class_ === 'string') return class_;
        if (Array.isArray(class_)) return class_.map(function(x) {
            return classToString(x);
        }).filter(function(x) {
            return x;
        }).join(' ');
        if (class_ && _typeof(class_) === 'object') return Object.entries(class_).map(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), k = _ref2[0], v = _ref2[1];
            return v ? k : '';
        }).filter(function(x) {
            return x;
        }).join(' ');
        return '';
    }
    /**
   * Parses and applies CSS styles to a DOM element.
   * Supports string, array, and object formats. Handles !important priority.
   *
   * @param {HTMLElement} dom - The DOM element to apply styles to.
   * @param {string|Array|Object.<string, string>} style - The style(s) to apply.
   * @returns {HTMLElement} The DOM element with styles applied.
   */ function parseStyle(dom, style) {
        if (!style) return dom;
        // Helper function to handle !important priority
        var IMPORTANT_PRIORITY_REGEX = /\s*!important\s*$/i;
        var parsePriority = function parsePriority(value) {
            if (typeof value === 'string' && IMPORTANT_PRIORITY_REGEX.test(value)) return {
                value: value.replace(IMPORTANT_PRIORITY_REGEX, ''),
                priority: 'important'
            };
            return {
                value: value,
                priority: ''
            };
        };
        if (typeof style === 'string') style.split(';').forEach(function(i) {
            var index = i.indexOf(':');
            if (index > 0) {
                var k = i.substring(0, index).trim();
                var v = i.substring(index + 1).trim();
                var _parsePriority = parsePriority(v), value = _parsePriority.value, priority = _parsePriority.priority;
                dom.style.setProperty(k, value, priority);
            }
        });
        else if (Array.isArray(style)) {
            var _iterator = _createForOfIteratorHelper(style), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var item = _step.value;
                    parseStyle(dom, item);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        } else if (_typeof(style) === 'object') for(var _i = 0, _Object$entries = Object.entries(style); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), k = _Object$entries$_i[0], v = _Object$entries$_i[1];
            var _parsePriority2 = parsePriority(v), value = _parsePriority2.value, priority = _parsePriority2.priority;
            dom.style.setProperty(k, value, priority);
        }
        return dom;
    }
    /**
   * Creates a DOM element with attributes and children.
   * This function provides a shorthand syntax for creating DOM elements.
   *
   * @param {string|HTMLElement} element - The tag name or existing element.
   * @param {Object.<string, *>} [attrs={}] - The attributes to set on the element.
   * @param {Array.<HTMLElement|string>} [children=[]] - The children to append.
   * @returns {HTMLElement} The created or modified element.
   */ function h(element, attrs, children) {
        var el = element instanceof HTMLElement ? element : document.createElement(element);
        var _attrs = attrs || {};
        var _children = children || [];
        // default attributes
        if (el.tagName === 'A') el.href = 'javascript:';
        for(var _i2 = 0, _Object$entries2 = Object.entries(_attrs); _i2 < _Object$entries2.length; _i2++){
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), k = _Object$entries2$_i[0], v = _Object$entries2$_i[1];
            if (v === undefined) continue;
            if ([
                'text',
                'innerText'
            ].includes(k)) el.innerText = v;
            else if ([
                'html',
                'innerHTML'
            ].includes(k)) el.innerHTML = v;
            else if (k === 'children') _children.push.apply(_children, _toConsumableArray(v));
            else if (k === 'class') el.setAttribute('class', classToString(v));
            else if (k === 'style') {
                if (typeof v === 'string') el.setAttribute('style', v);
                else parseStyle(el, v);
            } else if (k.startsWith('@') || k.startsWith('on')) {
                // event handlers
                var event = k.startsWith('@') ? k.substring(1) : k.substring(2).toLowerCase();
                var args = Array.isArray(v) ? v : [
                    v
                ];
                el.addEventListener.apply(el, [
                    event
                ].concat(_toConsumableArray(args)));
            } else if (k.startsWith('.')) // set property
            el[k.substring(1)] = v;
            else el.setAttribute(k, v);
        }
        if (_children.length) el.append.apply(el, _toConsumableArray(_children));
        return el;
    }
    /**
   * Checks if a value is a DOM node or a jQuery-like object.
   * Uses duck typing to detect jQuery objects without direct dependency.
   *
   * Note: Strings are not considered DOM nodes. Use {@link htmlToNodes} to
   * convert HTML strings into DOM nodes.
   *
   * @param {*} value - The value to check.
   * @returns {boolean} True if the value is a Node or jQuery-like object.
   */ function isDomNode(value) {
        if (value instanceof Node) return true;
        // Duck typing for jQuery-like objects (check for 'jquery' property)
        return Boolean(value && _typeof(value) === 'object' && typeof value.length === 'number' && value.length >= 0 && 'jquery' in value);
    }
    /**
   * Converts HTML to DOM nodes.
   * Uses duck typing to detect jQuery objects without direct dependency.
   *
   * @param {string|Node|Object} html - The HTML to convert. Can be a string, Node, or jQuery-like object.
   * @returns {NodeList|Array<Node>} The DOM nodes.
   */ function htmlToNodes(html) {
        // Duck typing check for jQuery objects (check for 'jquery' property)
        if (html && _typeof(html) === 'object' && 'jquery' in html) return Array.from(html);
        if (html instanceof Node) return [
            html
        ];
        if (typeof html !== 'string') html = new String(html).toString();
        var d = document.createElement('div');
        d.innerHTML = html;
        return d.childNodes;
    }
    var dom = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        classToString: classToString,
        getScrollBarWidth: getScrollBarWidth,
        h: h,
        htmlToNodes: htmlToNodes,
        isDomNode: isDomNode,
        parseStyle: parseStyle
    });
    var es_string_endsWith = {};
    var hasRequiredEs_string_endsWith;
    function requireEs_string_endsWith() {
        if (hasRequiredEs_string_endsWith) return es_string_endsWith;
        hasRequiredEs_string_endsWith = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThisClause();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var toLength = requireToLength();
        var toString = requireToString();
        var notARegExp = requireNotARegexp();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var correctIsRegExpLogic = requireCorrectIsRegexpLogic();
        var IS_PURE = requireIsPure();
        var slice = uncurryThis(''.slice);
        var min = Math.min;
        var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('endsWith');
        // https://github.com/zloirock/core-js/pull/702
        var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
            var descriptor = getOwnPropertyDescriptor(String.prototype, 'endsWith');
            return descriptor && !descriptor.writable;
        }();
        // `String.prototype.endsWith` method
        // https://tc39.es/ecma262/#sec-string.prototype.endswith
        $({
            target: 'String',
            proto: true,
            forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
        }, {
            endsWith: function endsWith(searchString /* , endPosition = @length */ ) {
                var that = toString(requireObjectCoercible(this));
                notARegExp(searchString);
                var search = toString(searchString);
                var endPosition = arguments.length > 1 ? arguments[1] : undefined;
                var len = that.length;
                var end = endPosition === undefined ? len : min(toLength(endPosition), len);
                return slice(that, end - search.length, end) === search;
            }
        });
        return es_string_endsWith;
    }
    requireEs_string_endsWith();
    /**
   * Table column and data processing utilities.
   *
   * This module provides utility functions for working with Bootstrap Table columns and data,
   * including field indexing, data attribute parsing, and conversion between DOM and data formats.
   *
   * @module utils/table-data
   */ /**
   * Gets the title of a field from a list of column definitions.
   *
   * @param {Array.<Object.<string, *>>} list - The list of column definitions.
   * @param {string} value - The field name to look for.
   * @returns {string} The title of the field, or empty string if not found.
   */ function getFieldTitle(list, value) {
        var _iterator = _createForOfIteratorHelper(list), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                if (item.field === value) return item.title;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return '';
    }
    /**
   * Sets field indices for columns with colspan/rowspan support.
   * Modifies the column definitions in place to add fieldIndex and colspanIndex properties.
   *
   * @param {Array.<Array.<Object.<string, *>>>} columns - The column definitions array.
   */ function setFieldIndex(columns) {
        var totalCol = 0;
        var flag = [];
        var _iterator2 = _createForOfIteratorHelper(columns[0]), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var column = _step2.value;
                totalCol += +column.colspan || 1;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        for(var i = 0; i < columns.length; i++){
            flag[i] = [];
            for(var j = 0; j < totalCol; j++)flag[i][j] = false;
        }
        for(var _i = 0; _i < columns.length; _i++){
            var _iterator3 = _createForOfIteratorHelper(columns[_i]), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var r = _step3.value;
                    var rowspan = +r.rowspan || 1;
                    var colspan = +r.colspan || 1;
                    var index = flag[_i].indexOf(false);
                    r.colspanIndex = index;
                    if (colspan === 1) {
                        r.fieldIndex = index;
                        // when field is undefined, use index instead
                        if (typeof r.field === 'undefined') r.field = index;
                    } else r.colspanGroup = +r.colspan;
                    for(var _j = 0; _j < rowspan; _j++)for(var k = 0; k < colspan; k++)flag[_i + _j][index + k] = true;
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
        }
    }
    /**
   * Updates field groups based on column visibility.
   * Modifies the column definitions in place to update colspan and visible properties.
   *
   * @param {Array.<Array.<Object.<string, *>>>} columns - The column definitions array.
   * @param {Array.<Object.<string, *>>} fieldColumns - The field columns to update.
   */ function updateFieldGroup(columns, fieldColumns) {
        var _ref;
        var allColumns = (_ref = []).concat.apply(_ref, _toConsumableArray(columns));
        var _iterator4 = _createForOfIteratorHelper(columns), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var c = _step4.value;
                var _iterator6 = _createForOfIteratorHelper(c), _step6;
                try {
                    for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                        var r = _step6.value;
                        if (r.colspanGroup > 1) {
                            var colspan = 0;
                            var _loop = function _loop(i) {
                                var underColumns = allColumns.filter(function(col) {
                                    return col.fieldIndex === i;
                                });
                                var column = underColumns[underColumns.length - 1];
                                if (!column) return 1; // continue
                                if (underColumns.length > 1) for(var j = 0; j < underColumns.length - 1; j++)underColumns[j].visible = column.visible;
                                if (column.visible) colspan++;
                            };
                            for(var i = r.colspanIndex; i < r.colspanIndex + r.colspanGroup; i++){
                                if (_loop(i)) continue;
                            }
                            r.colspan = colspan;
                            r.visible = colspan > 0;
                        }
                    }
                } catch (err) {
                    _iterator6.e(err);
                } finally{
                    _iterator6.f();
                }
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        if (columns.length < 2) return;
        var _iterator5 = _createForOfIteratorHelper(fieldColumns), _step5;
        try {
            var _loop2 = function _loop2() {
                var column = _step5.value;
                var sameColumns = allColumns.filter(function(col) {
                    return col.fieldIndex === column.fieldIndex;
                });
                if (sameColumns.length > 1) {
                    var _iterator7 = _createForOfIteratorHelper(sameColumns), _step7;
                    try {
                        for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                            var _c = _step7.value;
                            _c.visible = column.visible;
                        }
                    } catch (err) {
                        _iterator7.e(err);
                    } finally{
                        _iterator7.f();
                    }
                }
            };
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;)_loop2();
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
    /**
   * Converts camelCase data attribute names to kebab-case.
   *
   * @param {Object.<string, *>} dataAttr - The data attributes object.
   * @returns {Object.<string, *>} The data attributes with kebab-case keys.
   */ function getRealDataAttr(dataAttr) {
        for(var _i2 = 0, _Object$entries = Object.entries(dataAttr); _i2 < _Object$entries.length; _i2++){
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), attr = _Object$entries$_i[0], value = _Object$entries$_i[1];
            var auxAttr = attr.split(/(?=[A-Z])/).join('-').toLowerCase();
            if (auxAttr !== attr) {
                dataAttr[auxAttr] = value;
                delete dataAttr[attr];
            }
        }
        return dataAttr;
    }
    /**
   * Gets a field value from an item, supporting nested properties.
   *
   * @param {Object.<string, *>} item - The item to get the field from.
   * @param {string} field - The field name (supports dot notation for nested properties).
   * @param {boolean} escape - Whether to escape HTML in the returned value.
   * @param {boolean} [columnEscape=undefined] - Override for the escape parameter.
   * @returns {*} The field value, escaped if requested.
   */ function getItemField(item, field, escape) {
        var columnEscape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
        // use column escape if it is defined
        if (typeof columnEscape !== 'undefined') escape = columnEscape;
        if (typeof field !== 'string' || item.hasOwnProperty(field) || !field.includes('.')) return escape ? escapeHTML(item[field]) : item[field];
        var props = field.split('.');
        var value = item;
        var _iterator8 = _createForOfIteratorHelper(props), _step8;
        try {
            for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                var p = _step8.value;
                if (value === null || value === undefined) return; // undefined
                value = value[p];
            }
        } catch (err) {
            _iterator8.e(err);
        } finally{
            _iterator8.f();
        }
        return escape ? escapeHTML(value) : value;
    }
    /**
   * Finds the index of an item in an array using deep equality.
   *
   * @param {Array.<*>} items - The array to search in.
   * @param {*} item - The item to find.
   * @returns {number} The index of the item, or -1 if not found.
   */ function findIndex(items, item) {
        var _iterator9 = _createForOfIteratorHelper(items), _step9;
        try {
            for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
                var it = _step9.value;
                if (JSON.stringify(it) === JSON.stringify(item)) return items.indexOf(it);
            }
        } catch (err) {
            _iterator9.e(err);
        } finally{
            _iterator9.f();
        }
        return -1;
    }
    /**
   * Converts table rows (tr elements) to data array.
   * Preserves row and cell attributes including id, class, style, and data-* attributes.
   *
   * @param {Array.<Object.<string, *>>} columns - The column definitions.
   * @param {HTMLCollection|NodeList|Array<Element>} els - The tr elements.
   * @returns {Array.<Object.<string, *>>} The array of row data objects.
   */ function trToData(columns, els) {
        var data = [];
        var m = [];
        var elsArray = Array.from(els);
        for(var y = 0; y < elsArray.length; y++){
            var el = elsArray[y];
            var row = {};
            // save tr's id, class and data-* attributes
            row._id = DOMHelper.attr(el, 'id');
            row._class = DOMHelper.attr(el, 'class');
            row._data = getRealDataAttr(_objectSpread2({}, el.dataset));
            row._style = DOMHelper.attr(el, 'style');
            var cells = DOMHelper.children(el, 'td,th');
            for(var x = 0; x < cells.length; x++){
                var cell = cells[x];
                var colspan = parseInt(DOMHelper.attr(cell, 'colspan'), 10) || 1;
                var rowspan = parseInt(DOMHelper.attr(cell, 'rowspan'), 10) || 1;
                var currentX = x;
                // skip already occupied cells in current row
                for(; m[y] && m[y][currentX]; currentX++);
                // mark matrix elements occupied by current cell with true
                for(var tx = currentX; tx < currentX + colspan; tx++)for(var ty = y; ty < y + rowspan; ty++){
                    if (!m[ty]) // fill missing rows
                    m[ty] = [];
                    m[ty][tx] = true;
                }
                var field = columns[currentX].field;
                row[field] = escapeApostrophe(DOMHelper.html(cell).trim());
                // save td's id, class and data-* attributes
                row["_".concat(field, "_id")] = DOMHelper.attr(cell, 'id');
                row["_".concat(field, "_class")] = DOMHelper.attr(cell, 'class');
                row["_".concat(field, "_rowspan")] = DOMHelper.attr(cell, 'rowspan');
                row["_".concat(field, "_colspan")] = DOMHelper.attr(cell, 'colspan');
                row["_".concat(field, "_title")] = DOMHelper.attr(cell, 'title');
                row["_".concat(field, "_data")] = getRealDataAttr(_objectSpread2({}, cell.dataset));
                row["_".concat(field, "_style")] = DOMHelper.attr(cell, 'style');
            }
            data.push(row);
        }
        return data;
    }
    /**
   * Checks if any row in the data has auto-merge cells (rowspan/colspan).
   *
   * @param {Array.<Object.<string, *>>} data - The data array to check.
   * @returns {boolean} True if any row has auto-merge cells, false otherwise.
   */ function checkAutoMergeCells(data) {
        var _iterator0 = _createForOfIteratorHelper(data), _step0;
        try {
            for(_iterator0.s(); !(_step0 = _iterator0.n()).done;){
                var row = _step0.value;
                for(var _i3 = 0, _Object$keys = Object.keys(row); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (key.startsWith('_') && (key.endsWith('_rowspan') || key.endsWith('_colspan'))) return true;
                }
            }
        } catch (err) {
            _iterator0.e(err);
        } finally{
            _iterator0.f();
        }
        return false;
    }
    /**
   * Checks if any row in the data has rowspan cells with a span greater than 1.
   *
   * @param {Array.<Object.<string, *>>} data - The data array to check.
   * @returns {boolean} True if any row has real rowspan merges, false otherwise.
   */ function hasRowspanCells(data) {
        var _iterator1 = _createForOfIteratorHelper(data), _step1;
        try {
            for(_iterator1.s(); !(_step1 = _iterator1.n()).done;){
                var row = _step1.value;
                for(var _i4 = 0, _Object$keys2 = Object.keys(row); _i4 < _Object$keys2.length; _i4++){
                    var key = _Object$keys2[_i4];
                    if (key.startsWith('_') && key.endsWith('_rowspan') && (+row[key] || 0) > 1) return true;
                }
            }
        } catch (err) {
            _iterator1.e(err);
        } finally{
            _iterator1.f();
        }
        return false;
    }
    /**
   * Flattens rowspan cells in the data by copying the cell value from the
   * rowspan parent row into all spanned child rows, so each row becomes
   * independent and can be sorted without breaking the table layout.
   *
   * @param {Array.<Object.<string, *>>} data - The data array to flatten.
   */ function flattenRowspanCells(data) {
        for(var i = 0; i < data.length; i++){
            var row = data[i];
            for(var _i5 = 0, _Object$keys3 = Object.keys(row); _i5 < _Object$keys3.length; _i5++){
                var key = _Object$keys3[_i5];
                if (!key.startsWith('_') || !key.endsWith('_rowspan')) continue;
                var field = key.replace(/^_/, '').replace(/_rowspan$/, '');
                var rowspan = +row[key] || 1;
                if (rowspan <= 1) continue;
                var value = getItemField(row, field, false);
                var useFlatKey = row.hasOwnProperty(field);
                for(var j = 1; j < rowspan && i + j < data.length; j++){
                    var childRow = data[i + j];
                    if (field.includes('.') && !useFlatKey) {
                        var props = field.split('.');
                        var target = childRow;
                        for(var k = 0; k < props.length - 1; k++){
                            if (_typeof(target[props[k]]) !== 'object' || target[props[k]] === null) target[props[k]] = {};
                            target = target[props[k]];
                        }
                        target[props[props.length - 1]] = value;
                    } else childRow[field] = value;
                    delete childRow["_".concat(field, "_rowspan")];
                }
                delete row[key];
            }
        }
    }
    var tableData = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        checkAutoMergeCells: checkAutoMergeCells,
        findIndex: findIndex,
        flattenRowspanCells: flattenRowspanCells,
        getFieldTitle: getFieldTitle,
        getItemField: getItemField,
        getRealDataAttr: getRealDataAttr,
        hasRowspanCells: hasRowspanCells,
        setFieldIndex: setFieldIndex,
        trToData: trToData,
        updateFieldGroup: updateFieldGroup
    });
    var es_string_match = {};
    var hasRequiredEs_string_match;
    function requireEs_string_match() {
        if (hasRequiredEs_string_match) return es_string_match;
        hasRequiredEs_string_match = 1;
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var toLength = requireToLength();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var getMethod = requireGetMethod();
        var advanceStringIndex = requireAdvanceStringIndex();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var stringIndexOf = uncurryThis(''.indexOf);
        // @@match logic
        fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
            return [
                // `String.prototype.match` method
                // https://tc39.es/ecma262/#sec-string.prototype.match
                function match(regexp) {
                    var O = requireObjectCoercible(this);
                    var matcher = isObject(regexp) ? getMethod(regexp, MATCH) : undefined;
                    return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
                },
                // `RegExp.prototype[@@match]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                function(string) {
                    var rx = anObject(this);
                    var S = toString(string);
                    var res = maybeCallNative(nativeMatch, rx, S);
                    if (res.done) return res.value;
                    var flags = toString(getRegExpFlags(rx));
                    if (!~stringIndexOf(flags, 'g')) return regExpExec(rx, S);
                    var fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                    rx.lastIndex = 0;
                    var A = [];
                    var n = 0;
                    var result;
                    while((result = regExpExec(rx, S)) !== null){
                        var matchStr = toString(result[0]);
                        A[n] = matchStr;
                        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                        n++;
                    }
                    return n === 0 ? null : A;
                }
            ];
        });
        return es_string_match;
    }
    requireEs_string_match();
    var es_string_search = {};
    var sameValue;
    var hasRequiredSameValue;
    function requireSameValue() {
        if (hasRequiredSameValue) return sameValue;
        hasRequiredSameValue = 1;
        // `SameValue` abstract operation
        // https://tc39.es/ecma262/#sec-samevalue
        // eslint-disable-next-line es/no-object-is -- safe
        sameValue = Object.is || function is(x, y) {
            // eslint-disable-next-line no-self-compare -- NaN check
            return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
        };
        return sameValue;
    }
    var hasRequiredEs_string_search;
    function requireEs_string_search() {
        if (hasRequiredEs_string_search) return es_string_search;
        hasRequiredEs_string_search = 1;
        var call = requireFunctionCall();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var sameValue = requireSameValue();
        var toString = requireToString();
        var getMethod = requireGetMethod();
        var regExpExec = requireRegexpExecAbstract();
        // @@search logic
        fixRegExpWellKnownSymbolLogic('search', function(SEARCH, nativeSearch, maybeCallNative) {
            return [
                // `String.prototype.search` method
                // https://tc39.es/ecma262/#sec-string.prototype.search
                function search(regexp) {
                    var O = requireObjectCoercible(this);
                    var searcher = isObject(regexp) ? getMethod(regexp, SEARCH) : undefined;
                    return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
                },
                // `RegExp.prototype[@@search]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
                function(string) {
                    var rx = anObject(this);
                    var S = toString(string);
                    var res = maybeCallNative(nativeSearch, rx, S);
                    if (res.done) return res.value;
                    var previousLastIndex = rx.lastIndex;
                    if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
                    var result = regExpExec(rx, S);
                    if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
                    return result === null ? -1 : result.index;
                }
            ];
        });
        return es_string_search;
    }
    requireEs_string_search();
    var es_array_iterator;
    var hasRequiredEs_array_iterator;
    function requireEs_array_iterator() {
        if (hasRequiredEs_array_iterator) return es_array_iterator;
        hasRequiredEs_array_iterator = 1;
        var toIndexedObject = requireToIndexedObject();
        var addToUnscopables = requireAddToUnscopables();
        var Iterators = requireIterators();
        var InternalStateModule = requireInternalState();
        var defineProperty = requireObjectDefineProperty().f;
        var defineIterator = requireIteratorDefine();
        var createIterResultObject = requireCreateIterResultObject();
        var IS_PURE = requireIsPure();
        var DESCRIPTORS = requireDescriptors();
        var ARRAY_ITERATOR = 'Array Iterator';
        var setInternalState = InternalStateModule.set;
        var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
        // `Array.prototype.entries` method
        // https://tc39.es/ecma262/#sec-array.prototype.entries
        // `Array.prototype.keys` method
        // https://tc39.es/ecma262/#sec-array.prototype.keys
        // `Array.prototype.values` method
        // https://tc39.es/ecma262/#sec-array.prototype.values
        // `Array.prototype[@@iterator]` method
        // https://tc39.es/ecma262/#sec-array.prototype-@@iterator
        // `CreateArrayIterator` internal method
        // https://tc39.es/ecma262/#sec-createarrayiterator
        es_array_iterator = defineIterator(Array, 'Array', function(iterated, kind) {
            setInternalState(this, {
                type: ARRAY_ITERATOR,
                target: toIndexedObject(iterated),
                index: 0,
                kind: kind // kind
            });
        // `%ArrayIteratorPrototype%.next` method
        // https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
        }, function() {
            var state = getInternalState(this);
            var target = state.target;
            var index = state.index++;
            if (!target || index >= target.length) {
                state.target = null;
                return createIterResultObject(undefined, true);
            }
            switch(state.kind){
                case 'keys':
                    return createIterResultObject(index, false);
                case 'values':
                    return createIterResultObject(target[index], false);
            }
            return createIterResultObject([
                index,
                target[index]
            ], false);
        }, 'values');
        // argumentsList[@@iterator] is %ArrayProto_values%
        // https://tc39.es/ecma262/#sec-createunmappedargumentsobject
        // https://tc39.es/ecma262/#sec-createmappedargumentsobject
        var values = Iterators.Arguments = Iterators.Array;
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        // V8 ~ Chrome 45- bug
        if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
            defineProperty(values, 'name', {
                value: 'values'
            });
        } catch (error) {}
        return es_array_iterator;
    }
    requireEs_array_iterator();
    var es_array_slice = {};
    var arraySlice;
    var hasRequiredArraySlice;
    function requireArraySlice() {
        if (hasRequiredArraySlice) return arraySlice;
        hasRequiredArraySlice = 1;
        var uncurryThis = requireFunctionUncurryThis();
        arraySlice = uncurryThis([].slice);
        return arraySlice;
    }
    var hasRequiredEs_array_slice;
    function requireEs_array_slice() {
        if (hasRequiredEs_array_slice) return es_array_slice;
        hasRequiredEs_array_slice = 1;
        var $ = require_export();
        var isArray = requireIsArray();
        var isConstructor = requireIsConstructor();
        var isObject = requireIsObject();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var toIndexedObject = requireToIndexedObject();
        var createProperty = requireCreateProperty();
        var setArrayLength = requireArraySetLength();
        var wellKnownSymbol = requireWellKnownSymbol();
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var nativeSlice = requireArraySlice();
        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
        var SPECIES = wellKnownSymbol('species');
        var $Array = Array;
        var max = Math.max;
        // `Array.prototype.slice` method
        // https://tc39.es/ecma262/#sec-array.prototype.slice
        // fallback for not array-like ES3 strings and DOM objects
        $({
            target: 'Array',
            proto: true,
            forced: !HAS_SPECIES_SUPPORT
        }, {
            slice: function slice(start, end) {
                var O = toIndexedObject(this);
                var length = lengthOfArrayLike(O);
                var k = toAbsoluteIndex(start, length);
                var fin = toAbsoluteIndex(end === undefined ? length : end, length);
                // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
                var Constructor, result, n;
                if (isArray(O)) {
                    Constructor = O.constructor;
                    // cross-realm fallback
                    if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) Constructor = undefined;
                    else if (isObject(Constructor)) {
                        Constructor = Constructor[SPECIES];
                        if (Constructor === null) Constructor = undefined;
                    }
                    if (Constructor === $Array || Constructor === undefined) return nativeSlice(O, k, fin);
                }
                result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
                for(n = 0; k < fin; k++, n++)if (k in O) createProperty(result, n, O[k]);
                setArrayLength(result, n);
                return result;
            }
        });
        return es_array_slice;
    }
    requireEs_array_slice();
    var web_domCollections_iterator = {};
    var hasRequiredWeb_domCollections_iterator;
    function requireWeb_domCollections_iterator() {
        if (hasRequiredWeb_domCollections_iterator) return web_domCollections_iterator;
        hasRequiredWeb_domCollections_iterator = 1;
        var globalThis1 = requireGlobalThis();
        var DOMIterables = requireDomIterables();
        var DOMTokenListPrototype = requireDomTokenListPrototype();
        var ArrayIteratorMethods = requireEs_array_iterator();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var setToStringTag = requireSetToStringTag();
        var wellKnownSymbol = requireWellKnownSymbol();
        var ITERATOR = wellKnownSymbol('iterator');
        var ArrayValues = ArrayIteratorMethods.values;
        var handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
            if (CollectionPrototype) {
                // some Chrome versions have non-configurable methods on DOMTokenList
                if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
                    createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
                } catch (error) {
                    CollectionPrototype[ITERATOR] = ArrayValues;
                }
                setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
                if (DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in ArrayIteratorMethods){
                    // some Chrome versions have non-configurable methods on DOMTokenList
                    if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
                        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                    } catch (error) {
                        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                    }
                }
            }
        };
        for(var COLLECTION_NAME in DOMIterables)handlePrototype(globalThis1[COLLECTION_NAME] && globalThis1[COLLECTION_NAME].prototype, COLLECTION_NAME);
        handlePrototype(DOMTokenListPrototype, 'DOMTokenList');
        return web_domCollections_iterator;
    }
    requireWeb_domCollections_iterator();
    var web_urlSearchParams = {};
    var es_string_fromCodePoint = {};
    var hasRequiredEs_string_fromCodePoint;
    function requireEs_string_fromCodePoint() {
        if (hasRequiredEs_string_fromCodePoint) return es_string_fromCodePoint;
        hasRequiredEs_string_fromCodePoint = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThis();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var $RangeError = RangeError;
        var fromCharCode = String.fromCharCode;
        // eslint-disable-next-line es/no-string-fromcodepoint -- required for testing
        var $fromCodePoint = String.fromCodePoint;
        var join = uncurryThis([].join);
        // length should be 1, old FF problem
        var INCORRECT_LENGTH = !!$fromCodePoint && $fromCodePoint.length !== 1;
        // `String.fromCodePoint` method
        // https://tc39.es/ecma262/#sec-string.fromcodepoint
        $({
            target: 'String',
            stat: true,
            arity: 1,
            forced: INCORRECT_LENGTH
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            fromCodePoint: function fromCodePoint(x) {
                var elements = [];
                var length = arguments.length;
                var i = 0;
                var code;
                while(length > i){
                    code = +arguments[i];
                    if (toAbsoluteIndex(code, 0x10FFFF) !== code) throw new $RangeError(code + ' is not a valid code point');
                    elements[i++] = code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xD800, code % 0x400 + 0xDC00);
                }
                return join(elements, '');
            }
        });
        return es_string_fromCodePoint;
    }
    var safeGetBuiltIn;
    var hasRequiredSafeGetBuiltIn;
    function requireSafeGetBuiltIn() {
        if (hasRequiredSafeGetBuiltIn) return safeGetBuiltIn;
        hasRequiredSafeGetBuiltIn = 1;
        var globalThis1 = requireGlobalThis();
        var DESCRIPTORS = requireDescriptors();
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Avoid NodeJS experimental warning
        safeGetBuiltIn = function(name) {
            if (!DESCRIPTORS) return globalThis1[name];
            var descriptor = getOwnPropertyDescriptor(globalThis1, name);
            return descriptor && descriptor.value;
        };
        return safeGetBuiltIn;
    }
    var urlConstructorDetection;
    var hasRequiredUrlConstructorDetection;
    function requireUrlConstructorDetection() {
        if (hasRequiredUrlConstructorDetection) return urlConstructorDetection;
        hasRequiredUrlConstructorDetection = 1;
        var fails = requireFails();
        var wellKnownSymbol = requireWellKnownSymbol();
        var DESCRIPTORS = requireDescriptors();
        var IS_PURE = requireIsPure();
        var ITERATOR = wellKnownSymbol('iterator');
        urlConstructorDetection = !fails(function() {
            // eslint-disable-next-line unicorn/relative-url-style -- required for testing
            var url = new URL('b?a=1&b=2&c=3', 'https://a');
            var params = url.searchParams;
            var params2 = new URLSearchParams('a=1&a=2&b=3');
            var result = '';
            url.pathname = 'c%20d';
            params.forEach(function(value, key) {
                params['delete']('b');
                result += key + value;
            });
            params2['delete']('a', 2);
            // `undefined` case is a Chromium 117 bug
            // https://bugs.chromium.org/p/v8/issues/detail?id=14222
            params2['delete']('b', undefined);
            return IS_PURE && (!url.toJSON || !params2.has('a', 1) || params2.has('a', 2) || !params2.has('a', undefined) || params2.has('b')) || !params.size && (IS_PURE || !DESCRIPTORS) || !params.sort || url.href !== 'https://a/c%20d?a=1&c=3' || params.get('c') !== '3' || String(new URLSearchParams('?a=1')) !== 'a=1' || !params[ITERATOR] || new URL('https://a@b').username !== 'a' || new URLSearchParams(new URLSearchParams('a=b')).get('a') !== 'b' || new URL("https://\u0442\u0435\u0441\u0442").host !== 'xn--e1aybc' || new URL("https://a#\u0431").hash !== '#%D0%B1' || result !== 'a1c3' || new URL('https://x', undefined).host !== 'x';
        });
        return urlConstructorDetection;
    }
    var defineBuiltIns;
    var hasRequiredDefineBuiltIns;
    function requireDefineBuiltIns() {
        if (hasRequiredDefineBuiltIns) return defineBuiltIns;
        hasRequiredDefineBuiltIns = 1;
        var defineBuiltIn = requireDefineBuiltIn();
        defineBuiltIns = function(target, src, options) {
            for(var key in src)defineBuiltIn(target, key, src[key], options);
            return target;
        };
        return defineBuiltIns;
    }
    var anInstance;
    var hasRequiredAnInstance;
    function requireAnInstance() {
        if (hasRequiredAnInstance) return anInstance;
        hasRequiredAnInstance = 1;
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var $TypeError = TypeError;
        anInstance = function(it, Prototype) {
            if (isPrototypeOf(Prototype, it)) return it;
            throw new $TypeError('Incorrect invocation');
        };
        return anInstance;
    }
    var validateArgumentsLength;
    var hasRequiredValidateArgumentsLength;
    function requireValidateArgumentsLength() {
        if (hasRequiredValidateArgumentsLength) return validateArgumentsLength;
        hasRequiredValidateArgumentsLength = 1;
        var $TypeError = TypeError;
        validateArgumentsLength = function(passed, required) {
            if (passed < required) throw new $TypeError('Not enough arguments');
            return passed;
        };
        return validateArgumentsLength;
    }
    var arraySort;
    var hasRequiredArraySort;
    function requireArraySort() {
        if (hasRequiredArraySort) return arraySort;
        hasRequiredArraySort = 1;
        var arraySlice = requireArraySlice();
        var floor = Math.floor;
        var sort = function(array, comparefn) {
            var length = array.length;
            if (length < 8) {
                // insertion sort
                var i = 1;
                var element, j;
                while(i < length){
                    j = i;
                    element = array[i];
                    while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                    if (j !== i++) array[j] = element;
                }
            } else {
                // merge sort
                var middle = floor(length / 2);
                var left = sort(arraySlice(array, 0, middle), comparefn);
                var right = sort(arraySlice(array, middle), comparefn);
                var llength = left.length;
                var rlength = right.length;
                var lindex = 0;
                var rindex = 0;
                while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
            }
            return array;
        };
        arraySort = sort;
        return arraySort;
    }
    var web_urlSearchParams_constructor;
    var hasRequiredWeb_urlSearchParams_constructor;
    function requireWeb_urlSearchParams_constructor() {
        if (hasRequiredWeb_urlSearchParams_constructor) return web_urlSearchParams_constructor;
        hasRequiredWeb_urlSearchParams_constructor = 1;
        // TODO: in core-js [at] 4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
        requireEs_array_iterator();
        requireEs_string_fromCodePoint();
        var $ = require_export();
        var globalThis1 = requireGlobalThis();
        var safeGetBuiltIn = requireSafeGetBuiltIn();
        var getBuiltIn = requireGetBuiltIn();
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var DESCRIPTORS = requireDescriptors();
        var USE_NATIVE_URL = requireUrlConstructorDetection();
        var defineBuiltIn = requireDefineBuiltIn();
        var defineBuiltInAccessor = requireDefineBuiltInAccessor();
        var defineBuiltIns = requireDefineBuiltIns();
        var setToStringTag = requireSetToStringTag();
        var createIteratorConstructor = requireIteratorCreateConstructor();
        var InternalStateModule = requireInternalState();
        var anInstance = requireAnInstance();
        var isCallable = requireIsCallable();
        var hasOwn = requireHasOwnProperty();
        var bind = requireFunctionBindContext();
        var classof = requireClassof();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var $toString = requireToString();
        var create = requireObjectCreate();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        var getIterator = requireGetIterator();
        var getIteratorMethod = requireGetIteratorMethod();
        var createIterResultObject = requireCreateIterResultObject();
        var validateArgumentsLength = requireValidateArgumentsLength();
        var wellKnownSymbol = requireWellKnownSymbol();
        var arraySort = requireArraySort();
        var ITERATOR = wellKnownSymbol('iterator');
        var URL_SEARCH_PARAMS = 'URLSearchParams';
        var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + 'Iterator';
        var setInternalState = InternalStateModule.set;
        var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
        var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
        var nativeFetch = safeGetBuiltIn('fetch');
        var NativeRequest = safeGetBuiltIn('Request');
        var Headers = safeGetBuiltIn('Headers');
        var RequestPrototype = NativeRequest && NativeRequest.prototype;
        var HeadersPrototype = Headers && Headers.prototype;
        var TypeError1 = globalThis1.TypeError;
        var encodeURIComponent = globalThis1.encodeURIComponent;
        var fromCharCode = String.fromCharCode;
        var fromCodePoint = getBuiltIn('String', 'fromCodePoint');
        var $parseInt = parseInt;
        var charAt = uncurryThis(''.charAt);
        var join = uncurryThis([].join);
        var push = uncurryThis([].push);
        var replace = uncurryThis(''.replace);
        var shift = uncurryThis([].shift);
        var splice = uncurryThis([].splice);
        var split = uncurryThis(''.split);
        var stringSlice = uncurryThis(''.slice);
        var exec = uncurryThis(/./.exec);
        var plus = /\+/g;
        var FALLBACK_REPLACER = '\uFFFD';
        var VALID_HEX = /^[0-9a-f]+$/i;
        var parseHexOctet = function(string, start) {
            var substr = stringSlice(string, start, start + 2);
            if (!exec(VALID_HEX, substr)) return NaN;
            return $parseInt(substr, 16);
        };
        var getLeadingOnes = function(octet) {
            var count = 0;
            for(var mask = 0x80; mask > 0 && (octet & mask) !== 0; mask >>= 1)count++;
            return count;
        };
        var utf8Decode = function(octets) {
            var codePoint = null;
            var length = octets.length;
            switch(length){
                case 1:
                    codePoint = octets[0];
                    break;
                case 2:
                    codePoint = (octets[0] & 0x1F) << 6 | octets[1] & 0x3F;
                    break;
                case 3:
                    codePoint = (octets[0] & 0x0F) << 12 | (octets[1] & 0x3F) << 6 | octets[2] & 0x3F;
                    break;
                case 4:
                    codePoint = (octets[0] & 0x07) << 18 | (octets[1] & 0x3F) << 12 | (octets[2] & 0x3F) << 6 | octets[3] & 0x3F;
                    break;
            }
            // reject surrogates, overlong encodings, and out-of-range codepoints
            if (codePoint === null || codePoint > 0x10FFFF || codePoint >= 0xD800 && codePoint <= 0xDFFF || codePoint < (length > 3 ? 0x10000 : length > 2 ? 0x800 : length > 1 ? 0x80 : 0)) return null;
            return codePoint;
        };
        /* eslint-disable max-statements, max-depth -- ok */ var decode = function(input) {
            input = replace(input, plus, ' ');
            var length = input.length;
            var result = '';
            var i = 0;
            while(i < length){
                var decodedChar = charAt(input, i);
                if (decodedChar === '%') {
                    if (charAt(input, i + 1) === '%' || i + 3 > length) {
                        result += '%';
                        i++;
                        continue;
                    }
                    var octet = parseHexOctet(input, i + 1);
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (octet !== octet) {
                        result += decodedChar;
                        i++;
                        continue;
                    }
                    i += 2;
                    var byteSequenceLength = getLeadingOnes(octet);
                    if (byteSequenceLength === 0) decodedChar = fromCharCode(octet);
                    else {
                        if (byteSequenceLength === 1 || byteSequenceLength > 4) {
                            result += FALLBACK_REPLACER;
                            i++;
                            continue;
                        }
                        var octets = [
                            octet
                        ];
                        var sequenceIndex = 1;
                        while(sequenceIndex < byteSequenceLength){
                            i++;
                            if (i + 3 > length || charAt(input, i) !== '%') break;
                            var nextByte = parseHexOctet(input, i + 1);
                            // eslint-disable-next-line no-self-compare -- NaN check
                            if (nextByte !== nextByte || nextByte > 191 || nextByte < 128) break;
                            // https://encoding.spec.whatwg.org/#utf-8-decoder - position-specific byte ranges
                            if (sequenceIndex === 1) {
                                if (octet === 0xE0 && nextByte < 0xA0) break;
                                if (octet === 0xED && nextByte > 0x9F) break;
                                if (octet === 0xF0 && nextByte < 0x90) break;
                                if (octet === 0xF4 && nextByte > 0x8F) break;
                            }
                            push(octets, nextByte);
                            i += 2;
                            sequenceIndex++;
                        }
                        if (octets.length !== byteSequenceLength) {
                            result += FALLBACK_REPLACER;
                            continue;
                        }
                        var codePoint = utf8Decode(octets);
                        if (codePoint === null) {
                            for(var replacement = 0; replacement < byteSequenceLength; replacement++)result += FALLBACK_REPLACER;
                            i++;
                            continue;
                        } else decodedChar = fromCodePoint(codePoint);
                    }
                }
                result += decodedChar;
                i++;
            }
            return result;
        };
        /* eslint-enable max-statements, max-depth -- ok */ var find = /[!'()~]|%20/g;
        var replacements = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+'
        };
        var replacer = function(match) {
            return replacements[match];
        };
        var serialize = function(it) {
            return replace(encodeURIComponent(it), find, replacer);
        };
        var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
            setInternalState(this, {
                type: URL_SEARCH_PARAMS_ITERATOR,
                target: getInternalParamsState(params).entries,
                index: 0,
                kind: kind
            });
        }, URL_SEARCH_PARAMS, function next() {
            var state = getInternalIteratorState(this);
            var target = state.target;
            var index = state.index++;
            if (!target || index >= target.length) {
                state.target = null;
                return createIterResultObject(undefined, true);
            }
            var entry = target[index];
            switch(state.kind){
                case 'keys':
                    return createIterResultObject(entry.key, false);
                case 'values':
                    return createIterResultObject(entry.value, false);
            }
            return createIterResultObject([
                entry.key,
                entry.value
            ], false);
        }, true);
        var URLSearchParamsState = function(init) {
            this.entries = [];
            this.url = null;
            if (init !== undefined) {
                if (isObject(init)) this.parseObject(init);
                else this.parseQuery(typeof init == 'string' ? charAt(init, 0) === '?' ? stringSlice(init, 1) : init : $toString(init));
            }
        };
        URLSearchParamsState.prototype = {
            type: URL_SEARCH_PARAMS,
            bindURL: function(url) {
                this.url = url;
                this.update();
            },
            parseObject: function(object) {
                var entries = this.entries;
                var iteratorMethod = getIteratorMethod(object);
                var iterator, next, step, entryIterator, entryNext, first, second;
                if (iteratorMethod) {
                    iterator = getIterator(object, iteratorMethod);
                    next = iterator.next;
                    while(!(step = call(next, iterator)).done){
                        entryIterator = getIterator(anObject(step.value));
                        entryNext = entryIterator.next;
                        if ((first = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done) throw new TypeError1('Expected sequence with length 2');
                        push(entries, {
                            key: $toString(first.value),
                            value: $toString(second.value)
                        });
                    }
                } else for(var key in object)if (hasOwn(object, key)) push(entries, {
                    key: key,
                    value: $toString(object[key])
                });
            },
            parseQuery: function(query) {
                if (query) {
                    var entries = this.entries;
                    var attributes = split(query, '&');
                    var index = 0;
                    var attribute, entry;
                    while(index < attributes.length){
                        attribute = attributes[index++];
                        if (attribute.length) {
                            entry = split(attribute, '=');
                            push(entries, {
                                key: decode(shift(entry)),
                                value: decode(join(entry, '='))
                            });
                        }
                    }
                }
            },
            serialize: function() {
                var entries = this.entries;
                var result = [];
                var index = 0;
                var entry;
                while(index < entries.length){
                    entry = entries[index++];
                    push(result, serialize(entry.key) + '=' + serialize(entry.value));
                }
                return join(result, '&');
            },
            update: function() {
                this.entries.length = 0;
                this.parseQuery(this.url.query);
            },
            updateURL: function() {
                if (this.url) this.url.update();
            }
        };
        // `URLSearchParams` constructor
        // https://url.spec.whatwg.org/#interface-urlsearchparams
        var URLSearchParamsConstructor = function URLSearchParams1() {
            anInstance(this, URLSearchParamsPrototype);
            var init = arguments.length > 0 ? arguments[0] : undefined;
            var state = setInternalState(this, new URLSearchParamsState(init));
            if (!DESCRIPTORS) this.size = state.entries.length;
        };
        var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
        defineBuiltIns(URLSearchParamsPrototype, {
            // `URLSearchParams.prototype.append` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-append
            append: function append(name, value) {
                var state = getInternalParamsState(this);
                validateArgumentsLength(arguments.length, 2);
                push(state.entries, {
                    key: $toString(name),
                    value: $toString(value)
                });
                if (!DESCRIPTORS) this.size++;
                state.updateURL();
            },
            // `URLSearchParams.prototype.delete` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
            'delete': function(name /* , value */ ) {
                var state = getInternalParamsState(this);
                var length = validateArgumentsLength(arguments.length, 1);
                var entries = state.entries;
                var key = $toString(name);
                var $value = length < 2 ? undefined : arguments[1];
                var value = $value === undefined ? $value : $toString($value);
                var index = 0;
                while(index < entries.length){
                    var entry = entries[index];
                    if (entry.key === key && (value === undefined || entry.value === value)) splice(entries, index, 1);
                    else index++;
                }
                if (!DESCRIPTORS) this.size = entries.length;
                state.updateURL();
            },
            // `URLSearchParams.prototype.get` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-get
            get: function get(name) {
                var entries = getInternalParamsState(this).entries;
                validateArgumentsLength(arguments.length, 1);
                var key = $toString(name);
                var index = 0;
                for(; index < entries.length; index++){
                    if (entries[index].key === key) return entries[index].value;
                }
                return null;
            },
            // `URLSearchParams.prototype.getAll` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
            getAll: function getAll(name) {
                var entries = getInternalParamsState(this).entries;
                validateArgumentsLength(arguments.length, 1);
                var key = $toString(name);
                var result = [];
                var index = 0;
                for(; index < entries.length; index++)if (entries[index].key === key) push(result, entries[index].value);
                return result;
            },
            // `URLSearchParams.prototype.has` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-has
            has: function has(name /* , value */ ) {
                var entries = getInternalParamsState(this).entries;
                var length = validateArgumentsLength(arguments.length, 1);
                var key = $toString(name);
                var $value = length < 2 ? undefined : arguments[1];
                var value = $value === undefined ? $value : $toString($value);
                var index = 0;
                while(index < entries.length){
                    var entry = entries[index++];
                    if (entry.key === key && (value === undefined || entry.value === value)) return true;
                }
                return false;
            },
            // `URLSearchParams.prototype.set` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-set
            set: function set(name, value) {
                var state = getInternalParamsState(this);
                validateArgumentsLength(arguments.length, 2);
                var entries = state.entries;
                var found = false;
                var key = $toString(name);
                var val = $toString(value);
                var index = 0;
                var entry;
                for(; index < entries.length; index++){
                    entry = entries[index];
                    if (entry.key === key) {
                        if (found) splice(entries, index--, 1);
                        else {
                            found = true;
                            entry.value = val;
                        }
                    }
                }
                if (!found) push(entries, {
                    key: key,
                    value: val
                });
                if (!DESCRIPTORS) this.size = entries.length;
                state.updateURL();
            },
            // `URLSearchParams.prototype.sort` method
            // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
            sort: function sort() {
                var state = getInternalParamsState(this);
                arraySort(state.entries, function(a, b) {
                    return a.key > b.key ? 1 : -1;
                });
                state.updateURL();
            },
            // `URLSearchParams.prototype.forEach` method
            forEach: function forEach(callback /* , thisArg */ ) {
                var entries = getInternalParamsState(this).entries;
                var boundFunction = bind(callback, arguments.length > 1 ? arguments[1] : undefined);
                var index = 0;
                var entry;
                while(index < entries.length){
                    entry = entries[index++];
                    boundFunction(entry.value, entry.key, this);
                }
            },
            // `URLSearchParams.prototype.keys` method
            keys: function keys() {
                return new URLSearchParamsIterator(this, 'keys');
            },
            // `URLSearchParams.prototype.values` method
            values: function values() {
                return new URLSearchParamsIterator(this, 'values');
            },
            // `URLSearchParams.prototype.entries` method
            entries: function entries() {
                return new URLSearchParamsIterator(this, 'entries');
            }
        }, {
            enumerable: true
        });
        // `URLSearchParams.prototype[@@iterator]` method
        defineBuiltIn(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, {
            name: 'entries'
        });
        // `URLSearchParams.prototype.toString` method
        // https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
        defineBuiltIn(URLSearchParamsPrototype, 'toString', function toString() {
            return getInternalParamsState(this).serialize();
        }, {
            enumerable: true
        });
        // `URLSearchParams.prototype.size` getter
        // https://url.spec.whatwg.org/#dom-urlsearchparams-size
        if (DESCRIPTORS) defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
            get: function size() {
                return getInternalParamsState(this).entries.length;
            },
            configurable: true,
            enumerable: true
        });
        setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
        $({
            global: true,
            constructor: true,
            forced: !USE_NATIVE_URL
        }, {
            URLSearchParams: URLSearchParamsConstructor
        });
        // Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
        if (!USE_NATIVE_URL && isCallable(Headers)) {
            var headersHas = uncurryThis(HeadersPrototype.has);
            var headersSet = uncurryThis(HeadersPrototype.set);
            var wrapRequestOptions = function(init) {
                if (isObject(init)) {
                    var body = init.body;
                    var headers;
                    if (classof(body) === URL_SEARCH_PARAMS) {
                        headers = init.headers ? new Headers(init.headers) : new Headers();
                        if (!headersHas(headers, 'content-type')) headersSet(headers, 'content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                        return create(init, {
                            body: createPropertyDescriptor(0, $toString(body)),
                            headers: createPropertyDescriptor(0, headers)
                        });
                    }
                }
                return init;
            };
            if (isCallable(nativeFetch)) $({
                global: true,
                enumerable: true,
                dontCallGetSet: true,
                forced: true
            }, {
                fetch: function fetch(input /* , init */ ) {
                    return nativeFetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
                }
            });
            if (isCallable(NativeRequest)) {
                var RequestConstructor = function Request(input /* , init */ ) {
                    anInstance(this, RequestPrototype);
                    return new NativeRequest(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
                };
                RequestPrototype.constructor = RequestConstructor;
                RequestConstructor.prototype = RequestPrototype;
                $({
                    global: true,
                    constructor: true,
                    dontCallGetSet: true,
                    forced: true
                }, {
                    Request: RequestConstructor
                });
            }
        }
        web_urlSearchParams_constructor = {
            URLSearchParams: URLSearchParamsConstructor,
            getState: getInternalParamsState
        };
        return web_urlSearchParams_constructor;
    }
    var hasRequiredWeb_urlSearchParams;
    function requireWeb_urlSearchParams() {
        if (hasRequiredWeb_urlSearchParams) return web_urlSearchParams;
        hasRequiredWeb_urlSearchParams = 1;
        // TODO: Remove this module from `core-js [at] 4` since it's replaced to module below
        requireWeb_urlSearchParams_constructor();
        return web_urlSearchParams;
    }
    requireWeb_urlSearchParams();
    /**
   * General helper utilities.
   *
   * This module provides miscellaneous helper functions used throughout Bootstrap Table,
   * including debouncing, event handling, URL manipulation, and browser detection.
   *
   * @module utils/helper
   */ /**
   * Calculates the value of an object property, supporting function calls and nested properties.
   *
   * @param {Object.<string, *>} self - The context to use when calling functions.
   * @param {string|Function|*} name - The property name, function, or value to calculate.
   * @param {Array.<*>} args - The arguments to pass to the function.
   * @param {*} defaultValue - The default value to return if calculation fails.
   * @returns {*} The calculated value or default value.
   */ function calculateObjectValue(self1, name, args, defaultValue) {
        var func = name;
        if (typeof name === 'string') {
            // support obj.func1.func2
            var names = name.split('.');
            if (names.length > 1) {
                func = window;
                var _iterator = _createForOfIteratorHelper(names), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var f = _step.value;
                        func = func[f];
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            } else func = window[name];
        }
        if (func !== null && _typeof(func) === 'object') return func;
        if (typeof func === 'function') return func.apply(self1, args || []);
        if (!func && typeof name === 'string' && args && sprintf.apply(void 0, [
            name
        ].concat(_toConsumableArray(args)))) return sprintf.apply(void 0, [
            name
        ].concat(_toConsumableArray(args)));
        return defaultValue;
    }
    /**
   * Creates a debounced function that delays invoking func until after wait milliseconds.
   *
   * @param {Function} func - The function to debounce.
   * @param {number} wait - The number of milliseconds to delay.
   * @param {boolean} [immediate=false] - If true, trigger the function on the leading edge.
   * @returns {Function} The debounced function.
   */ function debounce(func, wait, immediate) {
        var timeout;
        return function executedFunction() {
            var context = this;
            var args = arguments;
            var later = function later() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    /**
   * Generates a unique event name with a prefix and optional ID.
   *
   * @param {string} eventPrefix - The prefix for the event name.
   * @param {string} [id=''] - The optional ID to append. If not provided, generates a random ID.
   * @returns {string} The generated event name.
   */ function getEventName(eventPrefix) {
        var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        id = id || "".concat(+new Date()).concat(~~(Math.random() * 1000000));
        return "".concat(eventPrefix, "-").concat(id);
    }
    /**
   * Checks if the table has a detail view icon.
   *
   * @param {Object.<string, *>} options - The table options.
   * @returns {boolean} True if the table has a detail view icon, false otherwise.
   */ function hasDetailViewIcon(options) {
        return options.detailView && options.detailViewIcon && !options.cardView;
    }
    /**
   * Gets the index offset for the detail view column.
   *
   * @param {Object.<string, *>} options - The table options.
   * @returns {number} The index offset (1 if detail view is on the left, 0 otherwise).
   */ function getDetailViewIndexOffset(options) {
        return hasDetailViewIcon(options) && options.detailViewAlign !== 'right' ? 1 : 0;
    }
    /**
   * Adds query parameters to a URL while preserving the hash fragment.
   *
   * @param {string} url - The base URL.
   * @param {Object.<string, string>} query - The query parameters to add.
   * @returns {string} The URL with query parameters added.
   */ function addQueryToUrl(url, query) {
        var hashArray = url.split('#');
        var _hashArray$0$split = hashArray[0].split('?'), _hashArray$0$split2 = _slicedToArray(_hashArray$0$split, 2), baseUrl = _hashArray$0$split2[0], search = _hashArray$0$split2[1];
        var urlParams = new URLSearchParams(search);
        for(var _i = 0, _Object$entries = Object.entries(query); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
            urlParams.set(key, value);
        }
        return "".concat(baseUrl, "?").concat(urlParams.toString(), "#").concat(hashArray.slice(1).join('#'));
    }
    /**
   * Checks if a value is numeric.
   *
   * @param {*} n - The value to check.
   * @returns {boolean} True if the value is numeric, false otherwise.
   */ function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
    /**
   * Checks if the current browser is Internet Explorer.
   *
   * @returns {boolean} True if the browser is IE, false otherwise.
   */ function isIEBrowser() {
        return navigator.userAgent.includes('MSIE ') || /Trident.*rv:11\./.test(navigator.userAgent);
    }
    var helper = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        addQueryToUrl: addQueryToUrl,
        calculateObjectValue: calculateObjectValue,
        debounce: debounce,
        getDetailViewIndexOffset: getDetailViewIndexOffset,
        getEventName: getEventName,
        hasDetailViewIcon: hasDetailViewIcon,
        isIEBrowser: isIEBrowser,
        isNumeric: isNumeric
    });
    /**
   * Search and sorting utilities.
   *
   * This module provides utility functions for searching and sorting table data,
   * including regex comparison, custom sorting logic, and search result highlighting.
   *
   * @module utils/search-sort
   */ /**
   * Compares a value against a search pattern using regex.
   * Supports both plain text search and regex patterns (e.g., /pattern/flags).
   *
   * @param {*} value - The value to search in.
   * @param {string} search - The search pattern or regex.
   * @returns {boolean} True if the value matches the search pattern, false otherwise.
   */ function regexCompare(value, search) {
        try {
            var regexpParts = search.match(/^\/(.*?)\/([gim]*)$/);
            if (value.toString().search(regexpParts ? new RegExp(regexpParts[1], regexpParts[2]) : new RegExp(search, 'gim')) !== -1) return true;
        } catch (e) {
            console.error(e);
            return false;
        }
        return false;
    }
    /**
   * Sorts two values with support for numeric, string, and empty value handling.
   *
   * @param {*} a - The first value to compare.
   * @param {*} b - The second value to compare.
   * @param {number} order - The sort order (1 for ascending, -1 for descending).
   * @param {Object.<string, *>} options - Sort options.
   * @param {boolean} [options.sortStable=false] - If true, use position for equal values.
   * @param {boolean} [options.sortEmptyLast=false] - If true, sort empty values last.
   * @param {number} aPosition - The position of the first value.
   * @param {number} bPosition - The position of the second value.
   * @returns {number} Negative if a < b, positive if a > b, 0 if equal.
   */ function sort(a, b, order, options, aPosition, bPosition) {
        if (a === undefined || a === null) a = '';
        if (b === undefined || b === null) b = '';
        if (options.sortStable && a === b) {
            a = aPosition;
            b = bPosition;
        }
        // If both values are numeric, do a numeric comparison
        if (isNumeric(a) && isNumeric(b)) {
            // Convert numerical values from string to float.
            a = parseFloat(a);
            b = parseFloat(b);
            if (a < b) return order * -1;
            if (a > b) return order;
            return 0;
        }
        if (options.sortEmptyLast) {
            if (a === '') return 1;
            if (b === '') return -1;
        }
        if (a === b) return 0;
        // If value is not a string, convert to string
        if (typeof a !== 'string') a = a.toString();
        if (a.localeCompare(b) === -1) return order * -1;
        return order;
    }
    /**
   * Highlights search text matches in HTML by wrapping them in <mark> tags.
   * Recursively processes all text nodes in the HTML.
   *
   * @param {string|Element} html - The HTML string or DOM element to process.
   * @param {string} searchText - The text to search for and highlight.
   * @returns {string|Element} The HTML with matches highlighted, or the processed element.
   */ function replaceSearchMark(html, searchText) {
        var isDom = html instanceof Element;
        var node = isDom ? html : document.createElement('div');
        var regExp = new RegExp(searchText, 'gim');
        var replaceTextWithDom = function replaceTextWithDom(text, regExp) {
            var result = [];
            var match;
            var lastIndex = 0;
            while((match = regExp.exec(text)) !== null){
                if (lastIndex !== match.index) result.push(document.createTextNode(text.substring(lastIndex, match.index)));
                var mark = document.createElement('mark');
                mark.innerText = match[0];
                result.push(mark);
                lastIndex = match.index + match[0].length;
            }
            if (!result.length) // no match
            return;
            if (lastIndex !== text.length) result.push(document.createTextNode(text.substring(lastIndex)));
            return result;
        };
        var _replaceMark = function replaceMark(node) {
            for(var i = 0; i < node.childNodes.length; i++){
                var child = node.childNodes[i];
                if (child.nodeType === document.TEXT_NODE) {
                    var elements = replaceTextWithDom(child.data, regExp);
                    if (elements) {
                        var _iterator = _createForOfIteratorHelper(elements), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var el = _step.value;
                                node.insertBefore(el, child);
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        node.removeChild(child);
                        i += elements.length - 1;
                    }
                }
                if (child.nodeType === document.ELEMENT_NODE) _replaceMark(child);
            }
        };
        if (!isDom) node.innerHTML = html;
        _replaceMark(node);
        return isDom ? node : node.innerHTML;
    }
    var searchSort = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        regexCompare: regexCompare,
        replaceSearchMark: replaceSearchMark,
        sort: sort
    });
    /**
   * Bootstrap Table Checkbox Utilities
   * Generate Bootstrap 5 or Bootstrap 3/4 compatible checkbox HTML and virtual DOM config
   *
   * @module utils/checkbox
   */ /**
   * Generate Bootstrap 5 or Bootstrap 3/4 compatible checkbox HTML
   * @param {Object} options - Configuration options
   * @param {string} options.name - checkbox name attribute
   * @param {string} [options.value] - checkbox value attribute
   * @param {boolean} [options.checked] - whether checked
   * @param {boolean} [options.disabled] - whether disabled
   * @param {string} [options.label] - display text
   * @param {string} [options.extraClass] - extra CSS classes (must contain only safe CSS characters: letters, digits, hyphens, underscores)
   * @param {boolean} [options.centered=true] - whether centered (for table checkbox)
   * @param {boolean} [options.withLabel=false] - whether include label (for dropdown menu)
   * @returns {string} HTML string
   */ function getCheckboxHtml(options) {
        var name = options.name, _options$value = options.value, value = _options$value === void 0 ? '' : _options$value, _options$checked = options.checked, checked = _options$checked === void 0 ? false : _options$checked, _options$disabled = options.disabled, disabled = _options$disabled === void 0 ? false : _options$disabled, _options$label = options.label, label = _options$label === void 0 ? '' : _options$label, _options$extraClass = options.extraClass, extraClass = _options$extraClass === void 0 ? '' : _options$extraClass, _options$centered = options.centered, centered = _options$centered === void 0 ? true : _options$centered, _options$withLabel = options.withLabel, withLabel = _options$withLabel === void 0 ? false : _options$withLabel;
        var checkedAttr = checked ? ' checked="checked"' : '';
        var disabledAttr = disabled ? ' disabled="disabled"' : '';
        var valueAttr = value !== undefined && value !== '' ? " value=\"".concat(escapeAttr(value), "\"") : '';
        var classAttr = extraClass ? " ".concat(extraClass) : '';
        var escapedName = escapeAttr(name);
        var escapedLabel = escapeHTML(label);
        if (getBootstrapVersion() === 5) {
            if (withLabel) return "<label class=\"dropdown-item dropdown-item-marker d-flex align-items-center gap-2\">\n        <input class=\"form-check-input m-0".concat(classAttr, "\" type=\"checkbox\" name=\"").concat(escapedName, "\"").concat(valueAttr).concat(checkedAttr).concat(disabledAttr, " />\n        <span>").concat(escapedLabel, "</span>\n      </label>");
            var centerClass = centered ? ' d-flex justify-content-center' : '';
            return "<div class=\"form-check".concat(centerClass, "\">\n      <input class=\"form-check-input").concat(classAttr, "\" type=\"checkbox\" name=\"").concat(escapedName, "\"").concat(valueAttr).concat(checkedAttr).concat(disabledAttr, " />\n    </div>");
        }
        if (withLabel) return "<label><input type=\"checkbox\" name=\"".concat(escapedName, "\"").concat(valueAttr).concat(checkedAttr).concat(disabledAttr).concat(classAttr, "> <span>").concat(escapedLabel, "</span></label>");
        return "<label><input type=\"checkbox\" name=\"".concat(escapedName, "\"").concat(valueAttr).concat(checkedAttr).concat(disabledAttr).concat(classAttr, " /><span></span></label>");
    }
    /**
   * Generate form-check wrapped checkbox HTML (for table cells)
   * @param {string} inputHtml - input element HTML (must be trusted or pre-escaped, as it is inserted without additional escaping)
   * @param {boolean} [centered=true] - whether centered
   * @returns {string} HTML string
   */ function wrapCheckbox(inputHtml) {
        var centered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (getBootstrapVersion() === 5) {
            var centerClass = centered ? ' d-flex justify-content-center' : '';
            return "<div class=\"form-check".concat(centerClass, "\">").concat(inputHtml, "</div>");
        }
        return "<label>".concat(inputHtml, "<span></span></label>");
    }
    /**
   * Get checkbox virtual DOM config (for virtual DOM rendering in body.js)
   * @param {Object} options - Configuration options
   * @param {Object} options.inputAttrs - input element attributes object
   * @param {string} options.formCheckClass - form-check CSS class name
   * @param {string} options.formCheckInputClass - form-check-input CSS class name
   * @param {boolean} [options.centered=true] - whether centered
   * @returns {Object} Virtual DOM config object with inputAttrs, wrapperAttrs, wrapperTag and hasSpan
   */ function getCheckboxVdomConfig(options) {
        var inputAttrs = options.inputAttrs, formCheckClass = options.formCheckClass, formCheckInputClass = options.formCheckInputClass, _options$centered2 = options.centered, centered = _options$centered2 === void 0 ? true : _options$centered2;
        if (getBootstrapVersion() === 5) {
            var centerClass = centered ? ' d-flex justify-content-center' : '';
            return {
                inputAttrs: _objectSpread2(_objectSpread2({}, inputAttrs), {}, {
                    class: formCheckInputClass
                }),
                wrapperAttrs: {
                    class: "".concat(formCheckClass).concat(centerClass)
                },
                wrapperTag: 'div',
                hasSpan: false
            };
        }
        return {
            inputAttrs: inputAttrs,
            wrapperAttrs: {},
            wrapperTag: 'label',
            hasSpan: true
        };
    }
    /**
   * Generate showColumns dropdown menu column selection checkbox HTML
   * Differs from getCheckboxHtml by using data-field instead of name attribute
   * @param {Object} options - Configuration options
   * @param {string} options.dataField - column field name (for data-field attribute)
   * @param {string} options.value - checkbox value attribute
   * @param {boolean} options.checked - whether checked
   * @param {boolean} options.disabled - whether disabled
   * @param {string} options.label - display text
   * @returns {string} HTML string
   */ function getDropdownColumnCheckboxHtml(options) {
        var dataField = options.dataField, value = options.value, checked = options.checked, disabled = options.disabled, label = options.label;
        var checkedAttr = checked ? ' checked="checked"' : '';
        var disabledAttr = disabled ? ' disabled="disabled"' : '';
        var escapedLabel = escapeHTML(label);
        if (getBootstrapVersion() === 5) return "<label class=\"dropdown-item dropdown-item-marker d-flex align-items-center gap-2\">\n      <input class=\"form-check-input m-0\" type=\"checkbox\" data-field=\"".concat(escapeAttr(dataField), "\" value=\"").concat(escapeAttr(value), "\"").concat(checkedAttr).concat(disabledAttr, " />\n      <span>").concat(escapedLabel, "</span>\n    </label>");
        return "<input type=\"checkbox\" data-field=\"".concat(escapeAttr(dataField), "\" value=\"").concat(escapeAttr(value), "\"").concat(checkedAttr).concat(disabledAttr, "> <span>").concat(escapedLabel, "</span>");
    }
    var checkbox = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        getCheckboxHtml: getCheckboxHtml,
        getCheckboxVdomConfig: getCheckboxVdomConfig,
        getDropdownColumnCheckboxHtml: getDropdownColumnCheckboxHtml,
        wrapCheckbox: wrapCheckbox
    });
    var Utils = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, framework), object), string), dom), tableData), searchSort), helper), checkbox);
    var VERSION = '1.27.3';
    var bootstrapVersion = Utils.getBootstrapVersion();
    var CONSTANTS = {
        3: {
            classes: {
                buttonActive: 'active',
                buttons: 'default',
                buttonsDropdown: 'btn-group',
                buttonsGroup: 'btn-group',
                buttonsPrefix: 'btn',
                dropdownActive: 'active',
                dropup: 'dropup',
                input: 'form-control',
                inputGroup: 'input-group',
                inputPrefix: 'input-',
                paginationActive: 'active',
                paginationDropdown: 'btn-group dropdown',
                pull: 'pull',
                select: 'form-control'
            },
            html: {
                dropdownCaret: '<span class="caret"></span>',
                icon: '<i class="%s %s"></i>',
                inputGroup: '<div class="input-group">%s<span class="input-group-btn">%s</span></div>',
                pageDropdown: [
                    '<ul class="dropdown-menu" role="menu">',
                    '</ul>'
                ],
                pageDropdownItem: '<li role="menuitem" class="%s"><a href="#">%s</a></li>',
                pagination: [
                    '<ul class="pagination%s">',
                    '</ul>'
                ],
                paginationItem: '<li class="page-item%s"><a class="page-link" aria-label="%s" href="javascript:void(0)">%s</a></li>',
                searchButton: '<button class="%s" type="button" name="search" title="%s">%s %s</button>',
                searchClearButton: '<button class="%s" type="button" name="clearSearch" title="%s">%s %s</button>',
                searchInput: '<input class="%s%s" type="text" placeholder="%s">',
                toolbarDropdown: [
                    '<ul class="dropdown-menu" role="menu">',
                    '</ul>'
                ],
                toolbarDropdownItem: '<li class="dropdown-item-marker" role="menuitem"><label>%s</label></li>',
                toolbarDropdownSeparator: '<li class="divider"></li>'
            }
        },
        4: {
            classes: {
                buttonActive: 'active',
                buttons: 'secondary',
                buttonsDropdown: 'btn-group',
                buttonsGroup: 'btn-group',
                buttonsPrefix: 'btn',
                dropdownActive: 'active',
                dropup: 'dropup',
                input: 'form-control',
                inputGroup: 'btn-group',
                inputPrefix: 'form-control-',
                paginationActive: 'active',
                paginationDropdown: 'btn-group dropdown',
                pull: 'float',
                select: 'form-control'
            },
            html: {
                dropdownCaret: '<span class="caret"></span>',
                icon: '<i class="%s %s"></i>',
                inputGroup: '<div class="input-group">%s<div class="input-group-append">%s</div></div>',
                pageDropdown: [
                    '<div class="dropdown-menu">',
                    '</div>'
                ],
                pageDropdownItem: '<a class="dropdown-item %s" href="#">%s</a>',
                pagination: [
                    '<ul class="pagination%s">',
                    '</ul>'
                ],
                paginationItem: '<li class="page-item%s"><a class="page-link" aria-label="%s" href="javascript:void(0)">%s</a></li>',
                searchButton: '<button class="%s" type="button" name="search" title="%s">%s %s</button>',
                searchClearButton: '<button class="%s" type="button" name="clearSearch" title="%s">%s %s</button>',
                searchInput: '<input class="%s%s" type="text" placeholder="%s">',
                toolbarDropdown: [
                    '<div class="dropdown-menu dropdown-menu-right">',
                    '</div>'
                ],
                toolbarDropdownItem: '<label class="dropdown-item dropdown-item-marker">%s</label>',
                toolbarDropdownSeparator: '<div class="dropdown-divider"></div>'
            }
        },
        5: {
            classes: {
                buttonActive: 'active',
                buttons: 'secondary',
                buttonsDropdown: 'btn-group',
                buttonsGroup: 'btn-group',
                buttonsPrefix: 'btn',
                dropdownActive: 'active',
                dropup: 'dropup',
                formCheck: 'form-check',
                formCheckInput: 'form-check-input',
                input: 'form-control',
                inputGroup: 'btn-group',
                inputPrefix: 'form-control-',
                paginationActive: 'active',
                paginationDropdown: 'btn-group dropdown',
                pull: 'float',
                select: 'form-select'
            },
            html: {
                dataToggle: 'data-bs-toggle',
                dropdownCaret: '<span class="caret"></span>',
                icon: '<i class="%s %s"></i>',
                inputGroup: '<div class="input-group">%s%s</div>',
                pageDropdown: [
                    '<div class="dropdown-menu">',
                    '</div>'
                ],
                pageDropdownItem: '<a class="dropdown-item %s" href="#">%s</a>',
                pagination: [
                    '<ul class="pagination%s">',
                    '</ul>'
                ],
                paginationItem: '<li class="page-item%s"><a class="page-link" aria-label="%s" href="javascript:void(0)">%s</a></li>',
                searchButton: '<button class="%s" type="button" name="search" title="%s">%s %s</button>',
                searchClearButton: '<button class="%s" type="button" name="clearSearch" title="%s">%s %s</button>',
                searchInput: '<input class="%s%s" type="text" placeholder="%s">',
                toolbarDropdown: [
                    '<div class="dropdown-menu dropdown-menu-end">',
                    '</div>'
                ],
                toolbarDropdownItem: '<label class="dropdown-item dropdown-item-marker">%s</label>',
                toolbarDropdownSeparator: '<div class="dropdown-divider"></div>'
            }
        }
    }[bootstrapVersion || 5];
    var ICONS = {
        glyphicon: {
            clearSearch: 'glyphicon-trash',
            columns: 'glyphicon-th icon-th',
            detailClose: 'glyphicon-minus icon-minus',
            detailOpen: 'glyphicon-plus icon-plus',
            fullscreen: 'glyphicon-fullscreen',
            paginationSwitchDown: 'glyphicon-collapse-down icon-chevron-down',
            paginationSwitchUp: 'glyphicon-collapse-up icon-chevron-up',
            refresh: 'glyphicon-refresh icon-refresh',
            search: 'glyphicon-search',
            toggleOff: 'glyphicon-list-alt icon-list-alt',
            toggleOn: 'glyphicon-list-alt icon-list-alt'
        },
        fa: {
            clearSearch: 'fa-trash',
            columns: 'fa-th-list',
            detailClose: 'fa-minus',
            detailOpen: 'fa-plus',
            fullscreen: 'fa-arrows-alt',
            paginationSwitchDown: 'fa-caret-square-down',
            paginationSwitchUp: 'fa-caret-square-up',
            refresh: 'fa-sync',
            search: 'fa-search',
            toggleOff: 'fa-toggle-off',
            toggleOn: 'fa-toggle-on'
        },
        bi: {
            clearSearch: 'bi-trash',
            columns: 'bi-list-ul',
            detailClose: 'bi-dash',
            detailOpen: 'bi-plus',
            fullscreen: 'bi-arrows-move',
            paginationSwitchDown: 'bi-caret-down-square',
            paginationSwitchUp: 'bi-caret-up-square',
            refresh: 'bi-arrow-clockwise',
            search: 'bi-search',
            toggleOff: 'bi-toggle-off',
            toggleOn: 'bi-toggle-on'
        },
        icon: {
            clearSearch: 'icon-trash-2',
            columns: 'icon-list',
            detailClose: 'icon-minus',
            detailOpen: 'icon-plus',
            fullscreen: 'icon-maximize',
            paginationSwitchDown: 'icon-arrow-up-circle',
            paginationSwitchUp: 'icon-arrow-down-circle',
            refresh: 'icon-refresh-cw',
            search: 'icon-search',
            toggleOff: 'icon-toggle-right',
            toggleOn: 'icon-toggle-right'
        },
        'material-icons': {
            clearSearch: 'delete',
            columns: 'view_list',
            detailClose: 'remove',
            detailOpen: 'add',
            fullscreen: 'fullscreen',
            paginationSwitchDown: 'grid_on',
            paginationSwitchUp: 'grid_off',
            refresh: 'refresh',
            search: 'search',
            sort: 'sort',
            toggleOff: 'tablet',
            toggleOn: 'tablet_android'
        }
    };
    var DEFAULTS = {
        ajax: undefined,
        ajaxOptions: {},
        buttons: {},
        buttonsAlign: 'right',
        buttonsAttributeTitle: 'title',
        buttonsClass: CONSTANTS.classes.buttons,
        buttonsOrder: [
            'paginationSwitch',
            'refresh',
            'toggle',
            'fullscreen',
            'columns'
        ],
        buttonsPrefix: CONSTANTS.classes.buttonsPrefix,
        buttonsToolbar: undefined,
        cache: true,
        cardView: false,
        checkboxHeader: true,
        classes: 'table table-bordered table-hover',
        clickToSelect: false,
        columns: [
            []
        ],
        contentType: 'application/json',
        customSearch: undefined,
        customSort: undefined,
        data: [],
        dataField: 'rows',
        dataType: 'json',
        detailFilter: function detailFilter(index, row) {
            return true;
        },
        detailFormatter: function detailFormatter(index, row) {
            return '';
        },
        detailView: false,
        detailViewAlign: 'left',
        detailViewByClick: false,
        detailViewIcon: true,
        escape: false,
        escapeTitle: true,
        filterOptions: {
            filterAlgorithm: 'and'
        },
        fixedScroll: false,
        footerField: 'footer',
        footerStyle: function footerStyle(column) {
            return {};
        },
        headerStyle: function headerStyle(column) {
            return {};
        },
        height: undefined,
        icons: {},
        // init in initConstants
        iconSize: undefined,
        iconsPrefix: undefined,
        // init in initConstants
        idField: undefined,
        ignoreClickToSelectOn: function ignoreClickToSelectOn(_ref) {
            var tagName = _ref.tagName;
            return [
                'A',
                'BUTTON'
            ].includes(tagName);
        },
        loadingFontSize: 'auto',
        loadingTemplate: function loadingTemplate(loadingMessage) {
            return "<span class=\"loading-wrap\">\n    <span class=\"loading-text\">".concat(loadingMessage, "</span>\n    <span class=\"animation-wrap\"><span class=\"animation-dot\"></span></span>\n    </span>\n  ");
        },
        locale: undefined,
        maintainMetaData: false,
        method: 'get',
        minimumCountColumns: 1,
        multipleSelectRow: false,
        pageList: [
            10,
            25,
            50,
            100
        ],
        pageNumber: 1,
        pageSize: 10,
        pagination: false,
        paginationDetailHAlign: 'left',
        // right, left
        paginationHAlign: 'right',
        // right, left
        paginationLoadMore: false,
        paginationLoop: true,
        paginationNextText: '&rsaquo;',
        paginationPagesBySide: 1,
        // Number of pages on each side (right, left) of the current page.
        paginationParts: [
            'pageInfo',
            'pageSize',
            'pageList'
        ],
        paginationPreText: '&lsaquo;',
        paginationSuccessivelySize: 5,
        // Maximum successively number of pages in a row
        paginationUseIntermediate: false,
        // Calculate intermediate pages for quick access
        paginationVAlign: 'bottom',
        // bottom, top, both
        queryParams: function queryParams(params) {
            return params;
        },
        queryParamsType: 'limit',
        // 'limit', undefined
        regexSearch: false,
        rememberOrder: false,
        responseHandler: function responseHandler(res) {
            return res;
        },
        rowAttributes: function rowAttributes(row, index) {
            return {};
        },
        rowStyle: function rowStyle(row, index) {
            return {};
        },
        search: false,
        searchable: false,
        searchAccentNeutralise: false,
        searchAlign: 'right',
        searchHighlight: false,
        searchOnEnterKey: false,
        searchSelector: false,
        searchText: '',
        searchTimeOut: 500,
        selectItemName: 'btSelectItem',
        serverSort: true,
        showButtonIcons: true,
        showButtonText: false,
        showColumns: false,
        showColumnsSearch: false,
        showColumnsToggleAll: false,
        showExtendedPagination: false,
        showFooter: false,
        showFullscreen: false,
        showHeader: true,
        showPaginationSwitch: false,
        showRefresh: false,
        showSearchButton: false,
        showSearchClearButton: false,
        showToggle: false,
        sidePagination: 'client',
        // client or server
        silentSort: true,
        singleSelect: false,
        smartDisplay: true,
        sortable: true,
        sortClass: undefined,
        sortEmptyLast: false,
        sortName: undefined,
        sortOrder: undefined,
        sortReset: false,
        sortResetPage: false,
        sortStable: false,
        strictSearch: false,
        theadClasses: '',
        toolbar: undefined,
        toolbarAlign: 'left',
        totalField: 'total',
        totalNotFiltered: 0,
        totalNotFilteredField: 'totalNotFiltered',
        totalRows: 0,
        trimOnSearch: true,
        undefinedText: '-',
        uniqueId: undefined,
        url: undefined,
        virtualScroll: false,
        virtualScrollItemHeight: undefined,
        visibleSearch: false,
        onAll: function onAll(name, args) {
            return false;
        },
        onCheck: function onCheck(row) {
            return false;
        },
        onCheckAll: function onCheckAll(rows) {
            return false;
        },
        onCheckSome: function onCheckSome(rows) {
            return false;
        },
        onClickCell: function onClickCell(field, value, row, $element) {
            return false;
        },
        onClickRow: function onClickRow(item, $element) {
            return false;
        },
        onCollapseRow: function onCollapseRow(index, row) {
            return false;
        },
        onColumnSwitch: function onColumnSwitch(field, checked) {
            return false;
        },
        onColumnSwitchAll: function onColumnSwitchAll(checked) {
            return false;
        },
        onDblClickCell: function onDblClickCell(field, value, row, $element) {
            return false;
        },
        onDblClickRow: function onDblClickRow(item, $element) {
            return false;
        },
        onExpandRow: function onExpandRow(index, row, $detail) {
            return false;
        },
        onLoadError: function onLoadError(status) {
            return false;
        },
        onLoadSuccess: function onLoadSuccess(data) {
            return false;
        },
        onPageChange: function onPageChange(number, size) {
            return false;
        },
        onPostBody: function onPostBody() {
            return false;
        },
        onPostFooter: function onPostFooter() {
            return false;
        },
        onPostHeader: function onPostHeader() {
            return false;
        },
        onPreBody: function onPreBody(data) {
            return false;
        },
        onRefresh: function onRefresh(params) {
            return false;
        },
        onRefreshOptions: function onRefreshOptions(options) {
            return false;
        },
        onResetView: function onResetView() {
            return false;
        },
        onScrollBody: function onScrollBody() {
            return false;
        },
        onSearch: function onSearch(text) {
            return false;
        },
        onSort: function onSort(name, order) {
            return false;
        },
        onToggle: function onToggle(cardView) {
            return false;
        },
        onTogglePagination: function onTogglePagination(newState) {
            return false;
        },
        onUncheck: function onUncheck(row) {
            return false;
        },
        onUncheckAll: function onUncheckAll(rows) {
            return false;
        },
        onUncheckSome: function onUncheckSome(rows) {
            return false;
        },
        onVirtualScroll: function onVirtualScroll(startIndex, endIndex) {
            return false;
        }
    };
    var EN = {
        formatAllRows: function formatAllRows() {
            return 'All';
        },
        formatClearSearch: function formatClearSearch() {
            return 'Clear Search';
        },
        formatColumns: function formatColumns() {
            return 'Columns';
        },
        formatColumnsToggleAll: function formatColumnsToggleAll() {
            return 'Toggle all';
        },
        formatDetailPagination: function formatDetailPagination(totalRows) {
            return "Showing ".concat(totalRows, " rows");
        },
        formatFullscreen: function formatFullscreen() {
            return 'Fullscreen';
        },
        formatLoadingMessage: function formatLoadingMessage() {
            return 'Loading, please wait';
        },
        formatNoMatches: function formatNoMatches() {
            return 'No matching records found';
        },
        formatPaginationSwitch: function formatPaginationSwitch() {
            return 'Hide/Show pagination';
        },
        formatPaginationSwitchDown: function formatPaginationSwitchDown() {
            return 'Show pagination';
        },
        formatPaginationSwitchUp: function formatPaginationSwitchUp() {
            return 'Hide pagination';
        },
        formatRecordsPerPage: function formatRecordsPerPage(pageNumber) {
            return "".concat(pageNumber, " rows per page");
        },
        formatRefresh: function formatRefresh() {
            return 'Refresh';
        },
        formatSearch: function formatSearch() {
            return 'Search';
        },
        formatShowingRows: function formatShowingRows(pageFrom, pageTo, totalRows, totalNotFiltered) {
            if (totalNotFiltered !== undefined && totalNotFiltered > 0 && totalNotFiltered > totalRows) return "Showing ".concat(pageFrom, " to ").concat(pageTo, " of ").concat(totalRows, " rows (filtered from ").concat(totalNotFiltered, " total rows)");
            return "Showing ".concat(pageFrom, " to ").concat(pageTo, " of ").concat(totalRows, " rows");
        },
        formatSRPaginationNextText: function formatSRPaginationNextText() {
            return 'next page';
        },
        formatSRPaginationPageText: function formatSRPaginationPageText(page) {
            return "to page ".concat(page);
        },
        formatSRPaginationPreText: function formatSRPaginationPreText() {
            return 'previous page';
        },
        formatToggleOff: function formatToggleOff() {
            return 'Hide card view';
        },
        formatToggleOn: function formatToggleOn() {
            return 'Show card view';
        }
    };
    var COLUMN_DEFAULTS = {
        align: undefined,
        // string: left, right, center
        cardVisible: true,
        cellStyle: undefined,
        // function
        checkbox: false,
        checkboxEnabled: true,
        class: undefined,
        // string
        clickToSelect: true,
        colspan: undefined,
        // number
        detailFormatter: undefined,
        // function
        escape: undefined,
        // boolean
        events: undefined,
        falign: undefined,
        // string: left, right, center
        field: undefined,
        // string
        footerFormatter: undefined,
        // function
        footerStyle: undefined,
        // function
        formatter: undefined,
        // function
        halign: undefined,
        // left, right, center
        order: 'asc',
        // asc, desc
        radio: false,
        rowspan: undefined,
        // number
        searchable: true,
        searchFormatter: true,
        searchHighlightFormatter: false,
        showSelectTitle: false,
        sortable: false,
        sorter: undefined,
        // function
        sortName: undefined,
        // string
        switchable: true,
        switchableLabel: undefined,
        // string
        title: undefined,
        // string
        titleTooltip: undefined,
        // string
        valign: undefined,
        // top, middle, bottom
        visible: true,
        width: undefined,
        // number
        widthUnit: 'px'
    };
    var METHODS = [
        'getOptions',
        'refreshOptions',
        'getData',
        'getFooterData',
        'getSelections',
        'load',
        'append',
        'prepend',
        'remove',
        'removeAll',
        'insertRow',
        'updateRow',
        'getRowByUniqueId',
        'updateByUniqueId',
        'removeByUniqueId',
        'updateCell',
        'updateCellByUniqueId',
        'showRow',
        'hideRow',
        'getHiddenRows',
        'showColumn',
        'hideColumn',
        'getVisibleColumns',
        'getHiddenColumns',
        'showAllColumns',
        'hideAllColumns',
        'mergeCells',
        'checkAll',
        'uncheckAll',
        'checkInvert',
        'check',
        'uncheck',
        'checkBy',
        'uncheckBy',
        'refresh',
        'destroy',
        'resetView',
        'showLoading',
        'hideLoading',
        'togglePagination',
        'toggleFullscreen',
        'toggleView',
        'resetSearch',
        'filterBy',
        'sortBy',
        'sortReset',
        'scrollTo',
        'getScrollPosition',
        'selectPage',
        'prevPage',
        'nextPage',
        'toggleDetailView',
        'expandRow',
        'collapseRow',
        'expandRowByUniqueId',
        'collapseRowByUniqueId',
        'expandAllRows',
        'collapseAllRows',
        'updateColumnTitle',
        'updateFormatText'
    ];
    var EVENTS = {
        'all.bs.table': 'onAll',
        'check-all.bs.table': 'onCheckAll',
        'check-some.bs.table': 'onCheckSome',
        'check.bs.table': 'onCheck',
        'click-cell.bs.table': 'onClickCell',
        'click-row.bs.table': 'onClickRow',
        'collapse-row.bs.table': 'onCollapseRow',
        'column-switch-all.bs.table': 'onColumnSwitchAll',
        'column-switch.bs.table': 'onColumnSwitch',
        'dbl-click-cell.bs.table': 'onDblClickCell',
        'dbl-click-row.bs.table': 'onDblClickRow',
        'expand-row.bs.table': 'onExpandRow',
        'load-error.bs.table': 'onLoadError',
        'load-success.bs.table': 'onLoadSuccess',
        'page-change.bs.table': 'onPageChange',
        'post-body.bs.table': 'onPostBody',
        'post-footer.bs.table': 'onPostFooter',
        'post-header.bs.table': 'onPostHeader',
        'pre-body.bs.table': 'onPreBody',
        'refresh-options.bs.table': 'onRefreshOptions',
        'refresh.bs.table': 'onRefresh',
        'reset-view.bs.table': 'onResetView',
        'scroll-body.bs.table': 'onScrollBody',
        'search.bs.table': 'onSearch',
        'sort.bs.table': 'onSort',
        'toggle-pagination.bs.table': 'onTogglePagination',
        'toggle.bs.table': 'onToggle',
        'uncheck-all.bs.table': 'onUncheckAll',
        'uncheck-some.bs.table': 'onUncheckSome',
        'uncheck.bs.table': 'onUncheck',
        'virtual-scroll.bs.table': 'onVirtualScroll'
    };
    Object.assign(DEFAULTS, EN);
    var Constants = {
        COLUMN_DEFAULTS: COLUMN_DEFAULTS,
        CONSTANTS: CONSTANTS,
        DEFAULTS: DEFAULTS,
        EVENTS: EVENTS,
        ICONS: ICONS,
        LOCALES: {
            en: EN,
            'en-US': EN
        },
        METHODS: METHODS,
        THEME: "bootstrap".concat(bootstrapVersion),
        VERSION: VERSION
    };
    var InitializationModule = {
        initConstants: function initConstants() {
            var opts = this.options;
            this.constants = Constants.CONSTANTS;
            this.constants.theme = $.fn.bootstrapTable.theme;
            this.constants.dataToggle = this.constants.html.dataToggle || 'data-toggle';
            // init iconsPrefix and icons
            var iconsPrefix = Utils.getIconsPrefix($.fn.bootstrapTable.theme);
            if (typeof opts.icons === 'string') opts.icons = Utils.calculateObjectValue(null, opts.icons);
            opts.iconsPrefix = opts.iconsPrefix || $.fn.bootstrapTable.defaults.iconsPrefix || iconsPrefix;
            opts.icons = Object.assign(Utils.getIcons(Constants.ICONS, opts.iconsPrefix), $.fn.bootstrapTable.defaults.icons, opts.icons);
            // init buttons class
            var buttonsPrefix = opts.buttonsPrefix ? "".concat(opts.buttonsPrefix, "-") : '';
            this.constants.buttonsClass = [
                opts.buttonsPrefix,
                buttonsPrefix + opts.buttonsClass,
                Utils.sprintf("".concat(buttonsPrefix, "%s"), opts.iconSize)
            ].join(' ').trim();
            this.buttons = Utils.calculateObjectValue(this, opts.buttons, [], {});
            if (_typeof(this.buttons) !== 'object') this.buttons = {};
        },
        initLocale: function initLocale() {
            if (this.options.locale) {
                var locales = $.fn.bootstrapTable.locales;
                var parts = this.options.locale.split(/-|_/);
                parts[0] = parts[0].toLowerCase();
                if (parts[1]) parts[1] = parts[1].toUpperCase();
                var localesToExtend = {};
                if (locales[this.options.locale]) localesToExtend = locales[this.options.locale];
                else if (locales[parts.join('-')]) localesToExtend = locales[parts.join('-')];
                else if (locales[parts[0]]) localesToExtend = locales[parts[0]];
                this._defaultLocales = this._defaultLocales || {};
                for(var _i = 0, _Object$entries = Object.entries(localesToExtend); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), formatName = _Object$entries$_i[0], func = _Object$entries$_i[1];
                    var defaultLocale = this._defaultLocales.hasOwnProperty(formatName) ? this._defaultLocales[formatName] : Constants.DEFAULTS[formatName];
                    if (this.options[formatName] !== defaultLocale) continue;
                    this.options[formatName] = func;
                    this._defaultLocales[formatName] = func;
                }
            }
        },
        initContainer: function initContainer() {
            var topPagination = [
                'top',
                'both'
            ].includes(this.options.paginationVAlign) ? '<div class="fixed-table-pagination clearfix"></div>' : '';
            var bottomPagination = [
                'bottom',
                'both'
            ].includes(this.options.paginationVAlign) ? '<div class="fixed-table-pagination"></div>' : '';
            var loadingTemplate = Utils.calculateObjectValue(this.options, this.options.loadingTemplate, [
                this.options.formatLoadingMessage()
            ]);
            this.$container = $("\n      <div class=\"bootstrap-table ".concat(this.constants.theme, "\">\n      <div class=\"fixed-table-toolbar\"></div>\n      ").concat(topPagination, "\n      <div class=\"fixed-table-container\">\n      <div class=\"fixed-table-header\"><table></table></div>\n      <div class=\"fixed-table-body\">\n      <div class=\"fixed-table-loading\">\n      ").concat(loadingTemplate, "\n      </div>\n      </div>\n      <div class=\"fixed-table-footer\"></div>\n      </div>\n      ").concat(bottomPagination, "\n      </div>\n    "));
            this.$container.insertAfter(this.$el);
            this.$tableContainer = this.$container.find('.fixed-table-container');
            this.$tableHeader = this.$container.find('.fixed-table-header');
            this.$tableBody = this.$container.find('.fixed-table-body');
            this.$tableLoading = this.$container.find('.fixed-table-loading');
            this.$tableFooter = this.$el.find('tfoot');
            // checking if custom table-toolbar exists or not
            if (this.options.buttonsToolbar) this.$toolbar = $('body').find(this.options.buttonsToolbar);
            else this.$toolbar = this.$container.find('.fixed-table-toolbar');
            this.$pagination = this.$container.find('.fixed-table-pagination');
            this.$tableBody.append(this.$el);
            this.$container.after('<div class="clearfix"></div>');
            this.$el.addClass(this.options.classes);
            this.$tableLoading.addClass(this.options.classes);
            if (this.options.height) {
                this.$tableContainer.addClass('fixed-height');
                if (this.options.showFooter) this.$tableContainer.addClass('has-footer');
                if (this.options.classes.split(' ').includes('table-bordered')) {
                    this.$tableBody.append('<div class="fixed-table-border"></div>');
                    this.$tableBorder = this.$tableBody.find('.fixed-table-border');
                    this.$tableLoading.addClass('fixed-table-border');
                }
                this.$tableFooter = this.$container.find('.fixed-table-footer');
            }
        },
        initTable: function initTable() {
            var _this = this;
            var columns = [];
            this.$header = this.$el.find('>thead');
            if (!this.$header.length) this.$header = $("<thead class=\"".concat(this.options.theadClasses, "\"></thead>")).appendTo(this.$el);
            else if (this.options.theadClasses) this.$header.addClass(this.options.theadClasses);
            this._headerTrClasses = [];
            this._headerTrStyles = [];
            this.$header.find('tr').each(function(i, el) {
                var $tr = $(el);
                var column = [];
                $tr.find('th').each(function(i, el) {
                    var $th = $(el);
                    // #2014: getFieldIndex and elsewhere assume this is string, causes issues if not
                    if (typeof $th.data('field') !== 'undefined') $th.data('field', "".concat($th.data('field')));
                    var _data = Object.assign({}, $th.data());
                    for(var key in _data)if ($.fn.bootstrapTable.columnDefaults.hasOwnProperty(key)) delete _data[key];
                    column.push(Utils.extend({}, {
                        _data: Utils.getRealDataAttr(_data),
                        title: $th.html(),
                        class: $th.attr('class'),
                        titleTooltip: $th.attr('title'),
                        rowspan: $th.attr('rowspan') ? +$th.attr('rowspan') : undefined,
                        colspan: $th.attr('colspan') ? +$th.attr('colspan') : undefined,
                        scope: $th.attr('scope') ? $th.attr('scope') : undefined,
                        style: Utils.normalizeStyle($th.attr('style'))
                    }, $th.data()));
                });
                columns.push(column);
                if ($tr.attr('class')) _this._headerTrClasses.push($tr.attr('class'));
                if ($tr.attr('style')) _this._headerTrStyles.push($tr.attr('style'));
            });
            if (!Array.isArray(this.options.columns[0])) this.options.columns = [
                this.options.columns
            ];
            this.options.columns = Utils.extend(true, [], columns, this.options.columns);
            this.columns = [];
            this.fieldsColumnsIndex = [];
            if (this.optionsColumnsChanged !== false) Utils.setFieldIndex(this.options.columns);
            this.options.columns.forEach(function(columns, i) {
                columns.forEach(function(_column, j) {
                    var column = Utils.extend({}, Constants.COLUMN_DEFAULTS, _column, {
                        passed: _column
                    });
                    if (typeof column.fieldIndex !== 'undefined') {
                        _this.columns[column.fieldIndex] = column;
                        _this.fieldsColumnsIndex[column.field] = column.fieldIndex;
                    }
                    _this.options.columns[i][j] = column;
                });
            });
            // if options.data is setting, do not process tbody and tfoot data
            if (!this.options.data.length) {
                var htmlData = Utils.trToData(this.columns, this.$el.find('>tbody>tr').get());
                if (htmlData.length) {
                    this.options.data = htmlData;
                    this.fromHtml = true;
                }
            }
            if (!(this.options.pagination && this.options.sidePagination !== 'server')) this.footerData = Utils.trToData(this.columns, this.$el.find('>tfoot>tr').get());
            if (this.footerData) this.$el.find('tfoot').html('<tr></tr>');
            if (!this.options.showFooter || this.options.cardView) this.$tableFooter.hide();
            else this.$tableFooter.show();
        }
    };
    var es_array_findIndex = {};
    var hasRequiredEs_array_findIndex;
    function requireEs_array_findIndex() {
        if (hasRequiredEs_array_findIndex) return es_array_findIndex;
        hasRequiredEs_array_findIndex = 1;
        var $ = require_export();
        var $findIndex = requireArrayIteration().findIndex;
        var addToUnscopables = requireAddToUnscopables();
        var FIND_INDEX = 'findIndex';
        var SKIPS_HOLES = true;
        // Shouldn't skip holes
        // eslint-disable-next-line es/no-array-prototype-findindex -- testing
        if (FIND_INDEX in []) Array(1)[FIND_INDEX](function() {
            SKIPS_HOLES = false;
        });
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findindex
        $({
            target: 'Array',
            proto: true,
            forced: SKIPS_HOLES
        }, {
            findIndex: function findIndex(callbackfn /* , that = undefined */ ) {
                return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables(FIND_INDEX);
        return es_array_findIndex;
    }
    requireEs_array_findIndex();
    var es_array_splice = {};
    var deletePropertyOrThrow;
    var hasRequiredDeletePropertyOrThrow;
    function requireDeletePropertyOrThrow() {
        if (hasRequiredDeletePropertyOrThrow) return deletePropertyOrThrow;
        hasRequiredDeletePropertyOrThrow = 1;
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        deletePropertyOrThrow = function(O, P) {
            if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
        };
        return deletePropertyOrThrow;
    }
    var hasRequiredEs_array_splice;
    function requireEs_array_splice() {
        if (hasRequiredEs_array_splice) return es_array_splice;
        hasRequiredEs_array_splice = 1;
        var $ = require_export();
        var toObject = requireToObject();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var setArrayLength = requireArraySetLength();
        var doesNotExceedSafeInteger = requireDoesNotExceedSafeInteger();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var createProperty = requireCreateProperty();
        var deletePropertyOrThrow = requireDeletePropertyOrThrow();
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');
        var max = Math.max;
        var min = Math.min;
        // `Array.prototype.splice` method
        // https://tc39.es/ecma262/#sec-array.prototype.splice
        // with adding support of @@species
        $({
            target: 'Array',
            proto: true,
            forced: !HAS_SPECIES_SUPPORT
        }, {
            splice: function splice(start, deleteCount /* , ...items */ ) {
                var O = toObject(this);
                var len = lengthOfArrayLike(O);
                var actualStart = toAbsoluteIndex(start, len);
                var argumentsLength = arguments.length;
                var insertCount, actualDeleteCount, A, k, from, to;
                if (argumentsLength === 0) insertCount = actualDeleteCount = 0;
                else if (argumentsLength === 1) {
                    insertCount = 0;
                    actualDeleteCount = len - actualStart;
                } else {
                    insertCount = argumentsLength - 2;
                    actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
                }
                doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
                A = arraySpeciesCreate(O, actualDeleteCount);
                for(k = 0; k < actualDeleteCount; k++){
                    from = actualStart + k;
                    if (from in O) createProperty(A, k, O[from]);
                }
                setArrayLength(A, actualDeleteCount);
                if (insertCount < actualDeleteCount) {
                    for(k = actualStart; k < len - actualDeleteCount; k++){
                        from = k + actualDeleteCount;
                        to = k + insertCount;
                        if (from in O) O[to] = O[from];
                        else deletePropertyOrThrow(O, to);
                    }
                    for(k = len; k > len - actualDeleteCount + insertCount; k--)deletePropertyOrThrow(O, k - 1);
                } else if (insertCount > actualDeleteCount) for(k = len - actualDeleteCount; k > actualStart; k--){
                    from = k + actualDeleteCount - 1;
                    to = k + insertCount - 1;
                    if (from in O) O[to] = O[from];
                    else deletePropertyOrThrow(O, to);
                }
                for(k = 0; k < insertCount; k++)O[k + actualStart] = arguments[k + 2];
                setArrayLength(O, len - actualDeleteCount + insertCount);
                return A;
            }
        });
        return es_array_splice;
    }
    requireEs_array_splice();
    var BLOCK_ROWS = 50;
    var CLUSTER_BLOCKS = 4;
    var VirtualScroll = /*#__PURE__*/ function() {
        function VirtualScroll(options) {
            var _this = this;
            _classCallCheck(this, VirtualScroll);
            this.rows = options.rows;
            this.scrollEl = options.scrollEl;
            this.contentEl = options.contentEl;
            this.callback = options.callback;
            this.itemHeight = options.itemHeight;
            this.cache = {};
            this.scrollTop = this.scrollEl.scrollTop;
            this.initDOM(this.rows, options.fixedScroll);
            this.scrollEl.scrollTop = this.scrollTop;
            this.lastCluster = 0;
            var onScroll = function onScroll() {
                if (_this.lastCluster !== (_this.lastCluster = _this.getNum())) {
                    _this.initDOM(_this.rows);
                    _this.callback(_this.startIndex, _this.endIndex);
                }
            };
            this.scrollEl.addEventListener('scroll', onScroll, false);
            this.destroy = function() {
                _this.contentEl.innerHtml = '';
                _this.scrollEl.removeEventListener('scroll', onScroll, false);
            };
        }
        return _createClass(VirtualScroll, [
            {
                key: "initDOM",
                value: function initDOM(rows, fixedScroll) {
                    if (typeof this.clusterHeight === 'undefined') {
                        this.cache.scrollTop = this.scrollEl.scrollTop;
                        this.cache.data = this.contentEl.innerHTML = rows[0] + rows[0] + rows[0];
                        this.getRowsHeight(rows);
                    } else if (this.blockHeight === 0) this.getRowsHeight(rows);
                    var data = this.initData(rows, this.getNum(fixedScroll));
                    var thisRows = data.rows.join('');
                    var dataChanged = this.checkChanges('data', thisRows);
                    var topOffsetChanged = this.checkChanges('top', data.topOffset);
                    var bottomOffsetChanged = this.checkChanges('bottom', data.bottomOffset);
                    var html = [];
                    if (dataChanged && topOffsetChanged) {
                        if (data.topOffset) html.push(this.getExtra('top', data.topOffset));
                        html.push(thisRows);
                        if (data.bottomOffset) html.push(this.getExtra('bottom', data.bottomOffset));
                        this.startIndex = data.start;
                        this.endIndex = data.end;
                        this.contentEl.innerHTML = html.join('');
                        if (fixedScroll) this.contentEl.scrollTop = this.cache.scrollTop;
                    } else if (bottomOffsetChanged) this.contentEl.lastChild.style.height = "".concat(data.bottomOffset, "px");
                }
            },
            {
                key: "getRowsHeight",
                value: function getRowsHeight() {
                    if (typeof this.itemHeight === 'undefined' || this.itemHeight === 0) {
                        var nodes = this.contentEl.children;
                        var node = nodes[Math.floor(nodes.length / 2)];
                        this.itemHeight = node.offsetHeight;
                    }
                    this.blockHeight = this.itemHeight * BLOCK_ROWS;
                    this.clusterRows = BLOCK_ROWS * CLUSTER_BLOCKS;
                    this.clusterHeight = this.blockHeight * CLUSTER_BLOCKS;
                }
            },
            {
                key: "getNum",
                value: function getNum(fixedScroll) {
                    this.scrollTop = fixedScroll ? this.cache.scrollTop : this.scrollEl.scrollTop;
                    return Math.floor(this.scrollTop / (this.clusterHeight - this.blockHeight)) || 0;
                }
            },
            {
                key: "initData",
                value: function initData(rows, num) {
                    if (rows.length < BLOCK_ROWS) return {
                        topOffset: 0,
                        bottomOffset: 0,
                        rowsAbove: 0,
                        rows: rows
                    };
                    var start = Math.max((this.clusterRows - BLOCK_ROWS) * num, 0);
                    var end = start + this.clusterRows;
                    var topOffset = Math.max(start * this.itemHeight, 0);
                    var bottomOffset = Math.max((rows.length - end) * this.itemHeight, 0);
                    var thisRows = [];
                    var rowsAbove = start;
                    if (topOffset < 1) rowsAbove++;
                    for(var i = start; i < end; i++)rows[i] && thisRows.push(rows[i]);
                    return {
                        start: start,
                        end: end,
                        topOffset: topOffset,
                        bottomOffset: bottomOffset,
                        rowsAbove: rowsAbove,
                        rows: thisRows
                    };
                }
            },
            {
                key: "checkChanges",
                value: function checkChanges(type, value) {
                    var changed = value !== this.cache[type];
                    this.cache[type] = value;
                    return changed;
                }
            },
            {
                key: "getExtra",
                value: function getExtra(className, height) {
                    var tag = document.createElement('tr');
                    tag.className = "virtual-scroll-".concat(className);
                    if (height) tag.style.height = "".concat(height, "px");
                    return tag.outerHTML;
                }
            }
        ]);
    }();
    var BodyModule = {
        initBodyEvent: function initBodyEvent() {
            var _this = this;
            // click to select by column
            this.$body.find('> tr[data-index] > td').off('click dblclick').on('click dblclick', function(e) {
                var $td = $(e.currentTarget);
                if ($td.find('.detail-icon').length || $td.index() - Utils.getDetailViewIndexOffset(_this.options) < 0) return;
                var $tr = $td.parent();
                var $cardViewArr = $(e.target).parents('.card-views').children();
                var $cardViewTarget = $(e.target).parents('.card-view');
                var rowIndex = $tr.data('index');
                var item = _this.data[rowIndex];
                var index = _this.options.cardView ? $cardViewArr.index($cardViewTarget) : $td[0].cellIndex;
                var fields = _this.getVisibleFields();
                var field = fields[index - Utils.getDetailViewIndexOffset(_this.options)];
                var column = _this.columns[_this.fieldsColumnsIndex[field]];
                var value = Utils.getItemField(item, field, _this.options.escape, column.escape);
                _this.trigger(e.type === 'click' ? 'click-cell' : 'dbl-click-cell', field, value, item, $td);
                _this.trigger(e.type === 'click' ? 'click-row' : 'dbl-click-row', item, $tr, field);
                // if click to select - then trigger the checkbox/radio click
                if (e.type === 'click' && _this.options.clickToSelect && column.clickToSelect && !Utils.calculateObjectValue(_this.options, _this.options.ignoreClickToSelectOn, [
                    e.target
                ])) {
                    var $selectItem = $tr.find(Utils.sprintf('[name="%s"]', _this.options.selectItemName));
                    if ($selectItem.length) $selectItem[0].click();
                }
                if (e.type === 'click' && _this.options.detailViewByClick) _this.toggleDetailView(rowIndex, _this.header.detailFormatters[_this.fieldsColumnsIndex[field]]);
            }).off('mousedown').on('mousedown', function(e) {
                // https://github.com/jquery/jquery/issues/1741
                _this.multipleSelectRowCtrlKey = e.ctrlKey || e.metaKey;
                _this.multipleSelectRowShiftKey = e.shiftKey;
            });
            this.$body.find('> tr[data-index] > td > .detail-icon').off('click').on('click', function(e) {
                e.preventDefault();
                _this.toggleDetailView($(e.currentTarget).parent().parent().data('index'));
                return false;
            });
            this.$selectItem = this.$body.find(Utils.sprintf('[name="%s"]', this.options.selectItemName));
            this.$selectItem.off('click').on('click', function(e) {
                e.stopImmediatePropagation();
                var $this = $(e.currentTarget);
                _this._toggleCheck($this.prop('checked'), $this.data('index'));
            });
            this.header.events.forEach(function(_events, i) {
                var events = _events;
                if (!events) return;
                // fix bug, if events is defined with namespace
                if (typeof events === 'string') events = Utils.calculateObjectValue(null, events);
                if (!events) throw new Error("Unknown event in the scope: ".concat(_events));
                var field = _this.header.fields[i];
                var fieldIndex = _this.getVisibleFields().indexOf(field);
                if (fieldIndex === -1) return;
                fieldIndex += Utils.getDetailViewIndexOffset(_this.options);
                var _loop = function _loop(key) {
                    if (!events.hasOwnProperty(key)) return 1; // continue
                    var event = events[key];
                    _this.$body.find('>tr:not(.no-records-found)').each(function(i, tr) {
                        var $tr = $(tr);
                        var $td = $tr.find(_this.options.cardView ? '.card-views>.card-view' : '>td').eq(fieldIndex);
                        var index = key.indexOf(' ');
                        var name = key.substring(0, index);
                        var el = key.substring(index + 1);
                        $td.find(el).off(name).on(name, function(e) {
                            var index = $tr.data('index');
                            var row = _this.data[index];
                            var value = row[field];
                            event.apply(_this, [
                                e,
                                value,
                                row,
                                index
                            ]);
                        });
                    });
                };
                for(var key in events){
                    if (_loop(key)) continue;
                }
            });
        },
        initHiddenRows: function initHiddenRows() {
            this.hiddenRows = [];
        },
        // eslint-disable-next-line no-unused-vars
        initRow: function initRow(item, i, data, trFragments) {
            var _this2 = this;
            if (Utils.findIndex(this.hiddenRows, item) > -1) return;
            var style = Utils.calculateObjectValue(this.options, this.options.rowStyle, [
                item,
                i
            ], {});
            var attributes = Utils.calculateObjectValue(this.options, this.options.rowAttributes, [
                item,
                i
            ], {});
            var data_ = {};
            if (item._data && !Utils.isEmptyObject(item._data)) for(var _i = 0, _Object$entries = Object.entries(item._data); _i < _Object$entries.length; _i++){
                var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), k = _Object$entries$_i[0], v = _Object$entries$_i[1];
                // ignore data-index
                if (k === 'index') return;
                data_["data-".concat(k)] = _typeof(v) === 'object' ? JSON.stringify(v) : v;
            }
            var tr = Utils.h('tr', _objectSpread2(_objectSpread2({
                id: Array.isArray(item) ? undefined : item._id,
                class: style && style.classes || (Array.isArray(item) ? undefined : item._class),
                style: style && style.css || (Array.isArray(item) ? undefined : item._style),
                'data-index': i,
                'data-uniqueid': Utils.getItemField(item, this.options.uniqueId, false),
                'data-has-detail-view': this.options.detailView && Utils.calculateObjectValue(null, this.options.detailFilter, [
                    i,
                    item
                ]) ? 'true' : undefined
            }, attributes), data_));
            var trChildren = [];
            var detailViewTemplate = '';
            if (Utils.hasDetailViewIcon(this.options)) {
                detailViewTemplate = Utils.h('td');
                if (Utils.calculateObjectValue(null, this.options.detailFilter, [
                    i,
                    item
                ])) detailViewTemplate.append(Utils.h('a', {
                    class: 'detail-icon',
                    href: '#',
                    html: Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, this.options.icons.detailOpen)
                }));
            }
            if (detailViewTemplate && this.options.detailViewAlign !== 'right') trChildren.push(detailViewTemplate);
            var tds = this.header.fields.map(function(field, j) {
                var column = _this2.columns[j];
                var value_ = Utils.getItemField(item, field, _this2.options.escape, column.escape);
                var value;
                var attrs = {
                    class: _this2.header.classes[j] ? [
                        _this2.header.classes[j]
                    ] : [],
                    style: _this2.header.styles[j] ? [
                        _this2.header.styles[j]
                    ] : []
                };
                var cardViewClass = "card-view card-view-field-".concat(field);
                if ((_this2.fromHtml || _this2.autoMergeCells) && typeof value_ === 'undefined') {
                    if (!column.checkbox && !column.radio) return;
                }
                if (!column.visible) return;
                if (_this2.options.cardView && !column.cardVisible) return;
                // handle class, style, id, rowspan, colspan and title of td
                for(var _i2 = 0, _arr = [
                    'class',
                    'style',
                    'id',
                    'rowspan',
                    'colspan',
                    'title'
                ]; _i2 < _arr.length; _i2++){
                    var attr = _arr[_i2];
                    var _value = item["_".concat(field, "_").concat(attr)];
                    if (!_value) continue;
                    if (attrs[attr]) attrs[attr].push(_value);
                    else attrs[attr] = _value;
                }
                var cellStyle = Utils.calculateObjectValue(_this2.header, _this2.header.cellStyles[j], [
                    value_,
                    item,
                    i,
                    field
                ], {});
                if (cellStyle.classes) attrs.class.push(cellStyle.classes);
                if (cellStyle.css) attrs.style.push(cellStyle.css);
                value = Utils.calculateObjectValue(column, _this2.header.formatters[j], [
                    value_,
                    item,
                    i,
                    field
                ], value_);
                if (!(column.checkbox || column.radio)) value = typeof value === 'undefined' || value === null ? _this2.options.undefinedText : value;
                if (column.searchable && _this2.searchText && _this2.options.searchHighlight && !(column.checkbox || column.radio)) {
                    var searchText = _this2.searchText.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                    if (_this2.options.searchAccentNeutralise && typeof value === 'string') {
                        var indexRegex = new RegExp("".concat(Utils.normalizeAccent(searchText)), 'gmi');
                        var match = indexRegex.exec(Utils.normalizeAccent(value));
                        if (match) searchText = value.substring(match.index, match.index + searchText.length);
                    }
                    var defValue = Utils.replaceSearchMark(value, searchText);
                    value = Utils.calculateObjectValue(column, column.searchHighlightFormatter, [
                        value,
                        _this2.searchText
                    ], defValue);
                }
                if (item["_".concat(field, "_data")] && !Utils.isEmptyObject(item["_".concat(field, "_data")])) for(var _i3 = 0, _Object$entries2 = Object.entries(item["_".concat(field, "_data")]); _i3 < _Object$entries2.length; _i3++){
                    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2), _k = _Object$entries2$_i[0], _v = _Object$entries2$_i[1];
                    // ignore data-index
                    if (_k === 'index') return;
                    attrs["data-".concat(_k)] = _v;
                }
                if (column.checkbox || column.radio) {
                    var type = column.checkbox ? 'checkbox' : 'radio';
                    var isChecked = Utils.isObject(value) && value.hasOwnProperty('checked') ? value.checked : (value === true || value_) && value !== false;
                    var isDisabled = !column.checkboxEnabled || value && value.disabled;
                    var valueNodes = _this2.header.formatters[j] && (typeof value === 'string' || Utils.isDomNode(value)) ? Utils.htmlToNodes(value) : [];
                    item[_this2.header.stateField] = value === true || !!value_ || value && value.checked;
                    var inputAttrs = {
                        'data-index': i,
                        name: _this2.options.selectItemName,
                        type: type,
                        value: item[_this2.options.idField],
                        checked: isChecked ? 'checked' : undefined,
                        disabled: isDisabled ? 'disabled' : undefined
                    };
                    var config = Utils.getCheckboxVdomConfig({
                        inputAttrs: inputAttrs,
                        formCheckClass: _this2.constants.classes.formCheck,
                        formCheckInputClass: _this2.constants.classes.formCheckInput
                    });
                    var wrapperChildNodes = [
                        Utils.h('input', config.inputAttrs)
                    ];
                    if (config.hasSpan) wrapperChildNodes.push(Utils.h('span'));
                    var children = [
                        Utils.h(config.wrapperTag, config.wrapperAttrs, wrapperChildNodes)
                    ].concat(_toConsumableArray(valueNodes));
                    return Utils.h(_this2.options.cardView ? 'div' : 'td', {
                        class: [
                            _this2.options.cardView ? cardViewClass : 'bs-checkbox',
                            column.class
                        ],
                        style: _this2.options.cardView ? undefined : attrs.style
                    }, children);
                }
                if (_this2.options.cardView) {
                    if (_this2.options.smartDisplay && value === '') return Utils.h('div', {
                        class: cardViewClass
                    });
                    var cardTitle = _this2.options.showHeader ? Utils.h('span', {
                        class: [
                            'card-view-title',
                            cellStyle.classes
                        ],
                        style: attrs.style,
                        html: Utils.getFieldTitle(_this2.columns, field)
                    }) : '';
                    return Utils.h('div', {
                        class: cardViewClass
                    }, [
                        cardTitle,
                        Utils.h('span', {
                            class: [
                                'card-view-value',
                                cellStyle.classes
                            ],
                            style: attrs.style
                        }, _toConsumableArray(Utils.htmlToNodes(value)))
                    ]);
                }
                return Utils.h('td', attrs, _toConsumableArray(Utils.htmlToNodes(value)));
            }).filter(function(x) {
                return x;
            });
            trChildren.push.apply(trChildren, _toConsumableArray(tds));
            if (detailViewTemplate && this.options.detailViewAlign === 'right') trChildren.push(detailViewTemplate);
            if (this.options.cardView) tr.append(Utils.h('td', {
                colspan: this.header.fields.length
            }, [
                Utils.h('div', {
                    class: 'card-views'
                }, trChildren)
            ]));
            else tr.append.apply(tr, trChildren);
            return tr;
        },
        initBody: function initBody(fixedScroll, updatedUid) {
            var _this3 = this;
            var data = this.getData();
            this.trigger('pre-body', data);
            this.$body = this.$el.find('>tbody');
            if (!this.$body.length) this.$body = $('<tbody></tbody>').appendTo(this.$el);
            // Fix #389 Bootstrap-table-flatJSON is not working
            if (!this.options.pagination || this.options.sidePagination === 'server') {
                this.pageFrom = 1;
                this.pageTo = data.length;
            }
            var rows = [];
            var trFragments = $(document.createDocumentFragment());
            var hasTr = false;
            var toExpand = [];
            this.autoMergeCells = Utils.checkAutoMergeCells(data.slice(this.pageFrom - 1, this.pageTo));
            for(var i = this.pageFrom - 1; i < this.pageTo; i++){
                var item = data[i];
                var tr = this.initRow(item, i, data, trFragments);
                hasTr = hasTr || !!tr;
                if (tr && tr instanceof Node) {
                    var uniqueId = this.options.uniqueId;
                    var toAppend = [
                        tr
                    ];
                    if (uniqueId && item.hasOwnProperty(uniqueId)) {
                        var itemUniqueId = item[uniqueId];
                        var oldTr = this.$body.find(Utils.sprintf('> tr[data-uniqueid="%s"][data-has-detail-view]', itemUniqueId));
                        var oldTrNext = oldTr.next();
                        if (oldTrNext.is('tr.detail-view')) {
                            toExpand.push(i);
                            if (!updatedUid || itemUniqueId !== updatedUid) toAppend.push(oldTrNext[0]);
                        }
                    }
                    if (!this.options.virtualScroll) trFragments.append(toAppend);
                    else rows.push($('<div>').html(toAppend).html());
                }
            }
            this.$el.removeAttr('role');
            // show no records
            if (!hasTr) {
                this.$body.html("<tr class=\"no-records-found\">".concat(Utils.sprintf('<td colspan="%s">%s</td>', this.getVisibleFields().length + Utils.getDetailViewIndexOffset(this.options), this.options.formatNoMatches()), "</tr>"));
                this.$el.attr('role', 'presentation');
            } else if (!this.options.virtualScroll) this.$body.html(trFragments);
            else {
                if (this.virtualScroll) this.virtualScroll.destroy();
                this.virtualScroll = new VirtualScroll({
                    rows: rows,
                    fixedScroll: fixedScroll,
                    scrollEl: this.$tableBody[0],
                    contentEl: this.$body[0],
                    itemHeight: this.options.virtualScrollItemHeight,
                    callback: function callback(startIndex, endIndex) {
                        _this3.fitHeader();
                        _this3.initBodyEvent();
                        _this3.trigger('virtual-scroll', startIndex, endIndex);
                    }
                });
            }
            toExpand.forEach(function(index) {
                _this3.expandRow(index);
            });
            if (!fixedScroll) this.scrollTo(0);
            this.initBodyEvent();
            this.initFooter();
            this.resetView();
            this.updateSelected();
            if (this.options.sidePagination !== 'server') this.options.totalRows = data.length;
            this.trigger('post-body', data);
        },
        resetView: function resetView(params) {
            var padding = 0;
            if (params && params.height) this.options.height = params.height;
            this.$tableContainer.toggleClass('has-card-view', this.options.cardView);
            if (this.options.height) {
                var fixedBody = this.$tableBody.get(0);
                this.hasScrollBar = fixedBody.scrollWidth > fixedBody.clientWidth;
            }
            if (!this.options.cardView && this.options.showHeader && this.options.height) {
                this.$tableHeader.show();
                this.resetHeader();
                padding += this.$header.outerHeight(true) + 1;
            } else {
                this.$tableHeader.hide();
                this.trigger('post-header');
            }
            if (!this.options.cardView && this.options.showFooter) {
                this.$tableFooter.show();
                this.fitFooter();
                if (this.options.height) padding += this.$tableFooter.outerHeight(true);
            }
            if (this.$container.hasClass('fullscreen')) {
                this.$tableContainer.css('height', '');
                this.$tableContainer.css('width', '');
            } else if (this.options.height) {
                if (this.$tableBorder) {
                    this.$tableBorder.css('width', '');
                    this.$tableBorder.css('height', '');
                }
                var toolbarHeight = this.$toolbar.outerHeight(true);
                var paginationHeight = this.$pagination.outerHeight(true);
                var height = this.options.height - toolbarHeight - paginationHeight;
                var $bodyTable = this.$tableBody.find('>table');
                var tableHeight = $bodyTable.outerHeight();
                this.$tableContainer.css('height', "".concat(height, "px"));
                if (this.$tableBorder && $bodyTable.is(':visible')) {
                    var tableBorderHeight = height - tableHeight - 2;
                    if (this.hasScrollBar) tableBorderHeight -= Utils.getScrollBarWidth();
                    this.$tableBorder.css('width', "".concat($bodyTable.outerWidth(), "px"));
                    this.$tableBorder.css('height', "".concat(tableBorderHeight, "px"));
                }
            }
            if (this.options.cardView) {
                // remove the element css
                this.$el.css('margin-top', '0');
                this.$tableContainer.css('padding-bottom', '0');
                this.$tableFooter.hide();
            } else {
                // Assign the correct sortable arrow
                this.resetCaret();
                this.$tableContainer.css('padding-bottom', "".concat(padding, "px"));
            }
            this.trigger('reset-view');
        },
        showLoading: function showLoading() {
            this.$tableLoading.toggleClass('open', true);
            var fontSize = this.options.loadingFontSize;
            if (this.options.loadingFontSize === 'auto') {
                fontSize = this.$tableLoading.width() * 0.04;
                fontSize = Math.max(12, fontSize);
                fontSize = Math.min(32, fontSize);
                fontSize = "".concat(fontSize, "px");
            }
            var $loadingWrap = this.$tableLoading.find('.loading-wrap');
            if ($loadingWrap.length) $loadingWrap.css('font-size', fontSize);
            else this.$tableLoading.css('font-size', fontSize);
            this.$tableLoading.find('.loading-text').css('font-size', fontSize);
        },
        hideLoading: function hideLoading() {
            this.$tableLoading.toggleClass('open', false);
        },
        scrollTo: function scrollTo(params) {
            var options = {
                unit: 'px',
                value: 0
            };
            if (_typeof(params) === 'object') options = Object.assign(options, params);
            else if (typeof params === 'string' && params === 'bottom') options.value = this.$tableBody[0].scrollHeight;
            else if (typeof params === 'string' || typeof params === 'number') options.value = params;
            var scrollTo = options.value;
            if (options.unit === 'rows') {
                scrollTo = 0;
                this.$body.find("> tr:lt(".concat(options.value, ")")).each(function(i, el) {
                    scrollTo += $(el).outerHeight(true);
                });
            }
            this.$tableBody.scrollTop(scrollTo);
        },
        getScrollPosition: function getScrollPosition() {
            return this.$tableBody.scrollTop();
        },
        showRow: function showRow(params) {
            this._toggleRow(params, true);
        },
        hideRow: function hideRow(params) {
            this._toggleRow(params, false);
        },
        _toggleRow: function _toggleRow(params, visible) {
            var row;
            if (params.hasOwnProperty('index')) row = this.getData()[params.index];
            else if (params.hasOwnProperty('uniqueId')) row = this.getRowByUniqueId(params.uniqueId);
            if (!row) return;
            var index = Utils.findIndex(this.hiddenRows, row);
            if (!visible && index === -1) this.hiddenRows.push(row);
            else if (visible && index > -1) this.hiddenRows.splice(index, 1);
            this.initBody(true);
            this.initPagination();
        },
        getHiddenRows: function getHiddenRows(show) {
            if (show) {
                this.initHiddenRows();
                this.initBody(true);
                this.initPagination();
                return;
            }
            var data = this.getData();
            var rows = [];
            var _iterator = _createForOfIteratorHelper(data), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var row = _step.value;
                    if (this.hiddenRows.includes(row)) rows.push(row);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            this.hiddenRows = rows;
            return rows;
        },
        showColumn: function showColumn(field) {
            this._toggleColumns(Array.isArray(field) ? field : [
                field
            ], true, true);
        },
        hideColumn: function hideColumn(field) {
            this._toggleColumns(Array.isArray(field) ? field : [
                field
            ], false, true);
        },
        _toggleColumnVisibility: function _toggleColumnVisibility(index, checked) {
            if (index === undefined || this.columns[index].visible === checked) return false;
            this.columns[index].visible = checked;
            return true;
        },
        _updateAfterColumnToggle: function _updateAfterColumnToggle(changedIndices, checked, needUpdate) {
            this.initHeader();
            this.initSearch();
            this.initPagination();
            this.initBody();
            if (this.options.showColumns) {
                var $items = this.$toolbar.find('.keep-open input:not(".toggle-all")').prop('disabled', false);
                if (needUpdate) {
                    var _iterator2 = _createForOfIteratorHelper(changedIndices), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var index = _step2.value;
                            $items.filter(Utils.sprintf('[value="%s"]', index)).prop('checked', checked);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                if ($items.filter(':checked').length <= this.options.minimumCountColumns) $items.filter(':checked').prop('disabled', true);
            }
        },
        _toggleColumns: function _toggleColumns(fields, checked, needUpdate) {
            if (!fields.length) return;
            var changedIndices = [];
            var _iterator3 = _createForOfIteratorHelper(fields), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var field = _step3.value;
                    var index = this.fieldsColumnsIndex[field];
                    if (this._toggleColumnVisibility(index, checked)) changedIndices.push(index);
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            if (changedIndices.length) this._updateAfterColumnToggle(changedIndices, checked, needUpdate);
        },
        showAllColumns: function showAllColumns() {
            this._toggleAllColumns(true);
        },
        hideAllColumns: function hideAllColumns() {
            this._toggleAllColumns(false);
        },
        _toggleAllColumns: function _toggleAllColumns(visible) {
            var _this4 = this;
            var _iterator4 = _createForOfIteratorHelper(this.columns.slice().reverse()), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var column = _step4.value;
                    if (column.switchable) {
                        if (!visible && this.options.showColumns && this.getVisibleColumns().filter(function(it) {
                            return it.switchable;
                        }).length === this.options.minimumCountColumns) continue;
                        column.visible = visible;
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
            this.initHeader();
            this.initSearch();
            this.initPagination();
            this.initBody();
            if (this.options.showColumns) {
                var $items = this.$toolbar.find('.keep-open input[type="checkbox"]:not(".toggle-all")').prop('disabled', false);
                if (visible) $items.prop('checked', visible);
                else $items.get().reverse().forEach(function(item) {
                    if ($items.filter(':checked').length > _this4.options.minimumCountColumns) $(item).prop('checked', visible);
                });
                if ($items.filter(':checked').length <= this.options.minimumCountColumns) $items.filter(':checked').prop('disabled', true);
            }
        },
        mergeCells: function mergeCells(options) {
            var row = options.index;
            var col = this.getVisibleFields().indexOf(options.field);
            var rowspan = +options.rowspan || 1;
            var colspan = +options.colspan || 1;
            var i;
            var j;
            var $tr = this.$body.find('>tr[data-index]');
            col += Utils.getDetailViewIndexOffset(this.options);
            var $td = $tr.eq(row).find('>td').eq(col);
            if (row < 0 || col < 0 || row >= this.data.length) return;
            for(i = row; i < row + rowspan; i++)for(j = col; j < col + colspan; j++)$tr.eq(i).find('>td').eq(j).hide();
            $td.attr('rowspan', rowspan).attr('colspan', colspan).show();
        },
        getVisibleColumns: function getVisibleColumns() {
            var _this5 = this;
            return this.columns.filter(function(column) {
                return column.visible && !_this5.isSelectionColumn(column);
            });
        },
        getHiddenColumns: function getHiddenColumns() {
            return this.columns.filter(function(_ref) {
                var visible = _ref.visible;
                return !visible;
            });
        }
    };
    var CheckModule = {
        updateSelected: function updateSelected() {
            var checkAll = this.$selectItem.filter(':enabled').length && this.$selectItem.filter(':enabled').length === this.$selectItem.filter(':enabled').filter(':checked').length;
            this.$selectAll.add(this.$selectAll_).prop('checked', checkAll);
            this.$selectItem.each(function(i, el) {
                $(el).closest('tr')[$(el).prop('checked') ? 'addClass' : 'removeClass']('selected');
            });
        },
        isSelectionColumn: function isSelectionColumn(column) {
            return column.radio || column.checkbox;
        },
        getSelections: function getSelections() {
            var _this = this;
            return (this.options.maintainMetaData ? this.options.data : this.data).filter(function(row) {
                return row[_this.header.stateField] === true;
            });
        },
        updateRows: function updateRows() {
            var _this2 = this;
            this.$selectItem.each(function(i, el) {
                _this2.data[$(el).data('index')][_this2.header.stateField] = $(el).prop('checked');
            });
        },
        resetRows: function resetRows() {
            if (this.data.length) {
                this.$selectAll.prop('checked', false);
                this.$selectItem.prop('checked', false);
            }
            if (this.header.stateField) {
                var _iterator = _createForOfIteratorHelper(this.data), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var row = _step.value;
                        row[this.header.stateField] = false;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            this.initHiddenRows();
        },
        checkAll: function checkAll() {
            this._toggleCheckAll(true);
        },
        uncheckAll: function uncheckAll() {
            this._toggleCheckAll(false);
        },
        _toggleCheckAll: function _toggleCheckAll(checked) {
            var rowsBefore = this.getSelections();
            this.$selectAll.add(this.$selectAll_).prop('checked', checked);
            this.$selectItem.filter(':enabled').prop('checked', checked);
            this.updateRows();
            this.updateSelected();
            var rowsAfter = this.getSelections();
            if (checked) {
                this.trigger('check-all', rowsAfter, rowsBefore);
                return;
            }
            this.trigger('uncheck-all', rowsAfter, rowsBefore);
        },
        checkInvert: function checkInvert() {
            var $items = this.$selectItem.filter(':enabled');
            var checked = $items.filter(':checked');
            $items.each(function(i, el) {
                $(el).prop('checked', !$(el).prop('checked'));
            });
            this.updateRows();
            this.updateSelected();
            this.trigger('uncheck-some', checked);
            checked = this.getSelections();
            this.trigger('check-some', checked);
        },
        check: function check(index) {
            this._toggleCheck(true, index);
        },
        uncheck: function uncheck(index) {
            this._toggleCheck(false, index);
        },
        _toggleCheck: function _toggleCheck(checked, index) {
            var $el = this.$selectItem.filter("[data-index=\"".concat(index, "\"]"));
            var row = this.data[index];
            if ($el.is(':radio') || this.options.singleSelect || this.options.multipleSelectRow && !this.multipleSelectRowCtrlKey && !this.multipleSelectRowShiftKey) {
                var _iterator2 = _createForOfIteratorHelper(this.options.data), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var r = _step2.value;
                        r[this.header.stateField] = false;
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                this.$selectItem.filter(':checked').not($el).prop('checked', false);
            }
            row[this.header.stateField] = checked;
            if (this.options.multipleSelectRow) {
                if (this.multipleSelectRowShiftKey && this.multipleSelectRowLastSelectedIndex >= 0) {
                    var _ref = this.multipleSelectRowLastSelectedIndex < index ? [
                        this.multipleSelectRowLastSelectedIndex,
                        index
                    ] : [
                        index,
                        this.multipleSelectRowLastSelectedIndex
                    ], _ref2 = _slicedToArray(_ref, 2), fromIndex = _ref2[0], toIndex = _ref2[1];
                    for(var i = fromIndex + 1; i < toIndex; i++){
                        this.data[i][this.header.stateField] = true;
                        this.$selectItem.filter("[data-index=\"".concat(i, "\"]")).prop('checked', true);
                    }
                }
                this.multipleSelectRowCtrlKey = false;
                this.multipleSelectRowShiftKey = false;
                this.multipleSelectRowLastSelectedIndex = checked ? index : -1;
            }
            $el.prop('checked', checked);
            this.updateSelected();
            this.trigger(checked ? 'check' : 'uncheck', this.data[index], $el);
        },
        checkBy: function checkBy(obj) {
            this._toggleCheckBy(true, obj);
        },
        uncheckBy: function uncheckBy(obj) {
            this._toggleCheckBy(false, obj);
        },
        _toggleCheckBy: function _toggleCheckBy(checked, obj) {
            var _this3 = this;
            if (!obj.hasOwnProperty('field') || !obj.hasOwnProperty('values')) return;
            var rows = [];
            this.data.forEach(function(row, i) {
                if (!row.hasOwnProperty(obj.field)) return false;
                if (obj.values.includes(row[obj.field])) {
                    var $el = _this3.$selectItem.filter(':enabled').filter(Utils.sprintf('[data-index="%s"]', i));
                    var onlyCurrentPage = obj.hasOwnProperty('onlyCurrentPage') ? obj.onlyCurrentPage : false;
                    $el = checked ? $el.not(':checked') : $el.filter(':checked');
                    if (!$el.length && onlyCurrentPage) return;
                    $el.prop('checked', checked);
                    row[_this3.header.stateField] = checked;
                    rows.push(row);
                    _this3.trigger(checked ? 'check' : 'uncheck', row, $el);
                }
            });
            this.updateSelected();
            this.trigger(checked ? 'check-some' : 'uncheck-some', rows);
        }
    };
    var es_array_sort = {};
    var environmentFfVersion;
    var hasRequiredEnvironmentFfVersion;
    function requireEnvironmentFfVersion() {
        if (hasRequiredEnvironmentFfVersion) return environmentFfVersion;
        hasRequiredEnvironmentFfVersion = 1;
        var userAgent = requireEnvironmentUserAgent();
        var firefox = userAgent.match(/firefox\/(\d+)/i);
        environmentFfVersion = !!firefox && +firefox[1];
        return environmentFfVersion;
    }
    var environmentIsIeOrEdge;
    var hasRequiredEnvironmentIsIeOrEdge;
    function requireEnvironmentIsIeOrEdge() {
        if (hasRequiredEnvironmentIsIeOrEdge) return environmentIsIeOrEdge;
        hasRequiredEnvironmentIsIeOrEdge = 1;
        var UA = requireEnvironmentUserAgent();
        environmentIsIeOrEdge = /MSIE|Trident/.test(UA);
        return environmentIsIeOrEdge;
    }
    var environmentWebkitVersion;
    var hasRequiredEnvironmentWebkitVersion;
    function requireEnvironmentWebkitVersion() {
        if (hasRequiredEnvironmentWebkitVersion) return environmentWebkitVersion;
        hasRequiredEnvironmentWebkitVersion = 1;
        var userAgent = requireEnvironmentUserAgent();
        var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
        environmentWebkitVersion = !!webkit && +webkit[1];
        return environmentWebkitVersion;
    }
    var hasRequiredEs_array_sort;
    function requireEs_array_sort() {
        if (hasRequiredEs_array_sort) return es_array_sort;
        hasRequiredEs_array_sort = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThis();
        var aCallable = requireACallable();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var deletePropertyOrThrow = requireDeletePropertyOrThrow();
        var toString = requireToString();
        var fails = requireFails();
        var internalSort = requireArraySort();
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var FF = requireEnvironmentFfVersion();
        var IE_OR_EDGE = requireEnvironmentIsIeOrEdge();
        var V8 = requireEnvironmentV8Version();
        var WEBKIT = requireEnvironmentWebkitVersion();
        var test = [];
        var nativeSort = uncurryThis(test.sort);
        var push = uncurryThis(test.push);
        // IE8-
        var FAILS_ON_UNDEFINED = fails(function() {
            test.sort(undefined);
        });
        // V8 bug
        var FAILS_ON_NULL = fails(function() {
            test.sort(null);
        });
        // Old WebKit
        var STRICT_METHOD = arrayMethodIsStrict('sort');
        var STABLE_SORT = !fails(function() {
            // feature detection can be too slow, so check engines versions
            if (V8) return V8 < 70;
            if (FF && FF > 3) return;
            if (IE_OR_EDGE) return true;
            if (WEBKIT) return WEBKIT < 603;
            var result = '';
            var code, chr, value, index;
            // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
            for(code = 65; code < 76; code++){
                chr = String.fromCharCode(code);
                switch(code){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        value = 3;
                        break;
                    case 68:
                    case 71:
                        value = 4;
                        break;
                    default:
                        value = 2;
                }
                for(index = 0; index < 47; index++)test.push({
                    k: chr + index,
                    v: value
                });
            }
            test.sort(function(a, b) {
                return b.v - a.v;
            });
            for(index = 0; index < test.length; index++){
                chr = test[index].k.charAt(0);
                if (result.charAt(result.length - 1) !== chr) result += chr;
            }
            return result !== 'DGBEFHACIJK';
        });
        var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
        var getSortCompare = function(comparefn) {
            return function(x, y) {
                if (y === undefined) return -1;
                if (x === undefined) return 1;
                if (comparefn !== undefined) return +comparefn(x, y) || 0;
                var xString = toString(x);
                var yString = toString(y);
                return xString === yString ? 0 : xString > yString ? 1 : -1;
            };
        };
        // `Array.prototype.sort` method
        // https://tc39.es/ecma262/#sec-array.prototype.sort
        $({
            target: 'Array',
            proto: true,
            forced: FORCED
        }, {
            sort: function sort(comparefn) {
                if (comparefn !== undefined) aCallable(comparefn);
                var array = toObject(this);
                if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
                var items = [];
                var arrayLength = lengthOfArrayLike(array);
                var itemsLength, index;
                for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                internalSort(items, getSortCompare(comparefn));
                itemsLength = lengthOfArrayLike(items);
                index = 0;
                while(index < itemsLength)array[index] = items[index++];
                while(index < arrayLength)deletePropertyOrThrow(array, index++);
                return array;
            }
        });
        return es_array_sort;
    }
    requireEs_array_sort();
    var es_number_constructor = {};
    var path;
    var hasRequiredPath;
    function requirePath() {
        if (hasRequiredPath) return path;
        hasRequiredPath = 1;
        var globalThis1 = requireGlobalThis();
        path = globalThis1;
        return path;
    }
    var thisNumberValue;
    var hasRequiredThisNumberValue;
    function requireThisNumberValue() {
        if (hasRequiredThisNumberValue) return thisNumberValue;
        hasRequiredThisNumberValue = 1;
        var uncurryThis = requireFunctionUncurryThis();
        // `thisNumberValue` abstract operation
        // https://tc39.es/ecma262/#sec-thisnumbervalue
        thisNumberValue = uncurryThis(1.1.valueOf);
        return thisNumberValue;
    }
    var hasRequiredEs_number_constructor;
    function requireEs_number_constructor() {
        if (hasRequiredEs_number_constructor) return es_number_constructor;
        hasRequiredEs_number_constructor = 1;
        var $ = require_export();
        var IS_PURE = requireIsPure();
        var DESCRIPTORS = requireDescriptors();
        var globalThis1 = requireGlobalThis();
        var path = requirePath();
        var uncurryThis = requireFunctionUncurryThis();
        var isForced = requireIsForced();
        var hasOwn = requireHasOwnProperty();
        var inheritIfRequired = requireInheritIfRequired();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var isSymbol = requireIsSymbol();
        var toPrimitive = requireToPrimitive();
        var fails = requireFails();
        var getOwnPropertyNames = requireObjectGetOwnPropertyNames().f;
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var defineProperty = requireObjectDefineProperty().f;
        var thisNumberValue = requireThisNumberValue();
        var trim = requireStringTrim().trim;
        var NUMBER = 'Number';
        var NativeNumber = globalThis1[NUMBER];
        var PureNumberNamespace = path[NUMBER];
        var NumberPrototype = NativeNumber.prototype;
        var TypeError1 = globalThis1.TypeError;
        var stringSlice = uncurryThis(''.slice);
        var charCodeAt = uncurryThis(''.charCodeAt);
        // `ToNumeric` abstract operation
        // https://tc39.es/ecma262/#sec-tonumeric
        var toNumeric = function(value) {
            var primValue = toPrimitive(value, 'number');
            return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
        };
        // `ToNumber` abstract operation
        // https://tc39.es/ecma262/#sec-tonumber
        var toNumber = function(argument) {
            var it = toPrimitive(argument, 'number');
            var first, third, radix, maxCode, digits, length, index, code;
            if (isSymbol(it)) throw new TypeError1('Cannot convert a Symbol value to a number');
            if (typeof it == 'string' && it.length > 2) {
                it = trim(it);
                first = charCodeAt(it, 0);
                if (first === 43 || first === 45) {
                    third = charCodeAt(it, 2);
                    if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
                } else if (first === 48) {
                    switch(charCodeAt(it, 1)){
                        // fast equal of /^0b[01]+$/i
                        case 66:
                        case 98:
                            radix = 2;
                            maxCode = 49;
                            break;
                        // fast equal of /^0o[0-7]+$/i
                        case 79:
                        case 111:
                            radix = 8;
                            maxCode = 55;
                            break;
                        default:
                            return +it;
                    }
                    digits = stringSlice(it, 2);
                    length = digits.length;
                    for(index = 0; index < length; index++){
                        code = charCodeAt(digits, index);
                        // parseInt parses a string to a first unavailable symbol
                        // but ToNumber should return NaN if a string contains unavailable symbols
                        if (code < 48 || code > maxCode) return NaN;
                    }
                    return parseInt(digits, radix);
                }
            }
            return +it;
        };
        var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));
        var calledWithNew = function(dummy) {
            // includes check on 1..constructor(foo) case
            return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
                thisNumberValue(dummy);
            });
        };
        // `Number` constructor
        // https://tc39.es/ecma262/#sec-number-constructor
        var NumberWrapper = function Number1(value) {
            var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
            return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
        };
        NumberWrapper.prototype = NumberPrototype;
        if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;
        $({
            global: true,
            constructor: true,
            wrap: true,
            forced: FORCED
        }, {
            Number: NumberWrapper
        });
        // Use `internal/copy-constructor-properties` helper in `core-js [at] 4`
        var copyConstructorProperties = function(target, source) {
            for(var keys = DESCRIPTORS ? getOwnPropertyNames(source) : // ES3:
            "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(','), j = 0, key; keys.length > j; j++)if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        };
        if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
        if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);
        return es_number_constructor;
    }
    requireEs_number_constructor();
    var DataModule = {
        initServer: function initServer(silent, query) {
            var _this = this;
            var data = {};
            var index = this.header.fields.indexOf(this.options.sortName);
            var params = {
                searchText: this.searchText,
                sortName: this.options.sortName,
                sortOrder: this.options.sortOrder
            };
            if (this.header.sortNames[index]) params.sortName = this.header.sortNames[index];
            if (this.options.pagination && this.options.sidePagination === 'server') {
                params.pageSize = this.options.pageSize === this.options.formatAllRows() ? this.options.totalRows : this.options.pageSize;
                params.pageNumber = this.options.pageNumber;
            }
            if (!this.options.url && !this.options.ajax) return;
            if (this.options.queryParamsType === 'limit') {
                params = {
                    search: params.searchText,
                    sort: params.sortName,
                    order: params.sortOrder
                };
                if (this.options.pagination && this.options.sidePagination === 'server') {
                    params.offset = this.options.pageSize === this.options.formatAllRows() ? 0 : this.options.pageSize * (this.options.pageNumber - 1);
                    params.limit = this.options.pageSize;
                    if (params.limit === 0 || this.options.pageSize === this.options.formatAllRows()) delete params.limit;
                }
            }
            if (this.options.search && this.options.sidePagination === 'server' && this.options.searchable && this.columns.filter(function(column) {
                return column.searchable;
            }).length) {
                params.searchable = [];
                var _iterator = _createForOfIteratorHelper(this.columns), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var column = _step.value;
                        if (!column.checkbox && column.searchable && (this.options.visibleSearch && column.visible || !this.options.visibleSearch)) params.searchable.push(column.field);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
            if (!Utils.isEmptyObject(this.filterColumnsPartial)) params.filter = JSON.stringify(this.filterColumnsPartial, null);
            Utils.extend(params, query || {});
            data = Utils.calculateObjectValue(this.options, this.options.queryParams, [
                params
            ], data);
            // false to stop request
            if (data === false) return;
            if (!silent) this.showLoading();
            var request = Utils.extend({}, Utils.calculateObjectValue(null, this.options.ajaxOptions), {
                type: this.options.method,
                url: this.options.url,
                data: this.options.contentType === 'application/json' && this.options.method === 'post' ? JSON.stringify(data) : data,
                cache: this.options.cache,
                contentType: this.options.contentType,
                dataType: this.options.dataType,
                success: function success(_res, textStatus, jqXHR) {
                    var res = Utils.calculateObjectValue(_this.options, _this.options.responseHandler, [
                        _res,
                        jqXHR
                    ], _res);
                    if (_this.options.sidePagination === 'client' && _this.options.paginationLoadMore) _this._paginationLoaded = _this.data.length === res.length;
                    _this.load(res);
                    _this.trigger('load-success', res, jqXHR && jqXHR.status, jqXHR);
                    if (!silent) _this.hideLoading();
                    if (_this.options.sidePagination === 'server' && _this.options.pageNumber > 1 && res[_this.options.totalField] > 0 && !res[_this.options.dataField].length) _this.updatePagination();
                },
                error: function error(jqXHR) {
                    // abort ajax by multiple request
                    if (jqXHR && jqXHR.status === 0 && _this._xhrAbort) {
                        _this._xhrAbort = false;
                        return;
                    }
                    var data = [];
                    if (_this.options.sidePagination === 'server') {
                        data = {};
                        data[_this.options.totalField] = 0;
                        data[_this.options.dataField] = [];
                    }
                    _this.load(data);
                    _this.trigger('load-error', jqXHR && jqXHR.status, jqXHR);
                    if (!silent) _this.hideLoading();
                }
            });
            if (this.options.ajax) Utils.calculateObjectValue(this, this.options.ajax, [
                request
            ], null);
            else {
                if (this._xhr && this._xhr.readyState !== 4) {
                    this._xhrAbort = true;
                    this._xhr.abort();
                }
                this._xhr = $.ajax(request);
            }
            return data;
        },
        initData: function initData(data, type) {
            if (type === 'append') this.options.data = this.options.data.concat(data);
            else if (type === 'prepend') this.options.data = [].concat(data).concat(this.options.data);
            else {
                data = data || Utils.deepCopy(this.options.data);
                this.options.data = Array.isArray(data) ? data : data[this.options.dataField];
            }
            this.data = _toConsumableArray(this.options.data);
            if (this.options.sortReset) this.unsortedData = _toConsumableArray(this.data);
            if (this.options.sidePagination === 'server') return;
            this.initSort();
        },
        initSort: function initSort() {
            var _this2 = this;
            var name = this.options.sortName;
            var order = this.options.sortOrder === 'desc' ? -1 : 1;
            var index = this.header.fields.indexOf(this.options.sortName);
            if (index !== -1) {
                if (this.options.sortStable) this.data.forEach(function(row, i) {
                    if (!row.hasOwnProperty('_position')) row._position = i;
                });
                if (Utils.hasRowspanCells(this.data)) Utils.flattenRowspanCells(this.data);
                if (this.options.customSort) Utils.calculateObjectValue(this.options, this.options.customSort, [
                    this.options.sortName,
                    this.options.sortOrder,
                    this.data
                ]);
                else this.data.sort(function(a, b) {
                    if (_this2.header.sortNames[index]) name = _this2.header.sortNames[index];
                    var aa = Utils.getItemField(a, name, _this2.options.escape);
                    var bb = Utils.getItemField(b, name, _this2.options.escape);
                    var value = Utils.calculateObjectValue(_this2.header, _this2.header.sorters[index], [
                        aa,
                        bb,
                        a,
                        b
                    ]);
                    if (value !== undefined) {
                        if (_this2.options.sortStable && value === 0) return order * (a._position - b._position);
                        return order * value;
                    }
                    return Utils.sort(aa, bb, order, _this2.options, a._position, b._position);
                });
                if (this.options.sortClass !== undefined) setTimeout(function() {
                    _this2.$el.removeClass(_this2.options.sortClass);
                    var index = _this2.$header.find("[data-field=\"".concat(_this2.options.sortName, "\"]")).index();
                    _this2.$el.find("tr td:nth-child(".concat(index + 1, ")")).addClass(_this2.options.sortClass);
                }, 250);
            } else if (this.options.sortReset) this.data = _toConsumableArray(this.unsortedData);
        },
        onSort: function onSort(_ref) {
            var type = _ref.type, currentTarget = _ref.currentTarget;
            var $this = type === 'keypress' ? $(currentTarget) : $(currentTarget).parent();
            var $this_ = this.$header.find('th').eq($this.index());
            this.$header.add(this.$header_).find('span.order').remove();
            if (this.options.sortName === $this.data('field')) {
                var currentSortOrder = this.options.sortOrder;
                var initialSortOrder = this.columns[this.fieldsColumnsIndex[$this.data('field')]].sortOrder || this.columns[this.fieldsColumnsIndex[$this.data('field')]].order;
                if (currentSortOrder === undefined) this.options.sortOrder = 'asc';
                else if (currentSortOrder === 'asc') this.options.sortOrder = this.options.sortReset ? initialSortOrder === 'asc' ? 'desc' : undefined : 'desc';
                else if (this.options.sortOrder === 'desc') this.options.sortOrder = this.options.sortReset ? initialSortOrder === 'desc' ? 'asc' : undefined : 'asc';
                if (this.options.sortOrder === undefined) this.options.sortName = undefined;
            } else {
                this.options.sortName = $this.data('field');
                if (this.options.rememberOrder) this.options.sortOrder = $this.data('order') === 'asc' ? 'desc' : 'asc';
                else this.options.sortOrder = this.columns[this.fieldsColumnsIndex[$this.data('field')]].sortOrder || this.columns[this.fieldsColumnsIndex[$this.data('field')]].order;
            }
            $this.add($this_).data('order', this.options.sortOrder);
            // Assign the correct sortable arrow
            this.resetCaret();
            this._sort();
        },
        _sort: function _sort() {
            if (this.options.sidePagination === 'server' && this.options.serverSort) {
                this.options.pageNumber = 1;
                this.trigger('sort', this.options.sortName, this.options.sortOrder);
                this.initServer(this.options.silentSort);
                return;
            }
            if (this.options.pagination && this.options.sortResetPage) {
                this.options.pageNumber = 1;
                this.initPagination();
            }
            this.trigger('sort', this.options.sortName, this.options.sortOrder);
            this.initSort();
            this.initBody();
        },
        sortReset: function sortReset() {
            this.options.sortName = undefined;
            this.options.sortOrder = undefined;
            this._sort();
        },
        sortBy: function sortBy(params) {
            this.options.sortName = params.field;
            this.options.sortOrder = params.hasOwnProperty('sortOrder') ? params.sortOrder : 'asc';
            this._sort();
        },
        getData: function getData(params) {
            var _this3 = this;
            var data = this.options.data;
            if ((this.searchText || this.options.customSearch || this.options.sortName !== undefined || this.enableCustomSort || // Fix #4616: this.enableCustomSort is for extensions
            !Utils.isEmptyObject(this.filterColumns) || typeof this.options.filterOptions.filterAlgorithm === 'function' || !Utils.isEmptyObject(this.filterColumnsPartial)) && (!params || !params.unfiltered)) data = this.data;
            if (params && !params.includeHiddenRows) {
                var hiddenRows = this.getHiddenRows();
                data = data.filter(function(row) {
                    return Utils.findIndex(hiddenRows, row) === -1;
                });
            }
            if (params && params.useCurrentPage) data = data.slice(this.pageFrom - 1, this.pageTo);
            if (params && params.formatted) return data.map(function(row) {
                var formattedColumns = {};
                for(var _i = 0, _Object$entries = Object.entries(row); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                    var column = _this3.columns[_this3.fieldsColumnsIndex[key]];
                    if (!column) continue;
                    formattedColumns[key] = Utils.calculateObjectValue(column, _this3.header.formatters[column.fieldIndex], [
                        value,
                        row,
                        row.index,
                        column.field
                    ], value);
                }
                return formattedColumns;
            });
            return data;
        },
        getFooterData: function getFooterData() {
            var _this$footerData;
            return (_this$footerData = this.footerData) !== null && _this$footerData !== void 0 ? _this$footerData : [];
        },
        load: function load(_data) {
            var data = _data;
            // #431: support pagination
            if (this.options.pagination && this.options.sidePagination === 'server') {
                this.options.totalRows = data[this.options.totalField];
                this.options.totalNotFiltered = data[this.options.totalNotFilteredField];
                this.footerData = data[this.options.footerField] ? [
                    data[this.options.footerField]
                ] : undefined;
            }
            var fixedScroll = this.options.fixedScroll || data.fixedScroll;
            data = Array.isArray(data) ? data : data[this.options.dataField];
            this.initData(data);
            this.initSearch();
            this.initPagination();
            this.initBody(fixedScroll);
        },
        append: function append(data) {
            this.initData(data, 'append');
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true);
        },
        prepend: function prepend(data) {
            this.initData(data, 'prepend');
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true);
        },
        remove: function remove(params) {
            var removed = 0;
            for(var i = this.options.data.length - 1; i >= 0; i--){
                var row = this.options.data[i];
                var value = Utils.getItemField(row, params.field, this.options.escape, row.escape);
                if (value === undefined && params.field !== '$index') continue;
                if (!row.hasOwnProperty(params.field) && params.field === '$index' && params.values.includes(i) || params.values.includes(value)) {
                    removed++;
                    this.options.data.splice(i, 1);
                }
            }
            if (!removed) return;
            if (this.options.sidePagination === 'server') {
                this.options.totalRows -= removed;
                this.data = _toConsumableArray(this.options.data);
            }
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true);
        },
        removeAll: function removeAll() {
            if (this.options.data.length > 0) {
                this.data.splice(0, this.data.length);
                this.options.data.splice(0, this.options.data.length);
                this.initSearch();
                this.initPagination();
                this.initBody(true);
            }
        },
        insertRow: function insertRow(params) {
            if (!params.hasOwnProperty('index') || !params.hasOwnProperty('row')) return;
            var row = this.data[params.index];
            var originalIndex = this.options.data.indexOf(row);
            if (originalIndex === -1) {
                this.append([
                    params.row
                ]);
                return;
            }
            this.data.splice(params.index, 0, params.row);
            this.options.data.splice(originalIndex, 0, params.row);
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true);
        },
        updateRow: function updateRow(params) {
            var allParams = Array.isArray(params) ? params : [
                params
            ];
            var _iterator2 = _createForOfIteratorHelper(allParams), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _params = _step2.value;
                    if (!_params.hasOwnProperty('index') || !_params.hasOwnProperty('row')) continue;
                    var row = this.data[_params.index];
                    var originalIndex = this.options.data.indexOf(row);
                    if (_params.hasOwnProperty('replace') && _params.replace) {
                        this.data[_params.index] = _params.row;
                        this.options.data[originalIndex] = _params.row;
                    } else {
                        Utils.extend(this.data[_params.index], _params.row);
                        Utils.extend(this.options.data[originalIndex], _params.row);
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true);
        },
        getRowByUniqueId: function getRowByUniqueId(_id) {
            var uniqueId = this.options.uniqueId;
            var len = this.options.data.length;
            var id = _id;
            var dataRow = null;
            var i;
            var row;
            for(i = len - 1; i >= 0; i--){
                row = this.options.data[i];
                var rowUniqueId = Utils.getItemField(row, uniqueId, this.options.escape, row.escape);
                if (rowUniqueId === undefined) continue;
                if (typeof rowUniqueId === 'string') id = _id.toString();
                else if (typeof rowUniqueId === 'number') {
                    if (Number(rowUniqueId) === rowUniqueId && rowUniqueId % 1 === 0) id = parseInt(_id, 10);
                    else if (rowUniqueId === Number(rowUniqueId) && rowUniqueId !== 0) id = parseFloat(_id);
                }
                if (rowUniqueId === id) {
                    dataRow = row;
                    break;
                }
            }
            return dataRow;
        },
        updateByUniqueId: function updateByUniqueId(params) {
            var allParams = Array.isArray(params) ? params : [
                params
            ];
            var updatedUid = null;
            var _iterator3 = _createForOfIteratorHelper(allParams), _step3;
            try {
                for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                    var _params2 = _step3.value;
                    if (!_params2.hasOwnProperty('id') || !_params2.hasOwnProperty('row')) continue;
                    var rowId = this.options.data.indexOf(this.getRowByUniqueId(_params2.id));
                    if (rowId === -1) continue;
                    if (_params2.hasOwnProperty('replace') && _params2.replace) this.options.data[rowId] = _params2.row;
                    else Utils.extend(this.options.data[rowId], _params2.row);
                    updatedUid = _params2.id;
                }
            } catch (err) {
                _iterator3.e(err);
            } finally{
                _iterator3.f();
            }
            this.initSearch();
            this.initPagination();
            this.initSort();
            this.initBody(true, updatedUid);
        },
        removeByUniqueId: function removeByUniqueId(id) {
            var len = this.options.data.length;
            var row = this.getRowByUniqueId(id);
            if (row) this.options.data.splice(this.options.data.indexOf(row), 1);
            if (len === this.options.data.length) return;
            if (this.options.sidePagination === 'server') {
                this.options.totalRows -= 1;
                this.data = _toConsumableArray(this.options.data);
            }
            this.initSearch();
            this.initPagination();
            this.initBody(true);
        },
        _updateCellOnly: function _updateCellOnly(field, index) {
            if (index === -1) return;
            var rowHtml = this.initRow(this.data[index], index);
            var fieldIndex = this.getVisibleFields().indexOf(field);
            if (fieldIndex === -1) return;
            fieldIndex += Utils.getDetailViewIndexOffset(this.options);
            this.$body.find(">tr[data-index=".concat(index, "]")).find(">td:eq(".concat(fieldIndex, ")")).replaceWith($(rowHtml).find(">td:eq(".concat(fieldIndex, ")")));
            this.initBodyEvent();
            this.initFooter();
            this.resetView();
            this.updateSelected();
        },
        updateCell: function updateCell(params) {
            if (!params.hasOwnProperty('index') || !params.hasOwnProperty('field') || !params.hasOwnProperty('value')) return;
            var row = this.data[params.index];
            var originalIndex = this.options.data.indexOf(row);
            this.data[params.index][params.field] = params.value;
            this.options.data[originalIndex][params.field] = params.value;
            if (params.reinit === false) {
                this._updateCellOnly(params.field, params.index);
                return;
            }
            this.initSort();
            this.initBody(true);
        },
        updateCellByUniqueId: function updateCellByUniqueId(params) {
            var _this4 = this;
            var allParams = Array.isArray(params) ? params : [
                params
            ];
            allParams.forEach(function(_ref2) {
                var id = _ref2.id, field = _ref2.field, value = _ref2.value;
                var row = _this4.getRowByUniqueId(id);
                var index = _this4.data.indexOf(row);
                var originalIndex = _this4.options.data.indexOf(row);
                if (!row || index === -1) return;
                _this4.data[index][field] = value;
                _this4.options.data[originalIndex][field] = value;
            });
            if (params.reinit === false) {
                this._updateCellOnly(params.field, this.data.indexOf(this.getRowByUniqueId(params.id)));
                return;
            }
            this.initSort();
            this.initBody(true);
        }
    };
    var DetailModule = {
        toggleDetailView: function toggleDetailView(index, _columnDetailFormatter) {
            var $tr = this.$body.find(Utils.sprintf('> tr[data-index="%s"]', index));
            if ($tr.next().is('tr.detail-view')) this.collapseRow(index);
            else this.expandRow(index, _columnDetailFormatter);
            this.resetView();
        },
        expandRow: function expandRow(index, _columnDetailFormatter) {
            var row = this.data[index];
            var $tr = this.$body.find(Utils.sprintf('> tr[data-index="%s"][data-has-detail-view]', index));
            if (this.options.detailViewIcon) $tr.find('a.detail-icon').html(Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, this.options.icons.detailClose));
            if ($tr.next().is('tr.detail-view')) return;
            $tr.after(Utils.sprintf('<tr class="detail-view"><td colspan="%s"></td></tr>', $tr.children('td').length));
            var $element = $tr.next().find('td');
            var detailFormatter = _columnDetailFormatter || this.options.detailFormatter;
            var content = Utils.calculateObjectValue(this.options, detailFormatter, [
                index,
                row,
                $element
            ], '');
            if ($element.length === 1) $element.append(content);
            this.trigger('expand-row', index, row, $element);
        },
        expandRowByUniqueId: function expandRowByUniqueId(uniqueId) {
            var row = this.getRowByUniqueId(uniqueId);
            if (!row) return;
            this.expandRow(this.data.indexOf(row));
        },
        collapseRow: function collapseRow(index) {
            var row = this.data[index];
            var $tr = this.$body.find(Utils.sprintf('> tr[data-index="%s"][data-has-detail-view]', index));
            if (!$tr.next().is('tr.detail-view')) return;
            if (this.options.detailViewIcon) $tr.find('a.detail-icon').html(Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, this.options.icons.detailOpen));
            this.trigger('collapse-row', index, row, $tr.next());
            $tr.next().remove();
        },
        collapseRowByUniqueId: function collapseRowByUniqueId(uniqueId) {
            var row = this.getRowByUniqueId(uniqueId);
            if (!row) return;
            this.collapseRow(this.data.indexOf(row));
        },
        expandAllRows: function expandAllRows() {
            var trs = this.$body.find('> tr[data-index][data-has-detail-view]');
            for(var i = 0; i < trs.length; i++)this.expandRow($(trs[i]).data('index'));
        },
        collapseAllRows: function collapseAllRows() {
            var trs = this.$body.find('> tr[data-index][data-has-detail-view]');
            for(var i = 0; i < trs.length; i++)this.collapseRow($(trs[i]).data('index'));
        }
    };
    var HeaderModule = {
        initHeader: function initHeader() {
            var _this = this;
            var visibleColumns = {};
            var headerHtml = [];
            this.header = {
                fields: [],
                styles: [],
                classes: [],
                formatters: [],
                detailFormatters: [],
                events: [],
                sorters: [],
                sortNames: [],
                cellStyles: [],
                searchables: []
            };
            Utils.updateFieldGroup(this.options.columns, this.columns);
            this.options.columns.forEach(function(columns, i) {
                var html = [];
                html.push("<tr".concat(Utils.sprintf(' class="%s"', _this._headerTrClasses[i]), " ").concat(Utils.sprintf(' style="%s"', _this._headerTrStyles[i]), ">"));
                var detailViewTemplate = '';
                if (i === 0 && Utils.hasDetailViewIcon(_this.options)) {
                    var rowspan = _this.options.columns.length > 1 ? " rowspan=\"".concat(_this.options.columns.length, "\"") : '';
                    detailViewTemplate = "<th class=\"detail\"".concat(rowspan, ">\n          <div class=\"fht-cell\"></div>\n          </th>");
                }
                if (detailViewTemplate && _this.options.detailViewAlign !== 'right') html.push(detailViewTemplate);
                columns.forEach(function(column, j) {
                    var class_ = Utils.sprintf(' class="%s"', column.class);
                    var unitWidth = column.widthUnit;
                    var width = parseFloat(column.width);
                    var columnHalign = column.halign ? column.halign : column.align;
                    var halign = Utils.sprintf('text-align: %s; ', columnHalign);
                    var align = Utils.sprintf('text-align: %s; ', column.align);
                    var style = Utils.sprintf('vertical-align: %s; ', column.valign);
                    style += Utils.sprintf('width: %s; ', (column.checkbox || column.radio) && !width ? !column.showSelectTitle ? '36px' : undefined : width ? width + unitWidth : undefined);
                    if (typeof column.fieldIndex === 'undefined' && !column.visible) return;
                    var headerStyle = Utils.calculateObjectValue(null, _this.options.headerStyle, [
                        column
                    ]);
                    var csses = [];
                    var data_ = [];
                    var classes = '';
                    if (headerStyle && headerStyle.css) for(var _i = 0, _Object$entries = Object.entries(headerStyle.css); _i < _Object$entries.length; _i++){
                        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        csses.push("".concat(key, ": ").concat(value));
                    }
                    if (headerStyle && headerStyle.classes) classes = Utils.sprintf(' class="%s"', column['class'] ? [
                        column['class'],
                        headerStyle.classes
                    ].join(' ') : headerStyle.classes);
                    if (typeof column.fieldIndex !== 'undefined') {
                        _this.header.fields[column.fieldIndex] = column.field;
                        _this.header.styles[column.fieldIndex] = align + style;
                        _this.header.classes[column.fieldIndex] = column.class;
                        _this.header.formatters[column.fieldIndex] = column.formatter;
                        _this.header.detailFormatters[column.fieldIndex] = column.detailFormatter;
                        _this.header.events[column.fieldIndex] = column.events;
                        _this.header.sorters[column.fieldIndex] = column.sorter;
                        _this.header.sortNames[column.fieldIndex] = column.sortName;
                        _this.header.cellStyles[column.fieldIndex] = column.cellStyle;
                        _this.header.searchables[column.fieldIndex] = column.searchable;
                        if (!column.visible) return;
                        if (_this.options.cardView && !column.cardVisible) return;
                        visibleColumns[column.field] = column;
                    }
                    if (Object.keys(column._data || {}).length > 0) for(var _i2 = 0, _Object$entries2 = Object.entries(column._data); _i2 < _Object$entries2.length; _i2++){
                        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), k = _Object$entries2$_i[0], v = _Object$entries2$_i[1];
                        data_.push("data-".concat(k, "='").concat(_typeof(v) === 'object' ? JSON.stringify(v) : v, "'"));
                    }
                    html.push("<th".concat(Utils.sprintf(' title="%s"', column.titleTooltip)), column.checkbox || column.radio ? Utils.sprintf(' class="bs-checkbox %s"', column['class'] || '') : classes || class_, Utils.sprintf(' style="%s"', (column.style || '') + halign + style + csses.join('; ') || undefined), Utils.sprintf(' rowspan="%s"', column.rowspan), Utils.sprintf(' colspan="%s"', column.colspan), Utils.sprintf(' scope="%s"', column.scope), Utils.sprintf(' data-field="%s"', column.field), // If `column` is not the first element of `this.options.columns[0]`, then className 'data-not-first-th' should be added.
                    j === 0 && i > 0 ? ' data-not-first-th' : '', data_.length > 0 ? data_.join(' ') : '', '>');
                    html.push(Utils.sprintf('<div class="th-inner %s">', _this.options.sortable && column.sortable ? "sortable".concat(columnHalign === 'center' ? ' sortable-center' : '', " both") : ''));
                    var text = _this.options.escape && _this.options.escapeTitle ? Utils.escapeHTML(column.title) : column.title;
                    var title = text;
                    if (column.checkbox) {
                        text = '';
                        if (!_this.options.singleSelect && _this.options.checkboxHeader) text = Utils.getCheckboxHtml({
                            name: 'btSelectAll',
                            centered: true,
                            withLabel: false
                        });
                        _this.header.stateField = column.field;
                    }
                    if (column.radio) {
                        text = '';
                        _this.header.stateField = column.field;
                    }
                    if (!text && column.showSelectTitle) text += title;
                    html.push(text);
                    html.push('</div>');
                    html.push('<div class="fht-cell"></div>');
                    html.push('</div>');
                    html.push('</th>');
                });
                if (detailViewTemplate && _this.options.detailViewAlign === 'right') html.push(detailViewTemplate);
                html.push('</tr>');
                if (html.length > 3) headerHtml.push(html.join(''));
            });
            this.$header.html(headerHtml.join(''));
            this.$header.find('th[data-field]').each(function(i, el) {
                $(el).data(visibleColumns[$(el).data('field')]);
            });
            this.$container.off('click', '.th-inner').on('click', '.th-inner', function(e) {
                var $this = $(e.currentTarget);
                if (_this.options.detailView && !$this.parent().hasClass('bs-checkbox')) {
                    if ($this.closest('.bootstrap-table')[0] !== _this.$container[0]) return false;
                }
                if (_this.options.sortable && $this.parent().data().sortable) _this.onSort(e);
            });
            var resizeEvent = Utils.getEventName('resize.bootstrap-table', this.$el.attr('id'));
            $(window).off(resizeEvent);
            if (!this.options.showHeader || this.options.cardView) {
                this.$header.hide();
                this.$tableHeader.hide();
                this.$tableLoading.css('top', 0);
            } else {
                this.$header.show();
                this.$tableHeader.show();
                this.$tableLoading.css('top', this.$header.outerHeight() + 1);
                // Assign the correct sortable arrow
                this.resetCaret();
                $(window).on(resizeEvent, function() {
                    return _this.resetView();
                });
            }
            this.$selectAll = this.$header.find('[name="btSelectAll"]');
            this.$selectAll.off('click').on('click', function(e) {
                e.stopPropagation();
                var checked = $(e.currentTarget).prop('checked');
                _this[checked ? 'checkAll' : 'uncheckAll']();
                _this.updateSelected();
            });
        },
        getVisibleFields: function getVisibleFields() {
            var visibleFields = [];
            var _iterator = _createForOfIteratorHelper(this.header.fields), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var field = _step.value;
                    var column = this.columns[this.fieldsColumnsIndex[field]];
                    if (!column || !column.visible || this.options.cardView && !column.cardVisible) continue;
                    visibleFields.push(field);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            return visibleFields;
        },
        resetHeader: function resetHeader() {
            var _this2 = this;
            // Fix #61: the hidden table reset header bug.
            // Fix bug: get $el.css('width') error sometime (height = 500)
            this._setDelayTimeout('header', function() {
                return _this2.fitHeader();
            }, this.$el.is(':hidden') ? 100 : 0);
        },
        fitHeader: function fitHeader() {
            var _this3 = this;
            if (this.$el.is(':hidden')) {
                this._setDelayTimeout('header', function() {
                    return _this3.fitHeader();
                }, 100);
                return;
            }
            var fixedBody = this.$tableBody.get(0);
            var scrollWidth = this.hasScrollBar && fixedBody.scrollHeight > fixedBody.clientHeight + this.$header.outerHeight() ? Utils.getScrollBarWidth() : 0;
            this.$el.css('margin-top', -this.$header.outerHeight());
            var focused = this.$tableHeader.find(':focus');
            if (focused.length > 0) {
                var $th = focused.parents('th');
                if ($th.length > 0) {
                    var dataField = $th.attr('data-field');
                    if (dataField !== undefined) {
                        var $headerTh = this.$header.find("[data-field='".concat(dataField, "']"));
                        if ($headerTh.length > 0) $headerTh.find(':input').addClass('focus-temp');
                    }
                }
            }
            this.$header_ = this.$header.clone(true, true);
            this.$selectAll_ = this.$header_.find('[name="btSelectAll"]');
            var $caption = this.$el.find('caption');
            var $fixedHeaderTable = this.$tableHeader.css('margin-right', scrollWidth).find('table').css('width', this.$el.outerWidth()).html('').attr('class', this.$el.attr('class'));
            if ($caption.length > 0) $fixedHeaderTable.append($caption.clone(true, true));
            $fixedHeaderTable.append(this.$header_);
            this.$tableLoading.css('width', this.$el.outerWidth());
            var focusedTemp = $('.focus-temp:visible:eq(0)');
            if (focusedTemp.length > 0) {
                focusedTemp.focus();
                this.$header.find('.focus-temp').removeClass('focus-temp');
            }
            // fix bug: $.data() is not working as expected after $.append()
            this.$header.find('th[data-field]').each(function(i, el) {
                _this3.$header_.find(Utils.sprintf('th[data-field="%s"]', $(el).data('field'))).data($(el).data());
            });
            var visibleFields = this.getVisibleFields();
            var $ths = this.$header_.find('th');
            var $tr = this.$body.find('>tr:not(.no-records-found,.virtual-scroll-top)').eq(0);
            while($tr.length && $tr.find('>td[colspan]:not([colspan="1"])').length)$tr = $tr.next();
            var trLength = $tr.find('> *').length;
            $tr.find('> *').each(function(i, el) {
                var $this = $(el);
                if (Utils.hasDetailViewIcon(_this3.options)) {
                    if (i === 0 && _this3.options.detailViewAlign !== 'right' || i === trLength - 1 && _this3.options.detailViewAlign === 'right') {
                        var $thDetail = $ths.filter('.detail');
                        var _zoomWidth = $thDetail.innerWidth() - $thDetail.find('.fht-cell').width();
                        $thDetail.find('.fht-cell').width($this.innerWidth() - _zoomWidth);
                        return;
                    }
                }
                var index = i - Utils.getDetailViewIndexOffset(_this3.options);
                var $th = _this3.$header_.find(Utils.sprintf('th[data-field="%s"]', visibleFields[index]));
                if ($th.length > 1) $th = $($ths[$this[0].cellIndex]);
                var zoomWidth = $th.innerWidth() - $th.find('.fht-cell').width();
                $th.find('.fht-cell').width($this.innerWidth() - zoomWidth);
            });
            this.horizontalScroll();
            this.trigger('post-header');
        },
        resetCaret: function resetCaret() {
            var _this$options = this.options, sortName = _this$options.sortName, sortOrder = _this$options.sortOrder;
            var ariaSort = sortOrder === 'asc' ? 'ascending' : 'descending';
            this.$header.find('th').each(function(i, th) {
                var isActive = $(th).data('field') === sortName;
                $(th).attr('aria-sort', isActive ? ariaSort : null).find('.sortable').removeClass('desc asc').addClass(isActive ? sortOrder : 'both');
            });
        },
        initFooter: function initFooter() {
            if (!this.options.showFooter || this.options.cardView) // do nothing
            return;
            var data = this.getData();
            var html = [];
            var detailTemplate = '';
            if (Utils.hasDetailViewIcon(this.options)) detailTemplate = Utils.h('th', {
                class: 'detail'
            }, [
                Utils.h('div', {
                    class: 'th-inner'
                }),
                Utils.h('div', {
                    class: 'fht-cell'
                })
            ]);
            if (detailTemplate && this.options.detailViewAlign !== 'right') html.push(detailTemplate);
            var _iterator2 = _createForOfIteratorHelper(this.columns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var column = _step2.value;
                    var hasData = this.footerData && this.footerData.length > 0;
                    if (!column.visible || hasData && !(column.field in this.footerData[0])) continue;
                    if (this.options.cardView && !column.cardVisible) return;
                    var style = Utils.calculateObjectValue(null, column.footerStyle || this.options.footerStyle, [
                        column
                    ]);
                    var csses = style && style.css || {};
                    var colspan = hasData && this.footerData[0]["_".concat(column.field, "_colspan")] || 0;
                    var value = hasData && this.footerData[0][column.field] || '';
                    value = Utils.calculateObjectValue(column, column.footerFormatter, [
                        data,
                        value
                    ], value);
                    html.push(Utils.h('th', {
                        class: [
                            column['class'],
                            style && style.classes
                        ],
                        style: _objectSpread2({
                            'text-align': column.falign ? column.falign : column.align,
                            'vertical-align': column.valign
                        }, csses),
                        colspan: colspan || undefined
                    }, [
                        Utils.h('div', {
                            class: 'th-inner'
                        }, _toConsumableArray(Utils.htmlToNodes(value))),
                        Utils.h('div', {
                            class: 'fht-cell'
                        })
                    ]));
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (detailTemplate && this.options.detailViewAlign === 'right') html.push(detailTemplate);
            if (!this.options.height && !this.$tableFooter.length) {
                this.$el.append('<tfoot><tr></tr></tfoot>');
                this.$tableFooter = this.$el.find('tfoot');
            }
            if (!this.$tableFooter.find('tr').length) this.$tableFooter.html('<table><thead><tr></tr></thead></table>');
            this.$tableFooter.find('tr').html(html);
            this.trigger('post-footer', this.$tableFooter);
        },
        fitFooter: function fitFooter() {
            var _this4 = this;
            if (this.$el.is(':hidden')) {
                this._setDelayTimeout('footer', function() {
                    return _this4.fitFooter();
                }, 100);
                return;
            }
            var fixedBody = this.$tableBody.get(0);
            var scrollWidth = this.hasScrollBar && fixedBody.scrollHeight > fixedBody.clientHeight + this.$header.outerHeight() ? Utils.getScrollBarWidth() : 0;
            this.$tableFooter.css('margin-right', scrollWidth).find('table').css('width', this.$el.outerWidth()).attr('class', this.$el.attr('class'));
            var $ths = this.$tableFooter.find('th');
            var $tr = this.$body.find('>tr:first-child:not(.no-records-found)');
            $ths.find('.fht-cell').width('auto');
            while($tr.length && $tr.find('>td[colspan]:not([colspan="1"])').length)$tr = $tr.next();
            var trLength = $tr.find('> *').length;
            $tr.find('> *').each(function(i, el) {
                var $this = $(el);
                if (Utils.hasDetailViewIcon(_this4.options)) {
                    if (i === 0 && _this4.options.detailViewAlign === 'left' || i === trLength - 1 && _this4.options.detailViewAlign === 'right') {
                        var $thDetail = $ths.filter('.detail');
                        var _zoomWidth2 = $thDetail.innerWidth() - $thDetail.find('.fht-cell').width();
                        $thDetail.find('.fht-cell').width($this.innerWidth() - _zoomWidth2);
                        return;
                    }
                }
                var $th = $ths.eq(i);
                var zoomWidth = $th.innerWidth() - $th.find('.fht-cell').width();
                $th.find('.fht-cell').width($this.innerWidth() - zoomWidth);
            });
            this.horizontalScroll();
        },
        horizontalScroll: function horizontalScroll() {
            var _this5 = this;
            // horizontal scroll event
            // TODO: it's probably better improving the layout than binding to scroll event
            this.$tableBody.off('scroll').on('scroll', function() {
                var scrollLeft = _this5.$tableBody.scrollLeft();
                if (_this5.options.showHeader && _this5.options.height) _this5.$tableHeader.scrollLeft(scrollLeft);
                if (_this5.options.showFooter && !_this5.options.cardView) _this5.$tableFooter.scrollLeft(scrollLeft);
                _this5.trigger('scroll-body', _this5.$tableBody);
            });
        },
        updateColumnTitle: function updateColumnTitle(params) {
            if (!params.hasOwnProperty('field') || !params.hasOwnProperty('title')) return;
            this.columns[this.fieldsColumnsIndex[params.field]].title = this.options.escape && this.options.escapeTitle ? Utils.escapeHTML(params.title) : params.title;
            if (this.columns[this.fieldsColumnsIndex[params.field]].visible) {
                this.$header.find('th[data-field]').each(function(i, el) {
                    if ($(el).data('field') === params.field) {
                        $($(el).find('.th-inner')[0]).html(params.title);
                        return false;
                    }
                });
                this.resetView();
            }
        }
    };
    var PaginationModule = {
        initPagination: function initPagination() {
            var _this = this;
            var opts = this.options;
            if (!opts.pagination) {
                this.$pagination.hide();
                return;
            }
            this.$pagination.show();
            var html = [];
            var allSelected = false;
            var i;
            var from;
            var to;
            var $pageList;
            var $pre;
            var $next;
            var $number;
            var data = this.getData({
                includeHiddenRows: false
            });
            var pageList = opts.pageList;
            if (typeof pageList === 'string') pageList = pageList.replace(/\[|\]| /g, '').toLowerCase().split(',');
            pageList = pageList.map(function(value) {
                if (typeof value === 'string') return value.toLowerCase() === opts.formatAllRows().toLowerCase() || [
                    'all',
                    'unlimited'
                ].includes(value.toLowerCase()) ? opts.formatAllRows() : +value;
                return value;
            });
            this.paginationParts = opts.paginationParts;
            if (typeof this.paginationParts === 'string') this.paginationParts = this.paginationParts.replace(/\[|\]| |'/g, '').split(',');
            if (opts.sidePagination !== 'server') opts.totalRows = data.length;
            this.totalPages = 0;
            if (opts.pageSize <= 0) {
                console.warn('pageSize must be a positive number, falling back to show all rows.');
                opts.pageSize = opts.totalRows || 1;
                allSelected = true;
            }
            if (opts.totalRows) {
                if (opts.pageSize === opts.formatAllRows()) {
                    opts.pageSize = opts.totalRows;
                    allSelected = true;
                }
                this.totalPages = ~~((opts.totalRows - 1) / opts.pageSize) + 1;
                opts.totalPages = this.totalPages;
            }
            if (this.totalPages > 0 && opts.pageNumber > this.totalPages) opts.pageNumber = this.totalPages;
            this.pageFrom = (opts.pageNumber - 1) * opts.pageSize + 1;
            this.pageTo = opts.pageNumber * opts.pageSize;
            if (this.pageTo > opts.totalRows) this.pageTo = opts.totalRows;
            if (this.options.pagination && this.options.sidePagination !== 'server') this.options.totalNotFiltered = this.options.data.length;
            if (!this.options.showExtendedPagination) this.options.totalNotFiltered = undefined;
            if (this.paginationParts.includes('pageInfo') || this.paginationParts.includes('pageInfoShort') || this.paginationParts.includes('pageSize')) html.push("<div class=\"".concat(this.constants.classes.pull, "-").concat(opts.paginationDetailHAlign, " pagination-detail\">"));
            if (this.paginationParts.includes('pageInfo') || this.paginationParts.includes('pageInfoShort')) {
                var totalRows = this.options.totalRows;
                if (this.options.sidePagination === 'client' && this.options.paginationLoadMore && !this._paginationLoaded && this.totalPages > 1) totalRows += ' +';
                var paginationInfo = this.paginationParts.includes('pageInfoShort') ? opts.formatDetailPagination(totalRows) : opts.formatShowingRows(this.pageFrom, this.pageTo, totalRows, opts.totalNotFiltered);
                html.push("<span class=\"pagination-info\">\n      ".concat(paginationInfo, "\n      </span>"));
            }
            if (this.paginationParts.includes('pageSize')) {
                html.push('<div class="page-list">');
                var pageNumber = [
                    "<div class=\"".concat(this.constants.classes.paginationDropdown, "\">\n        <button class=\"").concat(this.constants.buttonsClass, " dropdown-toggle\" type=\"button\" ").concat(this.constants.dataToggle, "=\"dropdown\">\n        <span class=\"page-size\">\n        ").concat(allSelected ? opts.formatAllRows() : opts.pageSize, "\n        </span>\n        ").concat(this.constants.html.dropdownCaret, "\n        </button>\n        ").concat(this.constants.html.pageDropdown[0])
                ];
                pageList.forEach(function(page, i) {
                    if (!opts.smartDisplay || i === 0 || pageList[i - 1] < opts.totalRows || page === opts.formatAllRows()) {
                        var active;
                        if (allSelected) active = page === opts.formatAllRows() ? _this.constants.classes.dropdownActive : '';
                        else active = page === opts.pageSize ? _this.constants.classes.dropdownActive : '';
                        pageNumber.push(Utils.sprintf(_this.constants.html.pageDropdownItem, active, page));
                    }
                });
                pageNumber.push("".concat(this.constants.html.pageDropdown[1], "</div>"));
                html.push(opts.formatRecordsPerPage(pageNumber.join('')));
            }
            if (this.paginationParts.includes('pageInfo') || this.paginationParts.includes('pageInfoShort') || this.paginationParts.includes('pageSize')) html.push('</div></div>');
            if (this.paginationParts.includes('pageList')) {
                html.push("<div class=\"".concat(this.constants.classes.pull, "-").concat(opts.paginationHAlign, " pagination\">"), Utils.sprintf(this.constants.html.pagination[0], Utils.sprintf(' pagination-%s', opts.iconSize)), Utils.sprintf(this.constants.html.paginationItem, ' page-pre', opts.formatSRPaginationPreText(), opts.paginationPreText));
                if (this.totalPages < opts.paginationSuccessivelySize) {
                    from = 1;
                    to = this.totalPages;
                } else {
                    from = opts.pageNumber - opts.paginationPagesBySide;
                    to = from + opts.paginationPagesBySide * 2;
                }
                if (opts.pageNumber < opts.paginationSuccessivelySize - 1) to = opts.paginationSuccessivelySize;
                if (opts.paginationSuccessivelySize > this.totalPages - from) from = from - (opts.paginationSuccessivelySize - (this.totalPages - from)) + 1;
                if (from < 1) from = 1;
                if (to > this.totalPages) to = this.totalPages;
                var middleSize = Math.round(opts.paginationPagesBySide / 2);
                var pageItem = function pageItem(i) {
                    var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                    return Utils.sprintf(_this.constants.html.paginationItem, classes + (i === opts.pageNumber ? " ".concat(_this.constants.classes.paginationActive) : ''), opts.formatSRPaginationPageText(i), i);
                };
                if (from > 1) {
                    var max = opts.paginationPagesBySide;
                    if (max >= from) max = from - 1;
                    for(i = 1; i <= max; i++)html.push(pageItem(i));
                    if (from - 1 === max + 1) {
                        i = from - 1;
                        html.push(pageItem(i));
                    } else if (from - 1 > max) {
                        if (from - opts.paginationPagesBySide * 2 > opts.paginationPagesBySide && opts.paginationUseIntermediate) {
                            i = Math.round((from - middleSize) / 2 + middleSize);
                            html.push(pageItem(i, ' page-intermediate'));
                        } else html.push(Utils.sprintf(this.constants.html.paginationItem, ' page-first-separator disabled', '', '...'));
                    }
                }
                for(i = from; i <= to; i++)html.push(pageItem(i));
                if (this.totalPages > to) {
                    var min = this.totalPages - (opts.paginationPagesBySide - 1);
                    if (to >= min) min = to + 1;
                    if (to + 1 === min - 1) {
                        i = to + 1;
                        html.push(pageItem(i));
                    } else if (min > to + 1) {
                        if (this.totalPages - to > opts.paginationPagesBySide * 2 && opts.paginationUseIntermediate) {
                            i = Math.round((this.totalPages - middleSize - to) / 2 + to);
                            html.push(pageItem(i, ' page-intermediate'));
                        } else html.push(Utils.sprintf(this.constants.html.paginationItem, ' page-last-separator disabled', '', '...'));
                    }
                    for(i = min; i <= this.totalPages; i++)html.push(pageItem(i));
                }
                html.push(Utils.sprintf(this.constants.html.paginationItem, ' page-next', opts.formatSRPaginationNextText(), opts.paginationNextText));
                html.push(this.constants.html.pagination[1], '</div>');
            }
            this.$pagination.html(html.join(''));
            var dropupClass = [
                'bottom',
                'both'
            ].includes(opts.paginationVAlign) ? " ".concat(this.constants.classes.dropup) : '';
            this.$pagination.last().find('.page-list > div').addClass(dropupClass);
            if (!opts.onlyInfoPagination) {
                $pageList = this.$pagination.find('.page-list a');
                $pre = this.$pagination.find('.page-pre');
                $next = this.$pagination.find('.page-next');
                $number = this.$pagination.find('.page-item').not('.page-next, .page-pre, .page-last-separator, .page-first-separator');
                if (this.totalPages <= 1) this.$pagination.find('div.pagination').hide();
                if (opts.smartDisplay) {
                    if (pageList.length < 2 || opts.totalRows <= pageList[0]) this.$pagination.find('div.page-list').hide();
                }
                // when data is empty, hide the pagination
                this.$pagination[this.getData().length ? 'show' : 'hide']();
                if (!opts.paginationLoop) {
                    if (opts.pageNumber === 1) $pre.addClass('disabled');
                    if (opts.pageNumber === this.totalPages) $next.addClass('disabled');
                }
                if (allSelected) opts.pageSize = opts.formatAllRows();
                $pageList.off('click').on('click', function(e) {
                    return _this.onPageListChange(e);
                });
                $pre.off('click').on('click', function(e) {
                    return _this.onPagePre(e);
                });
                $next.off('click').on('click', function(e) {
                    return _this.onPageNext(e);
                });
                $number.off('click').on('click', function(e) {
                    return _this.onPageNumber(e);
                });
            }
        },
        updatePagination: function updatePagination(event) {
            // Fix #171: IE disabled button can be clicked bug.
            if (event && $(event.currentTarget).hasClass('disabled')) return;
            if (!this.options.maintainMetaData) this.resetRows();
            this.initPagination();
            this.trigger('page-change', this.options.pageNumber, this.options.pageSize);
            if (this.options.sidePagination === 'server' || this.options.sidePagination === 'client' && this.options.paginationLoadMore && !this._paginationLoaded && this.options.pageNumber === this.totalPages) this.initServer();
            else this.initBody();
        },
        onPageListChange: function onPageListChange(event) {
            event.preventDefault();
            var $this = $(event.currentTarget);
            $this.parent().addClass(this.constants.classes.dropdownActive).siblings().removeClass(this.constants.classes.dropdownActive);
            this.options.pageSize = $this.text().toUpperCase() === this.options.formatAllRows().toUpperCase() ? this.options.formatAllRows() : +$this.text();
            this.$toolbar.find('.page-size').text(this.options.pageSize);
            this.updatePagination(event);
            return false;
        },
        onPagePre: function onPagePre(event) {
            if ($(event.target).hasClass('disabled')) return;
            event.preventDefault();
            if (this.options.pageNumber - 1 === 0) this.options.pageNumber = this.options.totalPages;
            else this.options.pageNumber--;
            this.updatePagination(event);
            return false;
        },
        onPageNext: function onPageNext(event) {
            if ($(event.target).hasClass('disabled')) return;
            event.preventDefault();
            if (this.options.pageNumber + 1 > this.options.totalPages) this.options.pageNumber = 1;
            else this.options.pageNumber++;
            this.updatePagination(event);
            return false;
        },
        onPageNumber: function onPageNumber(event) {
            event.preventDefault();
            if (this.options.pageNumber === +$(event.currentTarget).text()) return;
            this.options.pageNumber = +$(event.currentTarget).text();
            this.updatePagination(event);
            return false;
        },
        selectPage: function selectPage(page) {
            if (page > 0 && page <= this.options.totalPages) {
                this.options.pageNumber = page;
                this.updatePagination();
            }
        },
        prevPage: function prevPage() {
            if (this.options.pageNumber > 1) {
                this.options.pageNumber--;
                this.updatePagination();
            }
        },
        nextPage: function nextPage() {
            if (this.options.pageNumber < this.options.totalPages) {
                this.options.pageNumber++;
                this.updatePagination();
            }
        },
        togglePagination: function togglePagination() {
            this.options.pagination = !this.options.pagination;
            var icon = this.options.showButtonIcons ? this.options.pagination ? this.options.icons.paginationSwitchDown : this.options.icons.paginationSwitchUp : '';
            var text = this.options.showButtonText ? this.options.pagination ? this.options.formatPaginationSwitchUp() : this.options.formatPaginationSwitchDown() : '';
            this.$toolbar.find('button[name="paginationSwitch"]').html("".concat(Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, icon), " ").concat(text));
            this.updatePagination();
            this.trigger('toggle-pagination', this.options.pagination);
        }
    };
    var SearchModule = {
        initSearchText: function initSearchText() {
            if (this.options.search) {
                this.searchText = '';
                if (this.options.searchText !== '') {
                    var search = Utils.getSearchInput(this);
                    $(search).val(this.options.searchText);
                    this.onSearch({
                        currentTarget: search,
                        firedByInitSearchText: true
                    });
                }
            }
        },
        initSearch: function initSearch() {
            var _this = this;
            this.filterOptions = this.filterOptions || this.options.filterOptions;
            if (this.options.sidePagination !== 'server') {
                if (this.options.customSearch) {
                    this.data = Utils.calculateObjectValue(this.options, this.options.customSearch, [
                        this.options.data,
                        this.searchText,
                        this.filterColumns
                    ]);
                    if (this.options.sortReset) this.unsortedData = _toConsumableArray(this.data);
                    this.initSort();
                    return;
                }
                var rawSearchText = this.searchText && (this.fromHtml ? Utils.escapeHTML(this.searchText) : this.searchText);
                var searchText = rawSearchText ? rawSearchText.toLowerCase() : '';
                var f = Utils.isEmptyObject(this.filterColumns) ? null : this.filterColumns;
                if (this.options.searchAccentNeutralise) searchText = Utils.normalizeAccent(searchText);
                // Check filter
                if (typeof this.filterOptions.filterAlgorithm === 'function') this.data = this.options.data.filter(function(item) {
                    return _this.filterOptions.filterAlgorithm.apply(null, [
                        item,
                        f
                    ]);
                });
                else if (typeof this.filterOptions.filterAlgorithm === 'string') this.data = f ? this.options.data.filter(function(item) {
                    var filterAlgorithm = _this.filterOptions.filterAlgorithm;
                    if (![
                        'and',
                        'or'
                    ].includes(filterAlgorithm)) return true;
                    for(var key in f){
                        if (!Object.prototype.hasOwnProperty.call(f, key)) continue;
                        var value = Utils.getItemField(item, key, false);
                        var isArray = Array.isArray(f[key]);
                        var match = !isArray && f[key] === value || isArray && f[key].includes(value);
                        if (match && filterAlgorithm === 'or') return true;
                        if (!match && filterAlgorithm === 'and') return false;
                    }
                    return filterAlgorithm === 'and';
                }) : _toConsumableArray(this.options.data);
                var visibleFields = this.getVisibleFields();
                this.data = searchText ? this.data.filter(function(item, i) {
                    for(var j = 0; j < _this.header.fields.length; j++){
                        if (!_this.header.searchables[j] || _this.options.visibleSearch && visibleFields.indexOf(_this.header.fields[j]) === -1) continue;
                        var key = Utils.isNumeric(_this.header.fields[j]) ? parseInt(_this.header.fields[j], 10) : _this.header.fields[j];
                        var column = _this.columns[_this.fieldsColumnsIndex[key]];
                        var value = Utils.getItemField(item, key, false);
                        if (_this.options.searchAccentNeutralise) value = Utils.normalizeAccent(value);
                        // Fix #142: respect searchFormatter boolean
                        if (column && column.searchFormatter) {
                            value = Utils.calculateObjectValue(column, _this.header.formatters[j], [
                                value,
                                item,
                                i,
                                column.field
                            ], value);
                            if (_this.header.formatters[j] && typeof value !== 'number') // search innerText
                            value = $('<div>').html(value).text();
                        }
                        if (typeof value === 'string' || typeof value === 'number') {
                            if (_this.options.strictSearch) {
                                if ("".concat(value).toLowerCase() === searchText) return true;
                            } else if (_this.options.regexSearch) {
                                if (Utils.regexCompare(value, rawSearchText)) return true;
                            } else {
                                var largerSmallerEqualsRegex = /(?:(<=|=>|=<|>=|>|<)(?:\s+)?(-?\d+)?|(-?\d+)?(\s+)?(<=|=>|=<|>=|>|<))/gm;
                                var matches = largerSmallerEqualsRegex.exec(_this.searchText);
                                var comparisonCheck = false;
                                if (matches) {
                                    var operator = matches[1] || "".concat(matches[5], "l");
                                    var comparisonValue = matches[2] || matches[3];
                                    var int = parseInt(value, 10);
                                    var comparisonInt = parseInt(comparisonValue, 10);
                                    switch(operator){
                                        case '>':
                                        case '<l':
                                            comparisonCheck = int > comparisonInt;
                                            break;
                                        case '<':
                                        case '>l':
                                            comparisonCheck = int < comparisonInt;
                                            break;
                                        case '<=':
                                        case '=<':
                                        case '>=l':
                                        case '=>l':
                                            comparisonCheck = int <= comparisonInt;
                                            break;
                                        case '>=':
                                        case '=>':
                                        case '<=l':
                                        case '=<l':
                                            comparisonCheck = int >= comparisonInt;
                                            break;
                                    }
                                }
                                if (comparisonCheck || "".concat(value).toLowerCase().includes(searchText)) return true;
                            }
                        }
                    }
                    return false;
                }) : this.data;
                if (this.options.sortReset) this.unsortedData = _toConsumableArray(this.data);
                this.initSort();
            }
        },
        onSearch: function onSearch() {
            var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, currentTarget = _ref.currentTarget, firedByInitSearchText = _ref.firedByInitSearchText;
            var overwriteSearchText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (currentTarget !== undefined && $(currentTarget).length && overwriteSearchText) {
                var text = $(currentTarget).val().trim();
                if (this.options.trimOnSearch && $(currentTarget).val() !== text) $(currentTarget).val(text);
                if (this.searchText === text) return;
                var searchInput = Utils.getSearchInput(this);
                var $searchInput = $(searchInput);
                var $currentTarget = currentTarget instanceof jQuery ? currentTarget : $(currentTarget);
                if ($currentTarget.is($searchInput) || $currentTarget.hasClass('search-input')) {
                    this.searchText = text;
                    this.options.searchText = text;
                }
            }
            if (!firedByInitSearchText) this.options.pageNumber = 1;
            this.initSearch();
            if (firedByInitSearchText) {
                if (this.options.sidePagination === 'client') this.updatePagination();
            } else this.updatePagination();
            this.trigger('search', this.searchText);
        },
        resetSearch: function resetSearch(text) {
            var search = Utils.getSearchInput(this);
            var textToUse = text || '';
            $(search).val(textToUse);
            this.searchText = textToUse;
            this.options.searchText = textToUse;
            this.onSearch({
                currentTarget: search
            }, false);
        },
        filterBy: function filterBy(columns, options) {
            this.filterOptions = Utils.isEmptyObject(options) ? this.options.filterOptions : Utils.extend({}, this.options.filterOptions, options);
            this.filterColumns = Utils.isEmptyObject(columns) ? {} : columns;
            this.options.pageNumber = 1;
            this.initSearch();
            this.updatePagination();
        }
    };
    var ToolbarModule = {
        renderButton: function renderButton(buttonName, buttonConfig) {
            var opts = this.options;
            var buttonHtml;
            if (buttonConfig.hasOwnProperty('html')) {
                if (typeof buttonConfig.html === 'function') buttonHtml = buttonConfig.html();
                else buttonHtml = buttonConfig.html;
            } else {
                var buttonClass = this.constants.buttonsClass;
                if (buttonConfig.hasOwnProperty('attributes') && buttonConfig.attributes.class) buttonClass += " ".concat(buttonConfig.attributes.class);
                buttonHtml = "<button class=\"".concat(buttonClass, "\" type=\"button\" name=\"").concat(buttonName, "\"");
                if (buttonConfig.hasOwnProperty('attributes')) for(var _i = 0, _Object$entries = Object.entries(buttonConfig.attributes); _i < _Object$entries.length; _i++){
                    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), attributeName = _Object$entries$_i[0], value = _Object$entries$_i[1];
                    if (attributeName === 'class') continue;
                    var attribute = attributeName === 'title' ? opts.buttonsAttributeTitle : attributeName;
                    buttonHtml += " ".concat(attribute, "=\"").concat(value, "\"");
                }
                buttonHtml += '>';
                if (opts.showButtonIcons && buttonConfig.hasOwnProperty('icon')) buttonHtml += "".concat(Utils.sprintf(this.constants.html.icon, opts.iconsPrefix, buttonConfig.icon), " ");
                if (opts.showButtonText && buttonConfig.hasOwnProperty('text')) buttonHtml += buttonConfig.text;
                buttonHtml += '</button>';
            }
            return buttonHtml;
        },
        initToolbar: function initToolbar() {
            var _this = this;
            var opts = this.options;
            var html;
            var timeoutId;
            var $keepOpen;
            var switchableCount = 0;
            if (this.$toolbar.find('.bs-bars').children().length) $('body').append($(opts.toolbar));
            this.$toolbar.html('');
            if (typeof opts.toolbar === 'string' || _typeof(opts.toolbar) === 'object') $(Utils.sprintf('<div class="bs-bars %s-%s"></div>', this.constants.classes.pull, opts.toolbarAlign)).appendTo(this.$toolbar).append($(opts.toolbar));
            // showColumns, showToggle, showRefresh
            html = [
                "<div class=\"".concat([
                    'columns',
                    "columns-".concat(opts.buttonsAlign),
                    this.constants.classes.buttonsGroup,
                    "".concat(this.constants.classes.pull, "-").concat(opts.buttonsAlign)
                ].join(' '), "\">")
            ];
            if (typeof opts.buttonsOrder === 'string') opts.buttonsOrder = opts.buttonsOrder.replace(/\[|\]| |'/g, '').split(',');
            this.buttons = Object.assign(this.buttons, {
                paginationSwitch: {
                    text: opts.pagination ? opts.formatPaginationSwitchUp() : opts.formatPaginationSwitchDown(),
                    icon: opts.pagination ? opts.icons.paginationSwitchDown : opts.icons.paginationSwitchUp,
                    render: false,
                    event: this.togglePagination,
                    attributes: {
                        'aria-label': opts.formatPaginationSwitch(),
                        title: opts.formatPaginationSwitch()
                    }
                },
                refresh: {
                    text: opts.formatRefresh(),
                    icon: opts.icons.refresh,
                    render: false,
                    event: this.refresh,
                    attributes: {
                        'aria-label': opts.formatRefresh(),
                        title: opts.formatRefresh()
                    }
                },
                toggle: {
                    text: opts.formatToggleOn(),
                    icon: opts.icons.toggleOff,
                    render: false,
                    event: this.toggleView,
                    attributes: {
                        'aria-label': opts.formatToggleOn(),
                        title: opts.formatToggleOn()
                    }
                },
                fullscreen: {
                    text: opts.formatFullscreen(),
                    icon: opts.icons.fullscreen,
                    render: false,
                    event: this.toggleFullscreen,
                    attributes: {
                        'aria-label': opts.formatFullscreen(),
                        title: opts.formatFullscreen()
                    }
                },
                columns: {
                    render: false,
                    html: function html() {
                        var html = [];
                        html.push("<div class=\"keep-open ".concat(_this.constants.classes.buttonsDropdown, "\">\n            <button class=\"").concat(_this.constants.buttonsClass, " dropdown-toggle\" type=\"button\" ").concat(_this.constants.dataToggle, "=\"dropdown\"\n            aria-label=\"").concat(opts.formatColumns(), "\" ").concat(opts.buttonsAttributeTitle, "=\"").concat(opts.formatColumns(), "\">\n            ").concat(opts.showButtonIcons ? Utils.sprintf(_this.constants.html.icon, opts.iconsPrefix, opts.icons.columns) : '', "\n            ").concat(opts.showButtonText ? opts.formatColumns() : '', "\n            ").concat(_this.constants.html.dropdownCaret, "\n            </button>\n            ").concat(_this.constants.html.toolbarDropdown[0]));
                        if (opts.showColumnsSearch) {
                            html.push(Utils.sprintf(_this.constants.html.toolbarDropdownItem, Utils.sprintf('<input type="text" class="%s" name="columnsSearch" placeholder="%s" autocomplete="off">', _this.constants.classes.input, opts.formatSearch())));
                            html.push(_this.constants.html.toolbarDropdownSeparator);
                        }
                        if (opts.showColumnsToggleAll) {
                            var allFieldsVisible = _this.getVisibleColumns().length === _this.columns.filter(function(column) {
                                return !_this.isSelectionColumn(column);
                            }).length;
                            html.push(Utils.getCheckboxHtml({
                                name: 'toggle-all',
                                checked: allFieldsVisible,
                                label: opts.formatColumnsToggleAll(),
                                extraClass: 'toggle-all',
                                centered: false,
                                withLabel: true
                            }));
                            html.push(_this.constants.html.toolbarDropdownSeparator);
                        }
                        var visibleColumns = 0;
                        _this.columns.forEach(function(column) {
                            if (column.visible) visibleColumns++;
                        });
                        _this.columns.forEach(function(column, i) {
                            if (_this.isSelectionColumn(column)) return;
                            if (opts.cardView && !column.cardVisible) return;
                            var checked = column.visible ? ' checked="checked"' : '';
                            var disabled = visibleColumns <= opts.minimumCountColumns && checked ? ' disabled="disabled"' : '';
                            if (column.switchable) {
                                var checkboxHtml = Utils.getDropdownColumnCheckboxHtml({
                                    dataField: column.field,
                                    value: i,
                                    checked: !!checked,
                                    disabled: !!disabled,
                                    label: column.switchableLabel || column.title
                                });
                                // Bootstrap 3/4 needs to be wrapped with toolbarDropdownItem
                                if (Utils.getBootstrapVersion() === 5) html.push(checkboxHtml);
                                else html.push(Utils.sprintf(_this.constants.html.toolbarDropdownItem, checkboxHtml));
                                switchableCount++;
                            }
                        });
                        html.push(_this.constants.html.toolbarDropdown[1], '</div>');
                        return html.join('');
                    }
                }
            });
            var buttonsHtml = {};
            for(var _i2 = 0, _Object$entries2 = Object.entries(this.buttons); _i2 < _Object$entries2.length; _i2++){
                var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), buttonName = _Object$entries2$_i[0], buttonConfig = _Object$entries2$_i[1];
                buttonsHtml[buttonName] = this.renderButton(buttonName, buttonConfig);
                var optionName = "show".concat(buttonName.charAt(0).toUpperCase()).concat(buttonName.substring(1));
                var showOption = opts[optionName];
                if ((!buttonConfig.hasOwnProperty('render') || buttonConfig.hasOwnProperty('render') && buttonConfig.render) && (showOption === undefined || showOption === true)) opts[optionName] = true;
                if (!opts.buttonsOrder.includes(buttonName)) opts.buttonsOrder.push(buttonName);
            }
            // Adding the button html to the final toolbar html when the showOption is true
            var _iterator = _createForOfIteratorHelper(opts.buttonsOrder), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var button = _step.value;
                    var _showOption = opts["show".concat(button.charAt(0).toUpperCase()).concat(button.substring(1))];
                    if (_showOption) html.push(buttonsHtml[button]);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            html.push('</div>');
            // Fix #188: this.showToolbar is for extensions
            if (this.showToolbar || html.length > 2) {
                if (html.some(function(item) {
                    return Utils.isDomNode(item);
                })) {
                    // When there are DOM nodes, build the structure manually
                    // Build wrapper element once from the opening div string
                    var wrapper = $(html[0]);
                    // Skip html[0] (opening div) and html[html.length-1] (closing div)
                    // Append each button item into the wrapper
                    var _iterator2 = _createForOfIteratorHelper(html.slice(1, -1)), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var item = _step2.value;
                            wrapper.append.apply(wrapper, _toConsumableArray(Utils.htmlToNodes(item)));
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    this.$toolbar.append(wrapper);
                } else this.$toolbar.append(html.join(''));
            }
            var _loop = function _loop() {
                var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2), buttonName = _Object$entries3$_i[0], buttonConfig = _Object$entries3$_i[1];
                if (buttonConfig.hasOwnProperty('event')) {
                    if (typeof buttonConfig.event === 'function' || typeof buttonConfig.event === 'string') {
                        var event = typeof buttonConfig.event === 'string' ? window[buttonConfig.event] : buttonConfig.event;
                        _this.$toolbar.find("button[name=\"".concat(buttonName, "\"]")).off('click').on('click', function() {
                            return event.call(_this);
                        });
                        return 1; // continue
                    }
                    var _loop2 = function _loop2() {
                        var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i4], 2), eventType = _Object$entries4$_i[0], eventFunction = _Object$entries4$_i[1];
                        var event = typeof eventFunction === 'string' ? window[eventFunction] : eventFunction;
                        _this.$toolbar.find("button[name=\"".concat(buttonName, "\"]")).off(eventType).on(eventType, function() {
                            return event.call(_this);
                        });
                    };
                    for(var _i4 = 0, _Object$entries4 = Object.entries(buttonConfig.event); _i4 < _Object$entries4.length; _i4++)_loop2();
                }
            };
            for(var _i3 = 0, _Object$entries3 = Object.entries(this.buttons); _i3 < _Object$entries3.length; _i3++){
                if (_loop()) continue;
            }
            if (opts.showColumns) {
                $keepOpen = this.$toolbar.find('.keep-open');
                var $checkboxes = $keepOpen.find('input[type="checkbox"]:not(".toggle-all")');
                var $toggleAll = $keepOpen.find('input[type="checkbox"].toggle-all');
                if (switchableCount <= opts.minimumCountColumns) $keepOpen.find('input').prop('disabled', true);
                $keepOpen.find('li, label').off('click').on('click', function(e) {
                    e.stopImmediatePropagation();
                });
                $checkboxes.off('click').on('click', function(_ref) {
                    var currentTarget = _ref.currentTarget;
                    var $this = $(currentTarget);
                    _this._toggleColumns([
                        $this.data('field')
                    ], $this.prop('checked'), false);
                    _this.trigger('column-switch', $this.data('field'), $this.prop('checked'));
                    $toggleAll.prop('checked', $checkboxes.filter(':checked').length === _this.columns.filter(function(column) {
                        return !_this.isSelectionColumn(column);
                    }).length);
                });
                $toggleAll.off('click').on('click', function(_ref2) {
                    var currentTarget = _ref2.currentTarget;
                    _this._toggleAllColumns($(currentTarget).prop('checked'));
                    _this.trigger('column-switch-all', $(currentTarget).prop('checked'));
                });
                if (opts.showColumnsSearch) {
                    var $columnsSearch = $keepOpen.find('[name="columnsSearch"]');
                    var $listItems = $keepOpen.find('.dropdown-item-marker');
                    $columnsSearch.on('keyup paste change', function(_ref3) {
                        var currentTarget = _ref3.currentTarget;
                        var $this = $(currentTarget);
                        var searchValue = $this.val().toLowerCase();
                        $listItems.show();
                        $checkboxes.each(function(i, el) {
                            var $checkbox = $(el);
                            var $listItem = $checkbox.parents('.dropdown-item-marker');
                            var text = $listItem.text().toLowerCase();
                            if (!text.includes(searchValue)) $listItem.hide();
                        });
                    });
                }
            }
            var handleInputEvent = function handleInputEvent($searchInput) {
                var eventTriggers = $searchInput.is('select') ? 'change' : 'keyup drop blur mouseup';
                $searchInput.off(eventTriggers).on(eventTriggers, function(event) {
                    if (opts.searchOnEnterKey && event.keyCode !== 13) return;
                    if ([
                        37,
                        38,
                        39,
                        40
                    ].includes(event.keyCode)) return;
                    clearTimeout(timeoutId); // doesn't matter if it's 0
                    timeoutId = setTimeout(function() {
                        _this.onSearch({
                            currentTarget: event.currentTarget
                        });
                    }, opts.searchTimeOut);
                });
            };
            // Fix #4516: this.showSearchClearButton is for extensions
            if ((opts.search || this.showSearchClearButton) && typeof opts.searchSelector !== 'string') {
                html = [];
                var showSearchButton = Utils.sprintf(this.constants.html.searchButton, this.constants.buttonsClass, opts.formatSearch(), opts.showButtonIcons ? Utils.sprintf(this.constants.html.icon, opts.iconsPrefix, opts.icons.search) : '', opts.showButtonText ? opts.formatSearch() : '');
                var showSearchClearButton = Utils.sprintf(this.constants.html.searchClearButton, this.constants.buttonsClass, opts.formatClearSearch(), opts.showButtonIcons ? Utils.sprintf(this.constants.html.icon, opts.iconsPrefix, opts.icons.clearSearch) : '', opts.showButtonText ? opts.formatClearSearch() : '');
                var searchInputHtml = "<input class=\"".concat(this.constants.classes.input, "\n        ").concat(Utils.sprintf(' %s%s', this.constants.classes.inputPrefix, opts.iconSize), "\n        search-input\" type=\"search\" aria-label=\"").concat(opts.formatSearch(), "\" placeholder=\"").concat(opts.formatSearch(), "\" autocomplete=\"off\">");
                var searchInputFinalHtml = searchInputHtml;
                if (opts.showSearchButton || opts.showSearchClearButton) {
                    var _buttonsHtml = (opts.showSearchButton ? showSearchButton : '') + (opts.showSearchClearButton ? showSearchClearButton : '');
                    searchInputFinalHtml = opts.search ? Utils.sprintf(this.constants.html.inputGroup, searchInputHtml, _buttonsHtml) : _buttonsHtml;
                }
                html.push(Utils.sprintf("\n        <div class=\"".concat(this.constants.classes.pull, "-").concat(opts.searchAlign, " search ").concat(this.constants.classes.inputGroup, "\">\n          %s\n        </div>\n      "), searchInputFinalHtml));
                this.$toolbar.append(html.join(''));
                var searchInput = Utils.getSearchInput(this);
                var $searchInput = $(searchInput);
                if (opts.showSearchButton) {
                    this.$toolbar.find('.search button[name=search]').off('click').on('click', function() {
                        clearTimeout(timeoutId); // doesn't matter if it's 0
                        timeoutId = setTimeout(function() {
                            _this.onSearch({
                                currentTarget: searchInput
                            });
                        }, opts.searchTimeOut);
                    });
                    if (opts.searchOnEnterKey) handleInputEvent($searchInput);
                } else handleInputEvent($searchInput);
                if (opts.showSearchClearButton) this.$toolbar.find('.search button[name=clearSearch]').click(function() {
                    _this.resetSearch();
                });
            } else if (typeof opts.searchSelector === 'string') handleInputEvent($(Utils.getSearchInput(this)));
        },
        refresh: function refresh(params) {
            if (params && params.url) this.options.url = params.url;
            if (params && params.pageNumber) this.options.pageNumber = params.pageNumber;
            if (params && params.pageSize) this.options.pageSize = params.pageSize;
            if (params && params.query) this.options.url = Utils.addQueryToUrl(this.options.url, params.query);
            this.trigger('refresh', this.initServer(params && params.silent));
        },
        toggleView: function toggleView() {
            this.options.cardView = !this.options.cardView;
            this.initHeader();
            var icon = this.options.showButtonIcons ? this.options.cardView ? this.options.icons.toggleOn : this.options.icons.toggleOff : '';
            var text = this.options.cardView ? this.options.formatToggleOff() : this.options.formatToggleOn();
            this.$toolbar.find('button[name="toggle"]').html("".concat(Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, icon), " ").concat(this.options.showButtonText ? text : '')).attr('aria-label', text).attr(this.options.buttonsAttributeTitle, text);
            this.initBody();
            this.trigger('toggle', this.options.cardView);
        },
        toggleFullscreen: function toggleFullscreen() {
            this.$el.closest('.bootstrap-table').toggleClass('fullscreen');
            this.resetView();
        }
    };
    var BootstrapTable = /*#__PURE__*/ function() {
        function BootstrapTable(el, options) {
            _classCallCheck(this, BootstrapTable);
            this.options = options;
            this.$el = $(el);
            this.$el_ = this.$el.clone();
            this._timeoutId = {
                header: 0,
                footer: 0
            };
        }
        return _createClass(BootstrapTable, [
            {
                key: "init",
                value: function init() {
                    this.initConstants();
                    this.initLocale();
                    this.initContainer();
                    this.initTable();
                    this.initHeader();
                    this.initData();
                    this.initHiddenRows();
                    this.initToolbar();
                    this.initPagination();
                    this.initBody();
                    this.initSearchText();
                    this.initServer();
                }
            },
            {
                key: "trigger",
                value: function trigger(_name) {
                    var _this$options, _this$options2;
                    var name = "".concat(_name, ".bs.table");
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                    (_this$options = this.options)[BootstrapTable.EVENTS[name]].apply(_this$options, [].concat(args, [
                        this
                    ]));
                    this.$el.trigger($.Event(name, {
                        sender: this
                    }), args);
                    (_this$options2 = this.options).onAll.apply(_this$options2, [
                        name
                    ].concat([].concat(args, [
                        this
                    ])));
                    this.$el.trigger($.Event('all.bs.table', {
                        sender: this
                    }), [
                        name,
                        args
                    ]);
                }
            },
            {
                key: "getOptions",
                value: function getOptions() {
                    // deep copy and remove data
                    var options = Utils.extend({}, this.options);
                    delete options.data;
                    return Utils.extend(true, {}, options);
                }
            },
            {
                key: "refreshOptions",
                value: function refreshOptions(options) {
                    // If the objects are equivalent then avoid the call of destroy / init methods
                    if (Utils.compareObjects(this.options, options, true)) return;
                    this.optionsColumnsChanged = !!options.columns;
                    this.options = Utils.extend(this.options, options);
                    this.trigger('refresh-options', this.options);
                    this.destroy();
                    this.init();
                }
            },
            {
                key: "_setDelayTimeout",
                value: function _setDelayTimeout(type, callback, delay) {
                    clearTimeout(this._timeoutId[type]);
                    this._timeoutId[type] = setTimeout(callback, delay);
                }
            },
            {
                key: "destroy",
                value: function destroy() {
                    for(var _i = 0, _Object$keys = Object.keys(this._timeoutId); _i < _Object$keys.length; _i++){
                        var type = _Object$keys[_i];
                        clearTimeout(this._timeoutId[type]);
                    }
                    this.$el.insertBefore(this.$container);
                    $(this.options.toolbar).insertBefore(this.$el);
                    this.$container.next().remove();
                    this.$container.remove();
                    this.$el.html(this.$el_.html()).css('margin-top', '0').attr('class', this.$el_.attr('class') || ''); // reset the class
                    var resizeEvent = Utils.getEventName('resize.bootstrap-table', this.$el.attr('id'));
                    $(window).off(resizeEvent);
                }
            },
            {
                key: "updateFormatText",
                value: function updateFormatText(formatName, text) {
                    if (!/^format/.test(formatName) || !this.options[formatName]) return;
                    if (typeof text === 'string') this.options[formatName] = function() {
                        return text;
                    };
                    else if (typeof text === 'function') this.options[formatName] = text;
                    this.initToolbar();
                    this.initPagination();
                    this.initBody();
                }
            }
        ]);
    }();
    Object.assign(BootstrapTable.prototype, InitializationModule);
    Object.assign(BootstrapTable.prototype, HeaderModule);
    Object.assign(BootstrapTable.prototype, DataModule);
    Object.assign(BootstrapTable.prototype, ToolbarModule);
    Object.assign(BootstrapTable.prototype, SearchModule);
    Object.assign(BootstrapTable.prototype, PaginationModule);
    Object.assign(BootstrapTable.prototype, BodyModule);
    Object.assign(BootstrapTable.prototype, CheckModule);
    Object.assign(BootstrapTable.prototype, DetailModule);
    BootstrapTable.VERSION = Constants.VERSION;
    BootstrapTable.DEFAULTS = Constants.DEFAULTS;
    BootstrapTable.LOCALES = Constants.LOCALES;
    BootstrapTable.COLUMN_DEFAULTS = Constants.COLUMN_DEFAULTS;
    BootstrapTable.METHODS = Constants.METHODS;
    BootstrapTable.EVENTS = Constants.EVENTS;
    // BOOTSTRAP TABLE PLUGIN DEFINITION
    // =======================
    $.BootstrapTable = BootstrapTable;
    $.fn.bootstrapTable = function(option) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var value;
        this.each(function(i, el) {
            var data = $(el).data('bootstrap.table');
            if (typeof option === 'string') {
                var _data;
                if (!Constants.METHODS.includes(option)) throw new Error("Unknown method: ".concat(option));
                if (!data) return;
                value = (_data = data)[option].apply(_data, args);
                if (option === 'destroy') $(el).removeData('bootstrap.table');
                return;
            }
            if (data) {
                console.warn('You cannot initialize the table more than once!');
                return;
            }
            var options = Utils.extend(true, {}, BootstrapTable.DEFAULTS, $(el).data(), _typeof(option) === 'object' && option);
            data = new $.BootstrapTable(el, options);
            $(el).data('bootstrap.table', data);
            data.init();
        });
        return typeof value === 'undefined' ? this : value;
    };
    $.fn.bootstrapTable.Constructor = BootstrapTable;
    $.fn.bootstrapTable.theme = Constants.THEME;
    $.fn.bootstrapTable.VERSION = Constants.VERSION;
    $.fn.bootstrapTable.icons = Constants.ICONS;
    $.fn.bootstrapTable.defaults = BootstrapTable.DEFAULTS;
    $.fn.bootstrapTable.columnDefaults = BootstrapTable.COLUMN_DEFAULTS;
    $.fn.bootstrapTable.events = BootstrapTable.EVENTS;
    $.fn.bootstrapTable.locales = BootstrapTable.LOCALES;
    $.fn.bootstrapTable.methods = BootstrapTable.METHODS;
    $.fn.bootstrapTable.utils = Utils;
    // BOOTSTRAP TABLE INIT
    // =======================
    $(function() {
        $('[data-toggle="table"]').bootstrapTable();
    });
    return BootstrapTable;
});



var $ac89d4376ddd92a8$exports = {};

(function(global1, factory) {
    factory((parcelRequire("iUSsr")));
})($ac89d4376ddd92a8$exports, function($) {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithoutHoles(r) {
        if (Array.isArray(r)) return _arrayLikeToArray(r);
    }
    function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function _callSuper(t, o, e) {
        return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
    }
    function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
    }
    function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
            writable: false
        }), e;
    }
    function _get() {
        return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
            var p = _superPropBase(e, t);
            if (p) {
                var n = Object.getOwnPropertyDescriptor(p, t);
                return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
        }, _get.apply(null, arguments);
    }
    function _getPrototypeOf(t) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, _getPrototypeOf(t);
    }
    function _inherits(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: true,
                configurable: true
            }
        }), Object.defineProperty(t, "prototype", {
            writable: false
        }), e && _setPrototypeOf(t, e);
    }
    function _isNativeReflectConstruct() {
        try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (t) {}
        return (_isNativeReflectConstruct = function() {
            return !!t;
        })();
    }
    function _iterableToArray(r) {
        if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _possibleConstructorReturn(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(t);
    }
    function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, _setPrototypeOf(t, e);
    }
    function _superPropBase(t, o) {
        for(; !({}).hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
        return t;
    }
    function _superPropGet(t, o, e, r) {
        var p = _get(_getPrototypeOf(t.prototype), o, e);
        return "function" == typeof p ? function(t) {
            return p.apply(e, t);
        } : p;
    }
    function _toConsumableArray(r) {
        return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    var es_array_concat = {};
    var globalThis_1;
    var hasRequiredGlobalThis;
    function requireGlobalThis() {
        if (hasRequiredGlobalThis) return globalThis_1;
        hasRequiredGlobalThis = 1;
        var check = function(it) {
            return it && it.Math === Math && it;
        };
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        globalThis_1 = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof globalThis_1 == 'object' && globalThis_1) || // eslint-disable-next-line no-new-func -- fallback
        function() {
            return this;
        }() || Function('return this')();
        return globalThis_1;
    }
    var objectGetOwnPropertyDescriptor = {};
    var fails;
    var hasRequiredFails;
    function requireFails() {
        if (hasRequiredFails) return fails;
        hasRequiredFails = 1;
        fails = function(exec) {
            try {
                return !!exec();
            } catch (error) {
                return true;
            }
        };
        return fails;
    }
    var descriptors;
    var hasRequiredDescriptors;
    function requireDescriptors() {
        if (hasRequiredDescriptors) return descriptors;
        hasRequiredDescriptors = 1;
        var fails = requireFails();
        // Detect IE8's incomplete defineProperty implementation
        descriptors = !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] !== 7;
        });
        return descriptors;
    }
    var functionBindNative;
    var hasRequiredFunctionBindNative;
    function requireFunctionBindNative() {
        if (hasRequiredFunctionBindNative) return functionBindNative;
        hasRequiredFunctionBindNative = 1;
        var fails = requireFails();
        functionBindNative = !fails(function() {
            // eslint-disable-next-line es/no-function-prototype-bind -- safe
            var test = (function() {}).bind();
            // eslint-disable-next-line no-prototype-builtins -- safe
            return typeof test != 'function' || test.hasOwnProperty('prototype');
        });
        return functionBindNative;
    }
    var functionCall;
    var hasRequiredFunctionCall;
    function requireFunctionCall() {
        if (hasRequiredFunctionCall) return functionCall;
        hasRequiredFunctionCall = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var call = Function.prototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        functionCall = NATIVE_BIND ? call.bind(call) : function() {
            return call.apply(call, arguments);
        };
        return functionCall;
    }
    var objectPropertyIsEnumerable = {};
    var hasRequiredObjectPropertyIsEnumerable;
    function requireObjectPropertyIsEnumerable() {
        if (hasRequiredObjectPropertyIsEnumerable) return objectPropertyIsEnumerable;
        hasRequiredObjectPropertyIsEnumerable = 1;
        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
            1: 2
        }, 1);
        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
            var descriptor = getOwnPropertyDescriptor(this, V);
            return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
        return objectPropertyIsEnumerable;
    }
    var createPropertyDescriptor;
    var hasRequiredCreatePropertyDescriptor;
    function requireCreatePropertyDescriptor() {
        if (hasRequiredCreatePropertyDescriptor) return createPropertyDescriptor;
        hasRequiredCreatePropertyDescriptor = 1;
        createPropertyDescriptor = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
        return createPropertyDescriptor;
    }
    var functionUncurryThis;
    var hasRequiredFunctionUncurryThis;
    function requireFunctionUncurryThis() {
        if (hasRequiredFunctionUncurryThis) return functionUncurryThis;
        hasRequiredFunctionUncurryThis = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
        functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
            return function() {
                return call.apply(fn, arguments);
            };
        };
        return functionUncurryThis;
    }
    var classofRaw;
    var hasRequiredClassofRaw;
    function requireClassofRaw() {
        if (hasRequiredClassofRaw) return classofRaw;
        hasRequiredClassofRaw = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis(''.slice);
        classofRaw = function(it) {
            return stringSlice(toString(it), 8, -1);
        };
        return classofRaw;
    }
    var indexedObject;
    var hasRequiredIndexedObject;
    function requireIndexedObject() {
        if (hasRequiredIndexedObject) return indexedObject;
        hasRequiredIndexedObject = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var classof = requireClassofRaw();
        var $Object = Object;
        var split = uncurryThis(''.split);
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        indexedObject = fails(function() {
            // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
            // eslint-disable-next-line no-prototype-builtins -- safe
            return !$Object('z').propertyIsEnumerable(0);
        }) ? function(it) {
            return classof(it) === 'String' ? split(it, '') : $Object(it);
        } : $Object;
        return indexedObject;
    }
    var isNullOrUndefined;
    var hasRequiredIsNullOrUndefined;
    function requireIsNullOrUndefined() {
        if (hasRequiredIsNullOrUndefined) return isNullOrUndefined;
        hasRequiredIsNullOrUndefined = 1;
        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        isNullOrUndefined = function(it) {
            return it === null || it === undefined;
        };
        return isNullOrUndefined;
    }
    var requireObjectCoercible;
    var hasRequiredRequireObjectCoercible;
    function requireRequireObjectCoercible() {
        if (hasRequiredRequireObjectCoercible) return requireObjectCoercible;
        hasRequiredRequireObjectCoercible = 1;
        var isNullOrUndefined = requireIsNullOrUndefined();
        var $TypeError = TypeError;
        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        requireObjectCoercible = function(it) {
            if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
            return it;
        };
        return requireObjectCoercible;
    }
    var toIndexedObject;
    var hasRequiredToIndexedObject;
    function requireToIndexedObject() {
        if (hasRequiredToIndexedObject) return toIndexedObject;
        hasRequiredToIndexedObject = 1;
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = requireIndexedObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        toIndexedObject = function(it) {
            return IndexedObject(requireObjectCoercible(it));
        };
        return toIndexedObject;
    }
    var isCallable;
    var hasRequiredIsCallable;
    function requireIsCallable() {
        if (hasRequiredIsCallable) return isCallable;
        hasRequiredIsCallable = 1;
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        var documentAll = typeof document == 'object' && document.all;
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
            return typeof argument == 'function' || argument === documentAll;
        } : function(argument) {
            return typeof argument == 'function';
        };
        return isCallable;
    }
    var isObject;
    var hasRequiredIsObject;
    function requireIsObject() {
        if (hasRequiredIsObject) return isObject;
        hasRequiredIsObject = 1;
        var isCallable = requireIsCallable();
        isObject = function(it) {
            return typeof it == 'object' ? it !== null : isCallable(it);
        };
        return isObject;
    }
    var getBuiltIn;
    var hasRequiredGetBuiltIn;
    function requireGetBuiltIn() {
        if (hasRequiredGetBuiltIn) return getBuiltIn;
        hasRequiredGetBuiltIn = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var aFunction = function(argument) {
            return isCallable(argument) ? argument : undefined;
        };
        getBuiltIn = function(namespace, method) {
            return arguments.length < 2 ? aFunction(globalThis1[namespace]) : globalThis1[namespace] && globalThis1[namespace][method];
        };
        return getBuiltIn;
    }
    var objectIsPrototypeOf;
    var hasRequiredObjectIsPrototypeOf;
    function requireObjectIsPrototypeOf() {
        if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
        hasRequiredObjectIsPrototypeOf = 1;
        var uncurryThis = requireFunctionUncurryThis();
        objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
        return objectIsPrototypeOf;
    }
    var environmentUserAgent;
    var hasRequiredEnvironmentUserAgent;
    function requireEnvironmentUserAgent() {
        if (hasRequiredEnvironmentUserAgent) return environmentUserAgent;
        hasRequiredEnvironmentUserAgent = 1;
        var globalThis1 = requireGlobalThis();
        var navigator = globalThis1.navigator;
        var userAgent = navigator && navigator.userAgent;
        environmentUserAgent = userAgent ? String(userAgent) : '';
        return environmentUserAgent;
    }
    var environmentV8Version;
    var hasRequiredEnvironmentV8Version;
    function requireEnvironmentV8Version() {
        if (hasRequiredEnvironmentV8Version) return environmentV8Version;
        hasRequiredEnvironmentV8Version = 1;
        var globalThis1 = requireGlobalThis();
        var userAgent = requireEnvironmentUserAgent();
        var process = globalThis1.process;
        var Deno1 = globalThis1.Deno;
        var versions = process && process.versions || Deno1 && Deno1.version;
        var v8 = versions && versions.v8;
        var match, version;
        if (v8) {
            match = v8.split('.');
            // in old Chrome, versions of V8 isn't V8 = Chrome / 10
            // but their correct versions are not interesting for us
            version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }
        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
                match = userAgent.match(/Chrome\/(\d+)/);
                if (match) version = +match[1];
            }
        }
        environmentV8Version = version;
        return environmentV8Version;
    }
    var symbolConstructorDetection;
    var hasRequiredSymbolConstructorDetection;
    function requireSymbolConstructorDetection() {
        if (hasRequiredSymbolConstructorDetection) return symbolConstructorDetection;
        hasRequiredSymbolConstructorDetection = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = requireEnvironmentV8Version();
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        var $String = globalThis1.String;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol('symbol detection');
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
        return symbolConstructorDetection;
    }
    var useSymbolAsUid;
    var hasRequiredUseSymbolAsUid;
    function requireUseSymbolAsUid() {
        if (hasRequiredUseSymbolAsUid) return useSymbolAsUid;
        hasRequiredUseSymbolAsUid = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        useSymbolAsUid = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
        return useSymbolAsUid;
    }
    var isSymbol;
    var hasRequiredIsSymbol;
    function requireIsSymbol() {
        if (hasRequiredIsSymbol) return isSymbol;
        hasRequiredIsSymbol = 1;
        var getBuiltIn = requireGetBuiltIn();
        var isCallable = requireIsCallable();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var $Object = Object;
        isSymbol = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == 'symbol';
        } : function(it) {
            var $Symbol = getBuiltIn('Symbol');
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };
        return isSymbol;
    }
    var tryToString;
    var hasRequiredTryToString;
    function requireTryToString() {
        if (hasRequiredTryToString) return tryToString;
        hasRequiredTryToString = 1;
        var $String = String;
        tryToString = function(argument) {
            try {
                return $String(argument);
            } catch (error) {
                return 'Object';
            }
        };
        return tryToString;
    }
    var aCallable;
    var hasRequiredACallable;
    function requireACallable() {
        if (hasRequiredACallable) return aCallable;
        hasRequiredACallable = 1;
        var isCallable = requireIsCallable();
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        // `Assert: IsCallable(argument) is true`
        aCallable = function(argument) {
            if (isCallable(argument)) return argument;
            throw new $TypeError(tryToString(argument) + ' is not a function');
        };
        return aCallable;
    }
    var getMethod;
    var hasRequiredGetMethod;
    function requireGetMethod() {
        if (hasRequiredGetMethod) return getMethod;
        hasRequiredGetMethod = 1;
        var aCallable = requireACallable();
        var isNullOrUndefined = requireIsNullOrUndefined();
        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        getMethod = function(V, P) {
            var func = V[P];
            return isNullOrUndefined(func) ? undefined : aCallable(func);
        };
        return getMethod;
    }
    var ordinaryToPrimitive;
    var hasRequiredOrdinaryToPrimitive;
    function requireOrdinaryToPrimitive() {
        if (hasRequiredOrdinaryToPrimitive) return ordinaryToPrimitive;
        hasRequiredOrdinaryToPrimitive = 1;
        var call = requireFunctionCall();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var $TypeError = TypeError;
        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        ordinaryToPrimitive = function(input, pref) {
            var fn, val;
            if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
            if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            throw new $TypeError("Can't convert object to primitive value");
        };
        return ordinaryToPrimitive;
    }
    var sharedStore = {
        exports: {}
    };
    var isPure;
    var hasRequiredIsPure;
    function requireIsPure() {
        if (hasRequiredIsPure) return isPure;
        hasRequiredIsPure = 1;
        isPure = false;
        return isPure;
    }
    var defineGlobalProperty;
    var hasRequiredDefineGlobalProperty;
    function requireDefineGlobalProperty() {
        if (hasRequiredDefineGlobalProperty) return defineGlobalProperty;
        hasRequiredDefineGlobalProperty = 1;
        var globalThis1 = requireGlobalThis();
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        defineGlobalProperty = function(key, value) {
            try {
                defineProperty(globalThis1, key, {
                    value: value,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                globalThis1[key] = value;
            }
            return value;
        };
        return defineGlobalProperty;
    }
    var hasRequiredSharedStore;
    function requireSharedStore() {
        if (hasRequiredSharedStore) return sharedStore.exports;
        hasRequiredSharedStore = 1;
        var IS_PURE = requireIsPure();
        var globalThis1 = requireGlobalThis();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var SHARED = '__core-js_shared__';
        var store = sharedStore.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
        (store.versions || (store.versions = [])).push({
            version: '3.49.0',
            mode: IS_PURE ? 'pure' : 'global',
            copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
            license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
            source: 'https://github.com/zloirock/core-js'
        });
        return sharedStore.exports;
    }
    var shared;
    var hasRequiredShared;
    function requireShared() {
        if (hasRequiredShared) return shared;
        hasRequiredShared = 1;
        var store = requireSharedStore();
        shared = function(key, value) {
            return store[key] || (store[key] = value || {});
        };
        return shared;
    }
    var toObject;
    var hasRequiredToObject;
    function requireToObject() {
        if (hasRequiredToObject) return toObject;
        hasRequiredToObject = 1;
        var requireObjectCoercible = requireRequireObjectCoercible();
        var $Object = Object;
        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        toObject = function(argument) {
            return $Object(requireObjectCoercible(argument));
        };
        return toObject;
    }
    var hasOwnProperty_1;
    var hasRequiredHasOwnProperty;
    function requireHasOwnProperty() {
        if (hasRequiredHasOwnProperty) return hasOwnProperty_1;
        hasRequiredHasOwnProperty = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toObject = requireToObject();
        var hasOwnProperty = uncurryThis({}.hasOwnProperty);
        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
        };
        return hasOwnProperty_1;
    }
    var uid;
    var hasRequiredUid;
    function requireUid() {
        if (hasRequiredUid) return uid;
        hasRequiredUid = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.1.toString);
        uid = function(key) {
            return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
        };
        return uid;
    }
    var wellKnownSymbol;
    var hasRequiredWellKnownSymbol;
    function requireWellKnownSymbol() {
        if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
        hasRequiredWellKnownSymbol = 1;
        var globalThis1 = requireGlobalThis();
        var shared = requireShared();
        var hasOwn = requireHasOwnProperty();
        var uid = requireUid();
        var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var Symbol1 = globalThis1.Symbol;
        var WellKnownSymbolsStore = shared('wks');
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1['for'] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
        wellKnownSymbol = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol('Symbol.' + name);
            return WellKnownSymbolsStore[name];
        };
        return wellKnownSymbol;
    }
    var toPrimitive;
    var hasRequiredToPrimitive;
    function requireToPrimitive() {
        if (hasRequiredToPrimitive) return toPrimitive;
        hasRequiredToPrimitive = 1;
        var call = requireFunctionCall();
        var isObject = requireIsObject();
        var isSymbol = requireIsSymbol();
        var getMethod = requireGetMethod();
        var ordinaryToPrimitive = requireOrdinaryToPrimitive();
        var wellKnownSymbol = requireWellKnownSymbol();
        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        toPrimitive = function(input, pref) {
            if (!isObject(input) || isSymbol(input)) return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result;
            if (exoticToPrim) {
                if (pref === undefined) pref = 'default';
                result = call(exoticToPrim, input, pref);
                if (!isObject(result) || isSymbol(result)) return result;
                throw new $TypeError("Can't convert object to primitive value");
            }
            if (pref === undefined) pref = 'number';
            return ordinaryToPrimitive(input, pref);
        };
        return toPrimitive;
    }
    var toPropertyKey;
    var hasRequiredToPropertyKey;
    function requireToPropertyKey() {
        if (hasRequiredToPropertyKey) return toPropertyKey;
        hasRequiredToPropertyKey = 1;
        var toPrimitive = requireToPrimitive();
        var isSymbol = requireIsSymbol();
        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        toPropertyKey = function(argument) {
            var key = toPrimitive(argument, 'string');
            return isSymbol(key) ? key : key + '';
        };
        return toPropertyKey;
    }
    var documentCreateElement;
    var hasRequiredDocumentCreateElement;
    function requireDocumentCreateElement() {
        if (hasRequiredDocumentCreateElement) return documentCreateElement;
        hasRequiredDocumentCreateElement = 1;
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var document1 = globalThis1.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document1) && isObject(document1.createElement);
        documentCreateElement = function(it) {
            return EXISTS ? document1.createElement(it) : {};
        };
        return documentCreateElement;
    }
    var ie8DomDefine;
    var hasRequiredIe8DomDefine;
    function requireIe8DomDefine() {
        if (hasRequiredIe8DomDefine) return ie8DomDefine;
        hasRequiredIe8DomDefine = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        var createElement = requireDocumentCreateElement();
        // Thanks to IE8 for its funny defineProperty
        ie8DomDefine = !DESCRIPTORS && !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(createElement('div'), 'a', {
                get: function() {
                    return 7;
                }
            }).a !== 7;
        });
        return ie8DomDefine;
    }
    var hasRequiredObjectGetOwnPropertyDescriptor;
    function requireObjectGetOwnPropertyDescriptor() {
        if (hasRequiredObjectGetOwnPropertyDescriptor) return objectGetOwnPropertyDescriptor;
        hasRequiredObjectGetOwnPropertyDescriptor = 1;
        var DESCRIPTORS = requireDescriptors();
        var call = requireFunctionCall();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        var toIndexedObject = requireToIndexedObject();
        var toPropertyKey = requireToPropertyKey();
        var hasOwn = requireHasOwnProperty();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
            O = toIndexedObject(O);
            P = toPropertyKey(P);
            if (IE8_DOM_DEFINE) try {
                return $getOwnPropertyDescriptor(O, P);
            } catch (error) {}
            if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
        return objectGetOwnPropertyDescriptor;
    }
    var objectDefineProperty = {};
    var v8PrototypeDefineBug;
    var hasRequiredV8PrototypeDefineBug;
    function requireV8PrototypeDefineBug() {
        if (hasRequiredV8PrototypeDefineBug) return v8PrototypeDefineBug;
        hasRequiredV8PrototypeDefineBug = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        v8PrototypeDefineBug = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(function() {}, 'prototype', {
                value: 42,
                writable: false
            }).prototype !== 42;
        });
        return v8PrototypeDefineBug;
    }
    var anObject;
    var hasRequiredAnObject;
    function requireAnObject() {
        if (hasRequiredAnObject) return anObject;
        hasRequiredAnObject = 1;
        var isObject = requireIsObject();
        var $String = String;
        var $TypeError = TypeError;
        // `Assert: Type(argument) is Object`
        anObject = function(argument) {
            if (isObject(argument)) return argument;
            throw new $TypeError($String(argument) + ' is not an object');
        };
        return anObject;
    }
    var hasRequiredObjectDefineProperty;
    function requireObjectDefineProperty() {
        if (hasRequiredObjectDefineProperty) return objectDefineProperty;
        hasRequiredObjectDefineProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var anObject = requireAnObject();
        var toPropertyKey = requireToPropertyKey();
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = 'enumerable';
        var CONFIGURABLE = 'configurable';
        var WRITABLE = 'writable';
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        objectDefineProperty.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                var current = $getOwnPropertyDescriptor(O, P);
                if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                        writable: false
                    };
                }
            }
            return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return $defineProperty(O, P, Attributes);
            } catch (error) {}
            if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
        };
        return objectDefineProperty;
    }
    var createNonEnumerableProperty;
    var hasRequiredCreateNonEnumerableProperty;
    function requireCreateNonEnumerableProperty() {
        if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
        hasRequiredCreateNonEnumerableProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createNonEnumerableProperty = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
        return createNonEnumerableProperty;
    }
    var makeBuiltIn = {
        exports: {}
    };
    var functionName;
    var hasRequiredFunctionName;
    function requireFunctionName() {
        if (hasRequiredFunctionName) return functionName;
        hasRequiredFunctionName = 1;
        var DESCRIPTORS = requireDescriptors();
        var hasOwn = requireHasOwnProperty();
        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
        var EXISTS = hasOwn(FunctionPrototype, 'name');
        // additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() {}).name === 'something';
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
        functionName = {
            EXISTS: EXISTS,
            PROPER: PROPER,
            CONFIGURABLE: CONFIGURABLE
        };
        return functionName;
    }
    var inspectSource;
    var hasRequiredInspectSource;
    function requireInspectSource() {
        if (hasRequiredInspectSource) return inspectSource;
        hasRequiredInspectSource = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var isCallable = requireIsCallable();
        var store = requireSharedStore();
        var functionToString = uncurryThis(Function.toString);
        // this helper broken in `core-js [at] 3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
            return functionToString(it);
        };
        inspectSource = store.inspectSource;
        return inspectSource;
    }
    var weakMapBasicDetection;
    var hasRequiredWeakMapBasicDetection;
    function requireWeakMapBasicDetection() {
        if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
        hasRequiredWeakMapBasicDetection = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var WeakMap = globalThis1.WeakMap;
        weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
        return weakMapBasicDetection;
    }
    var sharedKey;
    var hasRequiredSharedKey;
    function requireSharedKey() {
        if (hasRequiredSharedKey) return sharedKey;
        hasRequiredSharedKey = 1;
        var shared = requireShared();
        var uid = requireUid();
        var keys = shared('keys');
        sharedKey = function(key) {
            return keys[key] || (keys[key] = uid(key));
        };
        return sharedKey;
    }
    var hiddenKeys;
    var hasRequiredHiddenKeys;
    function requireHiddenKeys() {
        if (hasRequiredHiddenKeys) return hiddenKeys;
        hasRequiredHiddenKeys = 1;
        hiddenKeys = {};
        return hiddenKeys;
    }
    var internalState;
    var hasRequiredInternalState;
    function requireInternalState() {
        if (hasRequiredInternalState) return internalState;
        hasRequiredInternalState = 1;
        var NATIVE_WEAK_MAP = requireWeakMapBasicDetection();
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var hasOwn = requireHasOwnProperty();
        var shared = requireSharedStore();
        var sharedKey = requireSharedKey();
        var hiddenKeys = requireHiddenKeys();
        var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
        var TypeError1 = globalThis1.TypeError;
        var WeakMap = globalThis1.WeakMap;
        var set, get, has;
        var enforce = function(it) {
            return has(it) ? get(it) : set(it, {});
        };
        var getterFor = function(TYPE) {
            return function(it) {
                var state;
                if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1('Incompatible receiver, ' + TYPE + ' required');
                return state;
            };
        };
        if (NATIVE_WEAK_MAP || shared.state) {
            var store = shared.state || (shared.state = new WeakMap());
            /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
            store.has = store.has;
            store.set = store.set;
            /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                store.set(it, metadata);
                return metadata;
            };
            get = function(it) {
                return store.get(it) || {};
            };
            has = function(it) {
                return store.has(it);
            };
        } else {
            var STATE = sharedKey('state');
            hiddenKeys[STATE] = true;
            set = function(it, metadata) {
                if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                createNonEnumerableProperty(it, STATE, metadata);
                return metadata;
            };
            get = function(it) {
                return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
                return hasOwn(it, STATE);
            };
        }
        internalState = {
            set: set,
            get: get,
            has: has,
            enforce: enforce,
            getterFor: getterFor
        };
        return internalState;
    }
    var hasRequiredMakeBuiltIn;
    function requireMakeBuiltIn() {
        if (hasRequiredMakeBuiltIn) return makeBuiltIn.exports;
        hasRequiredMakeBuiltIn = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var hasOwn = requireHasOwnProperty();
        var DESCRIPTORS = requireDescriptors();
        var CONFIGURABLE_FUNCTION_NAME = requireFunctionName().CONFIGURABLE;
        var inspectSource = requireInspectSource();
        var InternalStateModule = requireInternalState();
        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis(''.slice);
        var replace = uncurryThis(''.replace);
        var join = uncurryThis([].join);
        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
            return defineProperty(function() {}, 'length', {
                value: 8
            }).length !== 8;
        });
        var TEMPLATE = String(String).split('String');
        var makeBuiltIn$1 = makeBuiltIn.exports = function(value, name, options) {
            if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
            if (options && options.getter) name = 'get ' + name;
            if (options && options.setter) name = 'set ' + name;
            if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                if (DESCRIPTORS) defineProperty(value, 'name', {
                    value: name,
                    configurable: true
                });
                else value.name = name;
            }
            if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
                value: options.arity
            });
            try {
                if (options && hasOwn(options, 'constructor') && options.constructor) {
                    if (DESCRIPTORS) defineProperty(value, 'prototype', {
                        writable: false
                    });
                } else if (value.prototype) value.prototype = undefined;
            } catch (error) {}
            var state = enforceInternalState(value);
            if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
            return value;
        };
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn$1(function toString() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, 'toString');
        return makeBuiltIn.exports;
    }
    var defineBuiltIn;
    var hasRequiredDefineBuiltIn;
    function requireDefineBuiltIn() {
        if (hasRequiredDefineBuiltIn) return defineBuiltIn;
        hasRequiredDefineBuiltIn = 1;
        var isCallable = requireIsCallable();
        var definePropertyModule = requireObjectDefineProperty();
        var makeBuiltIn = requireMakeBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        defineBuiltIn = function(O, key, value, options) {
            if (!options) options = {};
            var simple = options.enumerable;
            var name = options.name !== undefined ? options.name : key;
            if (isCallable(value)) makeBuiltIn(value, name, options);
            if (options.global) {
                if (simple) O[key] = value;
                else defineGlobalProperty(key, value);
            } else {
                try {
                    if (!options.unsafe) delete O[key];
                    else if (O[key]) simple = true;
                } catch (error) {}
                if (simple) O[key] = value;
                else definePropertyModule.f(O, key, {
                    value: value,
                    enumerable: false,
                    configurable: !options.nonConfigurable,
                    writable: !options.nonWritable
                });
            }
            return O;
        };
        return defineBuiltIn;
    }
    var objectGetOwnPropertyNames = {};
    var mathTrunc;
    var hasRequiredMathTrunc;
    function requireMathTrunc() {
        if (hasRequiredMathTrunc) return mathTrunc;
        hasRequiredMathTrunc = 1;
        var ceil = Math.ceil;
        var floor = Math.floor;
        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        mathTrunc = Math.trunc || function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
        };
        return mathTrunc;
    }
    var toIntegerOrInfinity;
    var hasRequiredToIntegerOrInfinity;
    function requireToIntegerOrInfinity() {
        if (hasRequiredToIntegerOrInfinity) return toIntegerOrInfinity;
        hasRequiredToIntegerOrInfinity = 1;
        var trunc = requireMathTrunc();
        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        toIntegerOrInfinity = function(argument) {
            var number = +argument;
            // eslint-disable-next-line no-self-compare -- NaN check
            return number !== number || number === 0 ? 0 : trunc(number);
        };
        return toIntegerOrInfinity;
    }
    var toAbsoluteIndex;
    var hasRequiredToAbsoluteIndex;
    function requireToAbsoluteIndex() {
        if (hasRequiredToAbsoluteIndex) return toAbsoluteIndex;
        hasRequiredToAbsoluteIndex = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var max = Math.max;
        var min = Math.min;
        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        toAbsoluteIndex = function(index, length) {
            var integer = toIntegerOrInfinity(index);
            return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
        return toAbsoluteIndex;
    }
    var toLength;
    var hasRequiredToLength;
    function requireToLength() {
        if (hasRequiredToLength) return toLength;
        hasRequiredToLength = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var min = Math.min;
        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        toLength = function(argument) {
            var len = toIntegerOrInfinity(argument);
            return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
        return toLength;
    }
    var lengthOfArrayLike;
    var hasRequiredLengthOfArrayLike;
    function requireLengthOfArrayLike() {
        if (hasRequiredLengthOfArrayLike) return lengthOfArrayLike;
        hasRequiredLengthOfArrayLike = 1;
        var toLength = requireToLength();
        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        lengthOfArrayLike = function(obj) {
            return toLength(obj.length);
        };
        return lengthOfArrayLike;
    }
    var arrayIncludes;
    var hasRequiredArrayIncludes;
    function requireArrayIncludes() {
        if (hasRequiredArrayIncludes) return arrayIncludes;
        hasRequiredArrayIncludes = 1;
        var toIndexedObject = requireToIndexedObject();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIndexedObject($this);
                var length = lengthOfArrayLike(O);
                if (length === 0) return !IS_INCLUDES && -1;
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare -- NaN check
                if (IS_INCLUDES && el !== el) while(length > index){
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
                }
                else for(; length > index; index++){
                    if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
        arrayIncludes = {
            // `Array.prototype.includes` method
            // https://tc39.es/ecma262/#sec-array.prototype.includes
            includes: createMethod(true),
            // `Array.prototype.indexOf` method
            // https://tc39.es/ecma262/#sec-array.prototype.indexof
            indexOf: createMethod(false)
        };
        return arrayIncludes;
    }
    var objectKeysInternal;
    var hasRequiredObjectKeysInternal;
    function requireObjectKeysInternal() {
        if (hasRequiredObjectKeysInternal) return objectKeysInternal;
        hasRequiredObjectKeysInternal = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var hasOwn = requireHasOwnProperty();
        var toIndexedObject = requireToIndexedObject();
        var indexOf = requireArrayIncludes().indexOf;
        var hiddenKeys = requireHiddenKeys();
        var push = uncurryThis([].push);
        objectKeysInternal = function(object, names) {
            var O = toIndexedObject(object);
            var i = 0;
            var result = [];
            var key;
            for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
            // Don't enum bug & hidden keys
            while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
            return result;
        };
        return objectKeysInternal;
    }
    var enumBugKeys;
    var hasRequiredEnumBugKeys;
    function requireEnumBugKeys() {
        if (hasRequiredEnumBugKeys) return enumBugKeys;
        hasRequiredEnumBugKeys = 1;
        // IE8- don't enum bug keys
        enumBugKeys = [
            'constructor',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'toLocaleString',
            'toString',
            'valueOf'
        ];
        return enumBugKeys;
    }
    var hasRequiredObjectGetOwnPropertyNames;
    function requireObjectGetOwnPropertyNames() {
        if (hasRequiredObjectGetOwnPropertyNames) return objectGetOwnPropertyNames;
        hasRequiredObjectGetOwnPropertyNames = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = enumBugKeys.concat('length', 'prototype');
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
        };
        return objectGetOwnPropertyNames;
    }
    var objectGetOwnPropertySymbols = {};
    var hasRequiredObjectGetOwnPropertySymbols;
    function requireObjectGetOwnPropertySymbols() {
        if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
        hasRequiredObjectGetOwnPropertySymbols = 1;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
        return objectGetOwnPropertySymbols;
    }
    var ownKeys;
    var hasRequiredOwnKeys;
    function requireOwnKeys() {
        if (hasRequiredOwnKeys) return ownKeys;
        hasRequiredOwnKeys = 1;
        var getBuiltIn = requireGetBuiltIn();
        var uncurryThis = requireFunctionUncurryThis();
        var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var anObject = requireAnObject();
        var concat = uncurryThis([].concat);
        // all object keys, includes non-enumerable and symbols
        ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
        return ownKeys;
    }
    var copyConstructorProperties;
    var hasRequiredCopyConstructorProperties;
    function requireCopyConstructorProperties() {
        if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
        hasRequiredCopyConstructorProperties = 1;
        var hasOwn = requireHasOwnProperty();
        var ownKeys = requireOwnKeys();
        var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
        var definePropertyModule = requireObjectDefineProperty();
        copyConstructorProperties = function(target, source, exceptions) {
            var keys = ownKeys(source);
            var defineProperty = definePropertyModule.f;
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        };
        return copyConstructorProperties;
    }
    var isForced_1;
    var hasRequiredIsForced;
    function requireIsForced() {
        if (hasRequiredIsForced) return isForced_1;
        hasRequiredIsForced = 1;
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var replacement = /#|\.prototype\./;
        var isForced = function(feature, detection) {
            var value = data[normalize(feature)];
            return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
        };
        var normalize = isForced.normalize = function(string) {
            return String(string).replace(replacement, '.').toLowerCase();
        };
        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';
        isForced_1 = isForced;
        return isForced_1;
    }
    var _export;
    var hasRequired_export;
    function require_export() {
        if (hasRequired_export) return _export;
        hasRequired_export = 1;
        var globalThis1 = requireGlobalThis();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var defineBuiltIn = requireDefineBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var copyConstructorProperties = requireCopyConstructorProperties();
        var isForced = requireIsForced();
        /*
  	  options.target         - name of the target object
  	  options.global         - target is the global object
  	  options.stat           - export as static methods of target
  	  options.proto          - export as prototype methods of target
  	  options.real           - real prototype method for the `pure` version
  	  options.forced         - export even if the native feature is available
  	  options.bind           - bind methods to the target, required for the `pure` version
  	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  	  options.sham           - add a flag to not completely full polyfills
  	  options.enumerable     - export as enumerable property
  	  options.dontCallGetSet - prevent calling a getter on target
  	  options.name           - the .name of the function if it does not match the key
  	*/ _export = function(options, source) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) target = globalThis1;
            else if (STATIC) target = globalThis1[TARGET] || defineGlobalProperty(TARGET, {});
            else target = globalThis1[TARGET] && globalThis1[TARGET].prototype;
            if (target) for(key in source){
                sourceProperty = source[key];
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(target, key);
                    targetProperty = descriptor && descriptor.value;
                } else targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                // contained in target
                if (!FORCED && targetProperty !== undefined) {
                    if (typeof sourceProperty == typeof targetProperty) continue;
                    copyConstructorProperties(sourceProperty, targetProperty);
                }
                // add a flag to not completely full polyfills
                if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                defineBuiltIn(target, key, sourceProperty, options);
            }
        };
        return _export;
    }
    var isArray;
    var hasRequiredIsArray;
    function requireIsArray() {
        if (hasRequiredIsArray) return isArray;
        hasRequiredIsArray = 1;
        var classof = requireClassofRaw();
        // `IsArray` abstract operation
        // https://tc39.es/ecma262/#sec-isarray
        // eslint-disable-next-line es/no-array-isarray -- safe
        isArray = Array.isArray || function isArray(argument) {
            return classof(argument) === 'Array';
        };
        return isArray;
    }
    var doesNotExceedSafeInteger;
    var hasRequiredDoesNotExceedSafeInteger;
    function requireDoesNotExceedSafeInteger() {
        if (hasRequiredDoesNotExceedSafeInteger) return doesNotExceedSafeInteger;
        hasRequiredDoesNotExceedSafeInteger = 1;
        var $TypeError = TypeError;
        var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991
        doesNotExceedSafeInteger = function(it) {
            if (it > MAX_SAFE_INTEGER) throw new $TypeError('Maximum allowed index exceeded');
            return it;
        };
        return doesNotExceedSafeInteger;
    }
    var createProperty;
    var hasRequiredCreateProperty;
    function requireCreateProperty() {
        if (hasRequiredCreateProperty) return createProperty;
        hasRequiredCreateProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createProperty = function(object, key, value) {
            if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
            else object[key] = value;
        };
        return createProperty;
    }
    var arraySetLength;
    var hasRequiredArraySetLength;
    function requireArraySetLength() {
        if (hasRequiredArraySetLength) return arraySetLength;
        hasRequiredArraySetLength = 1;
        var DESCRIPTORS = requireDescriptors();
        var isArray = requireIsArray();
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Safari < 13 does not throw an error in this case
        var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function() {
            // makes no sense without proper strict mode support
            if (this !== undefined) return true;
            try {
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                Object.defineProperty([], 'length', {
                    writable: false
                }).length = 1;
            } catch (error) {
                return error instanceof TypeError;
            }
        }();
        arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function(O, length) {
            if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) throw new $TypeError('Cannot set read only .length');
            return O.length = length;
        } : function(O, length) {
            return O.length = length;
        };
        return arraySetLength;
    }
    var toStringTagSupport;
    var hasRequiredToStringTagSupport;
    function requireToStringTagSupport() {
        if (hasRequiredToStringTagSupport) return toStringTagSupport;
        hasRequiredToStringTagSupport = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var test = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        test[TO_STRING_TAG] = 'z';
        toStringTagSupport = String(test) === '[object z]';
        return toStringTagSupport;
    }
    var classof;
    var hasRequiredClassof;
    function requireClassof() {
        if (hasRequiredClassof) return classof;
        hasRequiredClassof = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var isCallable = requireIsCallable();
        var classofRaw = requireClassofRaw();
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var $Object = Object;
        // ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
        }()) === 'Arguments';
        // fallback for IE11 Script Access Denied error
        var tryGet = function(it, key) {
            try {
                return it[key];
            } catch (error) {}
        };
        // getting tag from ES6+ `Object.prototype.toString`
        classof = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result;
            return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
        };
        return classof;
    }
    var isConstructor;
    var hasRequiredIsConstructor;
    function requireIsConstructor() {
        if (hasRequiredIsConstructor) return isConstructor;
        hasRequiredIsConstructor = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var classof = requireClassof();
        var getBuiltIn = requireGetBuiltIn();
        var inspectSource = requireInspectSource();
        var noop = function() {};
        var construct = getBuiltIn('Reflect', 'construct');
        var constructorRegExp = /^\s*(?:class|function)\b/;
        var exec = uncurryThis(constructorRegExp.exec);
        var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
        var isConstructorModern = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            try {
                construct(noop, [], argument);
                return true;
            } catch (error) {
                return false;
            }
        };
        var isConstructorLegacy = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            switch(classof(argument)){
                case 'AsyncFunction':
                case 'GeneratorFunction':
                case 'AsyncGeneratorFunction':
                    return false;
            }
            try {
                // we can't check .prototype since constructors produced by .bind haven't it
                // `Function#toString` throws on some built-it function in some legacy engines
                // (for example, `DOMQuad` and similar in FF41-)
                return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
            } catch (error) {
                return true;
            }
        };
        isConstructorLegacy.sham = true;
        // `IsConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-isconstructor
        isConstructor = !construct || fails(function() {
            var called;
            return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                called = true;
            }) || called;
        }) ? isConstructorLegacy : isConstructorModern;
        return isConstructor;
    }
    var arraySpeciesConstructor;
    var hasRequiredArraySpeciesConstructor;
    function requireArraySpeciesConstructor() {
        if (hasRequiredArraySpeciesConstructor) return arraySpeciesConstructor;
        hasRequiredArraySpeciesConstructor = 1;
        var isArray = requireIsArray();
        var isConstructor = requireIsConstructor();
        var isObject = requireIsObject();
        var wellKnownSymbol = requireWellKnownSymbol();
        var SPECIES = wellKnownSymbol('species');
        var $Array = Array;
        // a part of `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesConstructor = function(originalArray) {
            var C;
            if (isArray(originalArray)) {
                C = originalArray.constructor;
                // cross-realm fallback
                if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
                else if (isObject(C)) {
                    C = C[SPECIES];
                    if (C === null) C = undefined;
                }
            }
            return C === undefined ? $Array : C;
        };
        return arraySpeciesConstructor;
    }
    var arraySpeciesCreate;
    var hasRequiredArraySpeciesCreate;
    function requireArraySpeciesCreate() {
        if (hasRequiredArraySpeciesCreate) return arraySpeciesCreate;
        hasRequiredArraySpeciesCreate = 1;
        var arraySpeciesConstructor = requireArraySpeciesConstructor();
        // `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesCreate = function(originalArray, length) {
            return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
        };
        return arraySpeciesCreate;
    }
    var arrayMethodHasSpeciesSupport;
    var hasRequiredArrayMethodHasSpeciesSupport;
    function requireArrayMethodHasSpeciesSupport() {
        if (hasRequiredArrayMethodHasSpeciesSupport) return arrayMethodHasSpeciesSupport;
        hasRequiredArrayMethodHasSpeciesSupport = 1;
        var fails = requireFails();
        var wellKnownSymbol = requireWellKnownSymbol();
        var V8_VERSION = requireEnvironmentV8Version();
        var SPECIES = wellKnownSymbol('species');
        arrayMethodHasSpeciesSupport = function(METHOD_NAME) {
            // We can't use this feature detection in V8 since it causes
            // deoptimization and serious performance degradation
            // https://github.com/zloirock/core-js/issues/677
            return V8_VERSION >= 51 || !fails(function() {
                var array = [];
                var constructor = array.constructor = {};
                constructor[SPECIES] = function() {
                    return {
                        foo: 1
                    };
                };
                return array[METHOD_NAME](Boolean).foo !== 1;
            });
        };
        return arrayMethodHasSpeciesSupport;
    }
    var hasRequiredEs_array_concat;
    function requireEs_array_concat() {
        if (hasRequiredEs_array_concat) return es_array_concat;
        hasRequiredEs_array_concat = 1;
        var $ = require_export();
        var fails = requireFails();
        var isArray = requireIsArray();
        var isObject = requireIsObject();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var doesNotExceedSafeInteger = requireDoesNotExceedSafeInteger();
        var createProperty = requireCreateProperty();
        var setArrayLength = requireArraySetLength();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var wellKnownSymbol = requireWellKnownSymbol();
        var V8_VERSION = requireEnvironmentV8Version();
        var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
        // We can't use this feature detection in V8 since it causes
        // deoptimization and serious performance degradation
        // https://github.com/zloirock/core-js/issues/679
        var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
            var array = [];
            array[IS_CONCAT_SPREADABLE] = false;
            return array.concat()[0] !== array;
        });
        var isConcatSpreadable = function(O) {
            if (!isObject(O)) return false;
            var spreadable = O[IS_CONCAT_SPREADABLE];
            return spreadable !== undefined ? !!spreadable : isArray(O);
        };
        var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');
        // `Array.prototype.concat` method
        // https://tc39.es/ecma262/#sec-array.prototype.concat
        // with adding support of @@isConcatSpreadable and @@species
        $({
            target: 'Array',
            proto: true,
            arity: 1,
            forced: FORCED
        }, {
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            concat: function concat(arg) {
                var O = toObject(this);
                var A = arraySpeciesCreate(O, 0);
                var n = 0;
                var i, k, length, len, E;
                for(i = -1, length = arguments.length; i < length; i++){
                    E = i === -1 ? O : arguments[i];
                    if (isConcatSpreadable(E)) {
                        len = lengthOfArrayLike(E);
                        doesNotExceedSafeInteger(n + len);
                        for(k = 0; k < len; k++, n++)if (k in E) createProperty(A, n, E[k]);
                    } else {
                        doesNotExceedSafeInteger(n + 1);
                        createProperty(A, n++, E);
                    }
                }
                setArrayLength(A, n);
                return A;
            }
        });
        return es_array_concat;
    }
    requireEs_array_concat();
    var es_array_filter = {};
    var functionUncurryThisClause;
    var hasRequiredFunctionUncurryThisClause;
    function requireFunctionUncurryThisClause() {
        if (hasRequiredFunctionUncurryThisClause) return functionUncurryThisClause;
        hasRequiredFunctionUncurryThisClause = 1;
        var classofRaw = requireClassofRaw();
        var uncurryThis = requireFunctionUncurryThis();
        functionUncurryThisClause = function(fn) {
            // Nashorn bug:
            //   https://github.com/zloirock/core-js/issues/1128
            //   https://github.com/zloirock/core-js/issues/1130
            if (classofRaw(fn) === 'Function') return uncurryThis(fn);
        };
        return functionUncurryThisClause;
    }
    var functionBindContext;
    var hasRequiredFunctionBindContext;
    function requireFunctionBindContext() {
        if (hasRequiredFunctionBindContext) return functionBindContext;
        hasRequiredFunctionBindContext = 1;
        var uncurryThis = requireFunctionUncurryThisClause();
        var aCallable = requireACallable();
        var NATIVE_BIND = requireFunctionBindNative();
        var bind = uncurryThis(uncurryThis.bind);
        // optional / simple context binding
        functionBindContext = function(fn, that) {
            aCallable(fn);
            return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
                return fn.apply(that, arguments);
            };
        };
        return functionBindContext;
    }
    var arrayIteration;
    var hasRequiredArrayIteration;
    function requireArrayIteration() {
        if (hasRequiredArrayIteration) return arrayIteration;
        hasRequiredArrayIteration = 1;
        var bind = requireFunctionBindContext();
        var IndexedObject = requireIndexedObject();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var createProperty = requireCreateProperty();
        // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
        var createMethod = function(TYPE) {
            var IS_MAP = TYPE === 1;
            var IS_FILTER = TYPE === 2;
            var IS_SOME = TYPE === 3;
            var IS_EVERY = TYPE === 4;
            var IS_FIND_INDEX = TYPE === 6;
            var IS_FILTER_REJECT = TYPE === 7;
            var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
            return function($this, callbackfn, that) {
                var O = toObject($this);
                var self1 = IndexedObject(O);
                var length = lengthOfArrayLike(self1);
                var boundFunction = bind(callbackfn, that);
                var index = 0;
                var resIndex = 0;
                var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
                var value, result;
                for(; length > index; index++)if (NO_HOLES || index in self1) {
                    value = self1[index];
                    result = boundFunction(value, index, O);
                    if (TYPE) {
                        if (IS_MAP) createProperty(target, index, result); // map
                        else if (result) switch(TYPE){
                            case 3:
                                return true; // some
                            case 5:
                                return value; // find
                            case 6:
                                return index; // findIndex
                            case 2:
                                createProperty(target, resIndex++, value); // filter
                        }
                        else switch(TYPE){
                            case 4:
                                return false; // every
                            case 7:
                                createProperty(target, resIndex++, value); // filterReject
                        }
                    }
                }
                return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
            };
        };
        arrayIteration = {
            // `Array.prototype.forEach` method
            // https://tc39.es/ecma262/#sec-array.prototype.foreach
            forEach: createMethod(0),
            // `Array.prototype.map` method
            // https://tc39.es/ecma262/#sec-array.prototype.map
            map: createMethod(1),
            // `Array.prototype.filter` method
            // https://tc39.es/ecma262/#sec-array.prototype.filter
            filter: createMethod(2),
            // `Array.prototype.some` method
            // https://tc39.es/ecma262/#sec-array.prototype.some
            some: createMethod(3),
            // `Array.prototype.every` method
            // https://tc39.es/ecma262/#sec-array.prototype.every
            every: createMethod(4),
            // `Array.prototype.find` method
            // https://tc39.es/ecma262/#sec-array.prototype.find
            find: createMethod(5),
            // `Array.prototype.findIndex` method
            // https://tc39.es/ecma262/#sec-array.prototype.findIndex
            findIndex: createMethod(6),
            // `Array.prototype.filterReject` method
            // https://github.com/tc39/proposal-array-filtering
            filterReject: createMethod(7)
        };
        return arrayIteration;
    }
    var hasRequiredEs_array_filter;
    function requireEs_array_filter() {
        if (hasRequiredEs_array_filter) return es_array_filter;
        hasRequiredEs_array_filter = 1;
        var $ = require_export();
        var $filter = requireArrayIteration().filter;
        var arrayMethodHasSpeciesSupport = requireArrayMethodHasSpeciesSupport();
        var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        // with adding support of @@species
        $({
            target: 'Array',
            proto: true,
            forced: !HAS_SPECIES_SUPPORT
        }, {
            filter: function filter(callbackfn /* , thisArg */ ) {
                return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        return es_array_filter;
    }
    requireEs_array_filter();
    var es_array_find = {};
    var objectDefineProperties = {};
    var objectKeys;
    var hasRequiredObjectKeys;
    function requireObjectKeys() {
        if (hasRequiredObjectKeys) return objectKeys;
        hasRequiredObjectKeys = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        objectKeys = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
        };
        return objectKeys;
    }
    var hasRequiredObjectDefineProperties;
    function requireObjectDefineProperties() {
        if (hasRequiredObjectDefineProperties) return objectDefineProperties;
        hasRequiredObjectDefineProperties = 1;
        var DESCRIPTORS = requireDescriptors();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var definePropertyModule = requireObjectDefineProperty();
        var anObject = requireAnObject();
        var toIndexedObject = requireToIndexedObject();
        var objectKeys = requireObjectKeys();
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        // eslint-disable-next-line es/no-object-defineproperties -- safe
        objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
            anObject(O);
            var props = toIndexedObject(Properties);
            var keys = objectKeys(Properties);
            var length = keys.length;
            var index = 0;
            var key;
            while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
            return O;
        };
        return objectDefineProperties;
    }
    var html;
    var hasRequiredHtml;
    function requireHtml() {
        if (hasRequiredHtml) return html;
        hasRequiredHtml = 1;
        var getBuiltIn = requireGetBuiltIn();
        html = getBuiltIn('document', 'documentElement');
        return html;
    }
    var objectCreate;
    var hasRequiredObjectCreate;
    function requireObjectCreate() {
        if (hasRequiredObjectCreate) return objectCreate;
        hasRequiredObjectCreate = 1;
        /* global ActiveXObject -- old IE, WSH */ var anObject = requireAnObject();
        var definePropertiesModule = requireObjectDefineProperties();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = requireHiddenKeys();
        var html = requireHtml();
        var documentCreateElement = requireDocumentCreateElement();
        var sharedKey = requireSharedKey();
        var GT = '>';
        var LT = '<';
        var PROTOTYPE = 'prototype';
        var SCRIPT = 'script';
        var IE_PROTO = sharedKey('IE_PROTO');
        var EmptyConstructor = function() {};
        var scriptTag = function(content) {
            return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
        };
        // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
        var NullProtoObjectViaActiveX = function(activeXDocument) {
            activeXDocument.write(scriptTag(''));
            activeXDocument.close();
            var temp = activeXDocument.parentWindow.Object;
            // eslint-disable-next-line no-useless-assignment -- avoid memory leak
            activeXDocument = null;
            return temp;
        };
        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var NullProtoObjectViaIFrame = function() {
            // Thrash, waste and sodomy: IE GC bug
            var iframe = documentCreateElement('iframe');
            var JS = 'java' + SCRIPT + ':';
            var iframeDocument;
            iframe.style.display = 'none';
            html.appendChild(iframe);
            // https://github.com/zloirock/core-js/issues/475
            iframe.src = String(JS);
            iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(scriptTag('document.F=Object'));
            iframeDocument.close();
            return iframeDocument.F;
        };
        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug
        var activeXDocument;
        var NullProtoObject = function() {
            try {
                activeXDocument = new ActiveXObject('htmlfile');
            } catch (error) {}
            NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
             : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
            var length = enumBugKeys.length;
            while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
            return NullProtoObject();
        };
        hiddenKeys[IE_PROTO] = true;
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        // eslint-disable-next-line es/no-object-create -- safe
        objectCreate = Object.create || function create(O, Properties) {
            var result;
            if (O !== null) {
                EmptyConstructor[PROTOTYPE] = anObject(O);
                result = new EmptyConstructor();
                EmptyConstructor[PROTOTYPE] = null;
                // add "__proto__" for Object.getPrototypeOf polyfill
                result[IE_PROTO] = O;
            } else result = NullProtoObject();
            return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
        };
        return objectCreate;
    }
    var addToUnscopables;
    var hasRequiredAddToUnscopables;
    function requireAddToUnscopables() {
        if (hasRequiredAddToUnscopables) return addToUnscopables;
        hasRequiredAddToUnscopables = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var create = requireObjectCreate();
        var defineProperty = requireObjectDefineProperty().f;
        var UNSCOPABLES = wellKnownSymbol('unscopables');
        var ArrayPrototype = Array.prototype;
        // Array.prototype[@@unscopables]
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null)
        });
        // add a key to Array.prototype[@@unscopables]
        addToUnscopables = function(key) {
            ArrayPrototype[UNSCOPABLES][key] = true;
        };
        return addToUnscopables;
    }
    var hasRequiredEs_array_find;
    function requireEs_array_find() {
        if (hasRequiredEs_array_find) return es_array_find;
        hasRequiredEs_array_find = 1;
        var $ = require_export();
        var $find = requireArrayIteration().find;
        var addToUnscopables = requireAddToUnscopables();
        var FIND = 'find';
        var SKIPS_HOLES = true;
        // Shouldn't skip holes
        // eslint-disable-next-line es/no-array-prototype-find -- testing
        if (FIND in []) Array(1)[FIND](function() {
            SKIPS_HOLES = false;
        });
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        $({
            target: 'Array',
            proto: true,
            forced: SKIPS_HOLES
        }, {
            find: function find(callbackfn /* , that = undefined */ ) {
                return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables(FIND);
        return es_array_find;
    }
    requireEs_array_find();
    var es_array_includes = {};
    var hasRequiredEs_array_includes;
    function requireEs_array_includes() {
        if (hasRequiredEs_array_includes) return es_array_includes;
        hasRequiredEs_array_includes = 1;
        var $ = require_export();
        var $includes = requireArrayIncludes().includes;
        var fails = requireFails();
        var addToUnscopables = requireAddToUnscopables();
        // FF99+ bug
        var BROKEN_ON_SPARSE = fails(function() {
            // eslint-disable-next-line es/no-array-prototype-includes -- detection
            return !Array(1).includes();
        });
        // Safari 26.4- bug
        var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function() {
            // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
            return [
                ,
                1
            ].includes(undefined, 1);
        });
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        $({
            target: 'Array',
            proto: true,
            forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX
        }, {
            includes: function includes(el /* , fromIndex = 0 */ ) {
                return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables('includes');
        return es_array_includes;
    }
    requireEs_array_includes();
    var es_array_indexOf = {};
    var arrayMethodIsStrict;
    var hasRequiredArrayMethodIsStrict;
    function requireArrayMethodIsStrict() {
        if (hasRequiredArrayMethodIsStrict) return arrayMethodIsStrict;
        hasRequiredArrayMethodIsStrict = 1;
        var fails = requireFails();
        arrayMethodIsStrict = function(METHOD_NAME, argument) {
            var method = [][METHOD_NAME];
            return !!method && fails(function() {
                // eslint-disable-next-line no-useless-call -- required for testing
                method.call(null, argument || function() {
                    return 1;
                }, 1);
            });
        };
        return arrayMethodIsStrict;
    }
    var hasRequiredEs_array_indexOf;
    function requireEs_array_indexOf() {
        if (hasRequiredEs_array_indexOf) return es_array_indexOf;
        hasRequiredEs_array_indexOf = 1;
        /* eslint-disable es/no-array-prototype-indexof -- required for testing */ var $ = require_export();
        var uncurryThis = requireFunctionUncurryThisClause();
        var $indexOf = requireArrayIncludes().indexOf;
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var nativeIndexOf = uncurryThis([].indexOf);
        var NEGATIVE_ZERO = !!nativeIndexOf && 1 / nativeIndexOf([
            1
        ], 1, -0) < 0;
        var FORCED = NEGATIVE_ZERO || !arrayMethodIsStrict('indexOf');
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        $({
            target: 'Array',
            proto: true,
            forced: FORCED
        }, {
            indexOf: function indexOf(searchElement /* , fromIndex = 0 */ ) {
                var fromIndex = arguments.length > 1 ? arguments[1] : undefined;
                return NEGATIVE_ZERO ? nativeIndexOf(this, searchElement, fromIndex) || 0 : $indexOf(this, searchElement, fromIndex);
            }
        });
        return es_array_indexOf;
    }
    requireEs_array_indexOf();
    var es_object_assign = {};
    var objectAssign;
    var hasRequiredObjectAssign;
    function requireObjectAssign() {
        if (hasRequiredObjectAssign) return objectAssign;
        hasRequiredObjectAssign = 1;
        var DESCRIPTORS = requireDescriptors();
        var uncurryThis = requireFunctionUncurryThis();
        var call = requireFunctionCall();
        var fails = requireFails();
        var objectKeys = requireObjectKeys();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var toObject = requireToObject();
        var IndexedObject = requireIndexedObject();
        // eslint-disable-next-line es/no-object-assign -- safe
        var $assign = Object.assign;
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        var defineProperty = Object.defineProperty;
        var concat = uncurryThis([].concat);
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        objectAssign = !$assign || fails(function() {
            // should have correct order of operations (Edge bug)
            if (DESCRIPTORS && $assign({
                b: 1
            }, $assign(defineProperty({}, 'a', {
                enumerable: true,
                get: function() {
                    defineProperty(this, 'b', {
                        value: 3,
                        enumerable: false
                    });
                }
            }), {
                b: 2
            })).b !== 1) return true;
            // should work with symbols and should have deterministic property order (V8 bug)
            var A = {};
            var B = {};
            // eslint-disable-next-line es/no-symbol -- safe
            var symbol = Symbol('assign detection');
            var alphabet = 'abcdefghijklmnopqrst';
            A[symbol] = 7;
            // eslint-disable-next-line es/no-array-prototype-foreach -- safe
            alphabet.split('').forEach(function(chr) {
                B[chr] = chr;
            });
            return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
        }) ? function assign(target, source) {
            var T = toObject(target);
            var argumentsLength = arguments.length;
            var index = 1;
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            var propertyIsEnumerable = propertyIsEnumerableModule.f;
            while(argumentsLength > index){
                var S = IndexedObject(arguments[index++]);
                var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while(length > j){
                    key = keys[j++];
                    if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                }
            }
            return T;
        } : $assign;
        return objectAssign;
    }
    var hasRequiredEs_object_assign;
    function requireEs_object_assign() {
        if (hasRequiredEs_object_assign) return es_object_assign;
        hasRequiredEs_object_assign = 1;
        var $ = require_export();
        var assign = requireObjectAssign();
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        // eslint-disable-next-line es/no-object-assign -- required for testing
        $({
            target: 'Object',
            stat: true,
            arity: 2,
            forced: Object.assign !== assign
        }, {
            assign: assign
        });
        return es_object_assign;
    }
    requireEs_object_assign();
    var es_object_keys = {};
    var hasRequiredEs_object_keys;
    function requireEs_object_keys() {
        if (hasRequiredEs_object_keys) return es_object_keys;
        hasRequiredEs_object_keys = 1;
        var $ = require_export();
        var toObject = requireToObject();
        var nativeKeys = requireObjectKeys();
        var fails = requireFails();
        var FAILS_ON_PRIMITIVES = fails(function() {
            nativeKeys(1);
        });
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        $({
            target: 'Object',
            stat: true,
            forced: FAILS_ON_PRIMITIVES
        }, {
            keys: function keys(it) {
                return nativeKeys(toObject(it));
            }
        });
        return es_object_keys;
    }
    requireEs_object_keys();
    var es_object_toString = {};
    var objectToString;
    var hasRequiredObjectToString;
    function requireObjectToString() {
        if (hasRequiredObjectToString) return objectToString;
        hasRequiredObjectToString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var classof = requireClassof();
        // `Object.prototype.toString` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        objectToString = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
            return '[object ' + classof(this) + ']';
        };
        return objectToString;
    }
    var hasRequiredEs_object_toString;
    function requireEs_object_toString() {
        if (hasRequiredEs_object_toString) return es_object_toString;
        hasRequiredEs_object_toString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var defineBuiltIn = requireDefineBuiltIn();
        var toString = requireObjectToString();
        // `Object.prototype.toString` method
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
            unsafe: true
        });
        return es_object_toString;
    }
    requireEs_object_toString();
    var es_object_values = {};
    var correctPrototypeGetter;
    var hasRequiredCorrectPrototypeGetter;
    function requireCorrectPrototypeGetter() {
        if (hasRequiredCorrectPrototypeGetter) return correctPrototypeGetter;
        hasRequiredCorrectPrototypeGetter = 1;
        var fails = requireFails();
        correctPrototypeGetter = !fails(function() {
            function F() {}
            F.prototype.constructor = null;
            // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
            return Object.getPrototypeOf(new F()) !== F.prototype;
        });
        return correctPrototypeGetter;
    }
    var objectGetPrototypeOf;
    var hasRequiredObjectGetPrototypeOf;
    function requireObjectGetPrototypeOf() {
        if (hasRequiredObjectGetPrototypeOf) return objectGetPrototypeOf;
        hasRequiredObjectGetPrototypeOf = 1;
        var hasOwn = requireHasOwnProperty();
        var isCallable = requireIsCallable();
        var toObject = requireToObject();
        var sharedKey = requireSharedKey();
        var CORRECT_PROTOTYPE_GETTER = requireCorrectPrototypeGetter();
        var IE_PROTO = sharedKey('IE_PROTO');
        var $Object = Object;
        var ObjectPrototype = $Object.prototype;
        // `Object.getPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.getprototypeof
        // eslint-disable-next-line es/no-object-getprototypeof -- safe
        objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function(O) {
            var object = toObject(O);
            if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
            var constructor = object.constructor;
            if (isCallable(constructor) && object instanceof constructor) return constructor.prototype;
            return object instanceof $Object ? ObjectPrototype : null;
        };
        return objectGetPrototypeOf;
    }
    var objectToArray;
    var hasRequiredObjectToArray;
    function requireObjectToArray() {
        if (hasRequiredObjectToArray) return objectToArray;
        hasRequiredObjectToArray = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        var uncurryThis = requireFunctionUncurryThis();
        var objectGetPrototypeOf = requireObjectGetPrototypeOf();
        var objectKeys = requireObjectKeys();
        var toIndexedObject = requireToIndexedObject();
        var $propertyIsEnumerable = requireObjectPropertyIsEnumerable().f;
        var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
        var push = uncurryThis([].push);
        // in some IE versions, `propertyIsEnumerable` returns incorrect result on integer keys
        // of `null` prototype objects
        var IE_BUG = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-create -- safe
            var O = Object.create(null);
            O[2] = 2;
            return !propertyIsEnumerable(O, 2);
        });
        // `Object.{ entries, values }` methods implementation
        var createMethod = function(TO_ENTRIES) {
            return function(it) {
                var O = toIndexedObject(it);
                var keys = objectKeys(O);
                var IE_WORKAROUND = IE_BUG && objectGetPrototypeOf(O) === null;
                var length = keys.length;
                var i = 0;
                var result = [];
                var key;
                while(length > i){
                    key = keys[i++];
                    if (!DESCRIPTORS || (IE_WORKAROUND ? key in O : propertyIsEnumerable(O, key))) push(result, TO_ENTRIES ? [
                        key,
                        O[key]
                    ] : O[key]);
                }
                return result;
            };
        };
        objectToArray = {
            // `Object.entries` method
            // https://tc39.es/ecma262/#sec-object.entries
            entries: createMethod(true),
            // `Object.values` method
            // https://tc39.es/ecma262/#sec-object.values
            values: createMethod(false)
        };
        return objectToArray;
    }
    var hasRequiredEs_object_values;
    function requireEs_object_values() {
        if (hasRequiredEs_object_values) return es_object_values;
        hasRequiredEs_object_values = 1;
        var $ = require_export();
        var $values = requireObjectToArray().values;
        // `Object.values` method
        // https://tc39.es/ecma262/#sec-object.values
        $({
            target: 'Object',
            stat: true
        }, {
            values: function values(O) {
                return $values(O);
            }
        });
        return es_object_values;
    }
    requireEs_object_values();
    var es_promise = {};
    var es_promise_constructor = {};
    var environment;
    var hasRequiredEnvironment;
    function requireEnvironment() {
        if (hasRequiredEnvironment) return environment;
        hasRequiredEnvironment = 1;
        /* global Bun, Deno -- detection */ var globalThis1 = requireGlobalThis();
        var userAgent = requireEnvironmentUserAgent();
        var classof = requireClassofRaw();
        var userAgentStartsWith = function(string) {
            return userAgent.slice(0, string.length) === string;
        };
        environment = function() {
            if (userAgentStartsWith('Bun/')) return 'BUN';
            if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
            if (userAgentStartsWith('Deno/')) return 'DENO';
            if (userAgentStartsWith('Node.js/')) return 'NODE';
            if (globalThis1.Bun && typeof Bun.version == 'string') return 'BUN';
            if (globalThis1.Deno && typeof Deno.version == 'object') return 'DENO';
            if (classof(globalThis1.process) === 'process') return 'NODE';
            if (globalThis1.window && globalThis1.document) return 'BROWSER';
            return 'REST';
        }();
        return environment;
    }
    var environmentIsNode;
    var hasRequiredEnvironmentIsNode;
    function requireEnvironmentIsNode() {
        if (hasRequiredEnvironmentIsNode) return environmentIsNode;
        hasRequiredEnvironmentIsNode = 1;
        var ENVIRONMENT = requireEnvironment();
        environmentIsNode = ENVIRONMENT === 'NODE';
        return environmentIsNode;
    }
    var path;
    var hasRequiredPath;
    function requirePath() {
        if (hasRequiredPath) return path;
        hasRequiredPath = 1;
        var globalThis1 = requireGlobalThis();
        path = globalThis1;
        return path;
    }
    var functionUncurryThisAccessor;
    var hasRequiredFunctionUncurryThisAccessor;
    function requireFunctionUncurryThisAccessor() {
        if (hasRequiredFunctionUncurryThisAccessor) return functionUncurryThisAccessor;
        hasRequiredFunctionUncurryThisAccessor = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var aCallable = requireACallable();
        functionUncurryThisAccessor = function(object, key, method) {
            try {
                // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
                return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
            } catch (error) {}
        };
        return functionUncurryThisAccessor;
    }
    var isPossiblePrototype;
    var hasRequiredIsPossiblePrototype;
    function requireIsPossiblePrototype() {
        if (hasRequiredIsPossiblePrototype) return isPossiblePrototype;
        hasRequiredIsPossiblePrototype = 1;
        var isObject = requireIsObject();
        isPossiblePrototype = function(argument) {
            return isObject(argument) || argument === null;
        };
        return isPossiblePrototype;
    }
    var aPossiblePrototype;
    var hasRequiredAPossiblePrototype;
    function requireAPossiblePrototype() {
        if (hasRequiredAPossiblePrototype) return aPossiblePrototype;
        hasRequiredAPossiblePrototype = 1;
        var isPossiblePrototype = requireIsPossiblePrototype();
        var $String = String;
        var $TypeError = TypeError;
        aPossiblePrototype = function(argument) {
            if (isPossiblePrototype(argument)) return argument;
            throw new $TypeError("Can't set " + $String(argument) + ' as a prototype');
        };
        return aPossiblePrototype;
    }
    var objectSetPrototypeOf;
    var hasRequiredObjectSetPrototypeOf;
    function requireObjectSetPrototypeOf() {
        if (hasRequiredObjectSetPrototypeOf) return objectSetPrototypeOf;
        hasRequiredObjectSetPrototypeOf = 1;
        /* eslint-disable no-proto -- safe */ var uncurryThisAccessor = requireFunctionUncurryThisAccessor();
        var isObject = requireIsObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var aPossiblePrototype = requireAPossiblePrototype();
        // `Object.setPrototypeOf` method
        // https://tc39.es/ecma262/#sec-object.setprototypeof
        // Works with __proto__ only. Old v8 can't work with null proto objects.
        // eslint-disable-next-line es/no-object-setprototypeof -- safe
        objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function() {
            var CORRECT_SETTER = false;
            var test = {};
            var setter;
            try {
                setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
                setter(test, []);
                CORRECT_SETTER = test instanceof Array;
            } catch (error) {}
            return function setPrototypeOf(O, proto) {
                requireObjectCoercible(O);
                aPossiblePrototype(proto);
                if (!isObject(O)) return O;
                if (CORRECT_SETTER) setter(O, proto);
                else O.__proto__ = proto;
                return O;
            };
        }() : undefined);
        return objectSetPrototypeOf;
    }
    var setToStringTag;
    var hasRequiredSetToStringTag;
    function requireSetToStringTag() {
        if (hasRequiredSetToStringTag) return setToStringTag;
        hasRequiredSetToStringTag = 1;
        var defineProperty = requireObjectDefineProperty().f;
        var hasOwn = requireHasOwnProperty();
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        setToStringTag = function(target, TAG, STATIC) {
            if (target && !STATIC) target = target.prototype;
            if (target && !hasOwn(target, TO_STRING_TAG)) defineProperty(target, TO_STRING_TAG, {
                configurable: true,
                value: TAG
            });
        };
        return setToStringTag;
    }
    var defineBuiltInAccessor;
    var hasRequiredDefineBuiltInAccessor;
    function requireDefineBuiltInAccessor() {
        if (hasRequiredDefineBuiltInAccessor) return defineBuiltInAccessor;
        hasRequiredDefineBuiltInAccessor = 1;
        var makeBuiltIn = requireMakeBuiltIn();
        var defineProperty = requireObjectDefineProperty();
        defineBuiltInAccessor = function(target, name, descriptor) {
            if (descriptor.get) makeBuiltIn(descriptor.get, name, {
                getter: true
            });
            if (descriptor.set) makeBuiltIn(descriptor.set, name, {
                setter: true
            });
            return defineProperty.f(target, name, descriptor);
        };
        return defineBuiltInAccessor;
    }
    var setSpecies;
    var hasRequiredSetSpecies;
    function requireSetSpecies() {
        if (hasRequiredSetSpecies) return setSpecies;
        hasRequiredSetSpecies = 1;
        var getBuiltIn = requireGetBuiltIn();
        var defineBuiltInAccessor = requireDefineBuiltInAccessor();
        var wellKnownSymbol = requireWellKnownSymbol();
        var DESCRIPTORS = requireDescriptors();
        var SPECIES = wellKnownSymbol('species');
        setSpecies = function(CONSTRUCTOR_NAME) {
            var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
            if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) defineBuiltInAccessor(Constructor, SPECIES, {
                configurable: true,
                get: function() {
                    return this;
                }
            });
        };
        return setSpecies;
    }
    var anInstance;
    var hasRequiredAnInstance;
    function requireAnInstance() {
        if (hasRequiredAnInstance) return anInstance;
        hasRequiredAnInstance = 1;
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var $TypeError = TypeError;
        anInstance = function(it, Prototype) {
            if (isPrototypeOf(Prototype, it)) return it;
            throw new $TypeError('Incorrect invocation');
        };
        return anInstance;
    }
    var aConstructor;
    var hasRequiredAConstructor;
    function requireAConstructor() {
        if (hasRequiredAConstructor) return aConstructor;
        hasRequiredAConstructor = 1;
        var isConstructor = requireIsConstructor();
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        // `Assert: IsConstructor(argument) is true`
        aConstructor = function(argument) {
            if (isConstructor(argument)) return argument;
            throw new $TypeError(tryToString(argument) + ' is not a constructor');
        };
        return aConstructor;
    }
    var speciesConstructor;
    var hasRequiredSpeciesConstructor;
    function requireSpeciesConstructor() {
        if (hasRequiredSpeciesConstructor) return speciesConstructor;
        hasRequiredSpeciesConstructor = 1;
        var anObject = requireAnObject();
        var aConstructor = requireAConstructor();
        var isNullOrUndefined = requireIsNullOrUndefined();
        var wellKnownSymbol = requireWellKnownSymbol();
        var SPECIES = wellKnownSymbol('species');
        // `SpeciesConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-speciesconstructor
        speciesConstructor = function(O, defaultConstructor) {
            var C = anObject(O).constructor;
            var S;
            return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
        };
        return speciesConstructor;
    }
    var functionApply;
    var hasRequiredFunctionApply;
    function requireFunctionApply() {
        if (hasRequiredFunctionApply) return functionApply;
        hasRequiredFunctionApply = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var FunctionPrototype = Function.prototype;
        var apply = FunctionPrototype.apply;
        var call = FunctionPrototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
        functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function() {
            return call.apply(apply, arguments);
        });
        return functionApply;
    }
    var arraySlice;
    var hasRequiredArraySlice;
    function requireArraySlice() {
        if (hasRequiredArraySlice) return arraySlice;
        hasRequiredArraySlice = 1;
        var uncurryThis = requireFunctionUncurryThis();
        arraySlice = uncurryThis([].slice);
        return arraySlice;
    }
    var validateArgumentsLength;
    var hasRequiredValidateArgumentsLength;
    function requireValidateArgumentsLength() {
        if (hasRequiredValidateArgumentsLength) return validateArgumentsLength;
        hasRequiredValidateArgumentsLength = 1;
        var $TypeError = TypeError;
        validateArgumentsLength = function(passed, required) {
            if (passed < required) throw new $TypeError('Not enough arguments');
            return passed;
        };
        return validateArgumentsLength;
    }
    var environmentIsIos;
    var hasRequiredEnvironmentIsIos;
    function requireEnvironmentIsIos() {
        if (hasRequiredEnvironmentIsIos) return environmentIsIos;
        hasRequiredEnvironmentIsIos = 1;
        var userAgent = requireEnvironmentUserAgent();
        environmentIsIos = /ipad|iphone|ipod/i.test(userAgent) && /applewebkit/i.test(userAgent);
        return environmentIsIos;
    }
    var task;
    var hasRequiredTask;
    function requireTask() {
        if (hasRequiredTask) return task;
        hasRequiredTask = 1;
        var globalThis1 = requireGlobalThis();
        var apply = requireFunctionApply();
        var bind = requireFunctionBindContext();
        var isCallable = requireIsCallable();
        var hasOwn = requireHasOwnProperty();
        var fails = requireFails();
        var html = requireHtml();
        var arraySlice = requireArraySlice();
        var createElement = requireDocumentCreateElement();
        var validateArgumentsLength = requireValidateArgumentsLength();
        var IS_IOS = requireEnvironmentIsIos();
        var IS_NODE = requireEnvironmentIsNode();
        var set = globalThis1.setImmediate;
        var clear = globalThis1.clearImmediate;
        var process = globalThis1.process;
        var Dispatch = globalThis1.Dispatch;
        var Function1 = globalThis1.Function;
        var MessageChannel = globalThis1.MessageChannel;
        var String1 = globalThis1.String;
        var counter = 0;
        var queue = {};
        var ONREADYSTATECHANGE = 'onreadystatechange';
        var $location, defer, channel, port;
        fails(function() {
            // Deno throws a ReferenceError on `location` access without `--location` flag
            $location = globalThis1.location;
        });
        var run = function(id) {
            if (hasOwn(queue, id)) {
                var fn = queue[id];
                delete queue[id];
                fn();
            }
        };
        var runner = function(id) {
            return function() {
                run(id);
            };
        };
        var eventListener = function(event) {
            run(event.data);
        };
        var globalPostMessageDefer = function(id) {
            // old engines have not location.origin
            globalThis1.postMessage(String1(id), $location.protocol + '//' + $location.host);
        };
        // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
        if (!set || !clear) {
            set = function setImmediate(handler) {
                validateArgumentsLength(arguments.length, 1);
                var fn = isCallable(handler) ? handler : Function1(handler);
                var args = arraySlice(arguments, 1);
                queue[++counter] = function() {
                    apply(fn, undefined, args);
                };
                defer(counter);
                return counter;
            };
            clear = function clearImmediate(id) {
                delete queue[id];
            };
            // Node.js 0.8-
            if (IS_NODE) defer = function(id) {
                process.nextTick(runner(id));
            };
            else if (Dispatch && Dispatch.now) defer = function(id) {
                Dispatch.now(runner(id));
            };
            else if (MessageChannel && !IS_IOS) {
                channel = new MessageChannel();
                port = channel.port2;
                channel.port1.onmessage = eventListener;
                defer = bind(port.postMessage, port);
            // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
            } else if (globalThis1.addEventListener && isCallable(globalThis1.postMessage) && !globalThis1.importScripts && $location && $location.protocol !== 'file:' && !fails(globalPostMessageDefer)) {
                defer = globalPostMessageDefer;
                globalThis1.addEventListener('message', eventListener, false);
            // IE8-
            } else if (ONREADYSTATECHANGE in createElement('script')) defer = function(id) {
                html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function() {
                    html.removeChild(this);
                    run(id);
                };
            };
            else defer = function(id) {
                setTimeout(runner(id), 0);
            };
        }
        task = {
            set: set,
            clear: clear
        };
        return task;
    }
    var safeGetBuiltIn;
    var hasRequiredSafeGetBuiltIn;
    function requireSafeGetBuiltIn() {
        if (hasRequiredSafeGetBuiltIn) return safeGetBuiltIn;
        hasRequiredSafeGetBuiltIn = 1;
        var globalThis1 = requireGlobalThis();
        var DESCRIPTORS = requireDescriptors();
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Avoid NodeJS experimental warning
        safeGetBuiltIn = function(name) {
            if (!DESCRIPTORS) return globalThis1[name];
            var descriptor = getOwnPropertyDescriptor(globalThis1, name);
            return descriptor && descriptor.value;
        };
        return safeGetBuiltIn;
    }
    var queue;
    var hasRequiredQueue;
    function requireQueue() {
        if (hasRequiredQueue) return queue;
        hasRequiredQueue = 1;
        var Queue = function() {
            this.head = null;
            this.tail = null;
        };
        Queue.prototype = {
            add: function(item) {
                var entry = {
                    item: item,
                    next: null
                };
                var tail = this.tail;
                if (tail) tail.next = entry;
                else this.head = entry;
                this.tail = entry;
            },
            get: function() {
                var entry = this.head;
                if (entry) {
                    var next = this.head = entry.next;
                    if (next === null) this.tail = null;
                    return entry.item;
                }
            }
        };
        queue = Queue;
        return queue;
    }
    var environmentIsIosPebble;
    var hasRequiredEnvironmentIsIosPebble;
    function requireEnvironmentIsIosPebble() {
        if (hasRequiredEnvironmentIsIosPebble) return environmentIsIosPebble;
        hasRequiredEnvironmentIsIosPebble = 1;
        var userAgent = requireEnvironmentUserAgent();
        environmentIsIosPebble = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';
        return environmentIsIosPebble;
    }
    var environmentIsWebosWebkit;
    var hasRequiredEnvironmentIsWebosWebkit;
    function requireEnvironmentIsWebosWebkit() {
        if (hasRequiredEnvironmentIsWebosWebkit) return environmentIsWebosWebkit;
        hasRequiredEnvironmentIsWebosWebkit = 1;
        var userAgent = requireEnvironmentUserAgent();
        environmentIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);
        return environmentIsWebosWebkit;
    }
    var microtask_1;
    var hasRequiredMicrotask;
    function requireMicrotask() {
        if (hasRequiredMicrotask) return microtask_1;
        hasRequiredMicrotask = 1;
        var globalThis1 = requireGlobalThis();
        var safeGetBuiltIn = requireSafeGetBuiltIn();
        var bind = requireFunctionBindContext();
        var macrotask = requireTask().set;
        var Queue = requireQueue();
        var IS_IOS = requireEnvironmentIsIos();
        var IS_IOS_PEBBLE = requireEnvironmentIsIosPebble();
        var IS_WEBOS_WEBKIT = requireEnvironmentIsWebosWebkit();
        var IS_NODE = requireEnvironmentIsNode();
        var MutationObserver = globalThis1.MutationObserver || globalThis1.WebKitMutationObserver;
        var document1 = globalThis1.document;
        var process = globalThis1.process;
        var Promise = globalThis1.Promise;
        var microtask = safeGetBuiltIn('queueMicrotask');
        var notify, toggle, node, promise, then;
        // modern engines have queueMicrotask method
        if (!microtask) {
            var queue = new Queue();
            var flush = function() {
                var parent, fn;
                if (IS_NODE && (parent = process.domain)) parent.exit();
                while(fn = queue.get())try {
                    fn();
                } catch (error) {
                    if (queue.head) notify();
                    throw error;
                }
                if (parent) parent.enter();
            };
            // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
            // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
            if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document1) {
                toggle = true;
                node = document1.createTextNode('');
                new MutationObserver(flush).observe(node, {
                    characterData: true
                });
                notify = function() {
                    node.data = toggle = !toggle;
                };
            // environments with maybe non-completely correct, but existent Promise
            } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
                // Promise.resolve without an argument throws an error in LG WebOS 2
                promise = Promise.resolve(undefined);
                // workaround of WebKit ~ iOS Safari 10.1 bug
                promise.constructor = Promise;
                then = bind(promise.then, promise);
                notify = function() {
                    then(flush);
                };
            // Node.js without promises
            } else if (IS_NODE) notify = function() {
                process.nextTick(flush);
            };
            else {
                // `webpack` dev server bug on IE global methods - use bind(fn, global)
                macrotask = bind(macrotask, globalThis1);
                notify = function() {
                    macrotask(flush);
                };
            }
            microtask = function(fn) {
                if (!queue.head) notify();
                queue.add(fn);
            };
        }
        microtask_1 = microtask;
        return microtask_1;
    }
    var hostReportErrors;
    var hasRequiredHostReportErrors;
    function requireHostReportErrors() {
        if (hasRequiredHostReportErrors) return hostReportErrors;
        hasRequiredHostReportErrors = 1;
        hostReportErrors = function(a, b) {
            try {
                // eslint-disable-next-line no-console -- safe
                arguments.length === 1 ? console.error(a) : console.error(a, b);
            } catch (error) {}
        };
        return hostReportErrors;
    }
    var perform;
    var hasRequiredPerform;
    function requirePerform() {
        if (hasRequiredPerform) return perform;
        hasRequiredPerform = 1;
        perform = function(exec) {
            try {
                return {
                    error: false,
                    value: exec()
                };
            } catch (error) {
                return {
                    error: true,
                    value: error
                };
            }
        };
        return perform;
    }
    var promiseNativeConstructor;
    var hasRequiredPromiseNativeConstructor;
    function requirePromiseNativeConstructor() {
        if (hasRequiredPromiseNativeConstructor) return promiseNativeConstructor;
        hasRequiredPromiseNativeConstructor = 1;
        var globalThis1 = requireGlobalThis();
        promiseNativeConstructor = globalThis1.Promise;
        return promiseNativeConstructor;
    }
    var promiseConstructorDetection;
    var hasRequiredPromiseConstructorDetection;
    function requirePromiseConstructorDetection() {
        if (hasRequiredPromiseConstructorDetection) return promiseConstructorDetection;
        hasRequiredPromiseConstructorDetection = 1;
        var globalThis1 = requireGlobalThis();
        var NativePromiseConstructor = requirePromiseNativeConstructor();
        var isCallable = requireIsCallable();
        var isForced = requireIsForced();
        var inspectSource = requireInspectSource();
        var wellKnownSymbol = requireWellKnownSymbol();
        var ENVIRONMENT = requireEnvironment();
        var IS_PURE = requireIsPure();
        var V8_VERSION = requireEnvironmentV8Version();
        var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
        var SPECIES = wellKnownSymbol('species');
        var SUBCLASSING = false;
        var NATIVE_PROMISE_REJECTION_EVENT = isCallable(globalThis1.PromiseRejectionEvent);
        var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function() {
            var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
            var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
            // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
            // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
            // We can't detect it synchronously, so just check versions
            if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
            // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
            if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
            // We can't use @@species feature detection in V8 since it causes
            // deoptimization and performance degradation
            // https://github.com/zloirock/core-js/issues/679
            if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
                // Detect correctness of subclassing with @@species support
                var promise = new NativePromiseConstructor(function(resolve) {
                    resolve(1);
                });
                var FakePromise = function(exec) {
                    exec(function() {}, function() {});
                };
                var constructor = promise.constructor = {};
                constructor[SPECIES] = FakePromise;
                SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
                if (!SUBCLASSING) return true;
            // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
            }
            return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT;
        });
        promiseConstructorDetection = {
            CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
            REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
            SUBCLASSING: SUBCLASSING
        };
        return promiseConstructorDetection;
    }
    var newPromiseCapability = {};
    var hasRequiredNewPromiseCapability;
    function requireNewPromiseCapability() {
        if (hasRequiredNewPromiseCapability) return newPromiseCapability;
        hasRequiredNewPromiseCapability = 1;
        var aCallable = requireACallable();
        var $TypeError = TypeError;
        var PromiseCapability = function(C) {
            var resolve, reject;
            this.promise = new C(function($$resolve, $$reject) {
                if (resolve !== undefined || reject !== undefined) throw new $TypeError('Bad Promise constructor');
                resolve = $$resolve;
                reject = $$reject;
            });
            this.resolve = aCallable(resolve);
            this.reject = aCallable(reject);
        };
        // `NewPromiseCapability` abstract operation
        // https://tc39.es/ecma262/#sec-newpromisecapability
        newPromiseCapability.f = function(C) {
            return new PromiseCapability(C);
        };
        return newPromiseCapability;
    }
    var hasRequiredEs_promise_constructor;
    function requireEs_promise_constructor() {
        if (hasRequiredEs_promise_constructor) return es_promise_constructor;
        hasRequiredEs_promise_constructor = 1;
        var $ = require_export();
        var IS_PURE = requireIsPure();
        var IS_NODE = requireEnvironmentIsNode();
        var globalThis1 = requireGlobalThis();
        var path = requirePath();
        var call = requireFunctionCall();
        var defineBuiltIn = requireDefineBuiltIn();
        var setPrototypeOf = requireObjectSetPrototypeOf();
        var setToStringTag = requireSetToStringTag();
        var setSpecies = requireSetSpecies();
        var aCallable = requireACallable();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var anInstance = requireAnInstance();
        var speciesConstructor = requireSpeciesConstructor();
        var task = requireTask().set;
        var microtask = requireMicrotask();
        var hostReportErrors = requireHostReportErrors();
        var perform = requirePerform();
        var Queue = requireQueue();
        var InternalStateModule = requireInternalState();
        var NativePromiseConstructor = requirePromiseNativeConstructor();
        var PromiseConstructorDetection = requirePromiseConstructorDetection();
        var newPromiseCapabilityModule = requireNewPromiseCapability();
        var PROMISE = 'Promise';
        var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
        var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
        var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
        var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
        var setInternalState = InternalStateModule.set;
        var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
        var PromiseConstructor = NativePromiseConstructor;
        var PromisePrototype = NativePromisePrototype;
        var TypeError1 = globalThis1.TypeError;
        var document1 = globalThis1.document;
        var process = globalThis1.process;
        var newPromiseCapability = newPromiseCapabilityModule.f;
        var newGenericPromiseCapability = newPromiseCapability;
        var DISPATCH_EVENT = !!(document1 && document1.createEvent && globalThis1.dispatchEvent);
        var UNHANDLED_REJECTION = 'unhandledrejection';
        var REJECTION_HANDLED = 'rejectionhandled';
        var PENDING = 0;
        var FULFILLED = 1;
        var REJECTED = 2;
        var HANDLED = 1;
        var UNHANDLED = 2;
        var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;
        // helpers
        var isThenable = function(it) {
            var then;
            return isObject(it) && isCallable(then = it.then) ? then : false;
        };
        var callReaction = function(reaction, state) {
            var value = state.value;
            var ok = state.state === FULFILLED;
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
                        state.rejection = HANDLED;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // can throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject(new TypeError1('Promise-chain cycle'));
                    else if (then = isThenable(result)) call(then, result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (error) {
                if (domain && !exited) domain.exit();
                reject(error);
            }
        };
        var notify = function(state, isReject) {
            if (state.notified) return;
            state.notified = true;
            microtask(function() {
                var reactions = state.reactions;
                var reaction;
                while(reaction = reactions.get())callReaction(reaction, state);
                state.notified = false;
                if (isReject && !state.rejection) onUnhandled(state);
            });
        };
        var dispatchEvent = function(name, promise, reason) {
            var event, handler;
            if (DISPATCH_EVENT) {
                event = document1.createEvent('Event');
                event.promise = promise;
                event.reason = reason;
                event.initEvent(name, false, true);
                globalThis1.dispatchEvent(event);
            } else event = {
                promise: promise,
                reason: reason
            };
            if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis1['on' + name])) handler(event);
            else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
        };
        var onUnhandled = function(state) {
            call(task, globalThis1, function() {
                var promise = state.facade;
                var value = state.value;
                var IS_UNHANDLED = isUnhandled(state);
                var result;
                if (IS_UNHANDLED) {
                    result = perform(function() {
                        if (IS_NODE) process.emit('unhandledRejection', value, promise);
                        else dispatchEvent(UNHANDLED_REJECTION, promise, value);
                    });
                    // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                    state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
                    if (result.error) throw result.value;
                }
            });
        };
        var isUnhandled = function(state) {
            return state.rejection !== HANDLED && !state.parent;
        };
        var onHandleUnhandled = function(state) {
            call(task, globalThis1, function() {
                var promise = state.facade;
                if (IS_NODE) process.emit('rejectionHandled', promise);
                else dispatchEvent(REJECTION_HANDLED, promise, state.value);
            });
        };
        var bind = function(fn, state, unwrap) {
            return function(value) {
                fn(state, value, unwrap);
            };
        };
        var internalReject = function(state, value, unwrap) {
            if (state.done) return;
            state.done = true;
            if (unwrap) state = unwrap;
            state.value = value;
            state.state = REJECTED;
            notify(state, true);
        };
        var internalResolve = function(state, value, unwrap) {
            if (state.done) return;
            state.done = true;
            if (unwrap) state = unwrap;
            try {
                if (state.facade === value) throw new TypeError1("Promise can't be resolved itself");
                var then = isThenable(value);
                if (then) microtask(function() {
                    var wrapper = {
                        done: false
                    };
                    try {
                        call(then, value, bind(internalResolve, wrapper, state), bind(internalReject, wrapper, state));
                    } catch (error) {
                        internalReject(wrapper, error, state);
                    }
                });
                else {
                    state.value = value;
                    state.state = FULFILLED;
                    notify(state, false);
                }
            } catch (error) {
                internalReject({
                    done: false
                }, error, state);
            }
        };
        // constructor polyfill
        if (FORCED_PROMISE_CONSTRUCTOR) {
            // 25.4.3.1 Promise(executor)
            PromiseConstructor = function Promise(executor) {
                anInstance(this, PromisePrototype);
                aCallable(executor);
                call(Internal, this);
                var state = getInternalPromiseState(this);
                try {
                    executor(bind(internalResolve, state), bind(internalReject, state));
                } catch (error) {
                    internalReject(state, error);
                }
            };
            PromisePrototype = PromiseConstructor.prototype;
            // eslint-disable-next-line no-unused-vars -- required for `.length`
            Internal = function Promise(executor) {
                setInternalState(this, {
                    type: PROMISE,
                    done: false,
                    notified: false,
                    parent: false,
                    reactions: new Queue(),
                    rejection: false,
                    state: PENDING,
                    value: null
                });
            };
            // `Promise.prototype.then` method
            // https://tc39.es/ecma262/#sec-promise.prototype.then
            Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
                var state = getInternalPromiseState(this);
                var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
                state.parent = true;
                reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
                reaction.fail = isCallable(onRejected) && onRejected;
                reaction.domain = IS_NODE ? process.domain : undefined;
                if (state.state === PENDING) state.reactions.add(reaction);
                else microtask(function() {
                    callReaction(reaction, state);
                });
                return reaction.promise;
            });
            OwnPromiseCapability = function() {
                var promise = new Internal();
                var state = getInternalPromiseState(promise);
                this.promise = promise;
                this.resolve = bind(internalResolve, state);
                this.reject = bind(internalReject, state);
            };
            newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
                return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
            };
            if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
                nativeThen = NativePromisePrototype.then;
                if (!NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
                defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
                    var that = this;
                    return new PromiseConstructor(function(resolve, reject) {
                        call(nativeThen, that, resolve, reject);
                    }).then(onFulfilled, onRejected);
                // https://github.com/zloirock/core-js/issues/640
                }, {
                    unsafe: true
                });
                // make `.constructor === Promise` work for native promise-based APIs
                try {
                    delete NativePromisePrototype.constructor;
                } catch (error) {}
                // make `instanceof Promise` work for native promise-based APIs
                if (setPrototypeOf) setPrototypeOf(NativePromisePrototype, PromisePrototype);
            }
        }
        // `Promise` constructor
        // https://tc39.es/ecma262/#sec-promise-executor
        $({
            global: true,
            constructor: true,
            wrap: true,
            forced: FORCED_PROMISE_CONSTRUCTOR
        }, {
            Promise: PromiseConstructor
        });
        PromiseWrapper = path.Promise;
        setToStringTag(PromiseConstructor, PROMISE, false, true);
        setSpecies(PROMISE);
        return es_promise_constructor;
    }
    var es_promise_all = {};
    var iterators;
    var hasRequiredIterators;
    function requireIterators() {
        if (hasRequiredIterators) return iterators;
        hasRequiredIterators = 1;
        iterators = {};
        return iterators;
    }
    var isArrayIteratorMethod;
    var hasRequiredIsArrayIteratorMethod;
    function requireIsArrayIteratorMethod() {
        if (hasRequiredIsArrayIteratorMethod) return isArrayIteratorMethod;
        hasRequiredIsArrayIteratorMethod = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var Iterators = requireIterators();
        var ITERATOR = wellKnownSymbol('iterator');
        var ArrayPrototype = Array.prototype;
        // check on default Array iterator
        isArrayIteratorMethod = function(it) {
            return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
        };
        return isArrayIteratorMethod;
    }
    var getIteratorMethod;
    var hasRequiredGetIteratorMethod;
    function requireGetIteratorMethod() {
        if (hasRequiredGetIteratorMethod) return getIteratorMethod;
        hasRequiredGetIteratorMethod = 1;
        var classof = requireClassof();
        var getMethod = requireGetMethod();
        var isNullOrUndefined = requireIsNullOrUndefined();
        var Iterators = requireIterators();
        var wellKnownSymbol = requireWellKnownSymbol();
        var ITERATOR = wellKnownSymbol('iterator');
        getIteratorMethod = function(it) {
            if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
        };
        return getIteratorMethod;
    }
    var getIterator;
    var hasRequiredGetIterator;
    function requireGetIterator() {
        if (hasRequiredGetIterator) return getIterator;
        hasRequiredGetIterator = 1;
        var call = requireFunctionCall();
        var aCallable = requireACallable();
        var anObject = requireAnObject();
        var tryToString = requireTryToString();
        var getIteratorMethod = requireGetIteratorMethod();
        var $TypeError = TypeError;
        getIterator = function(argument, usingIterator) {
            var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
            if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
            throw new $TypeError(tryToString(argument) + ' is not iterable');
        };
        return getIterator;
    }
    var iteratorClose;
    var hasRequiredIteratorClose;
    function requireIteratorClose() {
        if (hasRequiredIteratorClose) return iteratorClose;
        hasRequiredIteratorClose = 1;
        var call = requireFunctionCall();
        var anObject = requireAnObject();
        var getMethod = requireGetMethod();
        iteratorClose = function(iterator, kind, value) {
            var innerResult, innerError;
            anObject(iterator);
            try {
                innerResult = getMethod(iterator, 'return');
                if (!innerResult) {
                    if (kind === 'throw') throw value;
                    return value;
                }
                innerResult = call(innerResult, iterator);
            } catch (error) {
                innerError = true;
                innerResult = error;
            }
            if (kind === 'throw') throw value;
            if (innerError) throw innerResult;
            anObject(innerResult);
            return value;
        };
        return iteratorClose;
    }
    var iterate;
    var hasRequiredIterate;
    function requireIterate() {
        if (hasRequiredIterate) return iterate;
        hasRequiredIterate = 1;
        var bind = requireFunctionBindContext();
        var call = requireFunctionCall();
        var anObject = requireAnObject();
        var tryToString = requireTryToString();
        var isArrayIteratorMethod = requireIsArrayIteratorMethod();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var getIterator = requireGetIterator();
        var getIteratorMethod = requireGetIteratorMethod();
        var iteratorClose = requireIteratorClose();
        var $TypeError = TypeError;
        var Result = function(stopped, result) {
            this.stopped = stopped;
            this.result = result;
        };
        var ResultPrototype = Result.prototype;
        iterate = function(iterable, unboundFunction, options) {
            var that = options && options.that;
            var AS_ENTRIES = !!(options && options.AS_ENTRIES);
            var IS_RECORD = !!(options && options.IS_RECORD);
            var IS_ITERATOR = !!(options && options.IS_ITERATOR);
            var INTERRUPTED = !!(options && options.INTERRUPTED);
            var fn = bind(unboundFunction, that);
            var iterator, iterFn, index, length, result, next, step;
            var stop = function(condition) {
                var $iterator = iterator;
                iterator = undefined;
                if ($iterator) iteratorClose($iterator, 'normal');
                return new Result(true, condition);
            };
            var callFn = function(value) {
                if (AS_ENTRIES) {
                    anObject(value);
                    return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
                }
                return INTERRUPTED ? fn(value, stop) : fn(value);
            };
            if (IS_RECORD) iterator = iterable.iterator;
            else if (IS_ITERATOR) iterator = iterable;
            else {
                iterFn = getIteratorMethod(iterable);
                if (!iterFn) throw new $TypeError(tryToString(iterable) + ' is not iterable');
                // optimisation for array iterators
                if (isArrayIteratorMethod(iterFn)) {
                    for(index = 0, length = lengthOfArrayLike(iterable); length > index; index++){
                        result = callFn(iterable[index]);
                        if (result && isPrototypeOf(ResultPrototype, result)) return result;
                    }
                    return new Result(false);
                }
                iterator = getIterator(iterable, iterFn);
            }
            next = IS_RECORD ? iterable.next : iterator.next;
            while(!(step = call(next, iterator)).done){
                // `IteratorValue` errors should propagate without closing the iterator
                var value = step.value;
                try {
                    result = callFn(value);
                } catch (error) {
                    if (iterator) iteratorClose(iterator, 'throw', error);
                    else throw error;
                }
                if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
            }
            return new Result(false);
        };
        return iterate;
    }
    var checkCorrectnessOfIteration;
    var hasRequiredCheckCorrectnessOfIteration;
    function requireCheckCorrectnessOfIteration() {
        if (hasRequiredCheckCorrectnessOfIteration) return checkCorrectnessOfIteration;
        hasRequiredCheckCorrectnessOfIteration = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var ITERATOR = wellKnownSymbol('iterator');
        var SAFE_CLOSING = false;
        try {
            var called = 0;
            var iteratorWithReturn = {
                next: function() {
                    return {
                        done: !!called++
                    };
                },
                'return': function() {
                    SAFE_CLOSING = true;
                }
            };
            // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
            iteratorWithReturn[ITERATOR] = function() {
                return this;
            };
            // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
            Array.from(iteratorWithReturn, function() {
                throw 2;
            });
        } catch (error) {}
        checkCorrectnessOfIteration = function(exec, SKIP_CLOSING) {
            try {
                if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
            } catch (error) {
                return false;
            } // workaround of old WebKit + `eval` bug
            var ITERATION_SUPPORT = false;
            try {
                var object = {};
                // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                object[ITERATOR] = function() {
                    return {
                        next: function() {
                            return {
                                done: ITERATION_SUPPORT = true
                            };
                        }
                    };
                };
                exec(object);
            } catch (error) {}
            return ITERATION_SUPPORT;
        };
        return checkCorrectnessOfIteration;
    }
    var promiseStaticsIncorrectIteration;
    var hasRequiredPromiseStaticsIncorrectIteration;
    function requirePromiseStaticsIncorrectIteration() {
        if (hasRequiredPromiseStaticsIncorrectIteration) return promiseStaticsIncorrectIteration;
        hasRequiredPromiseStaticsIncorrectIteration = 1;
        var NativePromiseConstructor = requirePromiseNativeConstructor();
        var checkCorrectnessOfIteration = requireCheckCorrectnessOfIteration();
        var FORCED_PROMISE_CONSTRUCTOR = requirePromiseConstructorDetection().CONSTRUCTOR;
        promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function(iterable) {
            NativePromiseConstructor.all(iterable).then(undefined, function() {});
        });
        return promiseStaticsIncorrectIteration;
    }
    var hasRequiredEs_promise_all;
    function requireEs_promise_all() {
        if (hasRequiredEs_promise_all) return es_promise_all;
        hasRequiredEs_promise_all = 1;
        var $ = require_export();
        var call = requireFunctionCall();
        var aCallable = requireACallable();
        var newPromiseCapabilityModule = requireNewPromiseCapability();
        var perform = requirePerform();
        var iterate = requireIterate();
        var PROMISE_STATICS_INCORRECT_ITERATION = requirePromiseStaticsIncorrectIteration();
        // `Promise.all` method
        // https://tc39.es/ecma262/#sec-promise.all
        $({
            target: 'Promise',
            stat: true,
            forced: PROMISE_STATICS_INCORRECT_ITERATION
        }, {
            all: function all(iterable) {
                var C = this;
                var capability = newPromiseCapabilityModule.f(C);
                var resolve = capability.resolve;
                var reject = capability.reject;
                var result = perform(function() {
                    var $promiseResolve = aCallable(C.resolve);
                    var values = [];
                    var counter = 0;
                    var remaining = 1;
                    iterate(iterable, function(promise) {
                        var index = counter++;
                        var alreadyCalled = false;
                        remaining++;
                        call($promiseResolve, C, promise).then(function(value) {
                            if (alreadyCalled) return;
                            alreadyCalled = true;
                            values[index] = value;
                            --remaining || resolve(values);
                        }, reject);
                    });
                    --remaining || resolve(values);
                });
                if (result.error) reject(result.value);
                return capability.promise;
            }
        });
        return es_promise_all;
    }
    var es_promise_catch = {};
    var hasRequiredEs_promise_catch;
    function requireEs_promise_catch() {
        if (hasRequiredEs_promise_catch) return es_promise_catch;
        hasRequiredEs_promise_catch = 1;
        var $ = require_export();
        var IS_PURE = requireIsPure();
        var FORCED_PROMISE_CONSTRUCTOR = requirePromiseConstructorDetection().CONSTRUCTOR;
        var NativePromiseConstructor = requirePromiseNativeConstructor();
        var getBuiltIn = requireGetBuiltIn();
        var isCallable = requireIsCallable();
        var defineBuiltIn = requireDefineBuiltIn();
        var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
        // `Promise.prototype.catch` method
        // https://tc39.es/ecma262/#sec-promise.prototype.catch
        $({
            target: 'Promise',
            proto: true,
            forced: FORCED_PROMISE_CONSTRUCTOR,
            real: true
        }, {
            'catch': function(onRejected) {
                return this.then(undefined, onRejected);
            }
        });
        // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
        if (!IS_PURE && isCallable(NativePromiseConstructor)) {
            var method = getBuiltIn('Promise').prototype['catch'];
            if (NativePromisePrototype['catch'] !== method) defineBuiltIn(NativePromisePrototype, 'catch', method, {
                unsafe: true
            });
        }
        return es_promise_catch;
    }
    var es_promise_race = {};
    var hasRequiredEs_promise_race;
    function requireEs_promise_race() {
        if (hasRequiredEs_promise_race) return es_promise_race;
        hasRequiredEs_promise_race = 1;
        var $ = require_export();
        var call = requireFunctionCall();
        var aCallable = requireACallable();
        var newPromiseCapabilityModule = requireNewPromiseCapability();
        var perform = requirePerform();
        var iterate = requireIterate();
        var PROMISE_STATICS_INCORRECT_ITERATION = requirePromiseStaticsIncorrectIteration();
        // `Promise.race` method
        // https://tc39.es/ecma262/#sec-promise.race
        $({
            target: 'Promise',
            stat: true,
            forced: PROMISE_STATICS_INCORRECT_ITERATION
        }, {
            race: function race(iterable) {
                var C = this;
                var capability = newPromiseCapabilityModule.f(C);
                var reject = capability.reject;
                var result = perform(function() {
                    var $promiseResolve = aCallable(C.resolve);
                    iterate(iterable, function(promise) {
                        call($promiseResolve, C, promise).then(capability.resolve, reject);
                    });
                });
                if (result.error) reject(result.value);
                return capability.promise;
            }
        });
        return es_promise_race;
    }
    var es_promise_reject = {};
    var hasRequiredEs_promise_reject;
    function requireEs_promise_reject() {
        if (hasRequiredEs_promise_reject) return es_promise_reject;
        hasRequiredEs_promise_reject = 1;
        var $ = require_export();
        var newPromiseCapabilityModule = requireNewPromiseCapability();
        var FORCED_PROMISE_CONSTRUCTOR = requirePromiseConstructorDetection().CONSTRUCTOR;
        // `Promise.reject` method
        // https://tc39.es/ecma262/#sec-promise.reject
        $({
            target: 'Promise',
            stat: true,
            forced: FORCED_PROMISE_CONSTRUCTOR
        }, {
            reject: function reject(r) {
                var capability = newPromiseCapabilityModule.f(this);
                var capabilityReject = capability.reject;
                capabilityReject(r);
                return capability.promise;
            }
        });
        return es_promise_reject;
    }
    var es_promise_resolve = {};
    var promiseResolve;
    var hasRequiredPromiseResolve;
    function requirePromiseResolve() {
        if (hasRequiredPromiseResolve) return promiseResolve;
        hasRequiredPromiseResolve = 1;
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var newPromiseCapability = requireNewPromiseCapability();
        promiseResolve = function(C, x) {
            anObject(C);
            if (isObject(x) && x.constructor === C) return x;
            var promiseCapability = newPromiseCapability.f(C);
            var resolve = promiseCapability.resolve;
            resolve(x);
            return promiseCapability.promise;
        };
        return promiseResolve;
    }
    var hasRequiredEs_promise_resolve;
    function requireEs_promise_resolve() {
        if (hasRequiredEs_promise_resolve) return es_promise_resolve;
        hasRequiredEs_promise_resolve = 1;
        var $ = require_export();
        var getBuiltIn = requireGetBuiltIn();
        var IS_PURE = requireIsPure();
        var NativePromiseConstructor = requirePromiseNativeConstructor();
        var FORCED_PROMISE_CONSTRUCTOR = requirePromiseConstructorDetection().CONSTRUCTOR;
        var promiseResolve = requirePromiseResolve();
        var PromiseConstructorWrapper = getBuiltIn('Promise');
        var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;
        // `Promise.resolve` method
        // https://tc39.es/ecma262/#sec-promise.resolve
        $({
            target: 'Promise',
            stat: true,
            forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR
        }, {
            resolve: function resolve(x) {
                return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
            }
        });
        return es_promise_resolve;
    }
    var hasRequiredEs_promise;
    function requireEs_promise() {
        if (hasRequiredEs_promise) return es_promise;
        hasRequiredEs_promise = 1;
        // TODO: Remove this module from `core-js [at] 4` since it's split to modules listed below
        requireEs_promise_constructor();
        requireEs_promise_all();
        requireEs_promise_catch();
        requireEs_promise_race();
        requireEs_promise_reject();
        requireEs_promise_resolve();
        return es_promise;
    }
    requireEs_promise();
    var es_regexp_exec = {};
    var toString;
    var hasRequiredToString;
    function requireToString() {
        if (hasRequiredToString) return toString;
        hasRequiredToString = 1;
        var classof = requireClassof();
        var $String = String;
        toString = function(argument) {
            if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
            return $String(argument);
        };
        return toString;
    }
    var regexpFlags;
    var hasRequiredRegexpFlags;
    function requireRegexpFlags() {
        if (hasRequiredRegexpFlags) return regexpFlags;
        hasRequiredRegexpFlags = 1;
        var anObject = requireAnObject();
        // `RegExp.prototype.flags` getter implementation
        // https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
        regexpFlags = function() {
            var that = anObject(this);
            var result = '';
            if (that.hasIndices) result += 'd';
            if (that.global) result += 'g';
            if (that.ignoreCase) result += 'i';
            if (that.multiline) result += 'm';
            if (that.dotAll) result += 's';
            if (that.unicode) result += 'u';
            if (that.unicodeSets) result += 'v';
            if (that.sticky) result += 'y';
            return result;
        };
        return regexpFlags;
    }
    var regexpStickyHelpers;
    var hasRequiredRegexpStickyHelpers;
    function requireRegexpStickyHelpers() {
        if (hasRequiredRegexpStickyHelpers) return regexpStickyHelpers;
        hasRequiredRegexpStickyHelpers = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        var UNSUPPORTED_Y = fails(function() {
            var re = $RegExp('a', 'y');
            re.lastIndex = 2;
            return re.exec('abcd') !== null;
        });
        // UC Browser bug
        // https://github.com/zloirock/core-js/issues/1008
        var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
            return !$RegExp('a', 'y').sticky;
        });
        var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
            var re = $RegExp('^r', 'gy');
            re.lastIndex = 2;
            return re.exec('str') !== null;
        });
        regexpStickyHelpers = {
            BROKEN_CARET: BROKEN_CARET,
            MISSED_STICKY: MISSED_STICKY,
            UNSUPPORTED_Y: UNSUPPORTED_Y
        };
        return regexpStickyHelpers;
    }
    var regexpUnsupportedDotAll;
    var hasRequiredRegexpUnsupportedDotAll;
    function requireRegexpUnsupportedDotAll() {
        if (hasRequiredRegexpUnsupportedDotAll) return regexpUnsupportedDotAll;
        hasRequiredRegexpUnsupportedDotAll = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        regexpUnsupportedDotAll = fails(function() {
            var re = $RegExp('.', 's');
            return !(re.dotAll && re.test('\n') && re.flags === 's');
        });
        return regexpUnsupportedDotAll;
    }
    var regexpUnsupportedNcg;
    var hasRequiredRegexpUnsupportedNcg;
    function requireRegexpUnsupportedNcg() {
        if (hasRequiredRegexpUnsupportedNcg) return regexpUnsupportedNcg;
        hasRequiredRegexpUnsupportedNcg = 1;
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        // babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
        var $RegExp = globalThis1.RegExp;
        regexpUnsupportedNcg = fails(function() {
            var re = $RegExp('(?<a>b)', 'g');
            return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
        });
        return regexpUnsupportedNcg;
    }
    var regexpExec;
    var hasRequiredRegexpExec;
    function requireRegexpExec() {
        if (hasRequiredRegexpExec) return regexpExec;
        hasRequiredRegexpExec = 1;
        /* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var toString = requireToString();
        var regexpFlags = requireRegexpFlags();
        var stickyHelpers = requireRegexpStickyHelpers();
        var shared = requireShared();
        var create = requireObjectCreate();
        var getInternalState = requireInternalState().get;
        var UNSUPPORTED_DOT_ALL = requireRegexpUnsupportedDotAll();
        var UNSUPPORTED_NCG = requireRegexpUnsupportedNcg();
        var nativeReplace = shared('native-string-replace', String.prototype.replace);
        var nativeExec = RegExp.prototype.exec;
        var patchedExec = nativeExec;
        var charAt = uncurryThis(''.charAt);
        var indexOf = uncurryThis(''.indexOf);
        var replace = uncurryThis(''.replace);
        var stringSlice = uncurryThis(''.slice);
        var UPDATES_LAST_INDEX_WRONG = function() {
            var re1 = /a/;
            var re2 = /b*/g;
            call(nativeExec, re1, 'a');
            call(nativeExec, re2, 'a');
            return re1.lastIndex !== 0 || re2.lastIndex !== 0;
        }();
        var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;
        // nonparticipating capturing group, copied from es5-shim's String#split patch.
        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;
        var setGroups = function(re, groups) {
            var object = re.groups = create(null);
            for(var i = 0; i < groups.length; i++){
                var group = groups[i];
                object[group[0]] = re[group[1]];
            }
        };
        if (PATCH) patchedExec = function exec(string) {
            var re = this;
            var state = getInternalState(re);
            var str = toString(string);
            var raw = state.raw;
            var result, reCopy, lastIndex;
            if (raw) {
                raw.lastIndex = re.lastIndex;
                result = call(patchedExec, raw, str);
                re.lastIndex = raw.lastIndex;
                if (result && state.groups) setGroups(result, state.groups);
                return result;
            }
            var groups = state.groups;
            var sticky = UNSUPPORTED_Y && re.sticky;
            var flags = call(regexpFlags, re);
            var source = re.source;
            var charsAdded = 0;
            var strCopy = str;
            if (sticky) {
                flags = replace(flags, 'y', '');
                if (indexOf(flags, 'g') === -1) flags += 'g';
                strCopy = stringSlice(str, re.lastIndex);
                // Support anchored sticky behavior.
                var prevChar = re.lastIndex > 0 && charAt(str, re.lastIndex - 1);
                if (re.lastIndex > 0 && (!re.multiline || re.multiline && prevChar !== '\n' && prevChar !== '\r' && prevChar !== '\u2028' && prevChar !== '\u2029')) {
                    source = '(?: (?:' + source + '))';
                    strCopy = ' ' + strCopy;
                    charsAdded++;
                }
                // ^(? + rx + ) is needed, in combination with some str slicing, to
                // simulate the 'y' flag.
                reCopy = new RegExp('^(?:' + source + ')', flags);
            }
            if (NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
            var match = call(nativeExec, sticky ? reCopy : re, strCopy);
            if (sticky) {
                if (match) {
                    match.input = str;
                    match[0] = stringSlice(match[0], charsAdded);
                    match.index = re.lastIndex;
                    re.lastIndex += match[0].length;
                } else re.lastIndex = 0;
            } else if (UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
            if (NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
            // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
            call(nativeReplace, match[0], reCopy, function() {
                for(var i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
            });
            if (match && groups) setGroups(match, groups);
            return match;
        };
        regexpExec = patchedExec;
        return regexpExec;
    }
    var hasRequiredEs_regexp_exec;
    function requireEs_regexp_exec() {
        if (hasRequiredEs_regexp_exec) return es_regexp_exec;
        hasRequiredEs_regexp_exec = 1;
        var $ = require_export();
        var exec = requireRegexpExec();
        // `RegExp.prototype.exec` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.exec
        $({
            target: 'RegExp',
            proto: true,
            forced: /./.exec !== exec
        }, {
            exec: exec
        });
        return es_regexp_exec;
    }
    requireEs_regexp_exec();
    var es_regexp_toString = {};
    var regexpFlagsDetection;
    var hasRequiredRegexpFlagsDetection;
    function requireRegexpFlagsDetection() {
        if (hasRequiredRegexpFlagsDetection) return regexpFlagsDetection;
        hasRequiredRegexpFlagsDetection = 1;
        var globalThis1 = requireGlobalThis();
        var fails = requireFails();
        // babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
        var RegExp1 = globalThis1.RegExp;
        var FLAGS_GETTER_IS_CORRECT = !fails(function() {
            var INDICES_SUPPORT = true;
            try {
                RegExp1('.', 'd');
            } catch (error) {
                INDICES_SUPPORT = false;
            }
            var O = {};
            // modern V8 bug
            var calls = '';
            var expected = INDICES_SUPPORT ? 'dgimsy' : 'gimsy';
            var addGetter = function(key, chr) {
                // eslint-disable-next-line es/no-object-defineproperty -- safe
                Object.defineProperty(O, key, {
                    get: function() {
                        calls += chr;
                        return true;
                    }
                });
            };
            var pairs = {
                dotAll: 's',
                global: 'g',
                ignoreCase: 'i',
                multiline: 'm',
                sticky: 'y'
            };
            if (INDICES_SUPPORT) pairs.hasIndices = 'd';
            for(var key in pairs)addGetter(key, pairs[key]);
            // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
            var result = Object.getOwnPropertyDescriptor(RegExp1.prototype, 'flags').get.call(O);
            return result !== expected || calls !== expected;
        });
        regexpFlagsDetection = {
            correct: FLAGS_GETTER_IS_CORRECT
        };
        return regexpFlagsDetection;
    }
    var regexpGetFlags;
    var hasRequiredRegexpGetFlags;
    function requireRegexpGetFlags() {
        if (hasRequiredRegexpGetFlags) return regexpGetFlags;
        hasRequiredRegexpGetFlags = 1;
        var call = requireFunctionCall();
        var hasOwn = requireHasOwnProperty();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var regExpFlagsDetection = requireRegexpFlagsDetection();
        var regExpFlagsGetterImplementation = requireRegexpFlags();
        var RegExpPrototype = RegExp.prototype;
        regexpGetFlags = regExpFlagsDetection.correct ? function(it) {
            return it.flags;
        } : function(it) {
            return !regExpFlagsDetection.correct && isPrototypeOf(RegExpPrototype, it) && !hasOwn(it, 'flags') ? call(regExpFlagsGetterImplementation, it) : it.flags;
        };
        return regexpGetFlags;
    }
    var hasRequiredEs_regexp_toString;
    function requireEs_regexp_toString() {
        if (hasRequiredEs_regexp_toString) return es_regexp_toString;
        hasRequiredEs_regexp_toString = 1;
        var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
        var defineBuiltIn = requireDefineBuiltIn();
        var anObject = requireAnObject();
        var $toString = requireToString();
        var fails = requireFails();
        var getRegExpFlags = requireRegexpGetFlags();
        var TO_STRING = 'toString';
        var RegExpPrototype = RegExp.prototype;
        var nativeToString = RegExpPrototype[TO_STRING];
        var NOT_GENERIC = fails(function() {
            return nativeToString.call({
                source: 'a',
                flags: 'b'
            }) !== '/a/b';
        });
        // FF44- RegExp#toString has a wrong name
        var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;
        // `RegExp.prototype.toString` method
        // https://tc39.es/ecma262/#sec-regexp.prototype.tostring
        if (NOT_GENERIC || INCORRECT_NAME) defineBuiltIn(RegExpPrototype, TO_STRING, function toString() {
            var R = anObject(this);
            var pattern = $toString(R.source);
            var flags = $toString(getRegExpFlags(R));
            return '/' + pattern + '/' + flags;
        }, {
            unsafe: true
        });
        return es_regexp_toString;
    }
    requireEs_regexp_toString();
    var es_string_includes = {};
    var isRegexp;
    var hasRequiredIsRegexp;
    function requireIsRegexp() {
        if (hasRequiredIsRegexp) return isRegexp;
        hasRequiredIsRegexp = 1;
        var isObject = requireIsObject();
        var classof = requireClassofRaw();
        var wellKnownSymbol = requireWellKnownSymbol();
        var MATCH = wellKnownSymbol('match');
        // `IsRegExp` abstract operation
        // https://tc39.es/ecma262/#sec-isregexp
        isRegexp = function(it) {
            var isRegExp;
            return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
        };
        return isRegexp;
    }
    var notARegexp;
    var hasRequiredNotARegexp;
    function requireNotARegexp() {
        if (hasRequiredNotARegexp) return notARegexp;
        hasRequiredNotARegexp = 1;
        var isRegExp = requireIsRegexp();
        var $TypeError = TypeError;
        notARegexp = function(it) {
            if (isRegExp(it)) throw new $TypeError("The method doesn't accept regular expressions");
            return it;
        };
        return notARegexp;
    }
    var correctIsRegexpLogic;
    var hasRequiredCorrectIsRegexpLogic;
    function requireCorrectIsRegexpLogic() {
        if (hasRequiredCorrectIsRegexpLogic) return correctIsRegexpLogic;
        hasRequiredCorrectIsRegexpLogic = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var MATCH = wellKnownSymbol('match');
        correctIsRegexpLogic = function(METHOD_NAME) {
            var regexp = /./;
            try {
                '/./'[METHOD_NAME](regexp);
            } catch (error1) {
                try {
                    regexp[MATCH] = false;
                    return '/./'[METHOD_NAME](regexp);
                } catch (error2) {}
            }
            return false;
        };
        return correctIsRegexpLogic;
    }
    var hasRequiredEs_string_includes;
    function requireEs_string_includes() {
        if (hasRequiredEs_string_includes) return es_string_includes;
        hasRequiredEs_string_includes = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThis();
        var notARegExp = requireNotARegexp();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var toString = requireToString();
        var correctIsRegExpLogic = requireCorrectIsRegexpLogic();
        var stringIndexOf = uncurryThis(''.indexOf);
        // `String.prototype.includes` method
        // https://tc39.es/ecma262/#sec-string.prototype.includes
        $({
            target: 'String',
            proto: true,
            forced: !correctIsRegExpLogic('includes')
        }, {
            includes: function includes(searchString /* , position = 0 */ ) {
                return !!~stringIndexOf(toString(requireObjectCoercible(this)), toString(notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        return es_string_includes;
    }
    requireEs_string_includes();
    var es_string_split = {};
    var fixRegexpWellKnownSymbolLogic;
    var hasRequiredFixRegexpWellKnownSymbolLogic;
    function requireFixRegexpWellKnownSymbolLogic() {
        if (hasRequiredFixRegexpWellKnownSymbolLogic) return fixRegexpWellKnownSymbolLogic;
        hasRequiredFixRegexpWellKnownSymbolLogic = 1;
        // TODO: Remove from `core-js [at] 4` since it's moved to entry points
        requireEs_regexp_exec();
        var call = requireFunctionCall();
        var defineBuiltIn = requireDefineBuiltIn();
        var regexpExec = requireRegexpExec();
        var fails = requireFails();
        var wellKnownSymbol = requireWellKnownSymbol();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var SPECIES = wellKnownSymbol('species');
        var RegExpPrototype = RegExp.prototype;
        fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
            var SYMBOL = wellKnownSymbol(KEY);
            var DELEGATES_TO_SYMBOL = !fails(function() {
                // String methods call symbol-named RegExp methods
                var O = {};
                // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                O[SYMBOL] = function() {
                    return 7;
                };
                return ''[KEY](O) !== 7;
            });
            var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function() {
                // Symbol-named RegExp methods call .exec
                var execCalled = false;
                var re = /a/;
                if (KEY === 'split') {
                    // We can't use real regex here since it causes deoptimization
                    // and serious performance degradation in V8
                    // https://github.com/zloirock/core-js/issues/306
                    // RegExp[@@split] doesn't call the regex's exec method, but first creates
                    // a new one. We need to return the patched regex when creating the new one.
                    var constructor = {};
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    constructor[SPECIES] = function() {
                        return re;
                    };
                    re = {
                        constructor: constructor,
                        flags: ''
                    };
                    // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
                    re[SYMBOL] = /./[SYMBOL];
                }
                re.exec = function() {
                    execCalled = true;
                    return null;
                };
                re[SYMBOL]('');
                return !execCalled;
            });
            if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
                var nativeRegExpMethod = /./[SYMBOL];
                var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
                    var $exec = regexp.exec;
                    if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
                        if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                        // polyfilled function), leasing to infinite recursion.
                        // We avoid it by directly calling the native @@method method.
                        return {
                            done: true,
                            value: call(nativeRegExpMethod, regexp, str, arg2)
                        };
                        return {
                            done: true,
                            value: call(nativeMethod, str, regexp, arg2)
                        };
                    }
                    return {
                        done: false
                    };
                });
                defineBuiltIn(String.prototype, KEY, methods[0]);
                defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
            }
            if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
        };
        return fixRegexpWellKnownSymbolLogic;
    }
    var stringMultibyte;
    var hasRequiredStringMultibyte;
    function requireStringMultibyte() {
        if (hasRequiredStringMultibyte) return stringMultibyte;
        hasRequiredStringMultibyte = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var charAt = uncurryThis(''.charAt);
        var charCodeAt = uncurryThis(''.charCodeAt);
        var stringSlice = uncurryThis(''.slice);
        var createMethod = function(CONVERT_TO_STRING) {
            return function($this, pos) {
                var S = toString(requireObjectCoercible($this));
                var position = toIntegerOrInfinity(pos);
                var size = S.length;
                var first, second;
                if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
                first = charCodeAt(S, position);
                return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? charAt(S, position) : first : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
            };
        };
        stringMultibyte = {
            // `String.prototype.codePointAt` method
            // https://tc39.es/ecma262/#sec-string.prototype.codepointat
            codeAt: createMethod(false),
            // `String.prototype.at` method
            // https://github.com/mathiasbynens/String.prototype.at
            charAt: createMethod(true)
        };
        return stringMultibyte;
    }
    var advanceStringIndex;
    var hasRequiredAdvanceStringIndex;
    function requireAdvanceStringIndex() {
        if (hasRequiredAdvanceStringIndex) return advanceStringIndex;
        hasRequiredAdvanceStringIndex = 1;
        var charAt = requireStringMultibyte().charAt;
        // `AdvanceStringIndex` abstract operation
        // https://tc39.es/ecma262/#sec-advancestringindex
        advanceStringIndex = function(S, index, unicode) {
            return index + (unicode ? charAt(S, index).length || 1 : 1);
        };
        return advanceStringIndex;
    }
    var regexpExecAbstract;
    var hasRequiredRegexpExecAbstract;
    function requireRegexpExecAbstract() {
        if (hasRequiredRegexpExecAbstract) return regexpExecAbstract;
        hasRequiredRegexpExecAbstract = 1;
        var call = requireFunctionCall();
        var anObject = requireAnObject();
        var isCallable = requireIsCallable();
        var classof = requireClassofRaw();
        var regexpExec = requireRegexpExec();
        var $TypeError = TypeError;
        // `RegExpExec` abstract operation
        // https://tc39.es/ecma262/#sec-regexpexec
        regexpExecAbstract = function(R, S) {
            var exec = R.exec;
            if (isCallable(exec)) {
                var result = call(exec, R, S);
                if (result !== null) anObject(result);
                return result;
            }
            if (classof(R) === 'RegExp') return call(regexpExec, R, S);
            throw new $TypeError('RegExp#exec called on incompatible receiver');
        };
        return regexpExecAbstract;
    }
    var hasRequiredEs_string_split;
    function requireEs_string_split() {
        if (hasRequiredEs_string_split) return es_string_split;
        hasRequiredEs_string_split = 1;
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var speciesConstructor = requireSpeciesConstructor();
        var advanceStringIndex = requireAdvanceStringIndex();
        var toLength = requireToLength();
        var toString = requireToString();
        var getMethod = requireGetMethod();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var stickyHelpers = requireRegexpStickyHelpers();
        var fails = requireFails();
        var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
        var MAX_UINT32 = 0xFFFFFFFF;
        var min = Math.min;
        var push = uncurryThis([].push);
        var stringSlice = uncurryThis(''.slice);
        var stringIndexOf = uncurryThis(''.indexOf);
        // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
        // Weex JS has frozen built-in prototypes, so use try / catch wrapper
        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function() {
            // eslint-disable-next-line regexp/no-empty-group -- required for testing
            var re = /(?:)/;
            var originalExec = re.exec;
            re.exec = function() {
                return originalExec.apply(this, arguments);
            };
            var result = 'ab'.split(re);
            return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
        });
        var BUGGY = 'abbc'.split(/(b)*/)[1] === 'c' || // eslint-disable-next-line regexp/no-empty-group -- required for testing
        'test'.split(/(?:)/, -1).length !== 4 || 'ab'.split(/(?:ab)*/).length !== 2 || '.'.split(/(.?)(.?)/).length !== 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
        '.'.split(/()()/).length > 1 || ''.split(/.?/).length;
        // @@split logic
        fixRegExpWellKnownSymbolLogic('split', function(SPLIT, nativeSplit, maybeCallNative) {
            var internalSplit = '0'.split(undefined, 0).length ? function(separator, limit) {
                return separator === undefined && limit === 0 ? [] : call(nativeSplit, this, separator, limit);
            } : nativeSplit;
            return [
                // `String.prototype.split` method
                // https://tc39.es/ecma262/#sec-string.prototype.split
                function split(separator, limit) {
                    var O = requireObjectCoercible(this);
                    var splitter = isObject(separator) ? getMethod(separator, SPLIT) : undefined;
                    return splitter ? call(splitter, separator, O, limit) : call(internalSplit, toString(O), separator, limit);
                },
                // `RegExp.prototype[@@split]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
                //
                // NOTE: This cannot be properly polyfilled in engines that don't support
                // the 'y' flag.
                function(string, limit) {
                    var rx = anObject(this);
                    var S = toString(string);
                    if (!BUGGY) {
                        var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
                        if (res.done) return res.value;
                    }
                    var C = speciesConstructor(rx, RegExp);
                    var flags = toString(getRegExpFlags(rx));
                    var unicodeMatching = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                    if (UNSUPPORTED_Y) {
                        if (!~stringIndexOf(flags, 'g')) flags += 'g';
                    } else if (!~stringIndexOf(flags, 'y')) flags += 'y';
                    // ^(? + rx + ) is needed, in combination with some S slicing, to
                    // simulate the 'y' flag.
                    var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
                    var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                    if (lim === 0) return [];
                    if (S.length === 0) return regExpExec(splitter, S) === null ? [
                        S
                    ] : [];
                    var p = 0;
                    var q = 0;
                    var A = [];
                    while(q < S.length){
                        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
                        var z = regExpExec(splitter, UNSUPPORTED_Y ? stringSlice(S, q) : S);
                        var e;
                        if (z === null || (e = min(toLength(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = advanceStringIndex(S, q, unicodeMatching);
                        else {
                            push(A, stringSlice(S, p, q));
                            if (A.length === lim) return A;
                            for(var i = 1; i <= z.length - 1; i++){
                                push(A, z[i]);
                                if (A.length === lim) return A;
                            }
                            q = p = e;
                        }
                    }
                    push(A, stringSlice(S, p));
                    return A;
                }
            ];
        }, BUGGY || !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);
        return es_string_split;
    }
    requireEs_string_split();
    var es_string_trim = {};
    var whitespaces;
    var hasRequiredWhitespaces;
    function requireWhitespaces() {
        if (hasRequiredWhitespaces) return whitespaces;
        hasRequiredWhitespaces = 1;
        // a string of all valid unicode whitespaces
        whitespaces = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        return whitespaces;
    }
    var stringTrim;
    var hasRequiredStringTrim;
    function requireStringTrim() {
        if (hasRequiredStringTrim) return stringTrim;
        hasRequiredStringTrim = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var toString = requireToString();
        var whitespaces = requireWhitespaces();
        var replace = uncurryThis(''.replace);
        var ltrim = RegExp('^[' + whitespaces + ']+');
        var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');
        // `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
        var createMethod = function(TYPE) {
            return function($this) {
                var string = toString(requireObjectCoercible($this));
                if (TYPE & 1) string = replace(string, ltrim, '');
                if (TYPE & 2) string = replace(string, rtrim, '$1');
                return string;
            };
        };
        stringTrim = {
            // `String.prototype.{ trimLeft, trimStart }` methods
            // https://tc39.es/ecma262/#sec-string.prototype.trimstart
            start: createMethod(1),
            // `String.prototype.{ trimRight, trimEnd }` methods
            // https://tc39.es/ecma262/#sec-string.prototype.trimend
            end: createMethod(2),
            // `String.prototype.trim` method
            // https://tc39.es/ecma262/#sec-string.prototype.trim
            trim: createMethod(3)
        };
        return stringTrim;
    }
    var stringTrimForced;
    var hasRequiredStringTrimForced;
    function requireStringTrimForced() {
        if (hasRequiredStringTrimForced) return stringTrimForced;
        hasRequiredStringTrimForced = 1;
        var PROPER_FUNCTION_NAME = requireFunctionName().PROPER;
        var fails = requireFails();
        var whitespaces = requireWhitespaces();
        var non = '\u200B\u0085\u180E';
        // check that a method works with the correct list
        // of whitespaces and has a correct name
        stringTrimForced = function(METHOD_NAME) {
            return fails(function() {
                return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() !== non || PROPER_FUNCTION_NAME && whitespaces[METHOD_NAME].name !== METHOD_NAME;
            });
        };
        return stringTrimForced;
    }
    var hasRequiredEs_string_trim;
    function requireEs_string_trim() {
        if (hasRequiredEs_string_trim) return es_string_trim;
        hasRequiredEs_string_trim = 1;
        var $ = require_export();
        var $trim = requireStringTrim().trim;
        var forcedStringTrimMethod = requireStringTrimForced();
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        $({
            target: 'String',
            proto: true,
            forced: forcedStringTrimMethod('trim')
        }, {
            trim: function trim() {
                return $trim(this);
            }
        });
        return es_string_trim;
    }
    requireEs_string_trim();
    var web_domCollections_forEach = {};
    var domIterables;
    var hasRequiredDomIterables;
    function requireDomIterables() {
        if (hasRequiredDomIterables) return domIterables;
        hasRequiredDomIterables = 1;
        // iterable DOM collections
        // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
        domIterables = {
            CSSRuleList: 0,
            CSSStyleDeclaration: 0,
            CSSValueList: 0,
            ClientRectList: 0,
            DOMRectList: 0,
            DOMStringList: 0,
            DOMTokenList: 1,
            DataTransferItemList: 0,
            FileList: 0,
            HTMLAllCollection: 0,
            HTMLCollection: 0,
            HTMLFormElement: 0,
            HTMLSelectElement: 0,
            MediaList: 0,
            MimeTypeArray: 0,
            NamedNodeMap: 0,
            NodeList: 1,
            PaintRequestList: 0,
            Plugin: 0,
            PluginArray: 0,
            SVGLengthList: 0,
            SVGNumberList: 0,
            SVGPathSegList: 0,
            SVGPointList: 0,
            SVGStringList: 0,
            SVGTransformList: 0,
            SourceBufferList: 0,
            StyleSheetList: 0,
            TextTrackCueList: 0,
            TextTrackList: 0,
            TouchList: 0
        };
        return domIterables;
    }
    var domTokenListPrototype;
    var hasRequiredDomTokenListPrototype;
    function requireDomTokenListPrototype() {
        if (hasRequiredDomTokenListPrototype) return domTokenListPrototype;
        hasRequiredDomTokenListPrototype = 1;
        // in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
        var documentCreateElement = requireDocumentCreateElement();
        var classList = documentCreateElement('span').classList;
        var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
        domTokenListPrototype = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;
        return domTokenListPrototype;
    }
    var arrayForEach;
    var hasRequiredArrayForEach;
    function requireArrayForEach() {
        if (hasRequiredArrayForEach) return arrayForEach;
        hasRequiredArrayForEach = 1;
        var $forEach = requireArrayIteration().forEach;
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var STRICT_METHOD = arrayMethodIsStrict('forEach');
        // `Array.prototype.forEach` method implementation
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */ ) {
            return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
        // eslint-disable-next-line es/no-array-prototype-foreach -- safe
        } : [].forEach;
        return arrayForEach;
    }
    var hasRequiredWeb_domCollections_forEach;
    function requireWeb_domCollections_forEach() {
        if (hasRequiredWeb_domCollections_forEach) return web_domCollections_forEach;
        hasRequiredWeb_domCollections_forEach = 1;
        var globalThis1 = requireGlobalThis();
        var DOMIterables = requireDomIterables();
        var DOMTokenListPrototype = requireDomTokenListPrototype();
        var forEach = requireArrayForEach();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var handlePrototype = function(CollectionPrototype) {
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
                createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
            } catch (error) {
                CollectionPrototype.forEach = forEach;
            }
        };
        for(var COLLECTION_NAME in DOMIterables)if (DOMIterables[COLLECTION_NAME]) handlePrototype(globalThis1[COLLECTION_NAME] && globalThis1[COLLECTION_NAME].prototype);
        handlePrototype(DOMTokenListPrototype);
        return web_domCollections_forEach;
    }
    requireWeb_domCollections_forEach();
    var es_array_sort = {};
    var deletePropertyOrThrow;
    var hasRequiredDeletePropertyOrThrow;
    function requireDeletePropertyOrThrow() {
        if (hasRequiredDeletePropertyOrThrow) return deletePropertyOrThrow;
        hasRequiredDeletePropertyOrThrow = 1;
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        deletePropertyOrThrow = function(O, P) {
            if (!delete O[P]) throw new $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
        };
        return deletePropertyOrThrow;
    }
    var arraySort;
    var hasRequiredArraySort;
    function requireArraySort() {
        if (hasRequiredArraySort) return arraySort;
        hasRequiredArraySort = 1;
        var arraySlice = requireArraySlice();
        var floor = Math.floor;
        var sort = function(array, comparefn) {
            var length = array.length;
            if (length < 8) {
                // insertion sort
                var i = 1;
                var element, j;
                while(i < length){
                    j = i;
                    element = array[i];
                    while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
                    if (j !== i++) array[j] = element;
                }
            } else {
                // merge sort
                var middle = floor(length / 2);
                var left = sort(arraySlice(array, 0, middle), comparefn);
                var right = sort(arraySlice(array, middle), comparefn);
                var llength = left.length;
                var rlength = right.length;
                var lindex = 0;
                var rindex = 0;
                while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
            }
            return array;
        };
        arraySort = sort;
        return arraySort;
    }
    var environmentFfVersion;
    var hasRequiredEnvironmentFfVersion;
    function requireEnvironmentFfVersion() {
        if (hasRequiredEnvironmentFfVersion) return environmentFfVersion;
        hasRequiredEnvironmentFfVersion = 1;
        var userAgent = requireEnvironmentUserAgent();
        var firefox = userAgent.match(/firefox\/(\d+)/i);
        environmentFfVersion = !!firefox && +firefox[1];
        return environmentFfVersion;
    }
    var environmentIsIeOrEdge;
    var hasRequiredEnvironmentIsIeOrEdge;
    function requireEnvironmentIsIeOrEdge() {
        if (hasRequiredEnvironmentIsIeOrEdge) return environmentIsIeOrEdge;
        hasRequiredEnvironmentIsIeOrEdge = 1;
        var UA = requireEnvironmentUserAgent();
        environmentIsIeOrEdge = /MSIE|Trident/.test(UA);
        return environmentIsIeOrEdge;
    }
    var environmentWebkitVersion;
    var hasRequiredEnvironmentWebkitVersion;
    function requireEnvironmentWebkitVersion() {
        if (hasRequiredEnvironmentWebkitVersion) return environmentWebkitVersion;
        hasRequiredEnvironmentWebkitVersion = 1;
        var userAgent = requireEnvironmentUserAgent();
        var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
        environmentWebkitVersion = !!webkit && +webkit[1];
        return environmentWebkitVersion;
    }
    var hasRequiredEs_array_sort;
    function requireEs_array_sort() {
        if (hasRequiredEs_array_sort) return es_array_sort;
        hasRequiredEs_array_sort = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThis();
        var aCallable = requireACallable();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var deletePropertyOrThrow = requireDeletePropertyOrThrow();
        var toString = requireToString();
        var fails = requireFails();
        var internalSort = requireArraySort();
        var arrayMethodIsStrict = requireArrayMethodIsStrict();
        var FF = requireEnvironmentFfVersion();
        var IE_OR_EDGE = requireEnvironmentIsIeOrEdge();
        var V8 = requireEnvironmentV8Version();
        var WEBKIT = requireEnvironmentWebkitVersion();
        var test = [];
        var nativeSort = uncurryThis(test.sort);
        var push = uncurryThis(test.push);
        // IE8-
        var FAILS_ON_UNDEFINED = fails(function() {
            test.sort(undefined);
        });
        // V8 bug
        var FAILS_ON_NULL = fails(function() {
            test.sort(null);
        });
        // Old WebKit
        var STRICT_METHOD = arrayMethodIsStrict('sort');
        var STABLE_SORT = !fails(function() {
            // feature detection can be too slow, so check engines versions
            if (V8) return V8 < 70;
            if (FF && FF > 3) return;
            if (IE_OR_EDGE) return true;
            if (WEBKIT) return WEBKIT < 603;
            var result = '';
            var code, chr, value, index;
            // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
            for(code = 65; code < 76; code++){
                chr = String.fromCharCode(code);
                switch(code){
                    case 66:
                    case 69:
                    case 70:
                    case 72:
                        value = 3;
                        break;
                    case 68:
                    case 71:
                        value = 4;
                        break;
                    default:
                        value = 2;
                }
                for(index = 0; index < 47; index++)test.push({
                    k: chr + index,
                    v: value
                });
            }
            test.sort(function(a, b) {
                return b.v - a.v;
            });
            for(index = 0; index < test.length; index++){
                chr = test[index].k.charAt(0);
                if (result.charAt(result.length - 1) !== chr) result += chr;
            }
            return result !== 'DGBEFHACIJK';
        });
        var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
        var getSortCompare = function(comparefn) {
            return function(x, y) {
                if (y === undefined) return -1;
                if (x === undefined) return 1;
                if (comparefn !== undefined) return +comparefn(x, y) || 0;
                var xString = toString(x);
                var yString = toString(y);
                return xString === yString ? 0 : xString > yString ? 1 : -1;
            };
        };
        // `Array.prototype.sort` method
        // https://tc39.es/ecma262/#sec-array.prototype.sort
        $({
            target: 'Array',
            proto: true,
            forced: FORCED
        }, {
            sort: function sort(comparefn) {
                if (comparefn !== undefined) aCallable(comparefn);
                var array = toObject(this);
                if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);
                var items = [];
                var arrayLength = lengthOfArrayLike(array);
                var itemsLength, index;
                for(index = 0; index < arrayLength; index++)if (index in array) push(items, array[index]);
                internalSort(items, getSortCompare(comparefn));
                itemsLength = lengthOfArrayLike(items);
                index = 0;
                while(index < itemsLength)array[index] = items[index++];
                while(index < arrayLength)deletePropertyOrThrow(array, index++);
                return array;
            }
        });
        return es_array_sort;
    }
    requireEs_array_sort();
    var es_string_match = {};
    var hasRequiredEs_string_match;
    function requireEs_string_match() {
        if (hasRequiredEs_string_match) return es_string_match;
        hasRequiredEs_string_match = 1;
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var anObject = requireAnObject();
        var isObject = requireIsObject();
        var toLength = requireToLength();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var getMethod = requireGetMethod();
        var advanceStringIndex = requireAdvanceStringIndex();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var stringIndexOf = uncurryThis(''.indexOf);
        // @@match logic
        fixRegExpWellKnownSymbolLogic('match', function(MATCH, nativeMatch, maybeCallNative) {
            return [
                // `String.prototype.match` method
                // https://tc39.es/ecma262/#sec-string.prototype.match
                function match(regexp) {
                    var O = requireObjectCoercible(this);
                    var matcher = isObject(regexp) ? getMethod(regexp, MATCH) : undefined;
                    return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
                },
                // `RegExp.prototype[@@match]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
                function(string) {
                    var rx = anObject(this);
                    var S = toString(string);
                    var res = maybeCallNative(nativeMatch, rx, S);
                    if (res.done) return res.value;
                    var flags = toString(getRegExpFlags(rx));
                    if (!~stringIndexOf(flags, 'g')) return regExpExec(rx, S);
                    var fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                    rx.lastIndex = 0;
                    var A = [];
                    var n = 0;
                    var result;
                    while((result = regExpExec(rx, S)) !== null){
                        var matchStr = toString(result[0]);
                        A[n] = matchStr;
                        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                        n++;
                    }
                    return n === 0 ? null : A;
                }
            ];
        });
        return es_string_match;
    }
    requireEs_string_match();
    var es_string_replace = {};
    var getSubstitution;
    var hasRequiredGetSubstitution;
    function requireGetSubstitution() {
        if (hasRequiredGetSubstitution) return getSubstitution;
        hasRequiredGetSubstitution = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toObject = requireToObject();
        var floor = Math.floor;
        var charAt = uncurryThis(''.charAt);
        var replace = uncurryThis(''.replace);
        var stringSlice = uncurryThis(''.slice);
        // eslint-disable-next-line redos/no-vulnerable -- safe
        var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
        var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
        // `GetSubstitution` abstract operation
        // https://tc39.es/ecma262/#sec-getsubstitution
        getSubstitution = function(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
            if (namedCaptures !== undefined) {
                namedCaptures = toObject(namedCaptures);
                symbols = SUBSTITUTION_SYMBOLS;
            }
            return replace(replacement, symbols, function(match, ch) {
                var capture;
                switch(charAt(ch, 0)){
                    case '$':
                        return '$';
                    case '&':
                        return matched;
                    case '`':
                        return stringSlice(str, 0, position);
                    case "'":
                        return stringSlice(str, tailPos);
                    case '<':
                        capture = namedCaptures[stringSlice(ch, 1, -1)];
                        break;
                    default:
                        var n = +ch;
                        if (n === 0) return match;
                        if (n > m) {
                            var f = floor(n / 10);
                            if (f === 0) return match;
                            if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
                            return match;
                        }
                        capture = captures[n - 1];
                }
                return capture === undefined ? '' : capture;
            });
        };
        return getSubstitution;
    }
    var hasRequiredEs_string_replace;
    function requireEs_string_replace() {
        if (hasRequiredEs_string_replace) return es_string_replace;
        hasRequiredEs_string_replace = 1;
        var apply = requireFunctionApply();
        var call = requireFunctionCall();
        var uncurryThis = requireFunctionUncurryThis();
        var fixRegExpWellKnownSymbolLogic = requireFixRegexpWellKnownSymbolLogic();
        var fails = requireFails();
        var anObject = requireAnObject();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var toLength = requireToLength();
        var toString = requireToString();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var advanceStringIndex = requireAdvanceStringIndex();
        var getMethod = requireGetMethod();
        var getSubstitution = requireGetSubstitution();
        var getRegExpFlags = requireRegexpGetFlags();
        var regExpExec = requireRegexpExecAbstract();
        var wellKnownSymbol = requireWellKnownSymbol();
        var REPLACE = wellKnownSymbol('replace');
        var max = Math.max;
        var min = Math.min;
        var concat = uncurryThis([].concat);
        var push = uncurryThis([].push);
        var stringIndexOf = uncurryThis(''.indexOf);
        var stringSlice = uncurryThis(''.slice);
        var maybeToString = function(it) {
            return it === undefined ? it : String(it);
        };
        // IE <= 11 replaces $0 with the whole match, as if it was $&
        // https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
        var REPLACE_KEEPS_$0 = function() {
            // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
            return 'a'.replace(/./, '$0') === '$0';
        }();
        // Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
        var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
            if (/./[REPLACE]) return /./[REPLACE]('a', '$0') === '';
            return false;
        }();
        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function() {
            var re = /./;
            re.exec = function() {
                var result = [];
                result.groups = {
                    a: '7'
                };
                return result;
            };
            // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
            return ''.replace(re, '$<a>') !== '7';
        });
        // @@replace logic
        fixRegExpWellKnownSymbolLogic('replace', function(_, nativeReplace, maybeCallNative) {
            var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
            return [
                // `String.prototype.replace` method
                // https://tc39.es/ecma262/#sec-string.prototype.replace
                function replace(searchValue, replaceValue) {
                    var O = requireObjectCoercible(this);
                    var replacer = isObject(searchValue) ? getMethod(searchValue, REPLACE) : undefined;
                    return replacer ? call(replacer, searchValue, O, replaceValue) : call(nativeReplace, toString(O), searchValue, replaceValue);
                },
                // `RegExp.prototype[@@replace]` method
                // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
                function(string, replaceValue) {
                    var rx = anObject(this);
                    var S = toString(string);
                    var functionalReplace = isCallable(replaceValue);
                    if (!functionalReplace) replaceValue = toString(replaceValue);
                    var flags = toString(getRegExpFlags(rx));
                    if (typeof replaceValue == 'string' && !~stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) && !~stringIndexOf(replaceValue, '$<') && !~stringIndexOf(flags, 'y')) {
                        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                        if (res.done) return res.value;
                    }
                    var global1 = !!~stringIndexOf(flags, 'g');
                    var fullUnicode;
                    if (global1) {
                        fullUnicode = !!~stringIndexOf(flags, 'u') || !!~stringIndexOf(flags, 'v');
                        rx.lastIndex = 0;
                    }
                    var results = [];
                    var result;
                    while(true){
                        result = regExpExec(rx, S);
                        if (result === null) break;
                        push(results, result);
                        if (!global1) break;
                        var matchStr = toString(result[0]);
                        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                    }
                    var accumulatedResult = '';
                    var nextSourcePosition = 0;
                    for(var i = 0; i < results.length; i++){
                        result = results[i];
                        var matched = toString(result[0]);
                        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
                        var captures = [];
                        var replacement;
                        // NOTE: This is equivalent to
                        //   captures = result.slice(1).map(maybeToString)
                        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                        for(var j = 1; j < result.length; j++)push(captures, maybeToString(result[j]));
                        var namedCaptures = result.groups;
                        if (functionalReplace) {
                            var replacerArgs = concat([
                                matched
                            ], captures, position, S);
                            if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
                            replacement = toString(apply(replaceValue, undefined, replacerArgs));
                        } else replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                        if (position >= nextSourcePosition) {
                            accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
                            nextSourcePosition = position + matched.length;
                        }
                    }
                    return accumulatedResult + stringSlice(S, nextSourcePosition);
                }
            ];
        }, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
        return es_string_replace;
    }
    requireEs_string_replace();
    var es_string_startsWith = {};
    var hasRequiredEs_string_startsWith;
    function requireEs_string_startsWith() {
        if (hasRequiredEs_string_startsWith) return es_string_startsWith;
        hasRequiredEs_string_startsWith = 1;
        var $ = require_export();
        var uncurryThis = requireFunctionUncurryThisClause();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var toLength = requireToLength();
        var toString = requireToString();
        var notARegExp = requireNotARegexp();
        var requireObjectCoercible = requireRequireObjectCoercible();
        var correctIsRegExpLogic = requireCorrectIsRegexpLogic();
        var IS_PURE = requireIsPure();
        var stringSlice = uncurryThis(''.slice);
        var min = Math.min;
        var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
        // https://github.com/zloirock/core-js/pull/702
        var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function() {
            var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
            return descriptor && !descriptor.writable;
        }();
        // `String.prototype.startsWith` method
        // https://tc39.es/ecma262/#sec-string.prototype.startswith
        $({
            target: 'String',
            proto: true,
            forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC
        }, {
            startsWith: function startsWith(searchString /* , position = 0 */ ) {
                var that = toString(requireObjectCoercible(this));
                notARegExp(searchString);
                var search = toString(searchString);
                var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
                return stringSlice(that, index, index + search.length) === search;
            }
        });
        return es_string_startsWith;
    }
    requireEs_string_startsWith();
    /* eslint-disable no-use-before-define */ var Utils$1 = $.fn.bootstrapTable.utils;
    var searchControls = 'select, input:not([type="checkbox"]):not([type="radio"])';
    function getInputClass(that) {
        var isSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var formControlClass = isSelect ? that.constants.classes.select : that.constants.classes.input;
        return that.options.iconSize ? Utils$1.sprintf('%s %s-%s', formControlClass, formControlClass, that.options.iconSize) : formControlClass;
    }
    function getOptionsFromSelectControl(selectControl) {
        return selectControl[0].options;
    }
    function getControlContainer(that) {
        if (that.options.filterControlContainer) return $("".concat(that.options.filterControlContainer));
        if (that.options.height && that._initialized) return that.$tableContainer.find('.fixed-table-header table thead');
        return that.$header;
    }
    function isKeyAllowed(keyCode) {
        return $.inArray(keyCode, [
            37,
            38,
            39,
            40
        ]) > -1;
    }
    function getSearchControls(that) {
        return getControlContainer(that).find(searchControls);
    }
    function existOptionInSelectControl(selectControl, value) {
        var options = getOptionsFromSelectControl(selectControl);
        for(var i = 0; i < options.length; i++){
            if (options[i].value === Utils$1.unescapeHTML(value)) // The value is not valid to add
            return true;
        }
        // If we get here, the value is valid to add
        return false;
    }
    function addOptionToSelectControl(selectControl, _value, text, selected, shouldCompareText) {
        var value = _value === undefined || _value === null ? '' : _value.toString().trim();
        value = Utils$1.removeHTML(Utils$1.unescapeHTML(value));
        text = Utils$1.removeHTML(Utils$1.unescapeHTML(text));
        if (existOptionInSelectControl(selectControl, value)) return;
        var isSelected = shouldCompareText ? value === selected || text === selected : value === selected;
        var option = new Option(text, value, false, isSelected);
        selectControl.get(0).add(option);
    }
    function sortSelectControl(selectControl, orderBy, options) {
        var $selectControl = selectControl.get(0);
        if (orderBy === 'server') return;
        var tmpAry = new Array();
        for(var i = 0; i < $selectControl.options.length; i++){
            tmpAry[i] = new Array();
            tmpAry[i][0] = $selectControl.options[i].text;
            tmpAry[i][1] = $selectControl.options[i].value;
            tmpAry[i][2] = $selectControl.options[i].selected;
        }
        tmpAry.sort(function(a, b) {
            return Utils$1.sort(a[0], b[0], orderBy === 'desc' ? -1 : 1, options);
        });
        while($selectControl.options.length > 0)$selectControl.options[0] = null;
        for(var _i = 0; _i < tmpAry.length; _i++){
            var op = new Option(tmpAry[_i][0], tmpAry[_i][1], false, tmpAry[_i][2]);
            $selectControl.add(op);
        }
    }
    function fixHeaderCSS(_ref) {
        var $tableHeader = _ref.$tableHeader;
        $tableHeader.css('height', $tableHeader.find('table').outerHeight(true));
    }
    function getElementClass($element) {
        return $element.attr('class').split(' ').filter(function(className) {
            return className.startsWith('bootstrap-table-filter-control-');
        });
    }
    function getCursorPosition(el) {
        if ($(el).is('input[type=search]')) {
            var pos = 0;
            if ('selectionStart' in el) pos = el.selectionStart;
            else if ('selection' in document) {
                el.focus();
                var Sel = document.selection.createRange();
                var SelLength = document.selection.createRange().text.length;
                Sel.moveStart('character', -el.value.length);
                pos = Sel.text.length - SelLength;
            }
            return pos;
        }
        return -1;
    }
    function cacheValues(that) {
        var searchControls = getSearchControls(that);
        that._valuesFilterControl = [];
        searchControls.each(function() {
            var $field = $(this);
            var fieldClass = escapeID(getElementClass($field));
            if (that.options.height && !that.options.filterControlContainer) $field = that.$tableContainer.find(".fixed-table-header .".concat(fieldClass));
            else if (that.options.filterControlContainer) $field = $("".concat(that.options.filterControlContainer, " .").concat(fieldClass));
            else $field = that.$el.find(".".concat(fieldClass));
            that._valuesFilterControl.push({
                field: $field.closest('[data-field]').data('field'),
                value: $field.val(),
                position: getCursorPosition($field.get(0)),
                hasFocus: $field.is(':focus')
            });
        });
    }
    function setCaretPosition(elem, caretPos) {
        try {
            if (elem) {
                if (elem.createTextRange) {
                    var range = elem.createTextRange();
                    range.move('character', caretPos);
                    range.select();
                } else if (elem.setSelectionRange) elem.setSelectionRange(caretPos, caretPos);
            }
        } catch (ex) {
            console.error(ex);
        }
    }
    function setValues(that) {
        var field = null;
        var result = [];
        var searchControls = getSearchControls(that);
        if (that._valuesFilterControl.length > 0) {
            //  Callback to apply after settings fields values
            var callbacks = [];
            searchControls.each(function(i, el) {
                var $this = $(el);
                field = $this.closest('[data-field]').data('field');
                result = that._valuesFilterControl.filter(function(valueObj) {
                    return valueObj.field === field;
                });
                if (result.length > 0) {
                    if (result[0].hasFocus || result[0].value) {
                        var fieldToFocusCallback = function(element, cacheElementInfo) {
                            // Closure here to capture the field information
                            var closedCallback = function closedCallback() {
                                if (cacheElementInfo.hasFocus) element.focus();
                                if (Array.isArray(cacheElementInfo.value)) {
                                    var $element = $(element);
                                    $.each(cacheElementInfo.value, function(i, e) {
                                        $element.find(Utils$1.sprintf('option[value=\'%s\']', e)).prop('selected', true);
                                    });
                                } else element.value = cacheElementInfo.value;
                                setCaretPosition(element, cacheElementInfo.position);
                            };
                            return closedCallback;
                        }($this.get(0), result[0]);
                        callbacks.push(fieldToFocusCallback);
                    }
                }
            });
            // Callback call.
            if (callbacks.length > 0) callbacks.forEach(function(callback) {
                return callback();
            });
        }
    }
    function collectBootstrapTableFilterCookies() {
        var cookies = [];
        var cookieRegex = /bs\.table\.(filterControl|searchText)/g;
        var foundCookies = document.cookie.match(cookieRegex);
        var foundLocalStorage = localStorage;
        if (foundCookies) $.each(foundCookies, function(i, _cookie) {
            var cookie = _cookie;
            if (/./.test(cookie)) cookie = cookie.split('.').pop();
            if ($.inArray(cookie, cookies) === -1) cookies.push(cookie);
        });
        if (!foundLocalStorage) return cookies;
        Object.keys(localStorage).forEach(function(cookie) {
            if (!cookieRegex.test(cookie)) return;
            cookie = cookie.split('.').pop();
            if (!cookies.includes(cookie)) cookies.push(cookie);
        });
        return cookies;
    }
    function escapeID(id) {
        // eslint-disable-next-line no-useless-escape
        return String(id).replace(/([:.\[\],])/g, '\\$1');
    }
    function isColumnSearchableViaSelect(_ref2) {
        var filterControl = _ref2.filterControl, searchable = _ref2.searchable;
        return filterControl && filterControl.toLowerCase() === 'select' && searchable;
    }
    function isFilterDataNotGiven(_ref3) {
        var filterData = _ref3.filterData;
        return filterData === undefined || filterData.toLowerCase() === 'column';
    }
    function hasSelectControlElement(selectControl) {
        return selectControl && selectControl.length > 0;
    }
    function initFilterSelectControls(that) {
        var data = that.options.data;
        $.each(that.header.fields, function(j, field) {
            var column = that.columns[that.fieldsColumnsIndex[field]];
            var selectControl = getControlContainer(that).find("select.bootstrap-table-filter-control-".concat(escapeID(column.field)));
            if (isColumnSearchableViaSelect(column) && isFilterDataNotGiven(column) && hasSelectControlElement(selectControl)) {
                if (!selectControl[0].multiple && selectControl.get(selectControl.length - 1).options.length === 0) // Added the default option, must use a non-breaking space(&nbsp;) to pass the W3C validator
                addOptionToSelectControl(selectControl, '', column.filterControlPlaceholder || ' ', column.filterDefault);
                var uniqueValues = {};
                for(var i = 0; i < data.length; i++){
                    // Added a new value
                    var fieldValue = Utils$1.getItemField(data[i], field, false);
                    var formatter = that.options.editable && column.editable ? column._formatter : that.header.formatters[j];
                    var formattedValue = Utils$1.calculateObjectValue(that.header, formatter, [
                        fieldValue,
                        data[i],
                        i
                    ], fieldValue);
                    if (fieldValue === undefined || fieldValue === null) {
                        fieldValue = formattedValue;
                        column._forceFormatter = true;
                    }
                    if (column.filterDataCollector) formattedValue = Utils$1.calculateObjectValue(that.header, column.filterDataCollector, [
                        fieldValue,
                        data[i],
                        formattedValue
                    ], formattedValue);
                    if (column.searchFormatter) fieldValue = formattedValue;
                    uniqueValues[formattedValue] = fieldValue;
                    if (_typeof(formattedValue) === 'object' && formattedValue !== null) {
                        formattedValue.forEach(function(value) {
                            addOptionToSelectControl(selectControl, value, value, column.filterDefault);
                        });
                        continue;
                    }
                }
                // eslint-disable-next-line guard-for-in
                for(var key in uniqueValues)addOptionToSelectControl(selectControl, uniqueValues[key], key, column.filterDefault);
                if (that.options.sortSelectOptions) sortSelectControl(selectControl, column.filterOrderBy, that.options);
            }
        });
    }
    function getFilterDataMethod(objFilterDataMethod, searchTerm) {
        var keys = Object.keys(objFilterDataMethod);
        for(var i = 0; i < keys.length; i++){
            if (keys[i] === searchTerm) return objFilterDataMethod[searchTerm];
        }
        return null;
    }
    function createControls(that, header) {
        var addedFilterControl = false;
        var html;
        $.each(that.columns, function(_, column) {
            html = [];
            if (!column.visible && !(that.options.filterControlContainer && $(".bootstrap-table-filter-control-".concat(escapeID(column.field))).length >= 1)) return;
            if (!column.filterControl && !that.options.filterControlContainer) html.push('<div class="no-filter-control"></div>');
            else if (that.options.filterControlContainer) {
                // Use a filter control container instead of th
                var $filterControls = $(".bootstrap-table-filter-control-".concat(escapeID(column.field)));
                $.each($filterControls, function(_, filterControl) {
                    var $filterControl = $(filterControl);
                    if (!$filterControl.is('[type=radio]')) {
                        var placeholder = column.filterControlPlaceholder || '';
                        $filterControl.attr('placeholder', placeholder).val(column.filterDefault);
                    }
                    $filterControl.attr('data-field', column.field);
                });
                addedFilterControl = true;
            } else {
                // Create the control based on the html defined in the filterTemplate array.
                var nameControl = column.filterControl.toLowerCase();
                html.push('<div class="filter-control">');
                addedFilterControl = true;
                if (column.searchable && that.options.filterTemplate[nameControl]) html.push(that.options.filterTemplate[nameControl](that, column, column.filterControlPlaceholder ? column.filterControlPlaceholder : '', column.filterDefault));
            }
            // Filtering by default when it is set.
            if (column.filterControl && '' !== column.filterDefault && 'undefined' !== typeof column.filterDefault) {
                if (Utils$1.isEmptyObject(that.filterColumnsPartial)) that.filterColumnsPartial = {};
                if (!(column.field in that.filterColumnsPartial)) that.filterColumnsPartial[column.field] = column.filterDefault;
            }
            $.each(header.find('th'), function(_, th) {
                var $th = $(th);
                if ($th.data('field') === column.field) {
                    $th.find('.filter-control').remove();
                    $th.find('.fht-cell').html(html.join(''));
                    return false;
                }
            });
            if (column.filterData && column.filterData.toLowerCase() !== 'column') {
                var filterDataType = getFilterDataMethod(filterDataMethods, column.filterData.substring(0, column.filterData.indexOf(':')));
                var filterDataSource;
                var selectControl;
                if (filterDataType) {
                    filterDataSource = column.filterData.substring(column.filterData.indexOf(':') + 1, column.filterData.length);
                    selectControl = header.find(".bootstrap-table-filter-control-".concat(escapeID(column.field)));
                    addOptionToSelectControl(selectControl, '', column.filterControlPlaceholder, column.filterDefault, true);
                    filterDataType(that, filterDataSource, selectControl, that.options.filterOrderBy, column.filterDefault);
                } else throw new SyntaxError('Error. You should use any of these allowed filter data methods: var, obj, json, url, func. Use like this: var: {key: "value"}');
            }
        });
        if (addedFilterControl) {
            header.off('keyup', 'input').on('keyup', 'input', function(_ref4, obj) {
                var currentTarget = _ref4.currentTarget, keyCode = _ref4.keyCode;
                keyCode = obj ? obj.keyCode : keyCode;
                if (that.options.searchOnEnterKey && keyCode !== 13) return;
                if (isKeyAllowed(keyCode)) return;
                var $currentTarget = $(currentTarget);
                if ($currentTarget.is(':checkbox') || $currentTarget.is(':radio')) return;
                clearTimeout(currentTarget.timeoutId || 0);
                currentTarget.timeoutId = setTimeout(function() {
                    that.onColumnSearch({
                        currentTarget: currentTarget,
                        keyCode: keyCode
                    });
                }, that.options.searchTimeOut);
            });
            header.off('change', 'select').on('change', 'select', function(_ref5) {
                var currentTarget = _ref5.currentTarget, keyCode = _ref5.keyCode;
                var $selectControl = $(currentTarget);
                var value = $selectControl.val();
                var normalizedValue = value === null ? $selectControl.prop('multiple') ? [] : null : value;
                $selectControl.val(normalizedValue);
                clearTimeout(currentTarget.timeoutId || 0);
                currentTarget.timeoutId = setTimeout(function() {
                    that.onColumnSearch({
                        currentTarget: currentTarget,
                        keyCode: keyCode
                    });
                }, that.options.searchTimeOut);
            });
            header.off('mouseup', 'input:not([type=radio])').on('mouseup', 'input:not([type=radio])', function(_ref6) {
                var currentTarget = _ref6.currentTarget, keyCode = _ref6.keyCode;
                var $input = $(currentTarget);
                var oldValue = $input.val();
                if (oldValue === '') return;
                setTimeout(function() {
                    var newValue = $input.val();
                    if (newValue === '') {
                        clearTimeout(currentTarget.timeoutId || 0);
                        currentTarget.timeoutId = setTimeout(function() {
                            that.onColumnSearch({
                                currentTarget: currentTarget,
                                keyCode: keyCode
                            });
                        }, that.options.searchTimeOut);
                    }
                }, 1);
            });
            header.off('change', 'input[type=radio]').on('change', 'input[type=radio]', function(_ref7) {
                var currentTarget = _ref7.currentTarget, keyCode = _ref7.keyCode;
                clearTimeout(currentTarget.timeoutId || 0);
                currentTarget.timeoutId = setTimeout(function() {
                    that.onColumnSearch({
                        currentTarget: currentTarget,
                        keyCode: keyCode
                    });
                }, that.options.searchTimeOut);
            });
            // See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
            if (header.find('.date-filter-control').length > 0) $.each(that.columns, function(i, _ref8) {
                var filterDefault = _ref8.filterDefault, filterControl = _ref8.filterControl, field = _ref8.field, filterDatepickerOptions = _ref8.filterDatepickerOptions;
                if (filterControl !== undefined && filterControl.toLowerCase() === 'datepicker') {
                    var $datepicker = header.find(".date-filter-control.bootstrap-table-filter-control-".concat(escapeID(field)));
                    if (filterDefault) $datepicker.value(filterDefault);
                    if (filterDatepickerOptions.min) $datepicker.attr('min', filterDatepickerOptions.min);
                    if (filterDatepickerOptions.max) $datepicker.attr('max', filterDatepickerOptions.max);
                    if (filterDatepickerOptions.step) $datepicker.attr('step', filterDatepickerOptions.step);
                    if (filterDatepickerOptions.pattern) $datepicker.attr('pattern', filterDatepickerOptions.pattern);
                    $datepicker.on('change', function(_ref9) {
                        var currentTarget = _ref9.currentTarget;
                        clearTimeout(currentTarget.timeoutId || 0);
                        currentTarget.timeoutId = setTimeout(function() {
                            that.onColumnSearch({
                                currentTarget: currentTarget
                            });
                        }, that.options.searchTimeOut);
                    });
                }
            });
            if (that.options.sidePagination !== 'server') that.triggerSearch();
            if (!that.options.filterControlVisible) header.find('.filter-control, .no-filter-control').hide();
        } else header.find('.filter-control, .no-filter-control').hide();
        that.trigger('created-controls');
    }
    function getDirectionOfSelectOptions(_alignment) {
        var alignment = _alignment === undefined ? 'left' : _alignment.toLowerCase();
        switch(alignment){
            case 'left':
                return 'ltr';
            case 'right':
                return 'rtl';
            case 'auto':
                return 'auto';
            default:
                return 'ltr';
        }
    }
    function syncHeaders(that) {
        if (!that.options.height) return;
        var fixedHeader = that.$tableContainer.find('.fixed-table-header table thead');
        if (fixedHeader.length === 0) return;
        that.$header.children().find('th[data-field]').each(function(_, element) {
            if (element.classList[0] !== 'bs-checkbox') {
                var $element = $(element);
                var $field = $element.data('field');
                var $fixedField = that.$tableContainer.find("th[data-field='".concat($field, "']")).not($element);
                var input = $element.find('input');
                var fixedInput = $fixedField.find('input');
                if (input.length > 0 && fixedInput.length > 0) {
                    if (input.val() !== fixedInput.val()) input.val(fixedInput.val());
                }
            }
        });
    }
    var filterDataMethods = {
        func: function func(that, filterDataSource, selectControl, filterOrderBy, selected) {
            var variableValues = window[filterDataSource].apply();
            // eslint-disable-next-line guard-for-in
            for(var key in variableValues)addOptionToSelectControl(selectControl, key, variableValues[key], selected);
            if (that.options.sortSelectOptions) sortSelectControl(selectControl, filterOrderBy, that.options);
            setValues(that);
        },
        obj: function obj(that, filterDataSource, selectControl, filterOrderBy, selected) {
            var objectKeys = filterDataSource.split('.');
            var variableName = objectKeys.shift();
            var variableValues = window[variableName];
            if (objectKeys.length > 0) objectKeys.forEach(function(key) {
                variableValues = variableValues[key];
            });
            // eslint-disable-next-line guard-for-in
            for(var key in variableValues)addOptionToSelectControl(selectControl, variableValues[key], variableValues[key], selected);
            if (that.options.sortSelectOptions) sortSelectControl(selectControl, filterOrderBy, that.options);
            setValues(that);
        },
        var: function _var(that, filterDataSource, selectControl, filterOrderBy, selected) {
            var variableValues = window[filterDataSource];
            var isArray = Array.isArray(variableValues);
            for(var key in variableValues)if (isArray) addOptionToSelectControl(selectControl, variableValues[key], variableValues[key], selected, true);
            else addOptionToSelectControl(selectControl, key, variableValues[key], selected, true);
            if (that.options.sortSelectOptions) sortSelectControl(selectControl, filterOrderBy, that.options);
            setValues(that);
        },
        url: function url(that, filterDataSource, selectControl, filterOrderBy, selected) {
            $.ajax({
                url: filterDataSource,
                dataType: 'json',
                success: function success(data) {
                    // eslint-disable-next-line guard-for-in
                    for(var key in data)addOptionToSelectControl(selectControl, key, data[key], selected);
                    if (that.options.sortSelectOptions) sortSelectControl(selectControl, filterOrderBy, that.options);
                    setValues(that);
                }
            });
        },
        json: function json(that, filterDataSource, selectControl, filterOrderBy, selected) {
            var variableValues = JSON.parse(filterDataSource);
            // eslint-disable-next-line guard-for-in
            for(var key in variableValues)addOptionToSelectControl(selectControl, key, variableValues[key], selected);
            if (that.options.sortSelectOptions) sortSelectControl(selectControl, filterOrderBy, that.options);
            setValues(that);
        }
    };
    var Utils = $.fn.bootstrapTable.utils;
    Object.assign($.fn.bootstrapTable.defaults, {
        filterControl: false,
        filterControlVisible: true,
        filterControlMultipleSearch: false,
        filterControlMultipleSearchDelimiter: ',',
        filterControlSearchClear: true,
        // eslint-disable-next-line no-unused-vars
        onColumnSearch: function onColumnSearch(field, text) {
            return false;
        },
        onCreatedControls: function onCreatedControls() {
            return false;
        },
        alignmentSelectControlOptions: undefined,
        filterTemplate: {
            input: function input(that, column, placeholder, value) {
                return Utils.sprintf('<input type="search" class="%s bootstrap-table-filter-control-%s search-input" style="width: 100%;" placeholder="%s" value="%s">', getInputClass(that), column.field, 'undefined' === typeof placeholder ? '' : placeholder, 'undefined' === typeof value ? '' : value);
            },
            select: function select(that, column) {
                return Utils.sprintf('<select class="%s bootstrap-table-filter-control-%s %s" %s style="width: 100%;" dir="%s"></select>', getInputClass(that, true), column.field, '', '', getDirectionOfSelectOptions(that.options.alignmentSelectControlOptions));
            },
            datepicker: function datepicker(that, column, value) {
                return Utils.sprintf('<input type="date" class="%s date-filter-control bootstrap-table-filter-control-%s" style="width: 100%;" value="%s">', getInputClass(that), column.field, 'undefined' === typeof value ? '' : value);
            }
        },
        searchOnEnterKey: false,
        showFilterControlSwitch: false,
        sortSelectOptions: false,
        // internal variables
        _valuesFilterControl: [],
        _initialized: false,
        _isRendering: false,
        _usingMultipleSelect: false
    });
    Object.assign($.fn.bootstrapTable.columnDefaults, {
        filterControl: undefined,
        // input, select, datepicker
        filterControlMultipleSelect: false,
        filterControlMultipleSelectOptions: {},
        filterDataCollector: undefined,
        filterData: undefined,
        filterDatepickerOptions: {},
        filterStrictSearch: false,
        filterStartsWithSearch: false,
        filterControlPlaceholder: '',
        filterDefault: '',
        filterOrderBy: 'asc',
        // asc || desc
        filterCustomSearch: undefined
    });
    Object.assign($.fn.bootstrapTable.events, {
        'column-search.bs.table': 'onColumnSearch',
        'created-controls.bs.table': 'onCreatedControls'
    });
    Utils.assignIcons($.fn.bootstrapTable.icons, 'filterControlSwitchHide', {
        glyphicon: 'glyphicon-zoom-out icon-zoom-out',
        fa: 'fa-search-minus',
        bi: 'bi-zoom-out',
        'material-icons': 'zoom_out'
    });
    Utils.assignIcons($.fn.bootstrapTable.icons, 'filterControlSwitchShow', {
        glyphicon: 'glyphicon-zoom-in icon-zoom-in',
        fa: 'fa-search-plus',
        bi: 'bi-zoom-in',
        'material-icons': 'zoom_in'
    });
    Object.assign($.fn.bootstrapTable.locales, {
        formatFilterControlSwitch: function formatFilterControlSwitch() {
            return 'Hide/Show controls';
        },
        formatFilterControlSwitchHide: function formatFilterControlSwitchHide() {
            return 'Hide controls';
        },
        formatFilterControlSwitchShow: function formatFilterControlSwitchShow() {
            return 'Show controls';
        },
        formatClearSearch: function formatClearSearch() {
            return 'Clear filters';
        }
    });
    Object.assign($.fn.bootstrapTable.defaults, $.fn.bootstrapTable.locales);
    $.fn.bootstrapTable.methods.push('triggerSearch');
    $.fn.bootstrapTable.methods.push('clearFilterControl');
    $.fn.bootstrapTable.methods.push('toggleFilterControl');
    $.BootstrapTable = /*#__PURE__*/ function(_$$BootstrapTable) {
        function _class() {
            _classCallCheck(this, _class);
            return _callSuper(this, _class, arguments);
        }
        _inherits(_class, _$$BootstrapTable);
        return _createClass(_class, [
            {
                key: "init",
                value: function init() {
                    var _this = this;
                    // Make sure that the filterControl option is set
                    if (this.options.filterControl) {
                        // Make sure that the internal variables are set correctly
                        this._valuesFilterControl = [];
                        this._initialized = false;
                        this._usingMultipleSelect = false;
                        this._isRendering = false;
                        this.$el.on('reset-view.bs.table', Utils.debounce(function() {
                            initFilterSelectControls(_this);
                            setValues(_this);
                        }, 3)).on('toggle.bs.table', Utils.debounce(function(_, cardView) {
                            _this._initialized = false;
                            if (!cardView) {
                                initFilterSelectControls(_this);
                                setValues(_this);
                                _this._initialized = true;
                            }
                        }, 1)).on('post-header.bs.table', Utils.debounce(function() {
                            initFilterSelectControls(_this);
                            setValues(_this);
                        }, 3)).on('column-switch.bs.table', Utils.debounce(function() {
                            setValues(_this);
                            if (_this.options.height) _this.fitHeader();
                        }, 1)).on('post-body.bs.table', Utils.debounce(function() {
                            if (_this.options.height && !_this.options.filterControlContainer && _this.options.filterControlVisible) fixHeaderCSS(_this);
                            _this.$tableLoading.css('top', _this.$header.outerHeight() + 1);
                        }, 1)).on('all.bs.table', function() {
                            syncHeaders(_this);
                        });
                    }
                    _superPropGet(_class, "init", this)([]);
                }
            },
            {
                key: "initBody",
                value: function initBody() {
                    var _this2 = this;
                    _superPropGet(_class, "initBody", this)([]);
                    if (!this.options.filterControl) return;
                    setTimeout(function() {
                        initFilterSelectControls(_this2);
                        setValues(_this2);
                    }, 3);
                }
            },
            {
                key: "load",
                value: function load(data) {
                    _superPropGet(_class, "load", this)([
                        data
                    ]);
                    if (!this.options.filterControl) return;
                    createControls(this, getControlContainer(this));
                    setValues(this);
                }
            },
            {
                key: "initHeader",
                value: function initHeader() {
                    _superPropGet(_class, "initHeader", this)([]);
                    if (!this.options.filterControl) return;
                    createControls(this, getControlContainer(this));
                    this._initialized = true;
                }
            },
            {
                key: "initSearch",
                value: function initSearch() {
                    var _this3 = this;
                    var that = this;
                    var filterPartial = Utils.isEmptyObject(that.filterColumnsPartial) ? null : that.filterColumnsPartial;
                    _superPropGet(_class, "initSearch", this)([]);
                    if (this.options.sidePagination === 'server' || filterPartial === null) return;
                    // Check partial column filter
                    that.data = filterPartial ? that.data.filter(function(item, i) {
                        var itemIsExpected = [];
                        var keys1 = Object.keys(item);
                        var keys2 = Object.keys(filterPartial);
                        var keys = keys1.concat(keys2.filter(function(item) {
                            return !keys1.includes(item);
                        }));
                        keys.forEach(function(key) {
                            var thisColumn = that.columns[that.fieldsColumnsIndex[key]];
                            var rawFilterValue = filterPartial[key] || '';
                            var filterValue = rawFilterValue.toLowerCase();
                            var value = Utils.unescapeHTML(Utils.getItemField(item, key, false));
                            var tmpItemIsExpected;
                            if (_this3.options.searchAccentNeutralise) filterValue = Utils.normalizeAccent(filterValue);
                            var filterValues = [
                                filterValue
                            ];
                            if (_this3.options.filterControlMultipleSearch) filterValues = filterValue.split(_this3.options.filterControlMultipleSearchDelimiter);
                            filterValues.forEach(function(filterValue) {
                                if (tmpItemIsExpected === true) return;
                                filterValue = filterValue.trim();
                                if (filterValue === '') tmpItemIsExpected = true;
                                else {
                                    // Fix #142: search use formatted data
                                    if (thisColumn) {
                                        if (thisColumn.searchFormatter || thisColumn._forceFormatter) value = $.fn.bootstrapTable.utils.calculateObjectValue(thisColumn, that.header.formatters[$.inArray(key, that.header.fields)], [
                                            value,
                                            item,
                                            i
                                        ], value);
                                    }
                                    if ($.inArray(key, that.header.fields) !== -1) {
                                        if (value === undefined || value === null) tmpItemIsExpected = false;
                                        else if (_typeof(value) === 'object' && thisColumn.filterCustomSearch) itemIsExpected.push(that.isValueExpected(rawFilterValue, value, thisColumn, key));
                                        else if (_typeof(value) === 'object' && Array.isArray(value)) value.forEach(function(objectValue) {
                                            if (tmpItemIsExpected) return;
                                            tmpItemIsExpected = that.isValueExpected(filterValue, objectValue, thisColumn, key);
                                        });
                                        else if (_typeof(value) === 'object' && !Array.isArray(value)) Object.values(value).forEach(function(objectValue) {
                                            if (tmpItemIsExpected) return;
                                            tmpItemIsExpected = that.isValueExpected(filterValue, objectValue, thisColumn, key);
                                        });
                                        else if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') tmpItemIsExpected = that.isValueExpected(filterValue, value, thisColumn, key);
                                    }
                                }
                            });
                            itemIsExpected.push(tmpItemIsExpected);
                        });
                        return !itemIsExpected.includes(false);
                    }) : that.data;
                    that.unsortedData = _toConsumableArray(that.data);
                }
            },
            {
                key: "isValueExpected",
                value: function isValueExpected(searchValue, value, column, key) {
                    var tmpItemIsExpected;
                    if (column.filterControl === 'select') value = Utils.removeHTML(value.toString().toLowerCase());
                    if (this.options.searchAccentNeutralise) value = Utils.normalizeAccent(value);
                    if (column.filterStrictSearch || column.filterControl === 'select' && column.passed.filterStrictSearch !== false) tmpItemIsExpected = value.toString().toLowerCase() === searchValue.toString().toLowerCase();
                    else if (column.filterStartsWithSearch) tmpItemIsExpected = "".concat(value).toLowerCase().indexOf(searchValue) === 0;
                    else if (column.filterControl === 'datepicker') tmpItemIsExpected = new Date(value).getTime() === new Date(searchValue).getTime();
                    else if (this.options.regexSearch) tmpItemIsExpected = Utils.regexCompare(value, searchValue);
                    else tmpItemIsExpected = "".concat(value).toLowerCase().includes(searchValue);
                    var largerSmallerEqualsRegex = /(?:(<=|=>|=<|>=|>|<)(?:\s+)?(\d+)?|(\d+)?(\s+)?(<=|=>|=<|>=|>|<))/gm;
                    var matches = largerSmallerEqualsRegex.exec(searchValue);
                    if (matches) {
                        var operator = matches[1] || "".concat(matches[5], "l");
                        var comparisonValue = matches[2] || matches[3];
                        var int = parseInt(value, 10);
                        var comparisonInt = parseInt(comparisonValue, 10);
                        switch(operator){
                            case '>':
                            case '<l':
                                tmpItemIsExpected = int > comparisonInt;
                                break;
                            case '<':
                            case '>l':
                                tmpItemIsExpected = int < comparisonInt;
                                break;
                            case '<=':
                            case '=<':
                            case '>=l':
                            case '=>l':
                                tmpItemIsExpected = int <= comparisonInt;
                                break;
                            case '>=':
                            case '=>':
                            case '<=l':
                            case '=<l':
                                tmpItemIsExpected = int >= comparisonInt;
                                break;
                        }
                    }
                    if (column.filterCustomSearch) {
                        var customSearchResult = Utils.calculateObjectValue(column, column.filterCustomSearch, [
                            searchValue,
                            value,
                            key,
                            this.options.data
                        ], true);
                        if (customSearchResult !== null) tmpItemIsExpected = customSearchResult;
                    }
                    return tmpItemIsExpected;
                }
            },
            {
                key: "initColumnSearch",
                value: function initColumnSearch(filterColumnsDefaults) {
                    cacheValues(this);
                    if (filterColumnsDefaults) {
                        this.filterColumnsPartial = filterColumnsDefaults;
                        this.updatePagination();
                        // eslint-disable-next-line guard-for-in
                        for(var filter in filterColumnsDefaults)this.trigger('column-search', filter, filterColumnsDefaults[filter]);
                    }
                }
            },
            {
                key: "initToolbar",
                value: function initToolbar() {
                    this.showToolbar = this.showToolbar || this.options.showFilterControlSwitch;
                    this.showSearchClearButton = this.options.filterControl && this.options.showSearchClearButton;
                    if (this.options.showFilterControlSwitch) this.buttons = Object.assign(this.buttons, {
                        filterControlSwitch: {
                            text: this.options.filterControlVisible ? this.options.formatFilterControlSwitchHide() : this.options.formatFilterControlSwitchShow(),
                            icon: this.options.filterControlVisible ? this.options.icons.filterControlSwitchHide : this.options.icons.filterControlSwitchShow,
                            event: this.toggleFilterControl,
                            attributes: {
                                'aria-label': this.options.formatFilterControlSwitch(),
                                title: this.options.formatFilterControlSwitch()
                            }
                        }
                    });
                    _superPropGet(_class, "initToolbar", this)([]);
                }
            },
            {
                key: "resetSearch",
                value: function resetSearch(text) {
                    if (this.options.filterControl && this.options.filterControlSearchClear && this.options.showSearchClearButton) this.clearFilterControl();
                    _superPropGet(_class, "resetSearch", this)([
                        text
                    ]);
                }
            },
            {
                key: "clearFilterControl",
                value: function clearFilterControl() {
                    if (!this.options.filterControl) return;
                    var that = this;
                    var table = this.$el.closest('table');
                    var cookies = collectBootstrapTableFilterCookies();
                    var controls = getSearchControls(that);
                    // const search = Utils.getSearchInput(this)
                    var hasValues = false;
                    // Clear cache values
                    $.each(that._valuesFilterControl, function(i, item) {
                        hasValues = hasValues ? true : item.value !== '';
                        item.value = '';
                    });
                    // Clear controls in UI
                    $.each(controls, function(i, item) {
                        item.value = '';
                    });
                    // Cache controls again
                    setValues(that);
                    // clear cookies once the filters are clean
                    setTimeout(function() {
                        if (cookies && cookies.length > 0) $.each(cookies, function(i, item) {
                            if (that.deleteCookie !== undefined) that.deleteCookie(item);
                        });
                    }, that.options.searchTimeOut);
                    // If there is not any value in the controls exit this method
                    if (!hasValues) return;
                    // Clear each type of filter if it exists.
                    // Requires the body to reload each time a type of filter is found because we never know
                    // which ones are going to be present.
                    if (controls.length > 0) {
                        this.filterColumnsPartial = {};
                        controls.eq(0).trigger(this.tagName === 'INPUT' ? 'keyup' : 'change', {
                            keyCode: 13
                        });
                    /* controls.each(function () {
            $(this).trigger(this.tagName === 'INPUT' ? 'keyup' : 'change', { keyCode: 13 })
          })*/ } else return;
                    /* if (search.length > 0) {
          that.resetSearch('fc')
        }*/ // use the default sort order if it exists. do nothing if it does not
                    if (that.options.sortName !== table.data('sortName') || that.options.sortOrder !== table.data('sortOrder')) {
                        var sorter = this.$header.find(Utils.sprintf('[data-field="%s"]', $(controls[0]).closest('table').data('sortName')));
                        if (sorter.length > 0) {
                            that.onSort({
                                type: 'keypress',
                                currentTarget: sorter
                            });
                            $(sorter).find('.sortable').trigger('click');
                        }
                    }
                }
            },
            {
                key: "onColumnSearch",
                value: function onColumnSearch(_ref) {
                    var _this4 = this;
                    var currentTarget = _ref.currentTarget, keyCode = _ref.keyCode;
                    if (isKeyAllowed(keyCode)) return;
                    cacheValues(this);
                    var isInitialRender = !this._initialized;
                    // Cookie extension support
                    if (!this.options.cookie) {
                        if (!isInitialRender) this.options.pageNumber = 1;
                    } else // Force call the initServer method in Cookie extension
                    this._filterControlValuesLoaded = true;
                    if (Utils.isEmptyObject(this.filterColumnsPartial)) this.filterColumnsPartial = {};
                    // If searchOnEnterKey is set to true, then we need to iterate over all controls and grab their values.
                    var controls = this.options.searchOnEnterKey ? getSearchControls(this).toArray() : [
                        currentTarget
                    ];
                    controls.forEach(function(element) {
                        var $element = $(element);
                        var elementValue = $element.val();
                        var text = elementValue ? elementValue.trim() : '';
                        var $field = $element.closest('[data-field]').data('field');
                        _this4.trigger('column-search', $field, text);
                        if (text) _this4.filterColumnsPartial[$field] = text;
                        else delete _this4.filterColumnsPartial[$field];
                    });
                    this.onSearch({
                        currentTarget: currentTarget,
                        firedByInitSearchText: isInitialRender
                    }, false);
                }
            },
            {
                key: "toggleFilterControl",
                value: function toggleFilterControl() {
                    this.options.filterControlVisible = !this.options.filterControlVisible;
                    // Controls in original header or container.
                    var $filterControls = getControlContainer(this).find('.filter-control, .no-filter-control');
                    if (this.options.filterControlVisible) $filterControls.show();
                    else {
                        $filterControls.hide();
                        this.clearFilterControl();
                    }
                    // Controls in fixed header
                    if (this.options.height) {
                        var $fixedControls = this.$tableContainer.find('.fixed-table-header table thead').find('.filter-control, .no-filter-control');
                        $fixedControls.toggle(this.options.filterControlVisible);
                        fixHeaderCSS(this);
                    }
                    var icon = this.options.showButtonIcons ? this.options.filterControlVisible ? this.options.icons.filterControlSwitchHide : this.options.icons.filterControlSwitchShow : '';
                    var text = this.options.showButtonText ? this.options.filterControlVisible ? this.options.formatFilterControlSwitchHide() : this.options.formatFilterControlSwitchShow() : '';
                    this.$toolbar.find('>.columns').find('.filter-control-switch').html("".concat(Utils.sprintf(this.constants.html.icon, this.options.iconsPrefix, icon), " ").concat(text));
                }
            },
            {
                key: "triggerSearch",
                value: function triggerSearch() {
                    var searchControls = getSearchControls(this);
                    searchControls.each(function() {
                        var $element = $(this);
                        if ($element.is('select')) $element.trigger('change');
                        else $element.trigger('keyup');
                    });
                }
            },
            {
                key: "_toggleColumns",
                value: function _toggleColumns(fields, checked, needUpdate) {
                    if (fields.length) this._initialized = false;
                    _superPropGet(_class, "_toggleColumns", this)([
                        fields,
                        checked,
                        needUpdate
                    ]);
                    syncHeaders(this);
                }
            }
        ]);
    }($.BootstrapTable);
});



var $4caef02e350034d3$exports = {};

(function(global1, factory) {
    factory((parcelRequire("iUSsr")));
})($4caef02e350034d3$exports, function($) {
    'use strict';
    function _assertThisInitialized(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function _callSuper(t, o, e) {
        return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
    }
    function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(e, r) {
        for(var t = 0; t < r.length; t++){
            var o = r[t];
            o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
    }
    function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
            writable: false
        }), e;
    }
    function _get() {
        return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
            var p = _superPropBase(e, t);
            if (p) {
                var n = Object.getOwnPropertyDescriptor(p, t);
                return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
            }
        }, _get.apply(null, arguments);
    }
    function _getPrototypeOf(t) {
        return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t);
        }, _getPrototypeOf(t);
    }
    function _inherits(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: true,
                configurable: true
            }
        }), Object.defineProperty(t, "prototype", {
            writable: false
        }), e && _setPrototypeOf(t, e);
    }
    function _isNativeReflectConstruct() {
        try {
            var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        } catch (t) {}
        return (_isNativeReflectConstruct = function() {
            return !!t;
        })();
    }
    function _possibleConstructorReturn(t, e) {
        if (e && ("object" == typeof e || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return _assertThisInitialized(t);
    }
    function _setPrototypeOf(t, e) {
        return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t;
        }, _setPrototypeOf(t, e);
    }
    function _superPropBase(t, o) {
        for(; !({}).hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
        return t;
    }
    function _superPropGet(t, o, e, r) {
        var p = _get(_getPrototypeOf(t.prototype), o, e);
        return "function" == typeof p ? function(t) {
            return p.apply(e, t);
        } : p;
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
    var es_array_find = {};
    var globalThis_1;
    var hasRequiredGlobalThis;
    function requireGlobalThis() {
        if (hasRequiredGlobalThis) return globalThis_1;
        hasRequiredGlobalThis = 1;
        var check = function(it) {
            return it && it.Math === Math && it;
        };
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        globalThis_1 = // eslint-disable-next-line es/no-global-this -- safe
        check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
        check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof globalThis_1 == 'object' && globalThis_1) || // eslint-disable-next-line no-new-func -- fallback
        function() {
            return this;
        }() || Function('return this')();
        return globalThis_1;
    }
    var objectGetOwnPropertyDescriptor = {};
    var fails;
    var hasRequiredFails;
    function requireFails() {
        if (hasRequiredFails) return fails;
        hasRequiredFails = 1;
        fails = function(exec) {
            try {
                return !!exec();
            } catch (error) {
                return true;
            }
        };
        return fails;
    }
    var descriptors;
    var hasRequiredDescriptors;
    function requireDescriptors() {
        if (hasRequiredDescriptors) return descriptors;
        hasRequiredDescriptors = 1;
        var fails = requireFails();
        // Detect IE8's incomplete defineProperty implementation
        descriptors = !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty({}, 1, {
                get: function() {
                    return 7;
                }
            })[1] !== 7;
        });
        return descriptors;
    }
    var functionBindNative;
    var hasRequiredFunctionBindNative;
    function requireFunctionBindNative() {
        if (hasRequiredFunctionBindNative) return functionBindNative;
        hasRequiredFunctionBindNative = 1;
        var fails = requireFails();
        functionBindNative = !fails(function() {
            // eslint-disable-next-line es/no-function-prototype-bind -- safe
            var test = (function() {}).bind();
            // eslint-disable-next-line no-prototype-builtins -- safe
            return typeof test != 'function' || test.hasOwnProperty('prototype');
        });
        return functionBindNative;
    }
    var functionCall;
    var hasRequiredFunctionCall;
    function requireFunctionCall() {
        if (hasRequiredFunctionCall) return functionCall;
        hasRequiredFunctionCall = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var call = Function.prototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        functionCall = NATIVE_BIND ? call.bind(call) : function() {
            return call.apply(call, arguments);
        };
        return functionCall;
    }
    var objectPropertyIsEnumerable = {};
    var hasRequiredObjectPropertyIsEnumerable;
    function requireObjectPropertyIsEnumerable() {
        if (hasRequiredObjectPropertyIsEnumerable) return objectPropertyIsEnumerable;
        hasRequiredObjectPropertyIsEnumerable = 1;
        var $propertyIsEnumerable = {}.propertyIsEnumerable;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // Nashorn ~ JDK8 bug
        var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({
            1: 2
        }, 1);
        // `Object.prototype.propertyIsEnumerable` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
        objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
            var descriptor = getOwnPropertyDescriptor(this, V);
            return !!descriptor && descriptor.enumerable;
        } : $propertyIsEnumerable;
        return objectPropertyIsEnumerable;
    }
    var createPropertyDescriptor;
    var hasRequiredCreatePropertyDescriptor;
    function requireCreatePropertyDescriptor() {
        if (hasRequiredCreatePropertyDescriptor) return createPropertyDescriptor;
        hasRequiredCreatePropertyDescriptor = 1;
        createPropertyDescriptor = function(bitmap, value) {
            return {
                enumerable: !(bitmap & 1),
                configurable: !(bitmap & 2),
                writable: !(bitmap & 4),
                value: value
            };
        };
        return createPropertyDescriptor;
    }
    var functionUncurryThis;
    var hasRequiredFunctionUncurryThis;
    function requireFunctionUncurryThis() {
        if (hasRequiredFunctionUncurryThis) return functionUncurryThis;
        hasRequiredFunctionUncurryThis = 1;
        var NATIVE_BIND = requireFunctionBindNative();
        var FunctionPrototype = Function.prototype;
        var call = FunctionPrototype.call;
        // eslint-disable-next-line es/no-function-prototype-bind -- safe
        var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
        functionUncurryThis = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
            return function() {
                return call.apply(fn, arguments);
            };
        };
        return functionUncurryThis;
    }
    var classofRaw;
    var hasRequiredClassofRaw;
    function requireClassofRaw() {
        if (hasRequiredClassofRaw) return classofRaw;
        hasRequiredClassofRaw = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toString = uncurryThis({}.toString);
        var stringSlice = uncurryThis(''.slice);
        classofRaw = function(it) {
            return stringSlice(toString(it), 8, -1);
        };
        return classofRaw;
    }
    var indexedObject;
    var hasRequiredIndexedObject;
    function requireIndexedObject() {
        if (hasRequiredIndexedObject) return indexedObject;
        hasRequiredIndexedObject = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var classof = requireClassofRaw();
        var $Object = Object;
        var split = uncurryThis(''.split);
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        indexedObject = fails(function() {
            // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
            // eslint-disable-next-line no-prototype-builtins -- safe
            return !$Object('z').propertyIsEnumerable(0);
        }) ? function(it) {
            return classof(it) === 'String' ? split(it, '') : $Object(it);
        } : $Object;
        return indexedObject;
    }
    var isNullOrUndefined;
    var hasRequiredIsNullOrUndefined;
    function requireIsNullOrUndefined() {
        if (hasRequiredIsNullOrUndefined) return isNullOrUndefined;
        hasRequiredIsNullOrUndefined = 1;
        // we can't use just `it == null` since of `document.all` special case
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
        isNullOrUndefined = function(it) {
            return it === null || it === undefined;
        };
        return isNullOrUndefined;
    }
    var requireObjectCoercible;
    var hasRequiredRequireObjectCoercible;
    function requireRequireObjectCoercible() {
        if (hasRequiredRequireObjectCoercible) return requireObjectCoercible;
        hasRequiredRequireObjectCoercible = 1;
        var isNullOrUndefined = requireIsNullOrUndefined();
        var $TypeError = TypeError;
        // `RequireObjectCoercible` abstract operation
        // https://tc39.es/ecma262/#sec-requireobjectcoercible
        requireObjectCoercible = function(it) {
            if (isNullOrUndefined(it)) throw new $TypeError("Can't call method on " + it);
            return it;
        };
        return requireObjectCoercible;
    }
    var toIndexedObject;
    var hasRequiredToIndexedObject;
    function requireToIndexedObject() {
        if (hasRequiredToIndexedObject) return toIndexedObject;
        hasRequiredToIndexedObject = 1;
        // toObject with fallback for non-array-like ES3 strings
        var IndexedObject = requireIndexedObject();
        var requireObjectCoercible = requireRequireObjectCoercible();
        toIndexedObject = function(it) {
            return IndexedObject(requireObjectCoercible(it));
        };
        return toIndexedObject;
    }
    var isCallable;
    var hasRequiredIsCallable;
    function requireIsCallable() {
        if (hasRequiredIsCallable) return isCallable;
        hasRequiredIsCallable = 1;
        // https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
        var documentAll = typeof document == 'object' && document.all;
        // `IsCallable` abstract operation
        // https://tc39.es/ecma262/#sec-iscallable
        // eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
        isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function(argument) {
            return typeof argument == 'function' || argument === documentAll;
        } : function(argument) {
            return typeof argument == 'function';
        };
        return isCallable;
    }
    var isObject;
    var hasRequiredIsObject;
    function requireIsObject() {
        if (hasRequiredIsObject) return isObject;
        hasRequiredIsObject = 1;
        var isCallable = requireIsCallable();
        isObject = function(it) {
            return typeof it == 'object' ? it !== null : isCallable(it);
        };
        return isObject;
    }
    var getBuiltIn;
    var hasRequiredGetBuiltIn;
    function requireGetBuiltIn() {
        if (hasRequiredGetBuiltIn) return getBuiltIn;
        hasRequiredGetBuiltIn = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var aFunction = function(argument) {
            return isCallable(argument) ? argument : undefined;
        };
        getBuiltIn = function(namespace, method) {
            return arguments.length < 2 ? aFunction(globalThis1[namespace]) : globalThis1[namespace] && globalThis1[namespace][method];
        };
        return getBuiltIn;
    }
    var objectIsPrototypeOf;
    var hasRequiredObjectIsPrototypeOf;
    function requireObjectIsPrototypeOf() {
        if (hasRequiredObjectIsPrototypeOf) return objectIsPrototypeOf;
        hasRequiredObjectIsPrototypeOf = 1;
        var uncurryThis = requireFunctionUncurryThis();
        objectIsPrototypeOf = uncurryThis({}.isPrototypeOf);
        return objectIsPrototypeOf;
    }
    var environmentUserAgent;
    var hasRequiredEnvironmentUserAgent;
    function requireEnvironmentUserAgent() {
        if (hasRequiredEnvironmentUserAgent) return environmentUserAgent;
        hasRequiredEnvironmentUserAgent = 1;
        var globalThis1 = requireGlobalThis();
        var navigator = globalThis1.navigator;
        var userAgent = navigator && navigator.userAgent;
        environmentUserAgent = userAgent ? String(userAgent) : '';
        return environmentUserAgent;
    }
    var environmentV8Version;
    var hasRequiredEnvironmentV8Version;
    function requireEnvironmentV8Version() {
        if (hasRequiredEnvironmentV8Version) return environmentV8Version;
        hasRequiredEnvironmentV8Version = 1;
        var globalThis1 = requireGlobalThis();
        var userAgent = requireEnvironmentUserAgent();
        var process = globalThis1.process;
        var Deno = globalThis1.Deno;
        var versions = process && process.versions || Deno && Deno.version;
        var v8 = versions && versions.v8;
        var match, version;
        if (v8) {
            match = v8.split('.');
            // in old Chrome, versions of V8 isn't V8 = Chrome / 10
            // but their correct versions are not interesting for us
            version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
        }
        // BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
        // so check `userAgent` even if `.v8` exists, but 0
        if (!version && userAgent) {
            match = userAgent.match(/Edge\/(\d+)/);
            if (!match || match[1] >= 74) {
                match = userAgent.match(/Chrome\/(\d+)/);
                if (match) version = +match[1];
            }
        }
        environmentV8Version = version;
        return environmentV8Version;
    }
    var symbolConstructorDetection;
    var hasRequiredSymbolConstructorDetection;
    function requireSymbolConstructorDetection() {
        if (hasRequiredSymbolConstructorDetection) return symbolConstructorDetection;
        hasRequiredSymbolConstructorDetection = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var V8_VERSION = requireEnvironmentV8Version();
        var fails = requireFails();
        var globalThis1 = requireGlobalThis();
        var $String = globalThis1.String;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
        symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function() {
            var symbol = Symbol('symbol detection');
            // Chrome 38 Symbol has incorrect toString conversion
            // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
            // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
            // of course, fail.
            return !$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
            !Symbol.sham && V8_VERSION && V8_VERSION < 41;
        });
        return symbolConstructorDetection;
    }
    var useSymbolAsUid;
    var hasRequiredUseSymbolAsUid;
    function requireUseSymbolAsUid() {
        if (hasRequiredUseSymbolAsUid) return useSymbolAsUid;
        hasRequiredUseSymbolAsUid = 1;
        /* eslint-disable es/no-symbol -- required for testing */ var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        useSymbolAsUid = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';
        return useSymbolAsUid;
    }
    var isSymbol;
    var hasRequiredIsSymbol;
    function requireIsSymbol() {
        if (hasRequiredIsSymbol) return isSymbol;
        hasRequiredIsSymbol = 1;
        var getBuiltIn = requireGetBuiltIn();
        var isCallable = requireIsCallable();
        var isPrototypeOf = requireObjectIsPrototypeOf();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var $Object = Object;
        isSymbol = USE_SYMBOL_AS_UID ? function(it) {
            return typeof it == 'symbol';
        } : function(it) {
            var $Symbol = getBuiltIn('Symbol');
            return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
        };
        return isSymbol;
    }
    var tryToString;
    var hasRequiredTryToString;
    function requireTryToString() {
        if (hasRequiredTryToString) return tryToString;
        hasRequiredTryToString = 1;
        var $String = String;
        tryToString = function(argument) {
            try {
                return $String(argument);
            } catch (error) {
                return 'Object';
            }
        };
        return tryToString;
    }
    var aCallable;
    var hasRequiredACallable;
    function requireACallable() {
        if (hasRequiredACallable) return aCallable;
        hasRequiredACallable = 1;
        var isCallable = requireIsCallable();
        var tryToString = requireTryToString();
        var $TypeError = TypeError;
        // `Assert: IsCallable(argument) is true`
        aCallable = function(argument) {
            if (isCallable(argument)) return argument;
            throw new $TypeError(tryToString(argument) + ' is not a function');
        };
        return aCallable;
    }
    var getMethod;
    var hasRequiredGetMethod;
    function requireGetMethod() {
        if (hasRequiredGetMethod) return getMethod;
        hasRequiredGetMethod = 1;
        var aCallable = requireACallable();
        var isNullOrUndefined = requireIsNullOrUndefined();
        // `GetMethod` abstract operation
        // https://tc39.es/ecma262/#sec-getmethod
        getMethod = function(V, P) {
            var func = V[P];
            return isNullOrUndefined(func) ? undefined : aCallable(func);
        };
        return getMethod;
    }
    var ordinaryToPrimitive;
    var hasRequiredOrdinaryToPrimitive;
    function requireOrdinaryToPrimitive() {
        if (hasRequiredOrdinaryToPrimitive) return ordinaryToPrimitive;
        hasRequiredOrdinaryToPrimitive = 1;
        var call = requireFunctionCall();
        var isCallable = requireIsCallable();
        var isObject = requireIsObject();
        var $TypeError = TypeError;
        // `OrdinaryToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-ordinarytoprimitive
        ordinaryToPrimitive = function(input, pref) {
            var fn, val;
            if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
            if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
            throw new $TypeError("Can't convert object to primitive value");
        };
        return ordinaryToPrimitive;
    }
    var sharedStore = {
        exports: {}
    };
    var isPure;
    var hasRequiredIsPure;
    function requireIsPure() {
        if (hasRequiredIsPure) return isPure;
        hasRequiredIsPure = 1;
        isPure = false;
        return isPure;
    }
    var defineGlobalProperty;
    var hasRequiredDefineGlobalProperty;
    function requireDefineGlobalProperty() {
        if (hasRequiredDefineGlobalProperty) return defineGlobalProperty;
        hasRequiredDefineGlobalProperty = 1;
        var globalThis1 = requireGlobalThis();
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        defineGlobalProperty = function(key, value) {
            try {
                defineProperty(globalThis1, key, {
                    value: value,
                    configurable: true,
                    writable: true
                });
            } catch (error) {
                globalThis1[key] = value;
            }
            return value;
        };
        return defineGlobalProperty;
    }
    var hasRequiredSharedStore;
    function requireSharedStore() {
        if (hasRequiredSharedStore) return sharedStore.exports;
        hasRequiredSharedStore = 1;
        var IS_PURE = requireIsPure();
        var globalThis1 = requireGlobalThis();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var SHARED = '__core-js_shared__';
        var store = sharedStore.exports = globalThis1[SHARED] || defineGlobalProperty(SHARED, {});
        (store.versions || (store.versions = [])).push({
            version: '3.49.0',
            mode: IS_PURE ? 'pure' : 'global',
            copyright: "\xa9 2013\u20132025 Denis Pushkarev (zloirock.ru), 2025\u20132026 CoreJS Company (core-js.io). All rights reserved.",
            license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
            source: 'https://github.com/zloirock/core-js'
        });
        return sharedStore.exports;
    }
    var shared;
    var hasRequiredShared;
    function requireShared() {
        if (hasRequiredShared) return shared;
        hasRequiredShared = 1;
        var store = requireSharedStore();
        shared = function(key, value) {
            return store[key] || (store[key] = value || {});
        };
        return shared;
    }
    var toObject;
    var hasRequiredToObject;
    function requireToObject() {
        if (hasRequiredToObject) return toObject;
        hasRequiredToObject = 1;
        var requireObjectCoercible = requireRequireObjectCoercible();
        var $Object = Object;
        // `ToObject` abstract operation
        // https://tc39.es/ecma262/#sec-toobject
        toObject = function(argument) {
            return $Object(requireObjectCoercible(argument));
        };
        return toObject;
    }
    var hasOwnProperty_1;
    var hasRequiredHasOwnProperty;
    function requireHasOwnProperty() {
        if (hasRequiredHasOwnProperty) return hasOwnProperty_1;
        hasRequiredHasOwnProperty = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var toObject = requireToObject();
        var hasOwnProperty = uncurryThis({}.hasOwnProperty);
        // `HasOwnProperty` abstract operation
        // https://tc39.es/ecma262/#sec-hasownproperty
        // eslint-disable-next-line es/no-object-hasown -- safe
        hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
            return hasOwnProperty(toObject(it), key);
        };
        return hasOwnProperty_1;
    }
    var uid;
    var hasRequiredUid;
    function requireUid() {
        if (hasRequiredUid) return uid;
        hasRequiredUid = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var id = 0;
        var postfix = Math.random();
        var toString = uncurryThis(1.1.toString);
        uid = function(key) {
            return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
        };
        return uid;
    }
    var wellKnownSymbol;
    var hasRequiredWellKnownSymbol;
    function requireWellKnownSymbol() {
        if (hasRequiredWellKnownSymbol) return wellKnownSymbol;
        hasRequiredWellKnownSymbol = 1;
        var globalThis1 = requireGlobalThis();
        var shared = requireShared();
        var hasOwn = requireHasOwnProperty();
        var uid = requireUid();
        var NATIVE_SYMBOL = requireSymbolConstructorDetection();
        var USE_SYMBOL_AS_UID = requireUseSymbolAsUid();
        var Symbol1 = globalThis1.Symbol;
        var WellKnownSymbolsStore = shared('wks');
        var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol1['for'] || Symbol1 : Symbol1 && Symbol1.withoutSetter || uid;
        wellKnownSymbol = function(name) {
            if (!hasOwn(WellKnownSymbolsStore, name)) WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol1, name) ? Symbol1[name] : createWellKnownSymbol('Symbol.' + name);
            return WellKnownSymbolsStore[name];
        };
        return wellKnownSymbol;
    }
    var toPrimitive;
    var hasRequiredToPrimitive;
    function requireToPrimitive() {
        if (hasRequiredToPrimitive) return toPrimitive;
        hasRequiredToPrimitive = 1;
        var call = requireFunctionCall();
        var isObject = requireIsObject();
        var isSymbol = requireIsSymbol();
        var getMethod = requireGetMethod();
        var ordinaryToPrimitive = requireOrdinaryToPrimitive();
        var wellKnownSymbol = requireWellKnownSymbol();
        var $TypeError = TypeError;
        var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
        // `ToPrimitive` abstract operation
        // https://tc39.es/ecma262/#sec-toprimitive
        toPrimitive = function(input, pref) {
            if (!isObject(input) || isSymbol(input)) return input;
            var exoticToPrim = getMethod(input, TO_PRIMITIVE);
            var result;
            if (exoticToPrim) {
                if (pref === undefined) pref = 'default';
                result = call(exoticToPrim, input, pref);
                if (!isObject(result) || isSymbol(result)) return result;
                throw new $TypeError("Can't convert object to primitive value");
            }
            if (pref === undefined) pref = 'number';
            return ordinaryToPrimitive(input, pref);
        };
        return toPrimitive;
    }
    var toPropertyKey;
    var hasRequiredToPropertyKey;
    function requireToPropertyKey() {
        if (hasRequiredToPropertyKey) return toPropertyKey;
        hasRequiredToPropertyKey = 1;
        var toPrimitive = requireToPrimitive();
        var isSymbol = requireIsSymbol();
        // `ToPropertyKey` abstract operation
        // https://tc39.es/ecma262/#sec-topropertykey
        toPropertyKey = function(argument) {
            var key = toPrimitive(argument, 'string');
            return isSymbol(key) ? key : key + '';
        };
        return toPropertyKey;
    }
    var documentCreateElement;
    var hasRequiredDocumentCreateElement;
    function requireDocumentCreateElement() {
        if (hasRequiredDocumentCreateElement) return documentCreateElement;
        hasRequiredDocumentCreateElement = 1;
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var document1 = globalThis1.document;
        // typeof document.createElement is 'object' in old IE
        var EXISTS = isObject(document1) && isObject(document1.createElement);
        documentCreateElement = function(it) {
            return EXISTS ? document1.createElement(it) : {};
        };
        return documentCreateElement;
    }
    var ie8DomDefine;
    var hasRequiredIe8DomDefine;
    function requireIe8DomDefine() {
        if (hasRequiredIe8DomDefine) return ie8DomDefine;
        hasRequiredIe8DomDefine = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        var createElement = requireDocumentCreateElement();
        // Thanks to IE8 for its funny defineProperty
        ie8DomDefine = !DESCRIPTORS && !fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(createElement('div'), 'a', {
                get: function() {
                    return 7;
                }
            }).a !== 7;
        });
        return ie8DomDefine;
    }
    var hasRequiredObjectGetOwnPropertyDescriptor;
    function requireObjectGetOwnPropertyDescriptor() {
        if (hasRequiredObjectGetOwnPropertyDescriptor) return objectGetOwnPropertyDescriptor;
        hasRequiredObjectGetOwnPropertyDescriptor = 1;
        var DESCRIPTORS = requireDescriptors();
        var call = requireFunctionCall();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        var toIndexedObject = requireToIndexedObject();
        var toPropertyKey = requireToPropertyKey();
        var hasOwn = requireHasOwnProperty();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
        objectGetOwnPropertyDescriptor.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
            O = toIndexedObject(O);
            P = toPropertyKey(P);
            if (IE8_DOM_DEFINE) try {
                return $getOwnPropertyDescriptor(O, P);
            } catch (error) {}
            if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
        };
        return objectGetOwnPropertyDescriptor;
    }
    var objectDefineProperty = {};
    var v8PrototypeDefineBug;
    var hasRequiredV8PrototypeDefineBug;
    function requireV8PrototypeDefineBug() {
        if (hasRequiredV8PrototypeDefineBug) return v8PrototypeDefineBug;
        hasRequiredV8PrototypeDefineBug = 1;
        var DESCRIPTORS = requireDescriptors();
        var fails = requireFails();
        // V8 ~ Chrome 36-
        // https://bugs.chromium.org/p/v8/issues/detail?id=3334
        v8PrototypeDefineBug = DESCRIPTORS && fails(function() {
            // eslint-disable-next-line es/no-object-defineproperty -- required for testing
            return Object.defineProperty(function() {}, 'prototype', {
                value: 42,
                writable: false
            }).prototype !== 42;
        });
        return v8PrototypeDefineBug;
    }
    var anObject;
    var hasRequiredAnObject;
    function requireAnObject() {
        if (hasRequiredAnObject) return anObject;
        hasRequiredAnObject = 1;
        var isObject = requireIsObject();
        var $String = String;
        var $TypeError = TypeError;
        // `Assert: Type(argument) is Object`
        anObject = function(argument) {
            if (isObject(argument)) return argument;
            throw new $TypeError($String(argument) + ' is not an object');
        };
        return anObject;
    }
    var hasRequiredObjectDefineProperty;
    function requireObjectDefineProperty() {
        if (hasRequiredObjectDefineProperty) return objectDefineProperty;
        hasRequiredObjectDefineProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var IE8_DOM_DEFINE = requireIe8DomDefine();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var anObject = requireAnObject();
        var toPropertyKey = requireToPropertyKey();
        var $TypeError = TypeError;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var $defineProperty = Object.defineProperty;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
        var ENUMERABLE = 'enumerable';
        var CONFIGURABLE = 'configurable';
        var WRITABLE = 'writable';
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        objectDefineProperty.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
                var current = $getOwnPropertyDescriptor(O, P);
                if (current && current[WRITABLE]) {
                    O[P] = Attributes.value;
                    Attributes = {
                        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
                        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
                        writable: false
                    };
                }
            }
            return $defineProperty(O, P, Attributes);
        } : $defineProperty : function defineProperty(O, P, Attributes) {
            anObject(O);
            P = toPropertyKey(P);
            anObject(Attributes);
            if (IE8_DOM_DEFINE) try {
                return $defineProperty(O, P, Attributes);
            } catch (error) {}
            if ('get' in Attributes || 'set' in Attributes) throw new $TypeError('Accessors not supported');
            if ('value' in Attributes) O[P] = Attributes.value;
            return O;
        };
        return objectDefineProperty;
    }
    var createNonEnumerableProperty;
    var hasRequiredCreateNonEnumerableProperty;
    function requireCreateNonEnumerableProperty() {
        if (hasRequiredCreateNonEnumerableProperty) return createNonEnumerableProperty;
        hasRequiredCreateNonEnumerableProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createNonEnumerableProperty = DESCRIPTORS ? function(object, key, value) {
            return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
        } : function(object, key, value) {
            object[key] = value;
            return object;
        };
        return createNonEnumerableProperty;
    }
    var makeBuiltIn = {
        exports: {}
    };
    var functionName;
    var hasRequiredFunctionName;
    function requireFunctionName() {
        if (hasRequiredFunctionName) return functionName;
        hasRequiredFunctionName = 1;
        var DESCRIPTORS = requireDescriptors();
        var hasOwn = requireHasOwnProperty();
        var FunctionPrototype = Function.prototype;
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
        var EXISTS = hasOwn(FunctionPrototype, 'name');
        // additional protection from minified / mangled / dropped function names
        var PROPER = EXISTS && (function something() {}).name === 'something';
        var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
        functionName = {
            EXISTS: EXISTS,
            PROPER: PROPER,
            CONFIGURABLE: CONFIGURABLE
        };
        return functionName;
    }
    var inspectSource;
    var hasRequiredInspectSource;
    function requireInspectSource() {
        if (hasRequiredInspectSource) return inspectSource;
        hasRequiredInspectSource = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var isCallable = requireIsCallable();
        var store = requireSharedStore();
        var functionToString = uncurryThis(Function.toString);
        // this helper broken in `core-js [at] 3.4.1-3.4.4`, so we can't use `shared` helper
        if (!isCallable(store.inspectSource)) store.inspectSource = function(it) {
            return functionToString(it);
        };
        inspectSource = store.inspectSource;
        return inspectSource;
    }
    var weakMapBasicDetection;
    var hasRequiredWeakMapBasicDetection;
    function requireWeakMapBasicDetection() {
        if (hasRequiredWeakMapBasicDetection) return weakMapBasicDetection;
        hasRequiredWeakMapBasicDetection = 1;
        var globalThis1 = requireGlobalThis();
        var isCallable = requireIsCallable();
        var WeakMap = globalThis1.WeakMap;
        weakMapBasicDetection = isCallable(WeakMap) && /native code/.test(String(WeakMap));
        return weakMapBasicDetection;
    }
    var sharedKey;
    var hasRequiredSharedKey;
    function requireSharedKey() {
        if (hasRequiredSharedKey) return sharedKey;
        hasRequiredSharedKey = 1;
        var shared = requireShared();
        var uid = requireUid();
        var keys = shared('keys');
        sharedKey = function(key) {
            return keys[key] || (keys[key] = uid(key));
        };
        return sharedKey;
    }
    var hiddenKeys;
    var hasRequiredHiddenKeys;
    function requireHiddenKeys() {
        if (hasRequiredHiddenKeys) return hiddenKeys;
        hasRequiredHiddenKeys = 1;
        hiddenKeys = {};
        return hiddenKeys;
    }
    var internalState;
    var hasRequiredInternalState;
    function requireInternalState() {
        if (hasRequiredInternalState) return internalState;
        hasRequiredInternalState = 1;
        var NATIVE_WEAK_MAP = requireWeakMapBasicDetection();
        var globalThis1 = requireGlobalThis();
        var isObject = requireIsObject();
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var hasOwn = requireHasOwnProperty();
        var shared = requireSharedStore();
        var sharedKey = requireSharedKey();
        var hiddenKeys = requireHiddenKeys();
        var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
        var TypeError1 = globalThis1.TypeError;
        var WeakMap = globalThis1.WeakMap;
        var set, get, has;
        var enforce = function(it) {
            return has(it) ? get(it) : set(it, {});
        };
        var getterFor = function(TYPE) {
            return function(it) {
                var state;
                if (!isObject(it) || (state = get(it)).type !== TYPE) throw new TypeError1('Incompatible receiver, ' + TYPE + ' required');
                return state;
            };
        };
        if (NATIVE_WEAK_MAP || shared.state) {
            var store = shared.state || (shared.state = new WeakMap());
            /* eslint-disable no-self-assign -- prototype methods protection */ store.get = store.get;
            store.has = store.has;
            store.set = store.set;
            /* eslint-enable no-self-assign -- prototype methods protection */ set = function(it, metadata) {
                if (store.has(it)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                store.set(it, metadata);
                return metadata;
            };
            get = function(it) {
                return store.get(it) || {};
            };
            has = function(it) {
                return store.has(it);
            };
        } else {
            var STATE = sharedKey('state');
            hiddenKeys[STATE] = true;
            set = function(it, metadata) {
                if (hasOwn(it, STATE)) throw new TypeError1(OBJECT_ALREADY_INITIALIZED);
                metadata.facade = it;
                createNonEnumerableProperty(it, STATE, metadata);
                return metadata;
            };
            get = function(it) {
                return hasOwn(it, STATE) ? it[STATE] : {};
            };
            has = function(it) {
                return hasOwn(it, STATE);
            };
        }
        internalState = {
            set: set,
            get: get,
            has: has,
            enforce: enforce,
            getterFor: getterFor
        };
        return internalState;
    }
    var hasRequiredMakeBuiltIn;
    function requireMakeBuiltIn() {
        if (hasRequiredMakeBuiltIn) return makeBuiltIn.exports;
        hasRequiredMakeBuiltIn = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var hasOwn = requireHasOwnProperty();
        var DESCRIPTORS = requireDescriptors();
        var CONFIGURABLE_FUNCTION_NAME = requireFunctionName().CONFIGURABLE;
        var inspectSource = requireInspectSource();
        var InternalStateModule = requireInternalState();
        var enforceInternalState = InternalStateModule.enforce;
        var getInternalState = InternalStateModule.get;
        var $String = String;
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        var defineProperty = Object.defineProperty;
        var stringSlice = uncurryThis(''.slice);
        var replace = uncurryThis(''.replace);
        var join = uncurryThis([].join);
        var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function() {
            return defineProperty(function() {}, 'length', {
                value: 8
            }).length !== 8;
        });
        var TEMPLATE = String(String).split('String');
        var makeBuiltIn$1 = makeBuiltIn.exports = function(value, name, options) {
            if (stringSlice($String(name), 0, 7) === 'Symbol(') name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
            if (options && options.getter) name = 'get ' + name;
            if (options && options.setter) name = 'set ' + name;
            if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
                if (DESCRIPTORS) defineProperty(value, 'name', {
                    value: name,
                    configurable: true
                });
                else value.name = name;
            }
            if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) defineProperty(value, 'length', {
                value: options.arity
            });
            try {
                if (options && hasOwn(options, 'constructor') && options.constructor) {
                    if (DESCRIPTORS) defineProperty(value, 'prototype', {
                        writable: false
                    });
                } else if (value.prototype) value.prototype = undefined;
            } catch (error) {}
            var state = enforceInternalState(value);
            if (!hasOwn(state, 'source')) state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
            return value;
        };
        // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
        // eslint-disable-next-line no-extend-native -- required
        Function.prototype.toString = makeBuiltIn$1(function toString() {
            return isCallable(this) && getInternalState(this).source || inspectSource(this);
        }, 'toString');
        return makeBuiltIn.exports;
    }
    var defineBuiltIn;
    var hasRequiredDefineBuiltIn;
    function requireDefineBuiltIn() {
        if (hasRequiredDefineBuiltIn) return defineBuiltIn;
        hasRequiredDefineBuiltIn = 1;
        var isCallable = requireIsCallable();
        var definePropertyModule = requireObjectDefineProperty();
        var makeBuiltIn = requireMakeBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        defineBuiltIn = function(O, key, value, options) {
            if (!options) options = {};
            var simple = options.enumerable;
            var name = options.name !== undefined ? options.name : key;
            if (isCallable(value)) makeBuiltIn(value, name, options);
            if (options.global) {
                if (simple) O[key] = value;
                else defineGlobalProperty(key, value);
            } else {
                try {
                    if (!options.unsafe) delete O[key];
                    else if (O[key]) simple = true;
                } catch (error) {}
                if (simple) O[key] = value;
                else definePropertyModule.f(O, key, {
                    value: value,
                    enumerable: false,
                    configurable: !options.nonConfigurable,
                    writable: !options.nonWritable
                });
            }
            return O;
        };
        return defineBuiltIn;
    }
    var objectGetOwnPropertyNames = {};
    var mathTrunc;
    var hasRequiredMathTrunc;
    function requireMathTrunc() {
        if (hasRequiredMathTrunc) return mathTrunc;
        hasRequiredMathTrunc = 1;
        var ceil = Math.ceil;
        var floor = Math.floor;
        // `Math.trunc` method
        // https://tc39.es/ecma262/#sec-math.trunc
        // eslint-disable-next-line es/no-math-trunc -- safe
        mathTrunc = Math.trunc || function trunc(x) {
            var n = +x;
            return (n > 0 ? floor : ceil)(n);
        };
        return mathTrunc;
    }
    var toIntegerOrInfinity;
    var hasRequiredToIntegerOrInfinity;
    function requireToIntegerOrInfinity() {
        if (hasRequiredToIntegerOrInfinity) return toIntegerOrInfinity;
        hasRequiredToIntegerOrInfinity = 1;
        var trunc = requireMathTrunc();
        // `ToIntegerOrInfinity` abstract operation
        // https://tc39.es/ecma262/#sec-tointegerorinfinity
        toIntegerOrInfinity = function(argument) {
            var number = +argument;
            // eslint-disable-next-line no-self-compare -- NaN check
            return number !== number || number === 0 ? 0 : trunc(number);
        };
        return toIntegerOrInfinity;
    }
    var toAbsoluteIndex;
    var hasRequiredToAbsoluteIndex;
    function requireToAbsoluteIndex() {
        if (hasRequiredToAbsoluteIndex) return toAbsoluteIndex;
        hasRequiredToAbsoluteIndex = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var max = Math.max;
        var min = Math.min;
        // Helper for a popular repeating case of the spec:
        // Let integer be ? ToInteger(index).
        // If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
        toAbsoluteIndex = function(index, length) {
            var integer = toIntegerOrInfinity(index);
            return integer < 0 ? max(integer + length, 0) : min(integer, length);
        };
        return toAbsoluteIndex;
    }
    var toLength;
    var hasRequiredToLength;
    function requireToLength() {
        if (hasRequiredToLength) return toLength;
        hasRequiredToLength = 1;
        var toIntegerOrInfinity = requireToIntegerOrInfinity();
        var min = Math.min;
        // `ToLength` abstract operation
        // https://tc39.es/ecma262/#sec-tolength
        toLength = function(argument) {
            var len = toIntegerOrInfinity(argument);
            return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
        };
        return toLength;
    }
    var lengthOfArrayLike;
    var hasRequiredLengthOfArrayLike;
    function requireLengthOfArrayLike() {
        if (hasRequiredLengthOfArrayLike) return lengthOfArrayLike;
        hasRequiredLengthOfArrayLike = 1;
        var toLength = requireToLength();
        // `LengthOfArrayLike` abstract operation
        // https://tc39.es/ecma262/#sec-lengthofarraylike
        lengthOfArrayLike = function(obj) {
            return toLength(obj.length);
        };
        return lengthOfArrayLike;
    }
    var arrayIncludes;
    var hasRequiredArrayIncludes;
    function requireArrayIncludes() {
        if (hasRequiredArrayIncludes) return arrayIncludes;
        hasRequiredArrayIncludes = 1;
        var toIndexedObject = requireToIndexedObject();
        var toAbsoluteIndex = requireToAbsoluteIndex();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        // `Array.prototype.{ indexOf, includes }` methods implementation
        var createMethod = function(IS_INCLUDES) {
            return function($this, el, fromIndex) {
                var O = toIndexedObject($this);
                var length = lengthOfArrayLike(O);
                if (length === 0) return !IS_INCLUDES && -1;
                var index = toAbsoluteIndex(fromIndex, length);
                var value;
                // Array#includes uses SameValueZero equality algorithm
                // eslint-disable-next-line no-self-compare -- NaN check
                if (IS_INCLUDES && el !== el) while(length > index){
                    value = O[index++];
                    // eslint-disable-next-line no-self-compare -- NaN check
                    if (value !== value) return true;
                // Array#indexOf ignores holes, Array#includes - not
                }
                else for(; length > index; index++){
                    if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
                }
                return !IS_INCLUDES && -1;
            };
        };
        arrayIncludes = {
            // `Array.prototype.includes` method
            // https://tc39.es/ecma262/#sec-array.prototype.includes
            includes: createMethod(true),
            // `Array.prototype.indexOf` method
            // https://tc39.es/ecma262/#sec-array.prototype.indexof
            indexOf: createMethod(false)
        };
        return arrayIncludes;
    }
    var objectKeysInternal;
    var hasRequiredObjectKeysInternal;
    function requireObjectKeysInternal() {
        if (hasRequiredObjectKeysInternal) return objectKeysInternal;
        hasRequiredObjectKeysInternal = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var hasOwn = requireHasOwnProperty();
        var toIndexedObject = requireToIndexedObject();
        var indexOf = requireArrayIncludes().indexOf;
        var hiddenKeys = requireHiddenKeys();
        var push = uncurryThis([].push);
        objectKeysInternal = function(object, names) {
            var O = toIndexedObject(object);
            var i = 0;
            var result = [];
            var key;
            for(key in O)!hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
            // Don't enum bug & hidden keys
            while(names.length > i)if (hasOwn(O, key = names[i++])) ~indexOf(result, key) || push(result, key);
            return result;
        };
        return objectKeysInternal;
    }
    var enumBugKeys;
    var hasRequiredEnumBugKeys;
    function requireEnumBugKeys() {
        if (hasRequiredEnumBugKeys) return enumBugKeys;
        hasRequiredEnumBugKeys = 1;
        // IE8- don't enum bug keys
        enumBugKeys = [
            'constructor',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'toLocaleString',
            'toString',
            'valueOf'
        ];
        return enumBugKeys;
    }
    var hasRequiredObjectGetOwnPropertyNames;
    function requireObjectGetOwnPropertyNames() {
        if (hasRequiredObjectGetOwnPropertyNames) return objectGetOwnPropertyNames;
        hasRequiredObjectGetOwnPropertyNames = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = enumBugKeys.concat('length', 'prototype');
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        // eslint-disable-next-line es/no-object-getownpropertynames -- safe
        objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
            return internalObjectKeys(O, hiddenKeys);
        };
        return objectGetOwnPropertyNames;
    }
    var objectGetOwnPropertySymbols = {};
    var hasRequiredObjectGetOwnPropertySymbols;
    function requireObjectGetOwnPropertySymbols() {
        if (hasRequiredObjectGetOwnPropertySymbols) return objectGetOwnPropertySymbols;
        hasRequiredObjectGetOwnPropertySymbols = 1;
        // eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
        objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
        return objectGetOwnPropertySymbols;
    }
    var ownKeys;
    var hasRequiredOwnKeys;
    function requireOwnKeys() {
        if (hasRequiredOwnKeys) return ownKeys;
        hasRequiredOwnKeys = 1;
        var getBuiltIn = requireGetBuiltIn();
        var uncurryThis = requireFunctionUncurryThis();
        var getOwnPropertyNamesModule = requireObjectGetOwnPropertyNames();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var anObject = requireAnObject();
        var concat = uncurryThis([].concat);
        // all object keys, includes non-enumerable and symbols
        ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
            var keys = getOwnPropertyNamesModule.f(anObject(it));
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
        };
        return ownKeys;
    }
    var copyConstructorProperties;
    var hasRequiredCopyConstructorProperties;
    function requireCopyConstructorProperties() {
        if (hasRequiredCopyConstructorProperties) return copyConstructorProperties;
        hasRequiredCopyConstructorProperties = 1;
        var hasOwn = requireHasOwnProperty();
        var ownKeys = requireOwnKeys();
        var getOwnPropertyDescriptorModule = requireObjectGetOwnPropertyDescriptor();
        var definePropertyModule = requireObjectDefineProperty();
        copyConstructorProperties = function(target, source, exceptions) {
            var keys = ownKeys(source);
            var defineProperty = definePropertyModule.f;
            var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
            }
        };
        return copyConstructorProperties;
    }
    var isForced_1;
    var hasRequiredIsForced;
    function requireIsForced() {
        if (hasRequiredIsForced) return isForced_1;
        hasRequiredIsForced = 1;
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var replacement = /#|\.prototype\./;
        var isForced = function(feature, detection) {
            var value = data[normalize(feature)];
            return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
        };
        var normalize = isForced.normalize = function(string) {
            return String(string).replace(replacement, '.').toLowerCase();
        };
        var data = isForced.data = {};
        var NATIVE = isForced.NATIVE = 'N';
        var POLYFILL = isForced.POLYFILL = 'P';
        isForced_1 = isForced;
        return isForced_1;
    }
    var _export;
    var hasRequired_export;
    function require_export() {
        if (hasRequired_export) return _export;
        hasRequired_export = 1;
        var globalThis1 = requireGlobalThis();
        var getOwnPropertyDescriptor = requireObjectGetOwnPropertyDescriptor().f;
        var createNonEnumerableProperty = requireCreateNonEnumerableProperty();
        var defineBuiltIn = requireDefineBuiltIn();
        var defineGlobalProperty = requireDefineGlobalProperty();
        var copyConstructorProperties = requireCopyConstructorProperties();
        var isForced = requireIsForced();
        /*
  	  options.target         - name of the target object
  	  options.global         - target is the global object
  	  options.stat           - export as static methods of target
  	  options.proto          - export as prototype methods of target
  	  options.real           - real prototype method for the `pure` version
  	  options.forced         - export even if the native feature is available
  	  options.bind           - bind methods to the target, required for the `pure` version
  	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  	  options.sham           - add a flag to not completely full polyfills
  	  options.enumerable     - export as enumerable property
  	  options.dontCallGetSet - prevent calling a getter on target
  	  options.name           - the .name of the function if it does not match the key
  	*/ _export = function(options, source) {
            var TARGET = options.target;
            var GLOBAL = options.global;
            var STATIC = options.stat;
            var FORCED, target, key, targetProperty, sourceProperty, descriptor;
            if (GLOBAL) target = globalThis1;
            else if (STATIC) target = globalThis1[TARGET] || defineGlobalProperty(TARGET, {});
            else target = globalThis1[TARGET] && globalThis1[TARGET].prototype;
            if (target) for(key in source){
                sourceProperty = source[key];
                if (options.dontCallGetSet) {
                    descriptor = getOwnPropertyDescriptor(target, key);
                    targetProperty = descriptor && descriptor.value;
                } else targetProperty = target[key];
                FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
                // contained in target
                if (!FORCED && targetProperty !== undefined) {
                    if (typeof sourceProperty == typeof targetProperty) continue;
                    copyConstructorProperties(sourceProperty, targetProperty);
                }
                // add a flag to not completely full polyfills
                if (options.sham || targetProperty && targetProperty.sham) createNonEnumerableProperty(sourceProperty, 'sham', true);
                defineBuiltIn(target, key, sourceProperty, options);
            }
        };
        return _export;
    }
    var functionUncurryThisClause;
    var hasRequiredFunctionUncurryThisClause;
    function requireFunctionUncurryThisClause() {
        if (hasRequiredFunctionUncurryThisClause) return functionUncurryThisClause;
        hasRequiredFunctionUncurryThisClause = 1;
        var classofRaw = requireClassofRaw();
        var uncurryThis = requireFunctionUncurryThis();
        functionUncurryThisClause = function(fn) {
            // Nashorn bug:
            //   https://github.com/zloirock/core-js/issues/1128
            //   https://github.com/zloirock/core-js/issues/1130
            if (classofRaw(fn) === 'Function') return uncurryThis(fn);
        };
        return functionUncurryThisClause;
    }
    var functionBindContext;
    var hasRequiredFunctionBindContext;
    function requireFunctionBindContext() {
        if (hasRequiredFunctionBindContext) return functionBindContext;
        hasRequiredFunctionBindContext = 1;
        var uncurryThis = requireFunctionUncurryThisClause();
        var aCallable = requireACallable();
        var NATIVE_BIND = requireFunctionBindNative();
        var bind = uncurryThis(uncurryThis.bind);
        // optional / simple context binding
        functionBindContext = function(fn, that) {
            aCallable(fn);
            return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function() {
                return fn.apply(that, arguments);
            };
        };
        return functionBindContext;
    }
    var isArray;
    var hasRequiredIsArray;
    function requireIsArray() {
        if (hasRequiredIsArray) return isArray;
        hasRequiredIsArray = 1;
        var classof = requireClassofRaw();
        // `IsArray` abstract operation
        // https://tc39.es/ecma262/#sec-isarray
        // eslint-disable-next-line es/no-array-isarray -- safe
        isArray = Array.isArray || function isArray(argument) {
            return classof(argument) === 'Array';
        };
        return isArray;
    }
    var toStringTagSupport;
    var hasRequiredToStringTagSupport;
    function requireToStringTagSupport() {
        if (hasRequiredToStringTagSupport) return toStringTagSupport;
        hasRequiredToStringTagSupport = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var test = {};
        // eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
        test[TO_STRING_TAG] = 'z';
        toStringTagSupport = String(test) === '[object z]';
        return toStringTagSupport;
    }
    var classof;
    var hasRequiredClassof;
    function requireClassof() {
        if (hasRequiredClassof) return classof;
        hasRequiredClassof = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var isCallable = requireIsCallable();
        var classofRaw = requireClassofRaw();
        var wellKnownSymbol = requireWellKnownSymbol();
        var TO_STRING_TAG = wellKnownSymbol('toStringTag');
        var $Object = Object;
        // ES3 wrong here
        var CORRECT_ARGUMENTS = classofRaw(function() {
            return arguments;
        }()) === 'Arguments';
        // fallback for IE11 Script Access Denied error
        var tryGet = function(it, key) {
            try {
                return it[key];
            } catch (error) {}
        };
        // getting tag from ES6+ `Object.prototype.toString`
        classof = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
            var O, tag, result;
            return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
        };
        return classof;
    }
    var isConstructor;
    var hasRequiredIsConstructor;
    function requireIsConstructor() {
        if (hasRequiredIsConstructor) return isConstructor;
        hasRequiredIsConstructor = 1;
        var uncurryThis = requireFunctionUncurryThis();
        var fails = requireFails();
        var isCallable = requireIsCallable();
        var classof = requireClassof();
        var getBuiltIn = requireGetBuiltIn();
        var inspectSource = requireInspectSource();
        var noop = function() {};
        var construct = getBuiltIn('Reflect', 'construct');
        var constructorRegExp = /^\s*(?:class|function)\b/;
        var exec = uncurryThis(constructorRegExp.exec);
        var INCORRECT_TO_STRING = !constructorRegExp.test(noop);
        var isConstructorModern = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            try {
                construct(noop, [], argument);
                return true;
            } catch (error) {
                return false;
            }
        };
        var isConstructorLegacy = function isConstructor(argument) {
            if (!isCallable(argument)) return false;
            switch(classof(argument)){
                case 'AsyncFunction':
                case 'GeneratorFunction':
                case 'AsyncGeneratorFunction':
                    return false;
            }
            try {
                // we can't check .prototype since constructors produced by .bind haven't it
                // `Function#toString` throws on some built-it function in some legacy engines
                // (for example, `DOMQuad` and similar in FF41-)
                return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
            } catch (error) {
                return true;
            }
        };
        isConstructorLegacy.sham = true;
        // `IsConstructor` abstract operation
        // https://tc39.es/ecma262/#sec-isconstructor
        isConstructor = !construct || fails(function() {
            var called;
            return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
                called = true;
            }) || called;
        }) ? isConstructorLegacy : isConstructorModern;
        return isConstructor;
    }
    var arraySpeciesConstructor;
    var hasRequiredArraySpeciesConstructor;
    function requireArraySpeciesConstructor() {
        if (hasRequiredArraySpeciesConstructor) return arraySpeciesConstructor;
        hasRequiredArraySpeciesConstructor = 1;
        var isArray = requireIsArray();
        var isConstructor = requireIsConstructor();
        var isObject = requireIsObject();
        var wellKnownSymbol = requireWellKnownSymbol();
        var SPECIES = wellKnownSymbol('species');
        var $Array = Array;
        // a part of `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesConstructor = function(originalArray) {
            var C;
            if (isArray(originalArray)) {
                C = originalArray.constructor;
                // cross-realm fallback
                if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
                else if (isObject(C)) {
                    C = C[SPECIES];
                    if (C === null) C = undefined;
                }
            }
            return C === undefined ? $Array : C;
        };
        return arraySpeciesConstructor;
    }
    var arraySpeciesCreate;
    var hasRequiredArraySpeciesCreate;
    function requireArraySpeciesCreate() {
        if (hasRequiredArraySpeciesCreate) return arraySpeciesCreate;
        hasRequiredArraySpeciesCreate = 1;
        var arraySpeciesConstructor = requireArraySpeciesConstructor();
        // `ArraySpeciesCreate` abstract operation
        // https://tc39.es/ecma262/#sec-arrayspeciescreate
        arraySpeciesCreate = function(originalArray, length) {
            return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
        };
        return arraySpeciesCreate;
    }
    var createProperty;
    var hasRequiredCreateProperty;
    function requireCreateProperty() {
        if (hasRequiredCreateProperty) return createProperty;
        hasRequiredCreateProperty = 1;
        var DESCRIPTORS = requireDescriptors();
        var definePropertyModule = requireObjectDefineProperty();
        var createPropertyDescriptor = requireCreatePropertyDescriptor();
        createProperty = function(object, key, value) {
            if (DESCRIPTORS) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
            else object[key] = value;
        };
        return createProperty;
    }
    var arrayIteration;
    var hasRequiredArrayIteration;
    function requireArrayIteration() {
        if (hasRequiredArrayIteration) return arrayIteration;
        hasRequiredArrayIteration = 1;
        var bind = requireFunctionBindContext();
        var IndexedObject = requireIndexedObject();
        var toObject = requireToObject();
        var lengthOfArrayLike = requireLengthOfArrayLike();
        var arraySpeciesCreate = requireArraySpeciesCreate();
        var createProperty = requireCreateProperty();
        // `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
        var createMethod = function(TYPE) {
            var IS_MAP = TYPE === 1;
            var IS_FILTER = TYPE === 2;
            var IS_SOME = TYPE === 3;
            var IS_EVERY = TYPE === 4;
            var IS_FIND_INDEX = TYPE === 6;
            var IS_FILTER_REJECT = TYPE === 7;
            var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
            return function($this, callbackfn, that) {
                var O = toObject($this);
                var self1 = IndexedObject(O);
                var length = lengthOfArrayLike(self1);
                var boundFunction = bind(callbackfn, that);
                var index = 0;
                var resIndex = 0;
                var target = IS_MAP ? arraySpeciesCreate($this, length) : IS_FILTER || IS_FILTER_REJECT ? arraySpeciesCreate($this, 0) : undefined;
                var value, result;
                for(; length > index; index++)if (NO_HOLES || index in self1) {
                    value = self1[index];
                    result = boundFunction(value, index, O);
                    if (TYPE) {
                        if (IS_MAP) createProperty(target, index, result); // map
                        else if (result) switch(TYPE){
                            case 3:
                                return true; // some
                            case 5:
                                return value; // find
                            case 6:
                                return index; // findIndex
                            case 2:
                                createProperty(target, resIndex++, value); // filter
                        }
                        else switch(TYPE){
                            case 4:
                                return false; // every
                            case 7:
                                createProperty(target, resIndex++, value); // filterReject
                        }
                    }
                }
                return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
            };
        };
        arrayIteration = {
            // `Array.prototype.forEach` method
            // https://tc39.es/ecma262/#sec-array.prototype.foreach
            forEach: createMethod(0),
            // `Array.prototype.map` method
            // https://tc39.es/ecma262/#sec-array.prototype.map
            map: createMethod(1),
            // `Array.prototype.filter` method
            // https://tc39.es/ecma262/#sec-array.prototype.filter
            filter: createMethod(2),
            // `Array.prototype.some` method
            // https://tc39.es/ecma262/#sec-array.prototype.some
            some: createMethod(3),
            // `Array.prototype.every` method
            // https://tc39.es/ecma262/#sec-array.prototype.every
            every: createMethod(4),
            // `Array.prototype.find` method
            // https://tc39.es/ecma262/#sec-array.prototype.find
            find: createMethod(5),
            // `Array.prototype.findIndex` method
            // https://tc39.es/ecma262/#sec-array.prototype.findIndex
            findIndex: createMethod(6),
            // `Array.prototype.filterReject` method
            // https://github.com/tc39/proposal-array-filtering
            filterReject: createMethod(7)
        };
        return arrayIteration;
    }
    var objectDefineProperties = {};
    var objectKeys;
    var hasRequiredObjectKeys;
    function requireObjectKeys() {
        if (hasRequiredObjectKeys) return objectKeys;
        hasRequiredObjectKeys = 1;
        var internalObjectKeys = requireObjectKeysInternal();
        var enumBugKeys = requireEnumBugKeys();
        // `Object.keys` method
        // https://tc39.es/ecma262/#sec-object.keys
        // eslint-disable-next-line es/no-object-keys -- safe
        objectKeys = Object.keys || function keys(O) {
            return internalObjectKeys(O, enumBugKeys);
        };
        return objectKeys;
    }
    var hasRequiredObjectDefineProperties;
    function requireObjectDefineProperties() {
        if (hasRequiredObjectDefineProperties) return objectDefineProperties;
        hasRequiredObjectDefineProperties = 1;
        var DESCRIPTORS = requireDescriptors();
        var V8_PROTOTYPE_DEFINE_BUG = requireV8PrototypeDefineBug();
        var definePropertyModule = requireObjectDefineProperty();
        var anObject = requireAnObject();
        var toIndexedObject = requireToIndexedObject();
        var objectKeys = requireObjectKeys();
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        // eslint-disable-next-line es/no-object-defineproperties -- safe
        objectDefineProperties.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
            anObject(O);
            var props = toIndexedObject(Properties);
            var keys = objectKeys(Properties);
            var length = keys.length;
            var index = 0;
            var key;
            while(length > index)definePropertyModule.f(O, key = keys[index++], props[key]);
            return O;
        };
        return objectDefineProperties;
    }
    var html;
    var hasRequiredHtml;
    function requireHtml() {
        if (hasRequiredHtml) return html;
        hasRequiredHtml = 1;
        var getBuiltIn = requireGetBuiltIn();
        html = getBuiltIn('document', 'documentElement');
        return html;
    }
    var objectCreate;
    var hasRequiredObjectCreate;
    function requireObjectCreate() {
        if (hasRequiredObjectCreate) return objectCreate;
        hasRequiredObjectCreate = 1;
        /* global ActiveXObject -- old IE, WSH */ var anObject = requireAnObject();
        var definePropertiesModule = requireObjectDefineProperties();
        var enumBugKeys = requireEnumBugKeys();
        var hiddenKeys = requireHiddenKeys();
        var html = requireHtml();
        var documentCreateElement = requireDocumentCreateElement();
        var sharedKey = requireSharedKey();
        var GT = '>';
        var LT = '<';
        var PROTOTYPE = 'prototype';
        var SCRIPT = 'script';
        var IE_PROTO = sharedKey('IE_PROTO');
        var EmptyConstructor = function() {};
        var scriptTag = function(content) {
            return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
        };
        // Create object with fake `null` prototype: use ActiveX Object with cleared prototype
        var NullProtoObjectViaActiveX = function(activeXDocument) {
            activeXDocument.write(scriptTag(''));
            activeXDocument.close();
            var temp = activeXDocument.parentWindow.Object;
            // eslint-disable-next-line no-useless-assignment -- avoid memory leak
            activeXDocument = null;
            return temp;
        };
        // Create object with fake `null` prototype: use iframe Object with cleared prototype
        var NullProtoObjectViaIFrame = function() {
            // Thrash, waste and sodomy: IE GC bug
            var iframe = documentCreateElement('iframe');
            var JS = 'java' + SCRIPT + ':';
            var iframeDocument;
            iframe.style.display = 'none';
            html.appendChild(iframe);
            // https://github.com/zloirock/core-js/issues/475
            iframe.src = String(JS);
            iframeDocument = iframe.contentWindow.document;
            iframeDocument.open();
            iframeDocument.write(scriptTag('document.F=Object'));
            iframeDocument.close();
            return iframeDocument.F;
        };
        // Check for document.domain and active x support
        // No need to use active x approach when document.domain is not set
        // see https://github.com/es-shims/es5-shim/issues/150
        // variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
        // avoid IE GC bug
        var activeXDocument;
        var NullProtoObject = function() {
            try {
                activeXDocument = new ActiveXObject('htmlfile');
            } catch (error) {}
            NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
             : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
            var length = enumBugKeys.length;
            while(length--)delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
            return NullProtoObject();
        };
        hiddenKeys[IE_PROTO] = true;
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        // eslint-disable-next-line es/no-object-create -- safe
        objectCreate = Object.create || function create(O, Properties) {
            var result;
            if (O !== null) {
                EmptyConstructor[PROTOTYPE] = anObject(O);
                result = new EmptyConstructor();
                EmptyConstructor[PROTOTYPE] = null;
                // add "__proto__" for Object.getPrototypeOf polyfill
                result[IE_PROTO] = O;
            } else result = NullProtoObject();
            return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
        };
        return objectCreate;
    }
    var addToUnscopables;
    var hasRequiredAddToUnscopables;
    function requireAddToUnscopables() {
        if (hasRequiredAddToUnscopables) return addToUnscopables;
        hasRequiredAddToUnscopables = 1;
        var wellKnownSymbol = requireWellKnownSymbol();
        var create = requireObjectCreate();
        var defineProperty = requireObjectDefineProperty().f;
        var UNSCOPABLES = wellKnownSymbol('unscopables');
        var ArrayPrototype = Array.prototype;
        // Array.prototype[@@unscopables]
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        if (ArrayPrototype[UNSCOPABLES] === undefined) defineProperty(ArrayPrototype, UNSCOPABLES, {
            configurable: true,
            value: create(null)
        });
        // add a key to Array.prototype[@@unscopables]
        addToUnscopables = function(key) {
            ArrayPrototype[UNSCOPABLES][key] = true;
        };
        return addToUnscopables;
    }
    var hasRequiredEs_array_find;
    function requireEs_array_find() {
        if (hasRequiredEs_array_find) return es_array_find;
        hasRequiredEs_array_find = 1;
        var $ = require_export();
        var $find = requireArrayIteration().find;
        var addToUnscopables = requireAddToUnscopables();
        var FIND = 'find';
        var SKIPS_HOLES = true;
        // Shouldn't skip holes
        // eslint-disable-next-line es/no-array-prototype-find -- testing
        if (FIND in []) Array(1)[FIND](function() {
            SKIPS_HOLES = false;
        });
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        $({
            target: 'Array',
            proto: true,
            forced: SKIPS_HOLES
        }, {
            find: function find(callbackfn /* , that = undefined */ ) {
                return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
            }
        });
        // https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
        addToUnscopables(FIND);
        return es_array_find;
    }
    requireEs_array_find();
    var es_object_assign = {};
    var objectAssign;
    var hasRequiredObjectAssign;
    function requireObjectAssign() {
        if (hasRequiredObjectAssign) return objectAssign;
        hasRequiredObjectAssign = 1;
        var DESCRIPTORS = requireDescriptors();
        var uncurryThis = requireFunctionUncurryThis();
        var call = requireFunctionCall();
        var fails = requireFails();
        var objectKeys = requireObjectKeys();
        var getOwnPropertySymbolsModule = requireObjectGetOwnPropertySymbols();
        var propertyIsEnumerableModule = requireObjectPropertyIsEnumerable();
        var toObject = requireToObject();
        var IndexedObject = requireIndexedObject();
        // eslint-disable-next-line es/no-object-assign -- safe
        var $assign = Object.assign;
        // eslint-disable-next-line es/no-object-defineproperty -- required for testing
        var defineProperty = Object.defineProperty;
        var concat = uncurryThis([].concat);
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        objectAssign = !$assign || fails(function() {
            // should have correct order of operations (Edge bug)
            if (DESCRIPTORS && $assign({
                b: 1
            }, $assign(defineProperty({}, 'a', {
                enumerable: true,
                get: function() {
                    defineProperty(this, 'b', {
                        value: 3,
                        enumerable: false
                    });
                }
            }), {
                b: 2
            })).b !== 1) return true;
            // should work with symbols and should have deterministic property order (V8 bug)
            var A = {};
            var B = {};
            // eslint-disable-next-line es/no-symbol -- safe
            var symbol = Symbol('assign detection');
            var alphabet = 'abcdefghijklmnopqrst';
            A[symbol] = 7;
            // eslint-disable-next-line es/no-array-prototype-foreach -- safe
            alphabet.split('').forEach(function(chr) {
                B[chr] = chr;
            });
            return $assign({}, A)[symbol] !== 7 || objectKeys($assign({}, B)).join('') !== alphabet;
        }) ? function assign(target, source) {
            var T = toObject(target);
            var argumentsLength = arguments.length;
            var index = 1;
            var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
            var propertyIsEnumerable = propertyIsEnumerableModule.f;
            while(argumentsLength > index){
                var S = IndexedObject(arguments[index++]);
                var keys = getOwnPropertySymbols ? concat(objectKeys(S), getOwnPropertySymbols(S)) : objectKeys(S);
                var length = keys.length;
                var j = 0;
                var key;
                while(length > j){
                    key = keys[j++];
                    if (!DESCRIPTORS || call(propertyIsEnumerable, S, key)) T[key] = S[key];
                }
            }
            return T;
        } : $assign;
        return objectAssign;
    }
    var hasRequiredEs_object_assign;
    function requireEs_object_assign() {
        if (hasRequiredEs_object_assign) return es_object_assign;
        hasRequiredEs_object_assign = 1;
        var $ = require_export();
        var assign = requireObjectAssign();
        // `Object.assign` method
        // https://tc39.es/ecma262/#sec-object.assign
        // eslint-disable-next-line es/no-object-assign -- required for testing
        $({
            target: 'Object',
            stat: true,
            arity: 2,
            forced: Object.assign !== assign
        }, {
            assign: assign
        });
        return es_object_assign;
    }
    requireEs_object_assign();
    var es_object_toString = {};
    var objectToString;
    var hasRequiredObjectToString;
    function requireObjectToString() {
        if (hasRequiredObjectToString) return objectToString;
        hasRequiredObjectToString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var classof = requireClassof();
        // `Object.prototype.toString` method implementation
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        objectToString = TO_STRING_TAG_SUPPORT ? ({}).toString : function toString() {
            return '[object ' + classof(this) + ']';
        };
        return objectToString;
    }
    var hasRequiredEs_object_toString;
    function requireEs_object_toString() {
        if (hasRequiredEs_object_toString) return es_object_toString;
        hasRequiredEs_object_toString = 1;
        var TO_STRING_TAG_SUPPORT = requireToStringTagSupport();
        var defineBuiltIn = requireDefineBuiltIn();
        var toString = requireObjectToString();
        // `Object.prototype.toString` method
        // https://tc39.es/ecma262/#sec-object.prototype.tostring
        if (!TO_STRING_TAG_SUPPORT) defineBuiltIn(Object.prototype, 'toString', toString, {
            unsafe: true
        });
        return es_object_toString;
    }
    requireEs_object_toString();
    /**
   * @author vincent loh <vincent.ml@gmail.com>
   * @update J Manuel Corona <jmcg92@gmail.com>
   * @update zhixin wen <wenzhixin2010@gmail.com>
   */ var Utils = $.fn.bootstrapTable.utils;
    Object.assign($.fn.bootstrapTable.defaults, {
        stickyHeader: false,
        stickyHeaderOffsetY: 0,
        stickyHeaderOffsetLeft: 0,
        stickyHeaderOffsetRight: 0
    });
    $.BootstrapTable = /*#__PURE__*/ function(_$$BootstrapTable) {
        function _class() {
            _classCallCheck(this, _class);
            return _callSuper(this, _class, arguments);
        }
        _inherits(_class, _$$BootstrapTable);
        return _createClass(_class, [
            {
                key: "initHeader",
                value: function initHeader() {
                    var _this = this;
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    _superPropGet(_class, "initHeader", this)(args);
                    if (!this.options.stickyHeader) return;
                    this.$tableBody.find('.sticky-header-container,.sticky_anchor_begin,.sticky_anchor_end').remove();
                    this.$el.before('<div class="sticky-header-container"></div>');
                    this.$el.before('<div class="sticky_anchor_begin"></div>');
                    this.$el.after('<div class="sticky_anchor_end"></div>');
                    this.$header.addClass('sticky-header');
                    // clone header just once, to be used as sticky header
                    // deep clone header, using source header affects tbody>td width
                    this.$stickyContainer = this.$tableBody.find('.sticky-header-container');
                    this.$stickyBegin = this.$tableBody.find('.sticky_anchor_begin');
                    this.$stickyEnd = this.$tableBody.find('.sticky_anchor_end');
                    this.$stickyHeader = this.$header.clone(true, true);
                    // render sticky on window scroll or resize
                    var resizeEvent = Utils.getEventName('resize.sticky-header-table', this.$el.attr('id'));
                    var scrollEvent = Utils.getEventName('scroll.sticky-header-table', this.$el.attr('id'));
                    $(window).off(resizeEvent).on(resizeEvent, function() {
                        return _this.renderStickyHeader();
                    });
                    $(window).off(scrollEvent).on(scrollEvent, function() {
                        return _this.renderStickyHeader();
                    });
                    this.$tableBody.off('scroll').on('scroll', function() {
                        return _this.matchPositionX();
                    });
                }
            },
            {
                key: "onColumnSearch",
                value: function onColumnSearch(_ref) {
                    var currentTarget = _ref.currentTarget, keyCode = _ref.keyCode;
                    _superPropGet(_class, "onColumnSearch", this)([
                        {
                            currentTarget: currentTarget,
                            keyCode: keyCode
                        }
                    ]);
                    if (!this.options.stickyHeader) return;
                    this.renderStickyHeader();
                }
            },
            {
                key: "resetView",
                value: function resetView() {
                    var _this2 = this;
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    _superPropGet(_class, "resetView", this)(args);
                    if (!this.options.stickyHeader) return;
                    $('.bootstrap-table.fullscreen').off('scroll').on('scroll', function() {
                        return _this2.renderStickyHeader();
                    });
                }
            },
            {
                key: "resetCaret",
                value: function resetCaret() {
                    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                    _superPropGet(_class, "resetCaret", this)(args);
                    if (!this.options.stickyHeader) return;
                    if (this.$stickyHeader) {
                        var $ths = this.$stickyHeader.find('th');
                        this.$header.find('th').each(function(i, th) {
                            $ths.eq(i).find('.sortable').attr('class', $(th).find('.sortable').attr('class'));
                        });
                    }
                }
            },
            {
                key: "horizontalScroll",
                value: function horizontalScroll() {
                    var _this3 = this;
                    _superPropGet(_class, "horizontalScroll", this)([]);
                    if (!this.options.stickyHeader) return;
                    this.$tableBody.on('scroll', function() {
                        return _this3.matchPositionX();
                    });
                }
            },
            {
                key: "renderStickyHeader",
                value: function renderStickyHeader() {
                    var _this4 = this;
                    var that = this;
                    if (!this.$stickyContainer || !this.$stickyContainer.length || !this.$stickyBegin || !this.$stickyBegin.length || !this.$stickyEnd || !this.$stickyEnd.length) return;
                    this.$stickyHeader = this.$header.clone(true, true);
                    if (this.options.filterControl) $(this.$stickyHeader).off('keyup change mouseup').on('keyup change mouse', function(e) {
                        var $target = $(e.target);
                        var value = $target.val();
                        var field = $target.parents('th').data('field');
                        var $coreTh = that.$header.find("th[data-field=\"".concat(field, "\"]"));
                        if ($target.is('input')) $coreTh.find('input').val(value);
                        else if ($target.is('select')) {
                            var $select = $coreTh.find('select');
                            var normalizedValue = value === null ? $select.prop('multiple') ? [] : null : value;
                            $select.val(normalizedValue);
                        }
                        that.triggerSearch();
                    });
                    var top = $(window).scrollTop();
                    // top anchor scroll position, minus header height
                    var start = this.$stickyBegin.offset().top - this.options.stickyHeaderOffsetY;
                    // bottom anchor scroll position, minus header height, minus sticky height
                    var end = this.$stickyEnd.offset().top - this.options.stickyHeaderOffsetY - this.$header.height();
                    // show sticky when top anchor touches header, and when bottom anchor not exceeded
                    if (top > start && top <= end) {
                        // ensure clone and source column widths are the same
                        this.$stickyHeader.find('tr').each(function(indexRows, rows) {
                            $(rows).find('th').each(function(index, el) {
                                $(el).css('min-width', _this4.$header.find("tr:eq(".concat(indexRows, ")")).find("th:eq(".concat(index, ")")).css('width'));
                            });
                        });
                        // match bootstrap table style
                        this.$stickyContainer.show().addClass('fix-sticky fixed-table-container');
                        // stick it in position
                        var coords = this.$tableBody[0].getBoundingClientRect();
                        var width = '100%';
                        var stickyHeaderOffsetLeft = this.options.stickyHeaderOffsetLeft;
                        var stickyHeaderOffsetRight = this.options.stickyHeaderOffsetRight;
                        if (!stickyHeaderOffsetLeft) stickyHeaderOffsetLeft = coords.left;
                        if (!stickyHeaderOffsetRight) width = "".concat(coords.width, "px");
                        if (this.$el.closest('.bootstrap-table').hasClass('fullscreen')) {
                            stickyHeaderOffsetLeft = 0;
                            stickyHeaderOffsetRight = 0;
                            width = '100%';
                        }
                        this.$stickyContainer.css('top', "".concat(this.options.stickyHeaderOffsetY, "px"));
                        this.$stickyContainer.css('left', "".concat(stickyHeaderOffsetLeft, "px"));
                        this.$stickyContainer.css('right', "".concat(stickyHeaderOffsetRight, "px"));
                        this.$stickyContainer.css('width', "".concat(width));
                        // create scrollable container for header
                        this.$stickyTable = $('<table/>');
                        this.$stickyTable.addClass(this.options.classes);
                        // append cloned header to dom
                        this.$stickyContainer.html(this.$stickyTable.append(this.$stickyHeader));
                        // match clone and source header positions when left-right scroll
                        this.matchPositionX();
                    } else this.$stickyContainer.removeClass('fix-sticky').hide();
                }
            },
            {
                key: "matchPositionX",
                value: function matchPositionX() {
                    this.$stickyContainer.scrollLeft(this.$tableBody.scrollLeft());
                }
            }
        ]);
    }($.BootstrapTable);
});


// bootstrap-table@1.27.1 no longer ships the legacy natural-sorting dist extension,
// so formatted numeric columns use the shared numeric sorter below.
const $22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT = false;
const $22304431676f9932$var$ENABLE_STICKY_HEADERS = true;
const $22304431676f9932$var$MIN_TABLE_HEIGHT = 260;
const $22304431676f9932$var$MIN_PAGE_SIZE = 5;
const $22304431676f9932$var$MAX_PAGE_SIZE = 100;
const $22304431676f9932$var$VIEWPORT_MARGIN = 24;
const $22304431676f9932$var$RESIZE_DEBOUNCE_MS = 120;
const $22304431676f9932$var$BASE_PAGE_LIST = [
    10,
    25,
    50,
    100,
    'All'
];
const $22304431676f9932$var$TABLE_STATES = new WeakMap();
const $22304431676f9932$var$DETAIL_ICON = [
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-check" viewBox="0 0 16 16">',
    '<path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3.854 2.146a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 3.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 1 1 .708-.708L2 7.293l1.146-1.147a.5.5 0 0 1 .708 0m0 4a.5.5 0 0 1 0 .708l-1.5 1.5a.5.5 0 0 1-.708 0l-.5-.5a.5.5 0 0 1 .708-.708l.146.147 1.146-1.147a.5.5 0 0 1 .708 0"/>',
    '</svg>'
].join('');
const $22304431676f9932$var$CHECK_ICON = [
    '<span class="text-info">',
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">',
    '<path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>',
    '</svg>',
    '</span>'
].join('');
function $22304431676f9932$var$escapeHtml(value) {
    return String(value ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
function $22304431676f9932$var$escapeAttr(value) {
    return $22304431676f9932$var$escapeHtml(value);
}
function $22304431676f9932$var$stripHtml(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))('<div>').html(String(value ?? '')).text().trim();
}
function $22304431676f9932$var$splitPipeValues(value) {
    return String(value ?? '').split('|').map((item)=>item.trim()).filter(Boolean);
}
function $22304431676f9932$var$parseNumber(value) {
    const normalized = $22304431676f9932$var$stripHtml(value).replace(/\$/g, '').replace(/,/g, '').replace(/[^0-9.\-]/g, '').trim();
    if (!normalized) return null;
    const number = Number.parseFloat(normalized);
    return Number.isFinite(number) ? number : null;
}
function $22304431676f9932$var$getCellData(row, field) {
    return row[`_${field}_data`] || {};
}
function $22304431676f9932$var$formatBadge(value, className) {
    return `<span class="badge ${className}">${$22304431676f9932$var$escapeHtml(value)}</span>`;
}
function $22304431676f9932$var$renderBadgeList(values, className) {
    return values.map((item)=>$22304431676f9932$var$formatBadge(item, className)).join('<br>');
}
function $22304431676f9932$var$buildDetailsButton(url) {
    return [
        `<a class="btn btn-outline-primary" role="button" href="${$22304431676f9932$var$escapeAttr(url)}">`,
        $22304431676f9932$var$DETAIL_ICON,
        '</a>'
    ].join('');
}
function $22304431676f9932$var$linkFormatter(value, row, index, field) {
    const cellData = $22304431676f9932$var$getCellData(row, field);
    const label = $22304431676f9932$var$escapeHtml(value);
    if (!cellData.url) return label;
    return `<a href="${$22304431676f9932$var$escapeAttr(cellData.url)}">${label}</a>`;
}
function $22304431676f9932$var$muniSystemFormatter(value, row, index, field) {
    const values = $22304431676f9932$var$splitPipeValues($22304431676f9932$var$getCellData(row, field).values || value);
    return values.map((item)=>{
        if (item === 'Combined') return '<span class="badge" style="color:slategray;background-color:#ead7eb;">Combined</span>';
        if (item === 'Separate') return '<span class="badge" style="color:slategray;background-color:#bcdce7;">Separate</span>';
        if (item === 'Hybrid') return '<span class="badge text-bg-secondary">Hybrid</span>';
        return $22304431676f9932$var$formatBadge(item, 'text-bg-secondary');
    }).join(' ');
}
function $22304431676f9932$var$pocSystemFormatter(value, row, index, field) {
    return $22304431676f9932$var$splitPipeValues($22304431676f9932$var$getCellData(row, field).values || value).map((item)=>{
        if (item === 'CS') return '<span class="badge" style="color:slategray;background-color:#ead7eb;">CS</span>';
        if (item === 'SS') return '<span class="badge" style="color:slategray;background-color:#bcdce7;">SS</span>';
        return $22304431676f9932$var$formatBadge(item, 'text-bg-secondary');
    }).join(' ');
}
function $22304431676f9932$var$statusFormatter(value, row, index, field) {
    return $22304431676f9932$var$splitPipeValues($22304431676f9932$var$getCellData(row, field).values || value).map((item)=>{
        const className = item.includes('Projects Submitted') ? 'text-bg-primary' : 'text-bg-success';
        return $22304431676f9932$var$formatBadge(item, className);
    }).join(' ');
}
function $22304431676f9932$var$badgeListFormatter(value) {
    const values = $22304431676f9932$var$splitPipeValues(value);
    return values.length ? $22304431676f9932$var$renderBadgeList(values, 'text-bg-secondary') : '';
}
function $22304431676f9932$var$growFormatter(value, row, index, field) {
    const labels = $22304431676f9932$var$splitPipeValues($22304431676f9932$var$getCellData(row, field).labels);
    if (!labels.length) return String(value ?? '').toLowerCase() === 'yes' ? $22304431676f9932$var$formatBadge('Yes', 'text-bg-success') : '';
    return $22304431676f9932$var$renderBadgeList(labels, 'text-bg-success');
}
function $22304431676f9932$var$booleanIconFormatter(value) {
    return String(value ?? '').toLowerCase() === 'yes' ? $22304431676f9932$var$CHECK_ICON : '';
}
function $22304431676f9932$var$integerFormatter(value) {
    const number = $22304431676f9932$var$parseNumber(value);
    return number === null ? '' : Math.round(number).toLocaleString();
}
function $22304431676f9932$var$currencyFormatter(value) {
    const number = $22304431676f9932$var$parseNumber(value);
    return number === null ? '-' : `$${Math.round(number).toLocaleString()}`;
}
function $22304431676f9932$var$reductionFormatter(value, row, index, field) {
    const number = $22304431676f9932$var$parseNumber(value);
    if (number === null) return '';
    const unit = $22304431676f9932$var$getCellData(row, field).unit || '';
    const renderedNumber = number.toLocaleString(undefined, {
        maximumFractionDigits: 2
    });
    const renderedUnit = unit ? ` <span class="small text-muted">${$22304431676f9932$var$escapeHtml(unit)}</span>` : '';
    return `${renderedNumber}${renderedUnit}`;
}
function $22304431676f9932$var$coloredIntegerFormatter(value, row, index, field) {
    const rendered = $22304431676f9932$var$integerFormatter(value);
    if (!rendered) return '';
    const cellData = $22304431676f9932$var$getCellData(row, field);
    const style = [
        cellData.bgColor ? `background-color:${cellData.bgColor}` : '',
        cellData.textColor ? `color:${cellData.textColor}` : ''
    ].filter(Boolean).join(';');
    if (!style) return rendered;
    return `<span style="${$22304431676f9932$var$escapeAttr(style)}">${rendered}</span>`;
}
function $22304431676f9932$var$detailsFormatter(value, row, index, field) {
    const cellData = $22304431676f9932$var$getCellData(row, field);
    return cellData.url ? $22304431676f9932$var$buildDetailsButton(cellData.url) : '';
}
function $22304431676f9932$var$pipeValuesCollector(fieldValue) {
    return $22304431676f9932$var$splitPipeValues(fieldValue);
}
function $22304431676f9932$var$tributaryValuesCollector(fieldValue, row) {
    const values = $22304431676f9932$var$getCellData(row, 'tributaries').values || fieldValue;
    return $22304431676f9932$var$splitPipeValues(values);
}
function $22304431676f9932$var$pipeContains(searchValue, value) {
    if (!searchValue) return true;
    const target = String(searchValue).toLowerCase();
    return $22304431676f9932$var$splitPipeValues(value).some((item)=>item.toLowerCase() === target);
}
function $22304431676f9932$var$tributaryContains(searchValue, value, row) {
    if (!searchValue) return true;
    const target = String(searchValue).toLowerCase();
    const values = $22304431676f9932$var$getCellData(row, 'tributaries').values || value;
    return $22304431676f9932$var$splitPipeValues(values).some((item)=>item.toLowerCase() === target);
}
function $22304431676f9932$var$glsLabelCollector(fieldValue, row) {
    return [
        row.gls_label || 'no data'
    ];
}
function $22304431676f9932$var$glsLabelContains(searchValue, value, fieldName, allData) {
    if (!searchValue) return true;
    // filterCustomSearch receives (searchValue, cellValue, fieldName, allData) —
    // the 3rd arg is the field name string, not the row. Find the row via actual_ii.
    const row = (allData || []).find((r)=>r.actual_ii === value);
    return (row?.gls_label || 'no data') === searchValue;
}
function $22304431676f9932$var$numericSorter(a, b) {
    const left = $22304431676f9932$var$parseNumber(a);
    const right = $22304431676f9932$var$parseNumber(b);
    if (left === null && right === null) return 0;
    if (left === null) return -1;
    if (right === null) return 1;
    return left - right;
}
function $22304431676f9932$var$textSorter(a, b) {
    return $22304431676f9932$var$stripHtml(a).localeCompare($22304431676f9932$var$stripHtml(b), undefined, {
        numeric: true,
        sensitivity: 'base'
    });
}
function $22304431676f9932$var$buildPageList(pageSize) {
    const numericValues = $22304431676f9932$var$BASE_PAGE_LIST.filter((value)=>typeof value === 'number');
    if (typeof pageSize === 'number' && Number.isFinite(pageSize)) numericValues.push(pageSize);
    const uniqueValues = [
        ...new Set(numericValues)
    ].sort((left, right)=>left - right);
    return [
        ...uniqueValues,
        'All'
    ];
}
function $22304431676f9932$var$samePageList(left, right) {
    return JSON.stringify(left || []) === JSON.stringify(right || []);
}
function $22304431676f9932$var$processHtmxTableContent(table) {
    if (typeof window.htmx?.process !== 'function') return;
    const root = table.closest('.bootstrap-table') || table;
    window.htmx.process(root);
}
function $22304431676f9932$var$whenBootstrapTableReady(table, callback, attemptsRemaining = 20) {
    const $table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table);
    if ($table.data('bootstrap.table')) {
        callback($table);
        return;
    }
    if (attemptsRemaining <= 0) return;
    window.requestAnimationFrame(()=>{
        $22304431676f9932$var$whenBootstrapTableReady(table, callback, attemptsRemaining - 1);
    });
}
function $22304431676f9932$var$getStickyHeaderOptions() {
    return {
        stickyHeader: $22304431676f9932$var$ENABLE_STICKY_HEADERS,
        stickyHeaderOffsetLeft: 0,
        stickyHeaderOffsetRight: 0,
        stickyHeaderOffsetY: 0
    };
}
function $22304431676f9932$var$measureRowHeight($root) {
    const $row = $root.find('.fixed-table-body tbody tr:visible').not('.no-records-found').first();
    const height = Math.round($row.outerHeight() || 0);
    return height > 0 ? height : 40;
}
function $22304431676f9932$var$measureHeaderHeight($root) {
    return Math.round($root.find('.fixed-table-header thead').first().outerHeight() || $root.find('.fixed-table-body thead').first().outerHeight() || 44);
}
function $22304431676f9932$var$computeResponsiveHeight(table, $root) {
    const shell = table.closest('[data-coa-summary-shell]') || $root.get(0);
    const shellRect = shell.getBoundingClientRect();
    const toolbarHeight = Math.round($root.find('.fixed-table-toolbar').first().outerHeight(true) || 0);
    const paginationHeight = Math.round($root.find('.fixed-table-pagination').first().outerHeight(true) || 0);
    const available = window.innerHeight - shellRect.top - toolbarHeight - paginationHeight - $22304431676f9932$var$VIEWPORT_MARGIN;
    return Math.max($22304431676f9932$var$MIN_TABLE_HEIGHT, Math.floor(available));
}
function $22304431676f9932$var$computeAutoPageSize($table, $root, height) {
    const totalRows = $table.bootstrapTable('getData', {
        unfiltered: true
    }).length;
    const rowHeight = $22304431676f9932$var$measureRowHeight($root);
    const headerHeight = $22304431676f9932$var$measureHeaderHeight($root);
    const bodyHeight = Math.max(rowHeight, height - headerHeight - 8);
    const computed = Math.max($22304431676f9932$var$MIN_PAGE_SIZE, Math.floor(bodyHeight / rowHeight));
    const bounded = Math.min($22304431676f9932$var$MAX_PAGE_SIZE, computed);
    if (!totalRows) return bounded;
    return Math.max($22304431676f9932$var$MIN_PAGE_SIZE, Math.min(totalRows, bounded));
}
function $22304431676f9932$var$applyResponsiveLayout(table) {
    const $table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table);
    const state = $22304431676f9932$var$TABLE_STATES.get(table);
    const instance = $table.data('bootstrap.table');
    if (!state || !instance || state.isApplyingLayout) return;
    const $root = $table.closest('.bootstrap-table');
    if (!$root.length) return;
    const height = $22304431676f9932$var$computeResponsiveHeight(table, $root);
    const options = $table.bootstrapTable('getOptions');
    const pageSize = state.manualPageSize || $22304431676f9932$var$computeAutoPageSize($table, $root, height);
    const pageList = $22304431676f9932$var$buildPageList(pageSize);
    const shouldRefresh = options.pageSize !== pageSize || !$22304431676f9932$var$samePageList(options.pageList, pageList);
    state.isApplyingLayout = true;
    state.autoPageSize = pageSize;
    try {
        if (shouldRefresh) {
            state.isAutoUpdatingPageSize = true;
            $table.bootstrapTable('refreshOptions', {
                pageList: pageList,
                pageSize: pageSize
            });
            state.isAutoUpdatingPageSize = false;
        }
        $table.bootstrapTable('resetView', {
            height: height
        });
    } finally{
        state.isApplyingLayout = false;
    }
}
function $22304431676f9932$var$syncStickyHeader(table) {
    if (!$22304431676f9932$var$ENABLE_STICKY_HEADERS) return;
    $22304431676f9932$var$whenBootstrapTableReady(table, ($table)=>{
        const instance = $table.data('bootstrap.table');
        if (!instance || !instance.options.stickyHeader) return;
        const stickyOptions = $22304431676f9932$var$getStickyHeaderOptions();
        instance.options.stickyHeaderOffsetLeft = stickyOptions.stickyHeaderOffsetLeft;
        instance.options.stickyHeaderOffsetRight = stickyOptions.stickyHeaderOffsetRight;
        instance.options.stickyHeaderOffsetY = stickyOptions.stickyHeaderOffsetY;
        if (typeof instance.renderStickyHeader === 'function') instance.renderStickyHeader();
    });
}
function $22304431676f9932$var$applyInitialTableOptions(table) {
    $22304431676f9932$var$whenBootstrapTableReady(table, ($table)=>{
        const options = $table.bootstrapTable('getOptions');
        const nextOptions = {};
        if (!$22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT && (options.pagination || options.height)) {
            nextOptions.height = null;
            nextOptions.pagination = false;
        }
        if ($22304431676f9932$var$ENABLE_STICKY_HEADERS && !options.stickyHeader) Object.assign(nextOptions, $22304431676f9932$var$getStickyHeaderOptions());
        if (Object.keys(nextOptions).length > 0) $table.bootstrapTable('refreshOptions', nextOptions);
        if (!$22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT) $table.bootstrapTable('resetView');
        $22304431676f9932$var$syncStickyHeader(table);
    });
}
function $22304431676f9932$var$normalizeTributaryFilterOptions(table) {
    const $table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table);
    const selects = $table.closest('.bootstrap-table').find('select.bootstrap-table-filter-control-tributaries').get();
    selects.forEach((select)=>{
        const $select = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(select);
        const currentValue = String($select.val() ?? '').trim();
        const uniqueValues = new Set();
        Array.from(select.options).forEach((option)=>{
            const rawValue = String(option.value || option.text || '').trim();
            if (!rawValue) return;
            $22304431676f9932$var$splitPipeValues(rawValue).forEach((item)=>{
                uniqueValues.add(item);
            });
        });
        const sortedValues = Array.from(uniqueValues).sort((left, right)=>left.localeCompare(right, undefined, {
                sensitivity: 'base'
            }));
        select.options.length = 0;
        select.add(new Option(' ', ''));
        sortedValues.forEach((value)=>{
            select.add(new Option(value, value));
        });
        if (currentValue && uniqueValues.has(currentValue)) $select.val(currentValue);
        else $select.val('');
    });
}
function $22304431676f9932$var$refreshSummaryTable(table) {
    if ($22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT) $22304431676f9932$var$applyResponsiveLayout(table);
    if ($22304431676f9932$var$ENABLE_STICKY_HEADERS) $22304431676f9932$var$syncStickyHeader(table);
}
function $22304431676f9932$var$bindExportButtons(root = document) {
    root.querySelectorAll('[data-coa-export-table]').forEach((button)=>{
        if (button.dataset.coaExportBound === 'true') return;
        button.dataset.coaExportBound = 'true';
        button.addEventListener('click', (event)=>{
            event.preventDefault();
            const tableId = button.dataset.coaExportTable;
            const filename = button.dataset.coaExportFilename || `${tableId}.csv`;
            $22304431676f9932$var$downloadTableCsv(tableId, filename);
        });
    });
}
function $22304431676f9932$var$csvCell(value) {
    return `"${String(value ?? '').replace(/"/g, '""')}"`;
}
function $22304431676f9932$var$formatExportValue(row, field) {
    const cellData = $22304431676f9932$var$getCellData(row, field);
    const rawValue = row[field];
    if (field === 'details') return cellData.url || '';
    if (field === 'grow') {
        const labels = $22304431676f9932$var$splitPipeValues(cellData.labels);
        return labels.length ? labels.join('; ') : rawValue;
    }
    if (field === 'reduction') {
        const unit = cellData.unit || '';
        return unit && rawValue ? `${rawValue} ${unit}` : rawValue;
    }
    if (typeof rawValue === 'string' && rawValue.includes('|')) return $22304431676f9932$var$splitPipeValues(rawValue).join('; ');
    return $22304431676f9932$var$stripHtml(rawValue);
}
function $22304431676f9932$var$downloadTableCsv(tableId, filename) {
    const $table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(`#${tableId}`);
    if (!$table.length || !$table.data('bootstrap.table')) return;
    const columns = $table.bootstrapTable('getVisibleColumns').filter((column)=>column.field);
    const rows = $table.bootstrapTable('getData');
    const lines = [];
    lines.push(columns.map((column)=>$22304431676f9932$var$csvCell($22304431676f9932$var$stripHtml(column.title))).join(','));
    rows.forEach((row)=>{
        lines.push(columns.map((column)=>$22304431676f9932$var$csvCell($22304431676f9932$var$formatExportValue(row, column.field))).join(','));
    });
    const blob = new Blob([
        `${lines.join('\n')}\n`
    ], {
        type: 'text/csv;charset=utf-8;'
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
function $22304431676f9932$var$initSummaryTable(table) {
    if (table.dataset.coaSummaryBound === 'true') return;
    table.dataset.coaSummaryBound = 'true';
    const $table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))(table);
    $table.on('post-body.bs.table', ()=>{
        window.requestAnimationFrame(()=>{
            $22304431676f9932$var$refreshSummaryTable(table);
            $22304431676f9932$var$processHtmxTableContent(table);
        });
    });
    $table.on('created-controls.bs.table', ()=>{
        $22304431676f9932$var$normalizeTributaryFilterOptions(table);
    });
    if ($22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT) {
        const state = {
            autoPageSize: null,
            isApplyingLayout: false,
            isAutoUpdatingPageSize: false,
            manualPageSize: null
        };
        $22304431676f9932$var$TABLE_STATES.set(table, state);
        $table.on('page-change.bs.table', (event, pageNumber, pageSize)=>{
            if (state.isApplyingLayout || state.isAutoUpdatingPageSize) return;
            if (pageSize !== state.autoPageSize) state.manualPageSize = pageSize;
        });
    }
    if (!$22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT) {
        table.dataset.pagination = 'false';
        table.removeAttribute('data-pagination-v-align');
    }
    $22304431676f9932$var$applyInitialTableOptions(table);
    if ($table.data('bootstrap.table')) window.requestAnimationFrame(()=>{
        $22304431676f9932$var$normalizeTributaryFilterOptions(table);
        $22304431676f9932$var$refreshSummaryTable(table);
    });
}
function $22304431676f9932$var$bindStickyHeaderObservers(root = document) {
    if (!$22304431676f9932$var$ENABLE_STICKY_HEADERS) return;
    root.querySelectorAll('.navbar-collapse').forEach((element)=>{
        if (element.dataset.coaStickyObserverBound === 'true') return;
        element.dataset.coaStickyObserverBound = 'true';
        [
            'shown.bs.collapse',
            'hidden.bs.collapse'
        ].forEach((eventName)=>{
            element.addEventListener(eventName, $22304431676f9932$var$debouncedSummaryTableRefresh);
        });
    });
}
function $22304431676f9932$var$renderCombinedModalTemplate(modal, templateId) {
    const content = modal.querySelector('#coaCombinedRecordModalContent');
    const template = document.getElementById(templateId);
    if (!content || !template) return;
    content.innerHTML = template.innerHTML;
}
function $22304431676f9932$var$isCombinedModalTarget(event) {
    return event.detail.target?.id === 'coaCombinedRecordModalContent';
}
function $22304431676f9932$var$resetCombinedSummaryModal(modal, templateId = 'coaCombinedRecordModalLoadingTemplate') {
    $22304431676f9932$var$renderCombinedModalTemplate(modal, templateId);
}
function $22304431676f9932$var$initCombinedSummaryModal(root = document) {
    const modal = root.querySelector('#coaCombinedRecordModal');
    if (!modal || modal.dataset.coaModalBound === 'true') return;
    modal.dataset.coaModalBound = 'true';
    modal.addEventListener('show.bs.modal', ()=>{
        $22304431676f9932$var$resetCombinedSummaryModal(modal);
    });
    modal.addEventListener('hidden.bs.modal', ()=>{
        $22304431676f9932$var$resetCombinedSummaryModal(modal);
    });
    document.body.addEventListener('htmx:beforeRequest', (event)=>{
        if (!$22304431676f9932$var$isCombinedModalTarget(event)) return;
        $22304431676f9932$var$resetCombinedSummaryModal(modal);
    });
    document.body.addEventListener('htmx:responseError', (event)=>{
        if (!$22304431676f9932$var$isCombinedModalTarget(event)) return;
        $22304431676f9932$var$resetCombinedSummaryModal(modal, 'coaCombinedRecordModalErrorTemplate');
    });
}
function $22304431676f9932$var$initCoaSummaryTables(root = document) {
    root.querySelectorAll('table[data-coa-summary-table]').forEach((table)=>{
        $22304431676f9932$var$initSummaryTable(table);
    });
    $22304431676f9932$var$bindStickyHeaderObservers(root);
    $22304431676f9932$var$bindExportButtons(root);
    $22304431676f9932$var$initCombinedSummaryModal(root);
}
const $22304431676f9932$var$debouncedSummaryTableRefresh = (()=>{
    let timeoutId = null;
    return ()=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>{
            document.querySelectorAll('table[data-coa-summary-table]').forEach((table)=>{
                $22304431676f9932$var$refreshSummaryTable(table);
            });
        }, $22304431676f9932$var$RESIZE_DEBOUNCE_MS);
    };
})();
window.coaSummaryTables = {
    collectors: {
        glsLabel: $22304431676f9932$var$glsLabelCollector,
        pipeValues: $22304431676f9932$var$pipeValuesCollector,
        tributaryValues: $22304431676f9932$var$tributaryValuesCollector
    },
    config: {
        enablePaginationAndDynamicHeight: $22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT,
        enableStickyHeaders: $22304431676f9932$var$ENABLE_STICKY_HEADERS
    },
    downloadCsv: $22304431676f9932$var$downloadTableCsv,
    filters: {
        glsLabelContains: $22304431676f9932$var$glsLabelContains,
        pipeContains: $22304431676f9932$var$pipeContains,
        tributaryContains: $22304431676f9932$var$tributaryContains
    },
    formatters: {
        badgeList: $22304431676f9932$var$badgeListFormatter,
        booleanIcon: $22304431676f9932$var$booleanIconFormatter,
        coloredInteger: $22304431676f9932$var$coloredIntegerFormatter,
        currency: $22304431676f9932$var$currencyFormatter,
        details: $22304431676f9932$var$detailsFormatter,
        grow: $22304431676f9932$var$growFormatter,
        integer: $22304431676f9932$var$integerFormatter,
        link: $22304431676f9932$var$linkFormatter,
        muniSystem: $22304431676f9932$var$muniSystemFormatter,
        pocSystem: $22304431676f9932$var$pocSystemFormatter,
        reduction: $22304431676f9932$var$reductionFormatter,
        status: $22304431676f9932$var$statusFormatter
    },
    init: $22304431676f9932$var$initCoaSummaryTables,
    sorters: {
        numeric: $22304431676f9932$var$numericSorter,
        text: $22304431676f9932$var$textSorter
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $22304431676f9932$var$initCoaSummaryTables();
});
if ($22304431676f9932$var$ENABLE_PAGINATION_AND_DYNAMIC_HEIGHT) window.addEventListener('resize', $22304431676f9932$var$debouncedSummaryTableRefresh);
else if ($22304431676f9932$var$ENABLE_STICKY_HEADERS) window.addEventListener('resize', $22304431676f9932$var$debouncedSummaryTableRefresh);


var $bacf01ab4aec807d$var$t = function() {
    return $bacf01ab4aec807d$var$t = Object.assign || function(t) {
        for(var i, e = 1, s = arguments.length; e < s; e++)for(var n in i = arguments[e])Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        return t;
    }, $bacf01ab4aec807d$var$t.apply(this, arguments);
}, $bacf01ab4aec807d$export$1567cc001e3d0c1d = function() {
    function i(i, e, s) {
        var n = this;
        this.endVal = e, this.options = s, this.version = "2.10.1", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            autoAnimate: !1,
            autoAnimateDelay: 200,
            autoAnimateOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            n.startTime || (n.startTime = t);
            var i = t - n.startTime;
            n.remaining = n.duration - i, n.useEasing ? n.countDown ? n.frameVal = n.startVal - n.easingFn(i, 0, n.startVal - n.endVal, n.duration) : n.frameVal = n.easingFn(i, n.startVal, n.endVal - n.startVal, n.duration) : n.frameVal = n.startVal + (n.endVal - n.startVal) * (i / n.duration);
            var e = n.countDown ? n.frameVal < n.endVal : n.frameVal > n.endVal;
            n.frameVal = e ? n.endVal : n.frameVal, n.frameVal = Number(n.frameVal.toFixed(n.options.decimalPlaces)), n.printValue(n.frameVal), i < n.duration ? n.rAF = requestAnimationFrame(n.count) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.options.onCompleteCallback && n.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, e, s, a, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(n.options.decimalPlaces);
            var r = (i += "").split(".");
            if (e = r[0], s = r.length > 1 ? n.options.decimal + r[1] : "", n.options.useGrouping) {
                a = "";
                for(var l = 3, u = 0, h = 0, p = e.length; h < p; ++h)n.options.useIndianSeparators && 4 === h && (l = 2, u = 1), 0 !== h && u % l == 0 && (a = n.options.separator + a), u++, a = e[p - h - 1] + a;
                e = a;
            }
            return n.options.numerals && n.options.numerals.length && (e = e.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            })), o + n.options.prefix + e + s + n.options.suffix;
        }, this.easeOutExpo = function(t, i, e, s) {
            return e * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $bacf01ab4aec807d$var$t($bacf01ab4aec807d$var$t({}, this.defaults), s), this.options.enableScrollSpy && (this.options.autoAnimate = !0), void 0 !== this.options.scrollSpyDelay && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = !0), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = "string" == typeof i ? document.getElementById(i) : i, e = null == e ? this.parse(this.el.innerHTML) : e, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(e), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.autoAnimate && (this.error || "undefined" == typeof IntersectionObserver ? this.error ? console.error(this.error, i) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return i.prototype.setupObserver = function() {
        var t = this, e = i.observedElements.get(this.el);
        e && e.unobserve(), i.observedElements.set(this.el, this), this.observer = new IntersectionObserver(function(i) {
            for(var e = 0, s = i; e < s.length; e++){
                var n = s[e];
                n.isIntersecting && t.paused && !t.once ? (t.paused = !1, t.autoAnimateTimeout = setTimeout(function() {
                    return t.start();
                }, t.options.autoAnimateDelay), t.options.autoAnimateOnce && (t.once = !0, t.observer.disconnect())) : n.isIntersecting || t.paused || (clearTimeout(t.autoAnimateTimeout), t.reset());
            }
        }, {
            threshold: 0
        }), this.observer.observe(this.el);
    }, i.prototype.unobserve = function() {
        var t;
        clearTimeout(this.autoAnimateTimeout), null === (t = this.observer) || void 0 === t || t.disconnect(), i.observedElements.delete(this.el);
    }, i.prototype.onDestroy = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = null !== this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var e = this.countDown ? 1 : -1;
            this.endVal = t + e * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        if (this.paused) this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count);
        else {
            cancelAnimationFrame(this.rAF);
            var t = null !== this.finalEndVal ? this.duration + this.remaining : this.remaining;
            this.remaining = t;
        }
        this.paused = !this.paused;
    }, i.prototype.reset = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.once = !1, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var e = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, e);
            else if ("INPUT" === this.el.tagName) this.el.value = e;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = e : this.el.innerHTML = e;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i.prototype.parse = function(t) {
        var i = function(t) {
            return t.replace(/([.,'  ])/g, "\\$1");
        }, e = i(this.options.separator), s = i(this.options.decimal), n = t.replace(new RegExp(e, "g"), "").replace(new RegExp(s, "g"), ".");
        return parseFloat(n);
    }, i.observedElements = new WeakMap, i;
}();


document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('span[class*="stat-value"]').forEach((ele)=>{
        const options = {
            decimalPlaces: 0,
            duration: 1
        };
        const countupStrings = ele.className.split(' ').filter((cn)=>cn.startsWith('countup'));
        if (countupStrings.length > 0) {
            const decimalPlaces = Number(countupStrings[0].split('-')[1]);
            if (!Number.isNaN(decimalPlaces)) options.decimalPlaces = decimalPlaces;
        }
        const value = ele.innerHTML;
        const numericValue = Number(value);
        if (!Number.isNaN(numericValue)) {
            const countUp = new (0, $bacf01ab4aec807d$export$1567cc001e3d0c1d)(ele, value, options);
            if (!countUp.error) countUp.start();
            else console.error(countUp.error);
        }
    });
    console.log('Widget Counters loaded!');
});


var $eb11d1f138dc2541$var$List;
/******/ (function() {
    /******/ var __webpack_modules__ = {
        /***/ 104: /***/ function(module) {
            module.exports = function(list) {
                var _addAsync = function addAsync(values, callback, items) {
                    var valuesToAdd = values.splice(0, 50);
                    items = items || [];
                    items = items.concat(list.add(valuesToAdd));
                    if (values.length > 0) setTimeout(function() {
                        _addAsync(values, callback, items);
                    }, 1);
                    else {
                        list.update();
                        callback(items);
                    }
                };
                return _addAsync;
            };
        /***/ },
        /***/ 294: /***/ function(module) {
            module.exports = function(list) {
                // Add handlers
                list.handlers.filterStart = list.handlers.filterStart || [];
                list.handlers.filterComplete = list.handlers.filterComplete || [];
                return function(filterFunction) {
                    list.trigger('filterStart');
                    list.i = 1; // Reset paging
                    list.reset.filter();
                    if (filterFunction === undefined) list.filtered = false;
                    else {
                        list.filtered = true;
                        var is = list.items;
                        for(var i = 0, il = is.length; i < il; i++){
                            var item = is[i];
                            if (filterFunction(item)) item.filtered = true;
                            else item.filtered = false;
                        }
                    }
                    list.update();
                    list.trigger('filterComplete');
                    return list.visibleItems;
                };
            };
        /***/ },
        /***/ 503: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            var classes = __webpack_require__(536), events = __webpack_require__(647), extend = __webpack_require__(766), toString = __webpack_require__(797), getByClass = __webpack_require__(549), fuzzy = __webpack_require__(428);
            module.exports = function(list, options) {
                options = options || {};
                options = extend({
                    location: 0,
                    distance: 100,
                    threshold: 0.4,
                    multiSearch: true,
                    searchClass: 'fuzzy-search'
                }, options);
                var fuzzySearch = {
                    search: function search(searchString, columns) {
                        // Substract arguments from the searchString or put searchString as only argument
                        var searchArguments = options.multiSearch ? searchString.replace(/ +$/, '').split(/ +/) : [
                            searchString
                        ];
                        for(var k = 0, kl = list.items.length; k < kl; k++)fuzzySearch.item(list.items[k], columns, searchArguments);
                    },
                    item: function item(_item, columns, searchArguments) {
                        var found = true;
                        for(var i = 0; i < searchArguments.length; i++){
                            var foundArgument = false;
                            for(var j = 0, jl = columns.length; j < jl; j++)if (fuzzySearch.values(_item.values(), columns[j], searchArguments[i])) foundArgument = true;
                            if (!foundArgument) found = false;
                        }
                        _item.found = found;
                    },
                    values: function values(_values, value, searchArgument) {
                        if (_values.hasOwnProperty(value)) {
                            var text = toString(_values[value]).toLowerCase();
                            if (fuzzy(text, searchArgument, options)) return true;
                        }
                        return false;
                    }
                };
                events.bind(getByClass(list.listContainer, options.searchClass), 'keyup', list.utils.events.debounce(function(e) {
                    var target = e.target || e.srcElement; // IE have srcElement
                    list.search(target.value, fuzzySearch.search);
                }, list.searchDelay));
                return function(str, columns) {
                    list.search(str, columns, fuzzySearch.search);
                };
            };
        /***/ },
        /***/ 954: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            var naturalSort = __webpack_require__(813), getByClass = __webpack_require__(549), extend = __webpack_require__(766), indexOf = __webpack_require__(164), events = __webpack_require__(647), toString = __webpack_require__(797), classes = __webpack_require__(536), getAttribute = __webpack_require__(665), toArray = __webpack_require__(659);
            module.exports = function(id, options, values) {
                var self = this, init, Item = __webpack_require__(411)(self), addAsync = __webpack_require__(104)(self), initPagination = __webpack_require__(668)(self);
                init = {
                    start: function start() {
                        self.listClass = 'list';
                        self.searchClass = 'search';
                        self.sortClass = 'sort';
                        self.page = 10000;
                        self.i = 1;
                        self.items = [];
                        self.visibleItems = [];
                        self.matchingItems = [];
                        self.searched = false;
                        self.filtered = false;
                        self.searchColumns = undefined;
                        self.searchDelay = 0;
                        self.handlers = {
                            updated: []
                        };
                        self.valueNames = [];
                        self.utils = {
                            getByClass: getByClass,
                            extend: extend,
                            indexOf: indexOf,
                            events: events,
                            toString: toString,
                            naturalSort: naturalSort,
                            classes: classes,
                            getAttribute: getAttribute,
                            toArray: toArray
                        };
                        self.utils.extend(self, options);
                        self.listContainer = typeof id === 'string' ? document.getElementById(id) : id;
                        if (!self.listContainer) return;
                        self.list = getByClass(self.listContainer, self.listClass, true);
                        self.parse = __webpack_require__(857)(self);
                        self.templater = __webpack_require__(26)(self);
                        self.search = __webpack_require__(72)(self);
                        self.filter = __webpack_require__(294)(self);
                        self.sort = __webpack_require__(8)(self);
                        self.fuzzySearch = __webpack_require__(503)(self, options.fuzzySearch);
                        this.handlers();
                        this.items();
                        this.pagination();
                        self.update();
                    },
                    handlers: function handlers() {
                        for(var handler in self.handlers)if (self[handler] && self.handlers.hasOwnProperty(handler)) self.on(handler, self[handler]);
                    },
                    items: function items() {
                        self.parse(self.list);
                        if (values !== undefined) self.add(values);
                    },
                    pagination: function pagination() {
                        if (options.pagination !== undefined) {
                            if (options.pagination === true) options.pagination = [
                                {}
                            ];
                            if (options.pagination[0] === undefined) options.pagination = [
                                options.pagination
                            ];
                            for(var i = 0, il = options.pagination.length; i < il; i++)initPagination(options.pagination[i]);
                        }
                    }
                };
                /*
           * Re-parse the List, use if html have changed
           */ this.reIndex = function() {
                    self.items = [];
                    self.visibleItems = [];
                    self.matchingItems = [];
                    self.searched = false;
                    self.filtered = false;
                    self.parse(self.list);
                };
                this.toJSON = function() {
                    var json = [];
                    for(var i = 0, il = self.items.length; i < il; i++)json.push(self.items[i].values());
                    return json;
                };
                /*
           * Add object to list
           */ this.add = function(values, callback) {
                    if (values.length === 0) return;
                    if (callback) {
                        addAsync(values.slice(0), callback);
                        return;
                    }
                    var added = [], notCreate = false;
                    if (values[0] === undefined) values = [
                        values
                    ];
                    for(var i = 0, il = values.length; i < il; i++){
                        var item = null;
                        notCreate = self.items.length > self.page ? true : false;
                        item = new Item(values[i], undefined, notCreate);
                        self.items.push(item);
                        added.push(item);
                    }
                    self.update();
                    return added;
                };
                this.show = function(i, page) {
                    this.i = i;
                    this.page = page;
                    self.update();
                    return self;
                };
                /* Removes object from list.
           * Loops through the list and removes objects where
           * property "valuename" === value
           */ this.remove = function(valueName, value, options) {
                    var found = 0;
                    for(var i = 0, il = self.items.length; i < il; i++)if (self.items[i].values()[valueName] == value) {
                        self.templater.remove(self.items[i], options);
                        self.items.splice(i, 1);
                        il--;
                        i--;
                        found++;
                    }
                    self.update();
                    return found;
                };
                /* Gets the objects in the list which
           * property "valueName" === value
           */ this.get = function(valueName, value) {
                    var matchedItems = [];
                    for(var i = 0, il = self.items.length; i < il; i++){
                        var item = self.items[i];
                        if (item.values()[valueName] == value) matchedItems.push(item);
                    }
                    return matchedItems;
                };
                /*
           * Get size of the list
           */ this.size = function() {
                    return self.items.length;
                };
                /*
           * Removes all items from the list
           */ this.clear = function() {
                    self.templater.clear();
                    self.items = [];
                    return self;
                };
                this.on = function(event, callback) {
                    self.handlers[event].push(callback);
                    return self;
                };
                this.off = function(event, callback) {
                    var e = self.handlers[event];
                    var index = indexOf(e, callback);
                    if (index > -1) e.splice(index, 1);
                    return self;
                };
                this.trigger = function(event) {
                    var i = self.handlers[event].length;
                    while(i--)self.handlers[event][i](self);
                    return self;
                };
                this.reset = {
                    filter: function filter() {
                        var is = self.items, il = is.length;
                        while(il--)is[il].filtered = false;
                        return self;
                    },
                    search: function search() {
                        var is = self.items, il = is.length;
                        while(il--)is[il].found = false;
                        return self;
                    }
                };
                this.update = function() {
                    var is = self.items, il = is.length;
                    self.visibleItems = [];
                    self.matchingItems = [];
                    self.templater.clear();
                    for(var i = 0; i < il; i++){
                        if (is[i].matching() && self.matchingItems.length + 1 >= self.i && self.visibleItems.length < self.page) {
                            is[i].show();
                            self.visibleItems.push(is[i]);
                            self.matchingItems.push(is[i]);
                        } else if (is[i].matching()) {
                            self.matchingItems.push(is[i]);
                            is[i].hide();
                        } else is[i].hide();
                    }
                    self.trigger('updated');
                    return self;
                };
                init.start();
            };
        /***/ },
        /***/ 411: /***/ function(module) {
            module.exports = function(list) {
                return function(initValues, element, notCreate) {
                    var item = this;
                    this._values = {};
                    this.found = false; // Show if list.searched == true and this.found == true
                    this.filtered = false; // Show if list.filtered == true and this.filtered == true
                    var init = function init(initValues, element, notCreate) {
                        if (element === undefined) {
                            if (notCreate) item.values(initValues, notCreate);
                            else item.values(initValues);
                        } else {
                            item.elm = element;
                            var values = list.templater.get(item, initValues);
                            item.values(values);
                        }
                    };
                    this.values = function(newValues, notCreate) {
                        if (newValues !== undefined) {
                            for(var name in newValues)item._values[name] = newValues[name];
                            if (notCreate !== true) list.templater.set(item, item.values());
                        } else return item._values;
                    };
                    this.show = function() {
                        list.templater.show(item);
                    };
                    this.hide = function() {
                        list.templater.hide(item);
                    };
                    this.matching = function() {
                        return list.filtered && list.searched && item.found && item.filtered || list.filtered && !list.searched && item.filtered || !list.filtered && list.searched && item.found || !list.filtered && !list.searched;
                    };
                    this.visible = function() {
                        return item.elm && item.elm.parentNode == list.list ? true : false;
                    };
                    init(initValues, element, notCreate);
                };
            };
        /***/ },
        /***/ 668: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            var classes = __webpack_require__(536), events = __webpack_require__(647), List = __webpack_require__(954);
            module.exports = function(list) {
                var isHidden = false;
                var refresh = function refresh(pagingList, options) {
                    if (list.page < 1) {
                        list.listContainer.style.display = 'none';
                        isHidden = true;
                        return;
                    } else if (isHidden) list.listContainer.style.display = 'block';
                    var item, l = list.matchingItems.length, index = list.i, page = list.page, pages = Math.ceil(l / page), currentPage = Math.ceil(index / page), innerWindow = options.innerWindow || 2, left = options.left || options.outerWindow || 0, right = options.right || options.outerWindow || 0;
                    right = pages - right;
                    pagingList.clear();
                    for(var i = 1; i <= pages; i++){
                        var className = currentPage === i ? 'active' : '';
                        //console.log(i, left, right, currentPage, (currentPage - innerWindow), (currentPage + innerWindow), className);
                        if (is.number(i, left, right, currentPage, innerWindow)) {
                            item = pagingList.add({
                                page: i,
                                dotted: false
                            })[0];
                            if (className) classes(item.elm).add(className);
                            item.elm.firstChild.setAttribute('data-i', i);
                            item.elm.firstChild.setAttribute('data-page', page);
                        } else if (is.dotted(pagingList, i, left, right, currentPage, innerWindow, pagingList.size())) {
                            item = pagingList.add({
                                page: '...',
                                dotted: true
                            })[0];
                            classes(item.elm).add('disabled');
                        }
                    }
                };
                var is = {
                    number: function number(i, left, right, currentPage, innerWindow) {
                        return this.left(i, left) || this.right(i, right) || this.innerWindow(i, currentPage, innerWindow);
                    },
                    left: function left(i, _left) {
                        return i <= _left;
                    },
                    right: function right(i, _right) {
                        return i > _right;
                    },
                    innerWindow: function innerWindow(i, currentPage, _innerWindow) {
                        return i >= currentPage - _innerWindow && i <= currentPage + _innerWindow;
                    },
                    dotted: function dotted(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
                        return this.dottedLeft(pagingList, i, left, right, currentPage, innerWindow) || this.dottedRight(pagingList, i, left, right, currentPage, innerWindow, currentPageItem);
                    },
                    dottedLeft: function dottedLeft(pagingList, i, left, right, currentPage, innerWindow) {
                        return i == left + 1 && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
                    },
                    dottedRight: function dottedRight(pagingList, i, left, right, currentPage, innerWindow, currentPageItem) {
                        if (pagingList.items[currentPageItem - 1].values().dotted) return false;
                        else return i == right && !this.innerWindow(i, currentPage, innerWindow) && !this.right(i, right);
                    }
                };
                return function(options) {
                    var pagingList = new List(list.listContainer.id, {
                        listClass: options.paginationClass || 'pagination',
                        item: options.item || "<li><a class='page' href='#'></a></li>",
                        valueNames: [
                            'page',
                            'dotted'
                        ],
                        searchClass: 'pagination-search-that-is-not-supposed-to-exist',
                        sortClass: 'pagination-sort-that-is-not-supposed-to-exist'
                    });
                    events.bind(pagingList.listContainer, 'click', function(e) {
                        var target = e.target || e.srcElement, page = list.utils.getAttribute(target, 'data-page'), i = list.utils.getAttribute(target, 'data-i');
                        if (i) list.show((i - 1) * page + 1, page);
                    });
                    list.on('updated', function() {
                        refresh(pagingList, options);
                    });
                    refresh(pagingList, options);
                };
            };
        /***/ },
        /***/ 857: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            module.exports = function(list) {
                var Item = __webpack_require__(411)(list);
                var getChildren = function getChildren(parent) {
                    var nodes = parent.childNodes, items = [];
                    for(var i = 0, il = nodes.length; i < il; i++)// Only textnodes have a data attribute
                    if (nodes[i].data === undefined) items.push(nodes[i]);
                    return items;
                };
                var parse = function parse(itemElements, valueNames) {
                    for(var i = 0, il = itemElements.length; i < il; i++)list.items.push(new Item(valueNames, itemElements[i]));
                };
                var _parseAsync = function parseAsync(itemElements, valueNames) {
                    var itemsToIndex = itemElements.splice(0, 50); // TODO: If < 100 items, what happens in IE etc?
                    parse(itemsToIndex, valueNames);
                    if (itemElements.length > 0) setTimeout(function() {
                        _parseAsync(itemElements, valueNames);
                    }, 1);
                    else {
                        list.update();
                        list.trigger('parseComplete');
                    }
                };
                list.handlers.parseComplete = list.handlers.parseComplete || [];
                return function() {
                    var itemsToIndex = getChildren(list.list), valueNames = list.valueNames;
                    if (list.indexAsync) _parseAsync(itemsToIndex, valueNames);
                    else parse(itemsToIndex, valueNames);
                };
            };
        /***/ },
        /***/ 72: /***/ function(module) {
            module.exports = function(_list) {
                var item, text, columns, searchString, customSearch;
                var prepare = {
                    resetList: function resetList() {
                        _list.i = 1;
                        _list.templater.clear();
                        customSearch = undefined;
                    },
                    setOptions: function setOptions(args) {
                        if (args.length == 2 && args[1] instanceof Array) columns = args[1];
                        else if (args.length == 2 && typeof args[1] == 'function') {
                            columns = undefined;
                            customSearch = args[1];
                        } else if (args.length == 3) {
                            columns = args[1];
                            customSearch = args[2];
                        } else columns = undefined;
                    },
                    setColumns: function setColumns() {
                        if (_list.items.length === 0) return;
                        if (columns === undefined) columns = _list.searchColumns === undefined ? prepare.toArray(_list.items[0].values()) : _list.searchColumns;
                    },
                    setSearchString: function setSearchString(s) {
                        s = _list.utils.toString(s).toLowerCase();
                        searchString = s;
                    },
                    toArray: function toArray(values) {
                        var tmpColumn = [];
                        for(var name in values)tmpColumn.push(name);
                        return tmpColumn;
                    }
                };
                var search = {
                    list: function list() {
                        // Extract quoted phrases "word1 word2" from original searchString
                        // searchString is converted to lowercase by List.js
                        var words = [], phrase, ss = searchString;
                        while((phrase = ss.match(/"([^"]+)"/)) !== null){
                            words.push(phrase[1]);
                            ss = ss.substring(0, phrase.index) + ss.substring(phrase.index + phrase[0].length);
                        }
                        // Get remaining space-separated words (if any)
                        ss = ss.trim();
                        if (ss.length) words = words.concat(ss.split(/\s+/));
                        for(var k = 0, kl = _list.items.length; k < kl; k++){
                            var item = _list.items[k];
                            item.found = false;
                            if (!words.length) continue;
                            for(var i = 0, il = words.length; i < il; i++){
                                var word_found = false;
                                for(var j = 0, jl = columns.length; j < jl; j++){
                                    var values = item.values(), column = columns[j];
                                    if (values.hasOwnProperty(column) && values[column] !== undefined && values[column] !== null) {
                                        var text = typeof values[column] !== 'string' ? values[column].toString() : values[column];
                                        if (text.toLowerCase().indexOf(words[i]) !== -1) {
                                            // word found, so no need to check it against any other columns
                                            word_found = true;
                                            break;
                                        }
                                    }
                                }
                                // this word not found? no need to check any other words, the item cannot match
                                if (!word_found) break;
                            }
                            item.found = word_found;
                        }
                    },
                    // Removed search.item() and search.values()
                    reset: function reset() {
                        _list.reset.search();
                        _list.searched = false;
                    }
                };
                var searchMethod = function searchMethod(str) {
                    _list.trigger('searchStart');
                    prepare.resetList();
                    prepare.setSearchString(str);
                    prepare.setOptions(arguments); // str, cols|searchFunction, searchFunction
                    prepare.setColumns();
                    if (searchString === '') search.reset();
                    else {
                        _list.searched = true;
                        if (customSearch) customSearch(searchString, columns);
                        else search.list();
                    }
                    _list.update();
                    _list.trigger('searchComplete');
                    return _list.visibleItems;
                };
                _list.handlers.searchStart = _list.handlers.searchStart || [];
                _list.handlers.searchComplete = _list.handlers.searchComplete || [];
                _list.utils.events.bind(_list.utils.getByClass(_list.listContainer, _list.searchClass), 'keyup', _list.utils.events.debounce(function(e) {
                    var target = e.target || e.srcElement, // IE have srcElement
                    alreadyCleared = target.value === '' && !_list.searched;
                    if (!alreadyCleared) // If oninput already have resetted the list, do nothing
                    searchMethod(target.value);
                }, _list.searchDelay));
                // Used to detect click on HTML5 clear button
                _list.utils.events.bind(_list.utils.getByClass(_list.listContainer, _list.searchClass), 'input', function(e) {
                    var target = e.target || e.srcElement;
                    if (target.value === '') searchMethod('');
                });
                return searchMethod;
            };
        /***/ },
        /***/ 8: /***/ function(module) {
            module.exports = function(list) {
                var buttons = {
                    els: undefined,
                    clear: function clear() {
                        for(var i = 0, il = buttons.els.length; i < il; i++){
                            list.utils.classes(buttons.els[i]).remove('asc');
                            list.utils.classes(buttons.els[i]).remove('desc');
                        }
                    },
                    getOrder: function getOrder(btn) {
                        var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
                        if (predefinedOrder == 'asc' || predefinedOrder == 'desc') return predefinedOrder;
                        else if (list.utils.classes(btn).has('desc')) return 'asc';
                        else if (list.utils.classes(btn).has('asc')) return 'desc';
                        else return 'asc';
                    },
                    getInSensitive: function getInSensitive(btn, options) {
                        var insensitive = list.utils.getAttribute(btn, 'data-insensitive');
                        if (insensitive === 'false') options.insensitive = false;
                        else options.insensitive = true;
                    },
                    setOrder: function setOrder(options) {
                        for(var i = 0, il = buttons.els.length; i < il; i++){
                            var btn = buttons.els[i];
                            if (list.utils.getAttribute(btn, 'data-sort') !== options.valueName) continue;
                            var predefinedOrder = list.utils.getAttribute(btn, 'data-order');
                            if (predefinedOrder == 'asc' || predefinedOrder == 'desc') {
                                if (predefinedOrder == options.order) list.utils.classes(btn).add(options.order);
                            } else list.utils.classes(btn).add(options.order);
                        }
                    }
                };
                var floatRegex = /^[+-]?([0-9]*[.])?[0-9]+(e[0-9]+)?$/;
                var _sort = function sort() {
                    list.trigger('sortStart');
                    var options = {};
                    var target = arguments[0].currentTarget || arguments[0].srcElement || undefined; // arg[0] : val, arg[1] : { order: 'asc' }
                    if (target) {
                        options.valueName = list.utils.getAttribute(target, 'data-sort');
                        buttons.getInSensitive(target, options);
                        options.order = buttons.getOrder(target);
                    } else {
                        options = arguments[1] || options;
                        options.valueName = arguments[0];
                        options.order = options.order || 'asc';
                        options.insensitive = typeof options.insensitive == 'undefined' ? true : options.insensitive;
                    }
                    buttons.clear();
                    buttons.setOrder(options);
                    // caseInsensitive
                    // alphabet
                    var customSortFunction = options.sortFunction || list.sortFunction || null, multi = options.order === 'desc' ? -1 : 1, sortFunction;
                    if (customSortFunction) sortFunction = function sortFunction(itemA, itemB) {
                        return customSortFunction(itemA, itemB, options) * multi;
                    };
                    else sortFunction = function sortFunction(itemA, itemB) {
                        var itemAValue = itemA.values()[options.valueName];
                        var itemBValue = itemB.values()[options.valueName];
                        if (floatRegex.test(itemAValue) && floatRegex.test(itemBValue)) return (parseFloat(itemAValue) - parseFloat(itemBValue)) * multi;
                        return list.utils.naturalSort(itemA.values()[options.valueName] + '', itemB.values()[options.valueName] + '', {
                            caseInsensitive: !_sort.alphabet && options.insensitive,
                            alphabet: list.alphabet || options.alphabet || undefined
                        }) * multi;
                    };
                    list.items.sort(sortFunction);
                    list.update();
                    list.trigger('sortComplete');
                };
                // Add handlers
                list.handlers.sortStart = list.handlers.sortStart || [];
                list.handlers.sortComplete = list.handlers.sortComplete || [];
                buttons.els = list.utils.getByClass(list.listContainer, list.sortClass);
                list.utils.events.bind(buttons.els, 'click', _sort);
                list.on('searchStart', buttons.clear);
                list.on('filterStart', buttons.clear);
                return _sort;
            };
        /***/ },
        /***/ 26: /***/ function(module) {
            var Templater = function Templater(list) {
                var createItem, templater = this;
                var init = function init() {
                    var itemSource;
                    if (typeof list.item === 'function') {
                        createItem = function createItem(values) {
                            var item = list.item(values);
                            return getItemSource(item);
                        };
                        return;
                    }
                    if (typeof list.item === 'string') {
                        if (list.item.indexOf('<') === -1) itemSource = document.getElementById(list.item);
                        else itemSource = getItemSource(list.item);
                    } else /* If item source does not exists, use the first item in list as
              source for new items */ itemSource = getFirstListItem();
                    if (!itemSource) throw new Error("The list needs to have at least one item on init otherwise you'll have to add a template.");
                    itemSource = createCleanTemplateItem(itemSource, list.valueNames);
                    createItem = function createItem() {
                        return itemSource.cloneNode(true);
                    };
                };
                var createCleanTemplateItem = function createCleanTemplateItem(templateNode, valueNames) {
                    var el = templateNode.cloneNode(true);
                    el.removeAttribute('id');
                    for(var i = 0, il = valueNames.length; i < il; i++){
                        var elm = undefined, valueName = valueNames[i];
                        if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)el.setAttribute('data-' + valueName.data[j], '');
                        else if (valueName.attr && valueName.name) {
                            elm = list.utils.getByClass(el, valueName.name, true);
                            if (elm) elm.setAttribute(valueName.attr, '');
                        } else {
                            elm = list.utils.getByClass(el, valueName, true);
                            if (elm) elm.innerHTML = '';
                        }
                    }
                    return el;
                };
                var getFirstListItem = function getFirstListItem() {
                    var nodes = list.list.childNodes;
                    for(var i = 0, il = nodes.length; i < il; i++){
                        // Only textnodes have a data attribute
                        if (nodes[i].data === undefined) return nodes[i].cloneNode(true);
                    }
                    return undefined;
                };
                var getItemSource = function getItemSource(itemHTML) {
                    if (typeof itemHTML !== 'string') return undefined;
                    if (/<tr[\s>]/g.exec(itemHTML)) {
                        var tbody = document.createElement('tbody');
                        tbody.innerHTML = itemHTML;
                        return tbody.firstElementChild;
                    } else if (itemHTML.indexOf('<') !== -1) {
                        var div = document.createElement('div');
                        div.innerHTML = itemHTML;
                        return div.firstElementChild;
                    }
                    return undefined;
                };
                var getValueName = function getValueName(name) {
                    for(var i = 0, il = list.valueNames.length; i < il; i++){
                        var valueName = list.valueNames[i];
                        if (valueName.data) {
                            var data = valueName.data;
                            for(var j = 0, jl = data.length; j < jl; j++){
                                if (data[j] === name) return {
                                    data: name
                                };
                            }
                        } else if (valueName.attr && valueName.name && valueName.name == name) return valueName;
                        else if (valueName === name) return name;
                    }
                };
                var setValue = function setValue(item, name, value) {
                    var elm = undefined, valueName = getValueName(name);
                    if (!valueName) return;
                    if (valueName.data) item.elm.setAttribute('data-' + valueName.data, value);
                    else if (valueName.attr && valueName.name) {
                        elm = list.utils.getByClass(item.elm, valueName.name, true);
                        if (elm) elm.setAttribute(valueName.attr, value);
                    } else {
                        elm = list.utils.getByClass(item.elm, valueName, true);
                        if (elm) elm.innerHTML = value;
                    }
                };
                this.get = function(item, valueNames) {
                    templater.create(item);
                    var values = {};
                    for(var i = 0, il = valueNames.length; i < il; i++){
                        var elm = undefined, valueName = valueNames[i];
                        if (valueName.data) for(var j = 0, jl = valueName.data.length; j < jl; j++)values[valueName.data[j]] = list.utils.getAttribute(item.elm, 'data-' + valueName.data[j]);
                        else if (valueName.attr && valueName.name) {
                            elm = list.utils.getByClass(item.elm, valueName.name, true);
                            values[valueName.name] = elm ? list.utils.getAttribute(elm, valueName.attr) : '';
                        } else {
                            elm = list.utils.getByClass(item.elm, valueName, true);
                            values[valueName] = elm ? elm.innerHTML : '';
                        }
                    }
                    return values;
                };
                this.set = function(item, values) {
                    if (!templater.create(item)) {
                        for(var v in values)if (values.hasOwnProperty(v)) setValue(item, v, values[v]);
                    }
                };
                this.create = function(item) {
                    if (item.elm !== undefined) return false;
                    item.elm = createItem(item.values());
                    templater.set(item, item.values());
                    return true;
                };
                this.remove = function(item) {
                    if (item.elm.parentNode === list.list) list.list.removeChild(item.elm);
                };
                this.show = function(item) {
                    templater.create(item);
                    list.list.appendChild(item.elm);
                };
                this.hide = function(item) {
                    if (item.elm !== undefined && item.elm.parentNode === list.list) list.list.removeChild(item.elm);
                };
                this.clear = function() {
                    /* .innerHTML = ''; fucks up IE */ if (list.list.hasChildNodes()) while(list.list.childNodes.length >= 1)list.list.removeChild(list.list.firstChild);
                };
                init();
            };
            module.exports = function(list) {
                return new Templater(list);
            };
        /***/ },
        /***/ 536: /***/ function(module, __unused_webpack_exports, __webpack_require__) {
            /**
         * Module dependencies.
         */ var index = __webpack_require__(164);
            /**
         * Whitespace regexp.
         */ var re = /\s+/;
            /**
         * toString reference.
         */ var toString = Object.prototype.toString;
            /**
         * Wrap `el` in a `ClassList`.
         *
         * @param {Element} el
         * @return {ClassList}
         * @api public
         */ module.exports = function(el) {
                return new ClassList(el);
            };
            /**
         * Initialize a new ClassList for `el`.
         *
         * @param {Element} el
         * @api private
         */ function ClassList(el) {
                if (!el || !el.nodeType) throw new Error('A DOM element reference is required');
                this.el = el;
                this.list = el.classList;
            }
            /**
         * Add class `name` if not already present.
         *
         * @param {String} name
         * @return {ClassList}
         * @api public
         */ ClassList.prototype.add = function(name) {
                // classList
                if (this.list) {
                    this.list.add(name);
                    return this;
                }
                // fallback
                var arr = this.array();
                var i = index(arr, name);
                if (!~i) arr.push(name);
                this.el.className = arr.join(' ');
                return this;
            };
            /**
         * Remove class `name` when present, or
         * pass a regular expression to remove
         * any which match.
         *
         * @param {String|RegExp} name
         * @return {ClassList}
         * @api public
         */ ClassList.prototype.remove = function(name) {
                // classList
                if (this.list) {
                    this.list.remove(name);
                    return this;
                }
                // fallback
                var arr = this.array();
                var i = index(arr, name);
                if (~i) arr.splice(i, 1);
                this.el.className = arr.join(' ');
                return this;
            };
            /**
         * Toggle class `name`, can force state via `force`.
         *
         * For browsers that support classList, but do not support `force` yet,
         * the mistake will be detected and corrected.
         *
         * @param {String} name
         * @param {Boolean} force
         * @return {ClassList}
         * @api public
         */ ClassList.prototype.toggle = function(name, force) {
                // classList
                if (this.list) {
                    if ('undefined' !== typeof force) {
                        if (force !== this.list.toggle(name, force)) this.list.toggle(name); // toggle again to correct
                    } else this.list.toggle(name);
                    return this;
                }
                // fallback
                if ('undefined' !== typeof force) {
                    if (!force) this.remove(name);
                    else this.add(name);
                } else if (this.has(name)) this.remove(name);
                else this.add(name);
                return this;
            };
            /**
         * Return an array of classes.
         *
         * @return {Array}
         * @api public
         */ ClassList.prototype.array = function() {
                var className = this.el.getAttribute('class') || '';
                var str = className.replace(/^\s+|\s+$/g, '');
                var arr = str.split(re);
                if ('' === arr[0]) arr.shift();
                return arr;
            };
            /**
         * Check if class `name` is present.
         *
         * @param {String} name
         * @return {ClassList}
         * @api public
         */ ClassList.prototype.has = ClassList.prototype.contains = function(name) {
                return this.list ? this.list.contains(name) : !!~index(this.array(), name);
            };
        /***/ },
        /***/ 647: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
            var bind = window.addEventListener ? 'addEventListener' : 'attachEvent', unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent', prefix = bind !== 'addEventListener' ? 'on' : '', toArray = __webpack_require__(659);
            /**
         * Bind `el` event `type` to `fn`.
         *
         * @param {Element} el, NodeList, HTMLCollection or Array
         * @param {String} type
         * @param {Function} fn
         * @param {Boolean} capture
         * @api public
         */ exports.bind = function(el, type, fn, capture) {
                el = toArray(el);
                for(var i = 0, il = el.length; i < il; i++)el[i][bind](prefix + type, fn, capture || false);
            };
            /**
         * Unbind `el` event `type`'s callback `fn`.
         *
         * @param {Element} el, NodeList, HTMLCollection or Array
         * @param {String} type
         * @param {Function} fn
         * @param {Boolean} capture
         * @api public
         */ exports.unbind = function(el, type, fn, capture) {
                el = toArray(el);
                for(var i = 0, il = el.length; i < il; i++)el[i][unbind](prefix + type, fn, capture || false);
            };
            /**
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * `wait` milliseconds. If `immediate` is true, trigger the function on the
         * leading edge, instead of the trailing.
         *
         * @param {Function} fn
         * @param {Integer} wait
         * @param {Boolean} immediate
         * @api public
         */ exports.debounce = function(fn, wait, immediate) {
                var timeout;
                return wait ? function() {
                    var context = this, args = arguments;
                    var later = function later() {
                        timeout = null;
                        if (!immediate) fn.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) fn.apply(context, args);
                } : fn;
            };
        /***/ },
        /***/ 766: /***/ function(module) {
            /*
         * Source: https://github.com/segmentio/extend
         */ module.exports = function extend(object) {
                // Takes an unlimited number of extenders.
                var args = Array.prototype.slice.call(arguments, 1);
                // For each extender, copy their properties on our object.
                for(var i = 0, source; source = args[i]; i++){
                    if (!source) continue;
                    for(var property in source)object[property] = source[property];
                }
                return object;
            };
        /***/ },
        /***/ 428: /***/ function(module) {
            module.exports = function(text, pattern, options) {
                // Aproximately where in the text is the pattern expected to be found?
                var Match_Location = options.location || 0;
                //Determines how close the match must be to the fuzzy location (specified above). An exact letter match which is 'distance' characters away from the fuzzy location would score as a complete mismatch. A distance of '0' requires the match be at the exact location specified, a threshold of '1000' would require a perfect match to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                var Match_Distance = options.distance || 100;
                // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match (of both letters and location), a threshold of '1.0' would match anything.
                var Match_Threshold = options.threshold || 0.4;
                if (pattern === text) return true; // Exact match
                if (pattern.length > 32) return false; // This algorithm cannot be used
                // Set starting location at beginning text and initialise the alphabet.
                var loc = Match_Location, s = function() {
                    var q = {}, i;
                    for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] = 0;
                    for(i = 0; i < pattern.length; i++)q[pattern.charAt(i)] |= 1 << pattern.length - i - 1;
                    return q;
                }();
                // Compute and return the score for a match with e errors and x location.
                // Accesses loc and pattern through being a closure.
                function match_bitapScore_(e, x) {
                    var accuracy = e / pattern.length, proximity = Math.abs(loc - x);
                    if (!Match_Distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / Match_Distance;
                }
                var score_threshold = Match_Threshold, // Highest score beyond which we give up.
                best_loc = text.indexOf(pattern, loc); // Is there a nearby exact match? (speedup)
                if (best_loc != -1) {
                    score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
                    // What about in the other direction? (speedup)
                    best_loc = text.lastIndexOf(pattern, loc + pattern.length);
                    if (best_loc != -1) score_threshold = Math.min(match_bitapScore_(0, best_loc), score_threshold);
                }
                // Initialise the bit arrays.
                var matchmask = 1 << pattern.length - 1;
                best_loc = -1;
                var bin_min, bin_mid;
                var bin_max = pattern.length + text.length;
                var last_rd;
                for(var d = 0; d < pattern.length; d++){
                    // Scan for the best match; each iteration allows for one more error.
                    // Run a binary search to determine how far from 'loc' we can stray at this
                    // error level.
                    bin_min = 0;
                    bin_mid = bin_max;
                    while(bin_min < bin_mid){
                        if (match_bitapScore_(d, loc + bin_mid) <= score_threshold) bin_min = bin_mid;
                        else bin_max = bin_mid;
                        bin_mid = Math.floor((bin_max - bin_min) / 2 + bin_min);
                    }
                    // Use the result from this iteration as the maximum for the next.
                    bin_max = bin_mid;
                    var start = Math.max(1, loc - bin_mid + 1);
                    var finish = Math.min(loc + bin_mid, text.length) + pattern.length;
                    var rd = Array(finish + 2);
                    rd[finish + 1] = (1 << d) - 1;
                    for(var j = finish; j >= start; j--){
                        // The alphabet (s) is a sparse hash, so the following line generates
                        // warnings.
                        var charMatch = s[text.charAt(j - 1)];
                        if (d === 0) // First pass: exact match.
                        rd[j] = (rd[j + 1] << 1 | 1) & charMatch;
                        else // Subsequent passes: fuzzy match.
                        rd[j] = (rd[j + 1] << 1 | 1) & charMatch | ((last_rd[j + 1] | last_rd[j]) << 1 | 1) | last_rd[j + 1];
                        if (rd[j] & matchmask) {
                            var score = match_bitapScore_(d, j - 1);
                            // This match will almost certainly be better than any existing match.
                            // But check anyway.
                            if (score <= score_threshold) {
                                // Told you so.
                                score_threshold = score;
                                best_loc = j - 1;
                                if (best_loc > loc) // When passing loc, don't exceed our current distance from loc.
                                start = Math.max(1, 2 * loc - best_loc);
                                else break;
                            }
                        }
                    }
                    // No hope for a (better) match at greater error levels.
                    if (match_bitapScore_(d + 1, loc) > score_threshold) break;
                    last_rd = rd;
                }
                return best_loc < 0 ? false : true;
            };
        /***/ },
        /***/ 665: /***/ function(module) {
            /**
         * A cross-browser implementation of getAttribute.
         * Source found here: http://stackoverflow.com/a/3755343/361337 written by Vivin Paliath
         *
         * Return the value for `attr` at `element`.
         *
         * @param {Element} el
         * @param {String} attr
         * @api public
         */ module.exports = function(el, attr) {
                var result = el.getAttribute && el.getAttribute(attr) || null;
                if (!result) {
                    var attrs = el.attributes;
                    var length = attrs.length;
                    for(var i = 0; i < length; i++){
                        if (attrs[i] !== undefined) {
                            if (attrs[i].nodeName === attr) result = attrs[i].nodeValue;
                        }
                    }
                }
                return result;
            };
        /***/ },
        /***/ 549: /***/ function(module) {
            /**
         * A cross-browser implementation of getElementsByClass.
         * Heavily based on Dustin Diaz's function: http://dustindiaz.com/getelementsbyclass.
         *
         * Find all elements with class `className` inside `container`.
         * Use `single = true` to increase performance in older browsers
         * when only one element is needed.
         *
         * @param {String} className
         * @param {Element} container
         * @param {Boolean} single
         * @api public
         */ var getElementsByClassName = function getElementsByClassName(container, className, single) {
                if (single) return container.getElementsByClassName(className)[0];
                else return container.getElementsByClassName(className);
            };
            var querySelector = function querySelector(container, className, single) {
                className = '.' + className;
                if (single) return container.querySelector(className);
                else return container.querySelectorAll(className);
            };
            var polyfill = function polyfill(container, className, single) {
                var classElements = [], tag = '*';
                var els = container.getElementsByTagName(tag);
                var elsLen = els.length;
                var pattern = new RegExp('(^|\\s)' + className + '(\\s|$)');
                for(var i = 0, j = 0; i < elsLen; i++)if (pattern.test(els[i].className)) {
                    if (single) return els[i];
                    else {
                        classElements[j] = els[i];
                        j++;
                    }
                }
                return classElements;
            };
            module.exports = function() {
                return function(container, className, single, options) {
                    options = options || {};
                    if (options.test && options.getElementsByClassName || !options.test && document.getElementsByClassName) return getElementsByClassName(container, className, single);
                    else if (options.test && options.querySelector || !options.test && document.querySelector) return querySelector(container, className, single);
                    else return polyfill(container, className, single);
                };
            }();
        /***/ },
        /***/ 164: /***/ function(module) {
            var indexOf = [].indexOf;
            module.exports = function(arr, obj) {
                if (indexOf) return arr.indexOf(obj);
                for(var i = 0, il = arr.length; i < il; ++i){
                    if (arr[i] === obj) return i;
                }
                return -1;
            };
        /***/ },
        /***/ 659: /***/ function(module) {
            /**
         * Source: https://github.com/timoxley/to-array
         *
         * Convert an array-like object into an `Array`.
         * If `collection` is already an `Array`, then will return a clone of `collection`.
         *
         * @param {Array | Mixed} collection An `Array` or array-like object to convert e.g. `arguments` or `NodeList`
         * @return {Array} Naive conversion of `collection` to a new `Array`.
         * @api public
         */ module.exports = function toArray(collection) {
                if (typeof collection === 'undefined') return [];
                if (collection === null) return [
                    null
                ];
                if (collection === window) return [
                    window
                ];
                if (typeof collection === 'string') return [
                    collection
                ];
                if (isArray(collection)) return collection;
                if (typeof collection.length != 'number') return [
                    collection
                ];
                if (typeof collection === 'function' && collection instanceof Function) return [
                    collection
                ];
                var arr = [];
                for(var i = 0, il = collection.length; i < il; i++)if (Object.prototype.hasOwnProperty.call(collection, i) || i in collection) arr.push(collection[i]);
                if (!arr.length) return [];
                return arr;
            };
            function isArray(arr) {
                return Object.prototype.toString.call(arr) === '[object Array]';
            }
        /***/ },
        /***/ 797: /***/ function(module) {
            module.exports = function(s) {
                s = s === undefined ? '' : s;
                s = s === null ? '' : s;
                s = s.toString();
                return s;
            };
        /***/ },
        /***/ 813: /***/ function(module) {
            "use strict";
            const defaultAlphabetIndexMap = [];
            function isNumberCode(code) {
                return code >= 48 /* '0' */  && code <= 57 /* '9' */ ;
            }
            function naturalCompare(a, b, opts) {
                if (typeof a !== 'string') throw new TypeError(`The first argument must be a string. Received type '${typeof a}'`);
                if (typeof b !== 'string') throw new TypeError(`The second argument must be a string. Received type '${typeof b}'`);
                const lengthA = a.length;
                const lengthB = b.length;
                let indexA = 0;
                let indexB = 0;
                let alphabetIndexMap = defaultAlphabetIndexMap;
                let firstDifferenceInLeadingZeros = 0;
                if (opts) {
                    if (opts.caseInsensitive) {
                        a = a.toLowerCase();
                        b = b.toLowerCase();
                    }
                    if (opts.alphabet) alphabetIndexMap = buildAlphabetIndexMap(opts.alphabet);
                }
                while(indexA < lengthA && indexB < lengthB){
                    let charCodeA = a.charCodeAt(indexA);
                    let charCodeB = b.charCodeAt(indexB);
                    if (isNumberCode(charCodeA)) {
                        if (!isNumberCode(charCodeB)) return charCodeA - charCodeB;
                        let numStartA = indexA;
                        let numStartB = indexB;
                        while(charCodeA === 48 /* '0' */  && ++numStartA < lengthA)charCodeA = a.charCodeAt(numStartA);
                        while(charCodeB === 48 /* '0' */  && ++numStartB < lengthB)charCodeB = b.charCodeAt(numStartB);
                        if (numStartA !== numStartB && firstDifferenceInLeadingZeros === 0) firstDifferenceInLeadingZeros = numStartA - numStartB;
                        let numEndA = numStartA;
                        let numEndB = numStartB;
                        while(numEndA < lengthA && isNumberCode(a.charCodeAt(numEndA)))++numEndA;
                        while(numEndB < lengthB && isNumberCode(b.charCodeAt(numEndB)))++numEndB;
                        let difference = numEndA - numStartA - numEndB + numStartB; // numA length - numB length
                        if (difference !== 0) return difference;
                        while(numStartA < numEndA){
                            difference = a.charCodeAt(numStartA++) - b.charCodeAt(numStartB++);
                            if (difference !== 0) return difference;
                        }
                        indexA = numEndA;
                        indexB = numEndB;
                        continue;
                    }
                    if (charCodeA !== charCodeB) {
                        if (charCodeA < alphabetIndexMap.length && charCodeB < alphabetIndexMap.length && alphabetIndexMap[charCodeA] !== -1 && alphabetIndexMap[charCodeB] !== -1) return alphabetIndexMap[charCodeA] - alphabetIndexMap[charCodeB];
                        return charCodeA - charCodeB;
                    }
                    ++indexA;
                    ++indexB;
                }
                if (indexA < lengthA) return 1;
                if (indexB < lengthB) return -1;
                return firstDifferenceInLeadingZeros;
            }
            const alphabetIndexMapCache = {};
            function buildAlphabetIndexMap(alphabet) {
                const existingMap = alphabetIndexMapCache[alphabet];
                if (existingMap !== undefined) return existingMap;
                const indexMap = [];
                const maxCharCode = alphabet.split('').reduce((maxCode, char)=>{
                    return Math.max(maxCode, char.charCodeAt(0));
                }, 0);
                for(let i = 0; i <= maxCharCode; i++)indexMap.push(-1);
                for(let i = 0; i < alphabet.length; i++)indexMap[alphabet.charCodeAt(i)] = i;
                alphabetIndexMapCache[alphabet] = indexMap;
                return indexMap;
            }
            module.exports = naturalCompare;
        /***/ }
    };
    /************************************************************************/ /******/ // The module cache
    /******/ var __webpack_module_cache__ = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ // Check if module is in cache
        /******/ var cachedModule = __webpack_module_cache__[moduleId];
        /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module = __webpack_module_cache__[moduleId] = {
            /******/ // no module.id needed
            /******/ // no module.loaded needed
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/ /******/ // Return the exports of the module
        /******/ return module.exports;
    /******/ }
    /******/ /************************************************************************/ /******/ /******/ // startup
    /******/ // Load entry module and return exports
    /******/ // This entry module is referenced by other modules so it can't be inlined
    /******/ var __webpack_exports__ = __webpack_require__(954);
    /******/ $eb11d1f138dc2541$var$List = __webpack_exports__;
/******/ /******/ })();


window.$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
window.jQuery = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
window.bootstrap = $91ca15859685b28b$exports;
window.htmx = (0, $8if87.default);
const $2cfe5a1b9130a35b$var$helloWorld = ()=>console.log("javascript loaded!");
$2cfe5a1b9130a35b$var$helloWorld();
console.log("Bootstrap loaded!", $91ca15859685b28b$exports); // global bootstrap initializations
 // const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
 // const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))




})();
//# sourceMappingURL=trwwapi.bundle.js.map
